//源文件在public-json里
export function landTypeData() {
	var data = [{
			"name": "商服用地",
			"value": "05",
			"children": [{
					"name": "批发零售用地",
					"value": "051"
				},
				{
					"name": "住宿餐饮用地",
					"value": "052"
				},
				{
					"name": "商务金融用地",
					"value": "053"
				},
				{
					"name": "其他商服用地",
					"value": "054"
				}
			]
		},
		{
			"name": "工矿仓储用地",
			"value": "06",
			"children": [{
					"name": "工业用地",
					"value": "061"
				},
				{
					"name": "采矿用地",
					"value": "062"
				},
				{
					"name": "仓储用地",
					"value": "063"
				}
			]
		},
		{
			"name": "公共管理与公共服务用地",
			"value": "08",
			"children": [{
					"name": "机关团体用地",
					"value": "081"
				},
				{
					"name": "新闻出版用地",
					"value": "082"
				},
				{
					"name": "科教用地",
					"value": "083"
				},
				{
					"name": "医卫慈善用地",
					"value": "084"
				},
				{
					"name": "文体娱乐用地",
					"value": "085"
				},
				{
					"name": "公共设施用地",
					"value": "086"
				},
				{
					"name": "公园与绿地",
					"value": "087"
				},
				{
					"name": "风景名胜设施用地",
					"value": "088"
				}
			]
		},
		{
			"name": "交通运输用地",
			"value": "10",
			"children": [{
					"name": "铁路用地",
					"value": "101"
				},
				{
					"name": "公路用地",
					"value": "102"
				},
				{
					"name": "街巷用地",
					"value": "103"
				},
				{
					"name": "农村道路",
					"value": "104"
				},
				{
					"name": "机场用地",
					"value": "105"
				},
				{
					"name": "港口码头用地",
					"value": "106"
				},
				{
					"name": "管道运输用地",
					"value": "107"
				}
			]
		}
	];
	return data;

}
export function landIndustryData() {
	var data = [{
			"name": "农、林、牧、渔业",
			"value": "A",
			"children": [{
					"name": "农业",
					"value": "A01"
				},
				{
					"name": "林业",
					"value": "A02"
				},
				{
					"name": "畜牧业",
					"value": "A03"
				},
				{
					"name": "渔业",
					"value": "A04"
				},
				{
					"name": "农、林、牧、渔服务业",
					"value": "A05"
				}
			]
		},
		{
			"name": "采矿业",
			"value": "B",
			"children": [{
					"name": "煤炭开采和洗选业",
					"value": "B06"
				},
				{
					"name": "石油和天然气开采业",
					"value": "B07"
				},
				{
					"name": "黑色金属矿采选业",
					"value": "B08"
				},
				{
					"name": "有色金属矿采选业",
					"value": "B09"
				},
				{
					"name": "非金属矿采选业",
					"value": "B10"
				},
				{
					"name": "其他采矿业",
					"value": "B11"
				}
			]
		},
		{
			"name": "制造业",
			"value": "C",
			"children": [{
					"name": "农副食品加工业",
					"value": "C13"
				},
				{
					"name": "食品制造业",
					"value": "C14"
				},
				{
					"name": "饮料制造业",
					"value": "C15"
				},
				{
					"name": "烟草制品业",
					"value": "C16"
				},
				{
					"name": "纺织业",
					"value": "C17"
				},
				{
					"name": "纺织服装、鞋、帽制造业",
					"value": "C18"
				},
				{
					"name": "皮革、毛皮、羽毛（绒）及其制造业",
					"value": "C19"
				},
				{
					"name": "木材加工及木、竹、藤、棕、草制品业",
					"value": "C20"
				},
				{
					"name": "家具制造业",
					"value": "C21"
				},
				{
					"name": "造纸及纸质品业",
					"value": "C22"
				},
				{
					"name": "印刷业和记录媒体的复制",
					"value": "C23"
				},
				{
					"name": "文教体育用品制造业",
					"value": "C24"
				},
				{
					"name": "石油加工、炼焦及核燃料加工业",
					"value": "C25"
				},
				{
					"name": "化学原料及化学制品制造业",
					"value": "C26"
				},
				{
					"name": "医药制造业",
					"value": "C27"
				},
				{
					"name": "化学纤维制造业",
					"value": "C28"
				},
				{
					"name": "橡胶制品业",
					"value": "C29"
				},
				{
					"name": "塑料制品业",
					"value": "C30"
				},
				{
					"name": "非金属矿物制品业",
					"value": "C31"
				},
				{
					"name": "黑色金属冶炼及压延加工业",
					"value": "C32"
				},
				{
					"name": "有色金属冶炼及压延加工业",
					"value": "C33"
				},
				{
					"name": "金属制品业",
					"value": "C34"
				},
				{
					"name": "通用设备制造业",
					"value": "C35"
				},
				{
					"name": "专用设备制造业",
					"value": "C36"
				},
				{
					"name": "交通运输设备制造业",
					"value": "C37"
				},
				{
					"name": "电气机械及器材制造业",
					"value": "C39"
				},
				{
					"name": "通讯设备、计算机及其他电子设备制造业",
					"value": "C40"
				},
				{
					"name": "仪器仪表及文化、办公用机械制造业",
					"value": "C41"
				},
				{
					"name": "工艺品及其他制造业",
					"value": "C42"
				},
				{
					"name": "废弃资源和废旧材料回收加工业",
					"value": "C43"
				}
			]
		},
		{
			"name": "电力、燃气及水的生产和供应业",
			"value": "D",
			"children": [{
					"name": "电力、热力的生产和供应业",
					"value": "D44"
				},
				{
					"name": "燃气生产和供应业",
					"value": "D45"
				},
				{
					"name": "水的生产和供应业",
					"value": "D46"
				}
			]
		},
		{
			"name": "建筑业",
			"value": "E",
			"children": [{
					"name": "房屋和土木工程业",
					"value": "E47"
				},
				{
					"name": "建筑安装业",
					"value": "E48"
				},
				{
					"name": "建筑装饰业",
					"value": "E49"
				},
				{
					"name": "工程准备",
					"value": "E50"
				}
			]
		},
		{
			"name": "交通运输、仓储和邮政业",
			"value": "F",
			"children": [{
					"name": "铁路运输业",
					"value": "F51"
				},
				{
					"name": "道路运输业",
					"value": "F52"
				},
				{
					"name": "城市公共交通业",
					"value": "F53"
				},
				{
					"name": "水上运输业",
					"value": "F54"
				},
				{
					"name": "航空运输业",
					"value": "F55"
				},
				{
					"name": "管道运输业",
					"value": "F56"
				},
				{
					"name": "装卸搬运和其他运输服务业",
					"value": "F57"
				},
				{
					"name": "仓储业",
					"value": "F58"
				},
				{
					"name": "邮政业",
					"value": "F59"
				}
			]
		},
		{
			"name": "信息传输、计算机服务和软件业",
			"value": "G",
			"children": [{
					"name": "电信和其他信息传输服务业",
					"value": "G60"
				},
				{
					"name": "计算机服务业",
					"value": "G61"
				},
				{
					"name": "软件业",
					"value": "G62"
				}
			]
		},
		{
			"name": "批发和零售业",
			"value": "H",
			"children": [{
					"name": "批发业",
					"value": "H63"
				},
				{
					"name": "零售业",
					"value": "H65"
				}
			]
		},
		{
			"name": "住宿和餐饮业",
			"value": "I",
			"children": [{
					"name": "住宿业",
					"value": "I66"
				},
				{
					"name": "餐饮业",
					"value": "I74"
				}
			]
		},
		{
			"name": "金融业",
			"value": "J",
			"children": [{
					"name": "银行业",
					"value": "J68"
				},
				{
					"name": "证券业",
					"value": "J69"
				},
				{
					"name": "保险业",
					"value": "J70"
				},
				{
					"name": "其他金融服务",
					"value": "J71"
				}
			]
		},
		{
			"name": "房地产业",
			"value": "K",
			"children": [{
				"name": "房地产业",
				"value": "K72"
			}]
		},
		{
			"name": "租赁和商务服务业",
			"value": "L",
			"children": [{
					"name": "租赁业",
					"value": "L73"
				},
				{
					"name": "商务服务业",
					"value": "L74"
				}
			]
		},
		{
			"name": "科学研究、技术服务和地质勘查业",
			"value": "M",
			"children": [{
					"name": "研究与试验发展",
					"value": "M75"
				},
				{
					"name": "专业技术服务业",
					"value": "M76"
				},
				{
					"name": "科技交流和推广服务业",
					"value": "M77"
				},
				{
					"name": "地质勘查业",
					"value": "M78"
				}
			]
		},
		{
			"name": "水利、环境和公共设施管理业",
			"value": "N",
			"children": [{
					"name": "水利管理业",
					"value": "N79"
				},
				{
					"name": "环境管理业",
					"value": "N80"
				},
				{
					"name": "公共设施管理业",
					"value": "N81"
				}
			]
		},
		{
			"name": "居民服务和其他服务业",
			"value": "O",
			"children": [{
					"name": "居民服务业",
					"value": "O82"
				},
				{
					"name": "其他服务业",
					"value": "O83"
				}
			]
		},
		{
			"name": "教育",
			"value": "P",
			"children": [{
				"name": "教育业",
				"value": "P84"
			}]
		},
		{
			"name": "卫生、社会保障和社会福利业",
			"value": "Q",
			"children": [{
					"name": "卫生",
					"value": "Q85"
				},
				{
					"name": "社会保障业",
					"value": "Q86"
				},
				{
					"name": "社会福利业",
					"value": "Q87"
				}
			]
		},
		{
			"name": "文化、体育和娱乐业",
			"value": "R",
			"children": [{
					"name": "新闻出版业",
					"value": "R88"
				},
				{
					"name": "广播、电视、电影和音像业",
					"value": "R89"
				},
				{
					"name": "文化艺术业",
					"value": "R90"
				},
				{
					"name": "体育",
					"value": "R91"
				},
				{
					"name": "娱乐业",
					"value": "R92"
				}
			]
		},
		{
			"name": "公共管理和社会组织",
			"value": "S",
			"children": [{
					"name": "中国共产党机关",
					"value": "S93"
				},
				{
					"name": "国家机构",
					"value": "S94"
				},
				{
					"name": "人民政协和民主党派",
					"value": "S95"
				},
				{
					"name": "群众团体、社会团体和宗教组织",
					"value": "S96"
				},
				{
					"name": "基层群众自治组织",
					"value": "S97"
				}
			]
		},
		{
			"name": "国际组织",
			"value": "T",
			"children": [{
				"name": "国际组织",
				"value": "T98"
			}]
		}
	];
	return data;
}
export function landCityData() {
	var data = [{
			"areaId": "11",
			"areaName": "北京市",
			"latitude": 39.904989,
			"longitude": 116.405285,
			"children": [{
					"areaId": "1101",
					"areaName": "北京市市辖区",
					"latitude": 39.904989,
					"longitude": 116.405285,
					"children": [{
							"areaId": "110100",
							"areaName": "北京市本级",
							"latitude": 39.904989,
							"longitude": 116.405285
						},
						{
							"areaId": "110101",
							"areaName": "东城区",
							"latitude": 39.93157,
							"longitude": 116.41005
						},
						{
							"areaId": "110102",
							"areaName": "西城区",
							"latitude": 39.9305,
							"longitude": 116.36003
						},
						{
							"areaId": "110103",
							"areaName": "崇文区",
							"latitude": 39.904989,
							"longitude": 116.405285
						},
						{
							"areaId": "110104",
							"areaName": "宣武区",
							"latitude": 39.904989,
							"longitude": 116.405285
						},
						{
							"areaId": "110105",
							"areaName": "朝阳区",
							"latitude": 43.83339,
							"longitude": 125.2883
						},
						{
							"areaId": "110106",
							"areaName": "丰台区",
							"latitude": 39.8585,
							"longitude": 116.28625
						},
						{
							"areaId": "110107",
							"areaName": "石景山区",
							"latitude": 39.90564,
							"longitude": 116.2229
						},
						{
							"areaId": "110108",
							"areaName": "海淀区",
							"latitude": 39.95931,
							"longitude": 116.29812
						},
						{
							"areaId": "110109",
							"areaName": "门头沟区",
							"latitude": 39.94043,
							"longitude": 116.10137
						},
						{
							"areaId": "110111",
							"areaName": "房山区",
							"latitude": 39.74786,
							"longitude": 116.14257
						},
						{
							"areaId": "110112",
							"areaName": "通州区",
							"latitude": 32.0676,
							"longitude": 121.07293
						},
						{
							"areaId": "110113",
							"areaName": "顺义区",
							"latitude": 40.1302,
							"longitude": 116.65417
						},
						{
							"areaId": "110114",
							"areaName": "昌平区",
							"latitude": 40.22072,
							"longitude": 116.2312
						},
						{
							"areaId": "110115",
							"areaName": "大兴区",
							"latitude": 39.72668,
							"longitude": 116.34149
						},
						{
							"areaId": "110116",
							"areaName": "怀柔区",
							"latitude": 40.31602,
							"longitude": 116.63168
						},
						{
							"areaId": "110117",
							"areaName": "平谷区",
							"latitude": 40.14056,
							"longitude": 117.12133
						}
					]
				},
				{
					"areaId": "1102",
					"areaName": "北京市所辖县",
					"latitude": 39.904989,
					"longitude": 116.405285,
					"children": [{
							"areaId": "110228",
							"areaName": "密云县",
							"latitude": 39.904989,
							"longitude": 116.405285
						},
						{
							"areaId": "110229",
							"areaName": "延庆县",
							"latitude": 39.904989,
							"longitude": 116.405285
						}
					]
				}
			]
		},
		{
			"areaId": "12",
			"areaName": "天津市",
			"latitude": 39.125596,
			"longitude": 117.190182,
			"children": [{
					"areaId": "1201",
					"areaName": "天津市市辖区",
					"latitude": 39.125596,
					"longitude": 117.190182,
					"children": [{
							"areaId": "120100",
							"areaName": "天津市本级",
							"latitude": 39.125596,
							"longitude": 117.190182
						},
						{
							"areaId": "120101",
							"areaName": "和平区",
							"latitude": 24.17477,
							"longitude": 120.88349
						},
						{
							"areaId": "120102",
							"areaName": "河东区",
							"latitude": 35.08803,
							"longitude": 118.41055
						},
						{
							"areaId": "120103",
							"areaName": "河西区",
							"latitude": 39.10959,
							"longitude": 117.22327
						},
						{
							"areaId": "120104",
							"areaName": "南开区",
							"latitude": 39.13821,
							"longitude": 117.15074
						},
						{
							"areaId": "120105",
							"areaName": "河北区",
							"latitude": 22.494086,
							"longitude": 114.148959
						},
						{
							"areaId": "120106",
							"areaName": "红桥区",
							"latitude": 39.16715,
							"longitude": 117.15145
						},
						{
							"areaId": "120107",
							"areaName": "塘沽区",
							"latitude": 39.125596,
							"longitude": 117.190182
						},
						{
							"areaId": "120108",
							"areaName": "汉沽区",
							"latitude": 39.125596,
							"longitude": 117.190182
						},
						{
							"areaId": "120109",
							"areaName": "大港区",
							"latitude": 39.125596,
							"longitude": 117.190182
						},
						{
							"areaId": "120110",
							"areaName": "东丽区",
							"latitude": 39.0863,
							"longitude": 117.31436
						},
						{
							"areaId": "120111",
							"areaName": "西青区",
							"latitude": 39.14123,
							"longitude": 117.00927
						},
						{
							"areaId": "120112",
							"areaName": "津南区",
							"latitude": 22.24676,
							"longitude": 114.174134
						},
						{
							"areaId": "120113",
							"areaName": "北辰区",
							"latitude": 39.22131,
							"longitude": 117.13217
						},
						{
							"areaId": "120114",
							"areaName": "武清区",
							"latitude": 39.38415,
							"longitude": 117.04443
						},
						{
							"areaId": "120115",
							"areaName": "宝坻区",
							"latitude": 39.71761,
							"longitude": 117.3103
						},
						{
							"areaId": "120116",
							"areaName": "滨海新区",
							"latitude": 39.02668,
							"longitude": 117.70162
						}
					]
				},
				{
					"areaId": "1202",
					"areaName": "天津市所辖县",
					"latitude": 39.125596,
					"longitude": 117.190182,
					"children": [{
							"areaId": "120221",
							"areaName": "宁河县",
							"latitude": 39.125596,
							"longitude": 117.190182
						},
						{
							"areaId": "120223",
							"areaName": "静海县",
							"latitude": 39.125596,
							"longitude": 117.190182
						},
						{
							"areaId": "120225",
							"areaName": "蓟县",
							"latitude": 39.125596,
							"longitude": 117.190182
						}
					]
				}
			]
		},
		{
			"areaId": "13",
			"areaName": "河北省",
			"latitude": 38.045474,
			"longitude": 114.502461,
			"children": [{
					"areaId": "1301",
					"areaName": "石家庄市",
					"latitude": 38.045474,
					"longitude": 114.502461,
					"children": [{
							"areaId": "130100",
							"areaName": "石家庄市本级",
							"latitude": 38.045474,
							"longitude": 114.502461
						},
						{
							"areaId": "130102",
							"areaName": "长安区",
							"latitude": 34.15559,
							"longitude": 108.94586
						},
						{
							"areaId": "130103",
							"areaName": "桥东区",
							"latitude": 38.045474,
							"longitude": 114.502461
						},
						{
							"areaId": "130104",
							"areaName": "桥西区",
							"latitude": 40.81945,
							"longitude": 114.86962
						},
						{
							"areaId": "130105",
							"areaName": "新华区",
							"latitude": 33.7373,
							"longitude": 113.29402
						},
						{
							"areaId": "130107",
							"areaName": "井陉矿区",
							"latitude": 38.06705,
							"longitude": 114.06518
						},
						{
							"areaId": "130108",
							"areaName": "裕华区",
							"latitude": 38.00604,
							"longitude": 114.53115
						},
						{
							"areaId": "130121",
							"areaName": "井陉县",
							"latitude": 38.03688,
							"longitude": 114.14257
						},
						{
							"areaId": "130123",
							"areaName": "正定县",
							"latitude": 38.14445,
							"longitude": 114.57296
						},
						{
							"areaId": "130124",
							"areaName": "栾城县",
							"latitude": 38.045474,
							"longitude": 114.502461
						},
						{
							"areaId": "130125",
							"areaName": "行唐县",
							"latitude": 38.43654,
							"longitude": 114.55316
						},
						{
							"areaId": "130126",
							"areaName": "灵寿县",
							"latitude": 38.30845,
							"longitude": 114.38259
						},
						{
							"areaId": "130127",
							"areaName": "高邑县",
							"latitude": 37.61556,
							"longitude": 114.61142
						},
						{
							"areaId": "130128",
							"areaName": "深泽县",
							"latitude": 38.18353,
							"longitude": 115.20358
						},
						{
							"areaId": "130129",
							"areaName": "赞皇县",
							"latitude": 37.66135,
							"longitude": 114.38775
						},
						{
							"areaId": "130130",
							"areaName": "无极县",
							"latitude": 38.17653,
							"longitude": 114.97509
						},
						{
							"areaId": "130131",
							"areaName": "平山县",
							"latitude": 38.25994,
							"longitude": 114.186
						},
						{
							"areaId": "130132",
							"areaName": "元氏县",
							"latitude": 37.76668,
							"longitude": 114.52539
						},
						{
							"areaId": "130133",
							"areaName": "赵县",
							"latitude": 37.75628,
							"longitude": 114.77612
						},
						{
							"areaId": "130181",
							"areaName": "辛集市",
							"latitude": 37.94079,
							"longitude": 115.20626
						},
						{
							"areaId": "130182",
							"areaName": "藁城市",
							"latitude": 38.045474,
							"longitude": 114.502461
						},
						{
							"areaId": "130183",
							"areaName": "晋州市",
							"latitude": 38.03135,
							"longitude": 115.04348
						},
						{
							"areaId": "130184",
							"areaName": "新乐市",
							"latitude": 38.34417,
							"longitude": 114.68985
						},
						{
							"areaId": "130185",
							"areaName": "鹿泉市",
							"latitude": 38.045474,
							"longitude": 114.502461
						}
					]
				},
				{
					"areaId": "1302",
					"areaName": "唐山市",
					"latitude": 39.635113,
					"longitude": 118.175393,
					"children": [{
							"areaId": "130200",
							"areaName": "唐山市本级",
							"latitude": 39.635113,
							"longitude": 118.175393
						},
						{
							"areaId": "130202",
							"areaName": "路南区",
							"latitude": 39.62505,
							"longitude": 118.15431
						},
						{
							"areaId": "130203",
							"areaName": "路北区",
							"latitude": 39.62436,
							"longitude": 118.20079
						},
						{
							"areaId": "130204",
							"areaName": "古冶区",
							"latitude": 39.71993,
							"longitude": 118.45803
						},
						{
							"areaId": "130205",
							"areaName": "开平区",
							"latitude": 39.67128,
							"longitude": 118.26171
						},
						{
							"areaId": "130207",
							"areaName": "丰南区",
							"latitude": 39.56483,
							"longitude": 118.11282
						},
						{
							"areaId": "130208",
							"areaName": "丰润区",
							"latitude": 39.8244,
							"longitude": 118.12976
						},
						{
							"areaId": "130223",
							"areaName": "滦县",
							"latitude": 39.635113,
							"longitude": 118.175393
						},
						{
							"areaId": "130224",
							"areaName": "滦南县",
							"latitude": 39.5039,
							"longitude": 118.6741
						},
						{
							"areaId": "130225",
							"areaName": "乐亭县",
							"latitude": 39.42561,
							"longitude": 118.9125
						},
						{
							"areaId": "130227",
							"areaName": "迁西县",
							"latitude": 40.14587,
							"longitude": 118.31616
						},
						{
							"areaId": "130229",
							"areaName": "玉田县",
							"latitude": 39.90049,
							"longitude": 117.7388
						},
						{
							"areaId": "130230",
							"areaName": "唐海县",
							"latitude": 39.635113,
							"longitude": 118.175393
						},
						{
							"areaId": "130281",
							"areaName": "遵化市",
							"latitude": 40.18741,
							"longitude": 117.96444
						},
						{
							"areaId": "130283",
							"areaName": "迁安市",
							"latitude": 39.99833,
							"longitude": 118.70068
						}
					]
				},
				{
					"areaId": "1303",
					"areaName": "秦皇岛市",
					"latitude": 39.942531,
					"longitude": 119.586579,
					"children": [{
							"areaId": "130300",
							"areaName": "秦皇岛市本级",
							"latitude": 39.942531,
							"longitude": 119.586579
						},
						{
							"areaId": "130302",
							"areaName": "海港区",
							"latitude": 39.9345,
							"longitude": 119.61046
						},
						{
							"areaId": "130303",
							"areaName": "山海关区",
							"latitude": 39.97869,
							"longitude": 119.77563
						},
						{
							"areaId": "130304",
							"areaName": "北戴河区",
							"latitude": 39.83408,
							"longitude": 119.48388
						},
						{
							"areaId": "130321",
							"areaName": "青龙满族自治县",
							"latitude": 40.40743,
							"longitude": 118.95242
						},
						{
							"areaId": "130322",
							"areaName": "昌黎县",
							"latitude": 39.70884,
							"longitude": 119.16595
						},
						{
							"areaId": "130323",
							"areaName": "抚宁县",
							"latitude": 39.942531,
							"longitude": 119.586579
						},
						{
							"areaId": "130324",
							"areaName": "卢龙县",
							"latitude": 39.89176,
							"longitude": 118.89288
						}
					]
				},
				{
					"areaId": "1304",
					"areaName": "邯郸市",
					"latitude": 36.59385,
					"longitude": 114.53103,
					"children": [{
							"areaId": "130400",
							"areaName": "邯郸市本级",
							"latitude": 36.59385,
							"longitude": 114.53103
						},
						{
							"areaId": "130402",
							"areaName": "邯山区",
							"latitude": 36.60006,
							"longitude": 114.48375
						},
						{
							"areaId": "130403",
							"areaName": "丛台区",
							"latitude": 36.61847,
							"longitude": 114.49343
						},
						{
							"areaId": "130404",
							"areaName": "复兴区",
							"latitude": 24.820908,
							"longitude": 121.352613
						},
						{
							"areaId": "130406",
							"areaName": "峰峰矿区",
							"latitude": 36.41937,
							"longitude": 114.21148
						},
						{
							"areaId": "130421",
							"areaName": "邯郸县",
							"latitude": 36.59385,
							"longitude": 114.53103
						},
						{
							"areaId": "130423",
							"areaName": "临漳县",
							"latitude": 36.33461,
							"longitude": 114.6195
						},
						{
							"areaId": "130424",
							"areaName": "成安县",
							"latitude": 31.53487,
							"longitude": 104.56738
						},
						{
							"areaId": "130425",
							"areaName": "大名县",
							"latitude": 36.27994,
							"longitude": 115.15362
						},
						{
							"areaId": "130426",
							"areaName": "涉县",
							"latitude": 36.58072,
							"longitude": 113.69183
						},
						{
							"areaId": "130427",
							"areaName": "磁县",
							"latitude": 36.37392,
							"longitude": 114.37387
						},
						{
							"areaId": "130428",
							"areaName": "肥乡县",
							"latitude": 36.59385,
							"longitude": 114.53103
						},
						{
							"areaId": "130429",
							"areaName": "永年县",
							"latitude": 36.59385,
							"longitude": 114.53103
						},
						{
							"areaId": "130430",
							"areaName": "邱县",
							"latitude": 36.82082,
							"longitude": 115.17407
						},
						{
							"areaId": "130431",
							"areaName": "鸡泽县",
							"latitude": 36.92374,
							"longitude": 114.8742
						},
						{
							"areaId": "130432",
							"areaName": "广平县",
							"latitude": 36.48046,
							"longitude": 114.94653
						},
						{
							"areaId": "130433",
							"areaName": "馆陶县",
							"latitude": 36.53719,
							"longitude": 115.29913
						},
						{
							"areaId": "130434",
							"areaName": "魏县",
							"latitude": 36.36171,
							"longitude": 114.93518
						},
						{
							"areaId": "130435",
							"areaName": "曲周县",
							"latitude": 36.77671,
							"longitude": 114.95196
						},
						{
							"areaId": "130481",
							"areaName": "武安市",
							"latitude": 36.69281,
							"longitude": 114.20153
						}
					]
				},
				{
					"areaId": "1305",
					"areaName": "邢台市",
					"latitude": 37.0456,
					"longitude": 114.56575,
					"children": [{
							"areaId": "130500",
							"areaName": "邢台市本级",
							"latitude": 37.0456,
							"longitude": 114.56575
						},
						{
							"areaId": "130502",
							"areaName": "桥东区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "130503",
							"areaName": "桥西区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "130521",
							"areaName": "邢台县",
							"latitude": 37.0456,
							"longitude": 114.56575
						},
						{
							"areaId": "130522",
							"areaName": "临城县",
							"latitude": 37.43977,
							"longitude": 114.50387
						},
						{
							"areaId": "130523",
							"areaName": "内丘县",
							"latitude": 37.28671,
							"longitude": 114.51212
						},
						{
							"areaId": "130524",
							"areaName": "柏乡县",
							"latitude": 37.48242,
							"longitude": 114.69332
						},
						{
							"areaId": "130525",
							"areaName": "隆尧县",
							"latitude": 37.35351,
							"longitude": 114.77615
						},
						{
							"areaId": "130526",
							"areaName": "任县",
							"latitude": 37.0456,
							"longitude": 114.56575
						},
						{
							"areaId": "130527",
							"areaName": "南和县",
							"latitude": 37.0456,
							"longitude": 114.56575
						},
						{
							"areaId": "130528",
							"areaName": "宁晋县",
							"latitude": 37.61696,
							"longitude": 114.92117
						},
						{
							"areaId": "130529",
							"areaName": "巨鹿县",
							"latitude": 37.21801,
							"longitude": 115.03524
						},
						{
							"areaId": "130530",
							"areaName": "新河县",
							"latitude": 37.52718,
							"longitude": 115.24987
						},
						{
							"areaId": "130531",
							"areaName": "广宗县",
							"latitude": 37.0746,
							"longitude": 115.14254
						},
						{
							"areaId": "130532",
							"areaName": "平乡县",
							"latitude": 37.06317,
							"longitude": 115.03002
						},
						{
							"areaId": "130533",
							"areaName": "威县",
							"latitude": 36.9768,
							"longitude": 115.2637
						},
						{
							"areaId": "130534",
							"areaName": "清河县",
							"latitude": 37.07122,
							"longitude": 115.66479
						},
						{
							"areaId": "130535",
							"areaName": "临西县",
							"latitude": 36.87078,
							"longitude": 115.50097
						},
						{
							"areaId": "130581",
							"areaName": "南宫市",
							"latitude": 37.35799,
							"longitude": 115.39068
						},
						{
							"areaId": "130582",
							"areaName": "沙河市",
							"latitude": 36.8577,
							"longitude": 114.4981
						}
					]
				},
				{
					"areaId": "1306",
					"areaName": "保定市",
					"latitude": 38.867657,
					"longitude": 115.482331,
					"children": [{
							"areaId": "130600",
							"areaName": "保定市本级",
							"latitude": 38.867657,
							"longitude": 115.482331
						},
						{
							"areaId": "130602",
							"areaName": "新市区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "130603",
							"areaName": "北市区",
							"latitude": 38.867657,
							"longitude": 115.482331
						},
						{
							"areaId": "130604",
							"areaName": "南市区",
							"latitude": 38.867657,
							"longitude": 115.482331
						},
						{
							"areaId": "130621",
							"areaName": "满城县",
							"latitude": 38.867657,
							"longitude": 115.482331
						},
						{
							"areaId": "130622",
							"areaName": "清苑县",
							"latitude": 38.867657,
							"longitude": 115.482331
						},
						{
							"areaId": "130623",
							"areaName": "涞水县",
							"latitude": 39.39404,
							"longitude": 115.71517
						},
						{
							"areaId": "130624",
							"areaName": "阜平县",
							"latitude": 38.84763,
							"longitude": 114.19683
						},
						{
							"areaId": "130625",
							"areaName": "徐水县",
							"latitude": 38.867657,
							"longitude": 115.482331
						},
						{
							"areaId": "130626",
							"areaName": "定兴县",
							"latitude": 39.26312,
							"longitude": 115.80786
						},
						{
							"areaId": "130627",
							"areaName": "唐县",
							"latitude": 38.74513,
							"longitude": 114.98516
						},
						{
							"areaId": "130628",
							"areaName": "高阳县",
							"latitude": 38.70003,
							"longitude": 115.7788
						},
						{
							"areaId": "130629",
							"areaName": "容城县",
							"latitude": 39.0535,
							"longitude": 115.87158
						},
						{
							"areaId": "130630",
							"areaName": "涞源县",
							"latitude": 39.35388,
							"longitude": 114.69128
						},
						{
							"areaId": "130631",
							"areaName": "望都县",
							"latitude": 38.70996,
							"longitude": 115.1567
						},
						{
							"areaId": "130632",
							"areaName": "安新县",
							"latitude": 38.93532,
							"longitude": 115.93557
						},
						{
							"areaId": "130633",
							"areaName": "易县",
							"latitude": 39.34885,
							"longitude": 115.4981
						},
						{
							"areaId": "130634",
							"areaName": "曲阳县",
							"latitude": 38.62154,
							"longitude": 114.70123
						},
						{
							"areaId": "130635",
							"areaName": "蠡县",
							"latitude": 38.48974,
							"longitude": 115.57717
						},
						{
							"areaId": "130636",
							"areaName": "顺平县",
							"latitude": 38.83854,
							"longitude": 115.1347
						},
						{
							"areaId": "130637",
							"areaName": "博野县",
							"latitude": 38.4564,
							"longitude": 115.47033
						},
						{
							"areaId": "130638",
							"areaName": "雄县",
							"latitude": 38.99442,
							"longitude": 116.10873
						},
						{
							"areaId": "130681",
							"areaName": "涿州市",
							"latitude": 39.48622,
							"longitude": 115.98062
						},
						{
							"areaId": "130682",
							"areaName": "定州市",
							"latitude": 38.51623,
							"longitude": 114.9902
						},
						{
							"areaId": "130683",
							"areaName": "安国市",
							"latitude": 38.41391,
							"longitude": 115.32321
						},
						{
							"areaId": "130684",
							"areaName": "高碑店市",
							"latitude": 39.32655,
							"longitude": 115.87368
						}
					]
				},
				{
					"areaId": "1307",
					"areaName": "张家口市",
					"latitude": 40.811901,
					"longitude": 114.884091,
					"children": [{
							"areaId": "130700",
							"areaName": "张家口市本级",
							"latitude": 40.811901,
							"longitude": 114.884091
						},
						{
							"areaId": "130702",
							"areaName": "桥东区",
							"latitude": 40.78844,
							"longitude": 114.8943
						},
						{
							"areaId": "130703",
							"areaName": "桥西区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "130705",
							"areaName": "宣化区",
							"latitude": 40.56618,
							"longitude": 115.15497
						},
						{
							"areaId": "130706",
							"areaName": "下花园区",
							"latitude": 40.50236,
							"longitude": 115.28744
						},
						{
							"areaId": "130721",
							"areaName": "宣化县",
							"latitude": 40.811901,
							"longitude": 114.884091
						},
						{
							"areaId": "130722",
							"areaName": "张北县",
							"latitude": 41.15977,
							"longitude": 114.71432
						},
						{
							"areaId": "130723",
							"areaName": "康保县",
							"latitude": 41.85225,
							"longitude": 114.60031
						},
						{
							"areaId": "130724",
							"areaName": "沽源县",
							"latitude": 41.66959,
							"longitude": 115.68859
						},
						{
							"areaId": "130725",
							"areaName": "尚义县",
							"latitude": 41.07782,
							"longitude": 113.97134
						},
						{
							"areaId": "130726",
							"areaName": "蔚县",
							"latitude": 39.84067,
							"longitude": 114.58892
						},
						{
							"areaId": "130727",
							"areaName": "阳原县",
							"latitude": 40.10361,
							"longitude": 114.15051
						},
						{
							"areaId": "130728",
							"areaName": "怀安县",
							"latitude": 40.67425,
							"longitude": 114.38559
						},
						{
							"areaId": "130729",
							"areaName": "万全县",
							"latitude": 40.811901,
							"longitude": 114.884091
						},
						{
							"areaId": "130730",
							"areaName": "怀来县",
							"latitude": 40.41536,
							"longitude": 115.51773
						},
						{
							"areaId": "130731",
							"areaName": "涿鹿县",
							"latitude": 40.37636,
							"longitude": 115.22403
						},
						{
							"areaId": "130732",
							"areaName": "赤城县",
							"latitude": 40.91438,
							"longitude": 115.83187
						},
						{
							"areaId": "130733",
							"areaName": "崇礼县",
							"latitude": 40.811901,
							"longitude": 114.884091
						}
					]
				},
				{
					"areaId": "1308",
					"areaName": "承德市",
					"latitude": 40.976204,
					"longitude": 117.939152,
					"children": [{
							"areaId": "130800",
							"areaName": "承德市本级",
							"latitude": 40.976204,
							"longitude": 117.939152
						},
						{
							"areaId": "130802",
							"areaName": "双桥区",
							"latitude": 40.97466,
							"longitude": 117.9432
						},
						{
							"areaId": "130803",
							"areaName": "双滦区",
							"latitude": 40.95375,
							"longitude": 117.74487
						},
						{
							"areaId": "130804",
							"areaName": "鹰手营子矿区",
							"latitude": 40.54744,
							"longitude": 117.65985
						},
						{
							"areaId": "130821",
							"areaName": "承德县",
							"latitude": 40.76985,
							"longitude": 118.17639
						},
						{
							"areaId": "130822",
							"areaName": "兴隆县",
							"latitude": 40.41709,
							"longitude": 117.50073
						},
						{
							"areaId": "130823",
							"areaName": "平泉县",
							"latitude": 40.976204,
							"longitude": 117.939152
						},
						{
							"areaId": "130824",
							"areaName": "滦平县",
							"latitude": 40.94148,
							"longitude": 117.33276
						},
						{
							"areaId": "130825",
							"areaName": "隆化县",
							"latitude": 41.31412,
							"longitude": 117.7297
						},
						{
							"areaId": "130826",
							"areaName": "丰宁满族自治县",
							"latitude": 41.20481,
							"longitude": 116.6492
						},
						{
							"areaId": "130827",
							"areaName": "宽城满族自治县",
							"latitude": 40.60829,
							"longitude": 118.49176
						},
						{
							"areaId": "130828",
							"areaName": "围场满族蒙古族自治县",
							"latitude": 41.94368,
							"longitude": 117.7601
						}
					]
				},
				{
					"areaId": "1309",
					"areaName": "沧州市",
					"latitude": 38.310582,
					"longitude": 116.857461,
					"children": [{
							"areaId": "130900",
							"areaName": "沧州市本级",
							"latitude": 38.310582,
							"longitude": 116.857461
						},
						{
							"areaId": "130902",
							"areaName": "新华区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "130903",
							"areaName": "运河区",
							"latitude": 38.31352,
							"longitude": 116.85706
						},
						{
							"areaId": "130921",
							"areaName": "沧县",
							"latitude": 38.29361,
							"longitude": 116.87817
						},
						{
							"areaId": "130922",
							"areaName": "青县",
							"latitude": 38.58345,
							"longitude": 116.80316
						},
						{
							"areaId": "130923",
							"areaName": "东光县",
							"latitude": 37.8857,
							"longitude": 116.53668
						},
						{
							"areaId": "130924",
							"areaName": "海兴县",
							"latitude": 38.13958,
							"longitude": 117.49758
						},
						{
							"areaId": "130925",
							"areaName": "盐山县",
							"latitude": 38.05647,
							"longitude": 117.23092
						},
						{
							"areaId": "130926",
							"areaName": "肃宁县",
							"latitude": 38.42272,
							"longitude": 115.82971
						},
						{
							"areaId": "130927",
							"areaName": "南皮县",
							"latitude": 38.04109,
							"longitude": 116.70224
						},
						{
							"areaId": "130928",
							"areaName": "吴桥县",
							"latitude": 37.62546,
							"longitude": 116.3847
						},
						{
							"areaId": "130929",
							"areaName": "献县",
							"latitude": 38.19228,
							"longitude": 116.12695
						},
						{
							"areaId": "130930",
							"areaName": "孟村回族自治县",
							"latitude": 38.05338,
							"longitude": 117.10412
						},
						{
							"areaId": "130981",
							"areaName": "泊头市",
							"latitude": 38.08359,
							"longitude": 116.57824
						},
						{
							"areaId": "130982",
							"areaName": "任丘市",
							"latitude": 38.71124,
							"longitude": 116.1033
						},
						{
							"areaId": "130983",
							"areaName": "黄骅市",
							"latitude": 38.3706,
							"longitude": 117.33883
						},
						{
							"areaId": "130984",
							"areaName": "河间市",
							"latitude": 38.44549,
							"longitude": 116.0993
						}
					]
				},
				{
					"areaId": "1310",
					"areaName": "廊坊市",
					"latitude": 39.529244,
					"longitude": 116.713873,
					"children": [{
							"areaId": "131000",
							"areaName": "廊坊市本级",
							"latitude": 39.529244,
							"longitude": 116.713873
						},
						{
							"areaId": "131002",
							"areaName": "安次区",
							"latitude": 39.52057,
							"longitude": 116.70308
						},
						{
							"areaId": "131003",
							"areaName": "广阳区",
							"latitude": 39.52278,
							"longitude": 116.71069
						},
						{
							"areaId": "131022",
							"areaName": "固安县",
							"latitude": 39.43833,
							"longitude": 116.29916
						},
						{
							"areaId": "131023",
							"areaName": "永清县",
							"latitude": 39.32069,
							"longitude": 116.50091
						},
						{
							"areaId": "131024",
							"areaName": "香河县",
							"latitude": 39.76133,
							"longitude": 117.00634
						},
						{
							"areaId": "131025",
							"areaName": "大城县",
							"latitude": 23.852382,
							"longitude": 120.320934
						},
						{
							"areaId": "131026",
							"areaName": "文安县",
							"latitude": 38.87325,
							"longitude": 116.45846
						},
						{
							"areaId": "131028",
							"areaName": "大厂回族自治县",
							"latitude": 39.88649,
							"longitude": 116.98916
						},
						{
							"areaId": "131081",
							"areaName": "霸州市",
							"latitude": 39.12569,
							"longitude": 116.39154
						},
						{
							"areaId": "131082",
							"areaName": "三河市",
							"latitude": 39.98358,
							"longitude": 117.07229
						}
					]
				},
				{
					"areaId": "1311",
					"areaName": "衡水市",
					"latitude": 37.735097,
					"longitude": 115.665993,
					"children": [{
							"areaId": "131100",
							"areaName": "衡水市本级",
							"latitude": 37.735097,
							"longitude": 115.665993
						},
						{
							"areaId": "131102",
							"areaName": "桃城区",
							"latitude": 37.73499,
							"longitude": 115.67529
						},
						{
							"areaId": "131121",
							"areaName": "枣强县",
							"latitude": 37.51027,
							"longitude": 115.72576
						},
						{
							"areaId": "131122",
							"areaName": "武邑县",
							"latitude": 37.80181,
							"longitude": 115.88748
						},
						{
							"areaId": "131123",
							"areaName": "武强县",
							"latitude": 38.04138,
							"longitude": 115.98226
						},
						{
							"areaId": "131124",
							"areaName": "饶阳县",
							"latitude": 38.23529,
							"longitude": 115.72558
						},
						{
							"areaId": "131125",
							"areaName": "安平县",
							"latitude": 23.000763,
							"longitude": 120.16681
						},
						{
							"areaId": "131126",
							"areaName": "故城县",
							"latitude": 37.34773,
							"longitude": 115.97076
						},
						{
							"areaId": "131127",
							"areaName": "景县",
							"latitude": 37.6926,
							"longitude": 116.26904
						},
						{
							"areaId": "131128",
							"areaName": "阜城县",
							"latitude": 37.86881,
							"longitude": 116.14431
						},
						{
							"areaId": "131181",
							"areaName": "冀州市",
							"latitude": 37.735097,
							"longitude": 115.665993
						},
						{
							"areaId": "131182",
							"areaName": "深州市",
							"latitude": 38.00109,
							"longitude": 115.55993
						}
					]
				}
			]
		},
		{
			"areaId": "14",
			"areaName": "山西省",
			"latitude": 37.857014,
			"longitude": 112.549248,
			"children": [{
					"areaId": "1401",
					"areaName": "太原市",
					"latitude": 37.857014,
					"longitude": 112.549248,
					"children": [{
							"areaId": "140100",
							"areaName": "太原市本级",
							"latitude": 37.857014,
							"longitude": 112.549248
						},
						{
							"areaId": "140105",
							"areaName": "小店区",
							"latitude": 37.73565,
							"longitude": 112.56878
						},
						{
							"areaId": "140106",
							"areaName": "迎泽区",
							"latitude": 37.86326,
							"longitude": 112.56338
						},
						{
							"areaId": "140107",
							"areaName": "杏花岭区",
							"latitude": 37.88429,
							"longitude": 112.56237
						},
						{
							"areaId": "140108",
							"areaName": "尖草坪区",
							"latitude": 37.94193,
							"longitude": 112.48709
						},
						{
							"areaId": "140109",
							"areaName": "万柏林区",
							"latitude": 37.85923,
							"longitude": 112.51553
						},
						{
							"areaId": "140110",
							"areaName": "晋源区",
							"latitude": 37.72479,
							"longitude": 112.47985
						},
						{
							"areaId": "140121",
							"areaName": "清徐县",
							"latitude": 37.60758,
							"longitude": 112.35888
						},
						{
							"areaId": "140122",
							"areaName": "阳曲县",
							"latitude": 38.05989,
							"longitude": 112.67861
						},
						{
							"areaId": "140123",
							"areaName": "娄烦县",
							"latitude": 38.06689,
							"longitude": 111.79473
						},
						{
							"areaId": "140181",
							"areaName": "古交市",
							"latitude": 37.90983,
							"longitude": 112.16918
						}
					]
				},
				{
					"areaId": "1402",
					"areaName": "大同市",
					"latitude": 24.675997,
					"longitude": 121.605557,
					"children": [{
							"areaId": "140200",
							"areaName": "大同市本级",
							"latitude": 24.675997,
							"longitude": 121.605557
						},
						{
							"areaId": "140202",
							"areaName": "城区",
							"latitude": 24.675997,
							"longitude": 121.605557
						},
						{
							"areaId": "140203",
							"areaName": "矿区",
							"latitude": 24.675997,
							"longitude": 121.605557
						},
						{
							"areaId": "140211",
							"areaName": "南郊区",
							"latitude": 24.675997,
							"longitude": 121.605557
						},
						{
							"areaId": "140212",
							"areaName": "新荣区",
							"latitude": 40.25618,
							"longitude": 113.13504
						},
						{
							"areaId": "140221",
							"areaName": "阳高县",
							"latitude": 40.36256,
							"longitude": 113.75012
						},
						{
							"areaId": "140222",
							"areaName": "天镇县",
							"latitude": 40.42299,
							"longitude": 114.0931
						},
						{
							"areaId": "140223",
							"areaName": "广灵县",
							"latitude": 39.76082,
							"longitude": 114.28204
						},
						{
							"areaId": "140224",
							"areaName": "灵丘县",
							"latitude": 39.44043,
							"longitude": 114.23672
						},
						{
							"areaId": "140225",
							"areaName": "浑源县",
							"latitude": 39.69962,
							"longitude": 113.69552
						},
						{
							"areaId": "140226",
							"areaName": "左云县",
							"latitude": 40.01336,
							"longitude": 112.70266
						},
						{
							"areaId": "140227",
							"areaName": "大同县",
							"latitude": 24.675997,
							"longitude": 121.605557
						}
					]
				},
				{
					"areaId": "1403",
					"areaName": "阳泉市",
					"latitude": 37.861188,
					"longitude": 113.583285,
					"children": [{
							"areaId": "140300",
							"areaName": "阳泉市本级",
							"latitude": 37.861188,
							"longitude": 113.583285
						},
						{
							"areaId": "140302",
							"areaName": "城区",
							"latitude": 22.32673,
							"longitude": 114.195053
						},
						{
							"areaId": "140303",
							"areaName": "矿区",
							"latitude": 37.86895,
							"longitude": 113.55677
						},
						{
							"areaId": "140311",
							"areaName": "郊区",
							"latitude": 30.91976,
							"longitude": 117.80868
						},
						{
							"areaId": "140321",
							"areaName": "平定县",
							"latitude": 37.78601,
							"longitude": 113.65789
						},
						{
							"areaId": "140322",
							"areaName": "盂县",
							"latitude": 38.08579,
							"longitude": 113.41235
						}
					]
				},
				{
					"areaId": "1404",
					"areaName": "长治市",
					"latitude": 22.677062,
					"longitude": 120.527614,
					"children": [{
							"areaId": "140400",
							"areaName": "长治市本级",
							"latitude": 22.677062,
							"longitude": 120.527614
						},
						{
							"areaId": "140402",
							"areaName": "城区",
							"latitude": 22.677062,
							"longitude": 120.527614
						},
						{
							"areaId": "140411",
							"areaName": "郊区",
							"latitude": 22.677062,
							"longitude": 120.527614
						},
						{
							"areaId": "140421",
							"areaName": "长治县",
							"latitude": 22.677062,
							"longitude": 120.527614
						},
						{
							"areaId": "140423",
							"areaName": "襄垣县",
							"latitude": 36.53527,
							"longitude": 113.05157
						},
						{
							"areaId": "140424",
							"areaName": "屯留县",
							"latitude": 22.677062,
							"longitude": 120.527614
						},
						{
							"areaId": "140425",
							"areaName": "平顺县",
							"latitude": 36.20005,
							"longitude": 113.43603
						},
						{
							"areaId": "140426",
							"areaName": "黎城县",
							"latitude": 36.50301,
							"longitude": 113.38766
						},
						{
							"areaId": "140427",
							"areaName": "壶关县",
							"latitude": 36.11301,
							"longitude": 113.207
						},
						{
							"areaId": "140428",
							"areaName": "长子县",
							"latitude": 36.12125,
							"longitude": 112.87731
						},
						{
							"areaId": "140429",
							"areaName": "武乡县",
							"latitude": 36.83687,
							"longitude": 112.86343
						},
						{
							"areaId": "140430",
							"areaName": "沁县",
							"latitude": 36.75628,
							"longitude": 112.69863
						},
						{
							"areaId": "140431",
							"areaName": "沁源县",
							"latitude": 36.50008,
							"longitude": 112.33758
						},
						{
							"areaId": "140481",
							"areaName": "潞城市",
							"latitude": 22.677062,
							"longitude": 120.527614
						}
					]
				},
				{
					"areaId": "1405",
					"areaName": "晋城市",
					"latitude": 35.497553,
					"longitude": 112.851274,
					"children": [{
							"areaId": "140500",
							"areaName": "晋城市本级",
							"latitude": 35.497553,
							"longitude": 112.851274
						},
						{
							"areaId": "140502",
							"areaName": "城区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "140521",
							"areaName": "沁水县",
							"latitude": 35.69102,
							"longitude": 112.1871
						},
						{
							"areaId": "140522",
							"areaName": "阳城县",
							"latitude": 35.48614,
							"longitude": 112.41485
						},
						{
							"areaId": "140524",
							"areaName": "陵川县",
							"latitude": 35.77532,
							"longitude": 113.2806
						},
						{
							"areaId": "140525",
							"areaName": "泽州县",
							"latitude": 35.50789,
							"longitude": 112.83947
						},
						{
							"areaId": "140581",
							"areaName": "高平市",
							"latitude": 35.79705,
							"longitude": 112.92288
						}
					]
				},
				{
					"areaId": "1406",
					"areaName": "朔州市",
					"latitude": 39.331261,
					"longitude": 112.433387,
					"children": [{
							"areaId": "140600",
							"areaName": "朔州市本级",
							"latitude": 39.331261,
							"longitude": 112.433387
						},
						{
							"areaId": "140602",
							"areaName": "朔城区",
							"latitude": 39.31982,
							"longitude": 112.43189
						},
						{
							"areaId": "140603",
							"areaName": "平鲁区",
							"latitude": 39.51155,
							"longitude": 112.28833
						},
						{
							"areaId": "140621",
							"areaName": "山阴县",
							"latitude": 39.52697,
							"longitude": 112.81662
						},
						{
							"areaId": "140622",
							"areaName": "应县",
							"latitude": 39.55279,
							"longitude": 113.19052
						},
						{
							"areaId": "140623",
							"areaName": "右玉县",
							"latitude": 39.99011,
							"longitude": 112.46902
						},
						{
							"areaId": "140624",
							"areaName": "怀仁县",
							"latitude": 39.331261,
							"longitude": 112.433387
						}
					]
				},
				{
					"areaId": "1407",
					"areaName": "晋中市",
					"latitude": 37.696495,
					"longitude": 112.736465,
					"children": [{
							"areaId": "140700",
							"areaName": "晋中市本级",
							"latitude": 37.696495,
							"longitude": 112.736465
						},
						{
							"areaId": "140702",
							"areaName": "榆次区",
							"latitude": 37.6978,
							"longitude": 112.70788
						},
						{
							"areaId": "140721",
							"areaName": "榆社县",
							"latitude": 37.0721,
							"longitude": 112.97558
						},
						{
							"areaId": "140722",
							"areaName": "左权县",
							"latitude": 37.08235,
							"longitude": 113.37918
						},
						{
							"areaId": "140723",
							"areaName": "和顺县",
							"latitude": 37.32963,
							"longitude": 113.56988
						},
						{
							"areaId": "140724",
							"areaName": "昔阳县",
							"latitude": 37.61863,
							"longitude": 113.70517
						},
						{
							"areaId": "140725",
							"areaName": "寿阳县",
							"latitude": 37.88899,
							"longitude": 113.17495
						},
						{
							"areaId": "140726",
							"areaName": "太谷县",
							"latitude": 37.696495,
							"longitude": 112.736465
						},
						{
							"areaId": "140727",
							"areaName": "祁县",
							"latitude": 37.3579,
							"longitude": 112.33358
						},
						{
							"areaId": "140728",
							"areaName": "平遥县",
							"latitude": 37.1892,
							"longitude": 112.17553
						},
						{
							"areaId": "140729",
							"areaName": "灵石县",
							"latitude": 36.84814,
							"longitude": 111.7774
						},
						{
							"areaId": "140781",
							"areaName": "介休市",
							"latitude": 37.02771,
							"longitude": 111.91824
						}
					]
				},
				{
					"areaId": "1408",
					"areaName": "运城市",
					"latitude": 35.022778,
					"longitude": 111.003957,
					"children": [{
							"areaId": "140800",
							"areaName": "运城市本级",
							"latitude": 35.022778,
							"longitude": 111.003957
						},
						{
							"areaId": "140802",
							"areaName": "盐湖区",
							"latitude": 35.0151,
							"longitude": 110.99827
						},
						{
							"areaId": "140821",
							"areaName": "临猗县",
							"latitude": 35.14455,
							"longitude": 110.77432
						},
						{
							"areaId": "140822",
							"areaName": "万荣县",
							"latitude": 23.715346,
							"longitude": 121.407493
						},
						{
							"areaId": "140823",
							"areaName": "闻喜县",
							"latitude": 35.35553,
							"longitude": 111.22265
						},
						{
							"areaId": "140824",
							"areaName": "稷山县",
							"latitude": 35.59993,
							"longitude": 110.97924
						},
						{
							"areaId": "140825",
							"areaName": "新绛县",
							"latitude": 35.61566,
							"longitude": 111.22509
						},
						{
							"areaId": "140826",
							"areaName": "绛县",
							"latitude": 35.49096,
							"longitude": 111.56668
						},
						{
							"areaId": "140827",
							"areaName": "垣曲县",
							"latitude": 35.29923,
							"longitude": 111.67166
						},
						{
							"areaId": "140828",
							"areaName": "夏县",
							"latitude": 35.14121,
							"longitude": 111.21966
						},
						{
							"areaId": "140829",
							"areaName": "平陆县",
							"latitude": 34.83772,
							"longitude": 111.21704
						},
						{
							"areaId": "140830",
							"areaName": "芮城县",
							"latitude": 34.69384,
							"longitude": 110.69455
						},
						{
							"areaId": "140881",
							"areaName": "永济市",
							"latitude": 34.86556,
							"longitude": 110.44537
						},
						{
							"areaId": "140882",
							"areaName": "河津市",
							"latitude": 35.59478,
							"longitude": 110.7116
						}
					]
				},
				{
					"areaId": "1409",
					"areaName": "忻州市",
					"latitude": 38.41769,
					"longitude": 112.733538,
					"children": [{
							"areaId": "140900",
							"areaName": "忻州市本级",
							"latitude": 38.41769,
							"longitude": 112.733538
						},
						{
							"areaId": "140902",
							"areaName": "忻府区",
							"latitude": 38.40414,
							"longitude": 112.74603
						},
						{
							"areaId": "140921",
							"areaName": "定襄县",
							"latitude": 38.47387,
							"longitude": 112.95733
						},
						{
							"areaId": "140922",
							"areaName": "五台县",
							"latitude": 38.72774,
							"longitude": 113.25256
						},
						{
							"areaId": "140923",
							"areaName": "代县",
							"latitude": 39.06717,
							"longitude": 112.95913
						},
						{
							"areaId": "140924",
							"areaName": "繁峙县",
							"latitude": 39.18886,
							"longitude": 113.26303
						},
						{
							"areaId": "140925",
							"areaName": "宁武县",
							"latitude": 39.00211,
							"longitude": 112.30423
						},
						{
							"areaId": "140926",
							"areaName": "静乐县",
							"latitude": 38.3602,
							"longitude": 111.94158
						},
						{
							"areaId": "140927",
							"areaName": "神池县",
							"latitude": 39.09,
							"longitude": 112.20541
						},
						{
							"areaId": "140928",
							"areaName": "五寨县",
							"latitude": 38.90757,
							"longitude": 111.8489
						},
						{
							"areaId": "140929",
							"areaName": "岢岚县",
							"latitude": 38.70452,
							"longitude": 111.57388
						},
						{
							"areaId": "140930",
							"areaName": "河曲县",
							"latitude": 39.38439,
							"longitude": 111.13821
						},
						{
							"areaId": "140931",
							"areaName": "保德县",
							"latitude": 39.02248,
							"longitude": 111.08656
						},
						{
							"areaId": "140932",
							"areaName": "偏关县",
							"latitude": 39.43609,
							"longitude": 111.50863
						},
						{
							"areaId": "140981",
							"areaName": "原平市",
							"latitude": 38.73181,
							"longitude": 112.70584
						}
					]
				},
				{
					"areaId": "1410",
					"areaName": "临汾市",
					"latitude": 36.08415,
					"longitude": 111.517973,
					"children": [{
							"areaId": "141000",
							"areaName": "临汾市本级",
							"latitude": 36.08415,
							"longitude": 111.517973
						},
						{
							"areaId": "141002",
							"areaName": "尧都区",
							"latitude": 36.08298,
							"longitude": 111.5787
						},
						{
							"areaId": "141021",
							"areaName": "曲沃县",
							"latitude": 35.64119,
							"longitude": 111.47525
						},
						{
							"areaId": "141022",
							"areaName": "翼城县",
							"latitude": 35.73881,
							"longitude": 111.7181
						},
						{
							"areaId": "141023",
							"areaName": "襄汾县",
							"latitude": 35.87711,
							"longitude": 111.44204
						},
						{
							"areaId": "141024",
							"areaName": "洪洞县",
							"latitude": 36.25425,
							"longitude": 111.67501
						},
						{
							"areaId": "141025",
							"areaName": "古县",
							"latitude": 36.26688,
							"longitude": 111.92041
						},
						{
							"areaId": "141026",
							"areaName": "安泽县",
							"latitude": 36.14803,
							"longitude": 112.24981
						},
						{
							"areaId": "141027",
							"areaName": "浮山县",
							"latitude": 35.96854,
							"longitude": 111.84744
						},
						{
							"areaId": "141028",
							"areaName": "吉县",
							"latitude": 36.09873,
							"longitude": 110.68148
						},
						{
							"areaId": "141029",
							"areaName": "乡宁县",
							"latitude": 35.97072,
							"longitude": 110.84652
						},
						{
							"areaId": "141030",
							"areaName": "大宁县",
							"latitude": 36.46624,
							"longitude": 110.75216
						},
						{
							"areaId": "141031",
							"areaName": "隰县",
							"latitude": 36.69258,
							"longitude": 110.93881
						},
						{
							"areaId": "141032",
							"areaName": "永和县",
							"latitude": 25.007802,
							"longitude": 121.51366
						},
						{
							"areaId": "141033",
							"areaName": "蒲县",
							"latitude": 36.41243,
							"longitude": 111.09674
						},
						{
							"areaId": "141034",
							"areaName": "汾西县",
							"latitude": 36.65063,
							"longitude": 111.56811
						},
						{
							"areaId": "141081",
							"areaName": "侯马市",
							"latitude": 35.61903,
							"longitude": 111.37207
						},
						{
							"areaId": "141082",
							"areaName": "霍州市",
							"latitude": 36.5638,
							"longitude": 111.755
						}
					]
				},
				{
					"areaId": "1411",
					"areaName": "吕梁市",
					"latitude": 37.524366,
					"longitude": 111.134335,
					"children": [{
							"areaId": "141100",
							"areaName": "吕梁市本级",
							"latitude": 37.524366,
							"longitude": 111.134335
						},
						{
							"areaId": "141102",
							"areaName": "离石区",
							"latitude": 37.5177,
							"longitude": 111.15059
						},
						{
							"areaId": "141121",
							"areaName": "文水县",
							"latitude": 37.43841,
							"longitude": 112.02829
						},
						{
							"areaId": "141122",
							"areaName": "交城县",
							"latitude": 37.5512,
							"longitude": 112.1585
						},
						{
							"areaId": "141123",
							"areaName": "兴县",
							"latitude": 38.46321,
							"longitude": 111.12692
						},
						{
							"areaId": "141124",
							"areaName": "临县",
							"latitude": 37.95271,
							"longitude": 110.99282
						},
						{
							"areaId": "141125",
							"areaName": "柳林县",
							"latitude": 37.42932,
							"longitude": 110.88922
						},
						{
							"areaId": "141126",
							"areaName": "石楼县",
							"latitude": 36.99731,
							"longitude": 110.8352
						},
						{
							"areaId": "141127",
							"areaName": "岚县",
							"latitude": 38.27874,
							"longitude": 111.67627
						},
						{
							"areaId": "141128",
							"areaName": "方山县",
							"latitude": 37.88979,
							"longitude": 111.24011
						},
						{
							"areaId": "141129",
							"areaName": "中阳县",
							"latitude": 37.35715,
							"longitude": 111.1795
						},
						{
							"areaId": "141130",
							"areaName": "交口县",
							"latitude": 36.98213,
							"longitude": 111.18103
						},
						{
							"areaId": "141181",
							"areaName": "孝义市",
							"latitude": 37.14414,
							"longitude": 111.77362
						},
						{
							"areaId": "141182",
							"areaName": "汾阳市",
							"latitude": 37.26605,
							"longitude": 111.7882
						}
					]
				}
			]
		},
		{
			"areaId": "15",
			"areaName": "内蒙古",
			"latitude": 40.818311,
			"longitude": 111.670801,
			"children": [{
					"areaId": "1501",
					"areaName": "呼和浩特市",
					"latitude": 40.818311,
					"longitude": 111.670801,
					"children": [{
							"areaId": "150100",
							"areaName": "呼和浩特市本级",
							"latitude": 40.818311,
							"longitude": 111.670801
						},
						{
							"areaId": "150102",
							"areaName": "新城区",
							"latitude": 34.26641,
							"longitude": 108.9608
						},
						{
							"areaId": "150103",
							"areaName": "回民区",
							"latitude": 40.80827,
							"longitude": 111.62402
						},
						{
							"areaId": "150104",
							"areaName": "玉泉区",
							"latitude": 40.75227,
							"longitude": 111.67456
						},
						{
							"areaId": "150105",
							"areaName": "赛罕区",
							"latitude": 40.79207,
							"longitude": 111.70224
						},
						{
							"areaId": "150121",
							"areaName": "土默特左旗",
							"latitude": 40.72229,
							"longitude": 111.14898
						},
						{
							"areaId": "150122",
							"areaName": "托克托县",
							"latitude": 40.27492,
							"longitude": 111.19101
						},
						{
							"areaId": "150123",
							"areaName": "和林格尔县",
							"latitude": 40.37892,
							"longitude": 111.82205
						},
						{
							"areaId": "150124",
							"areaName": "清水河县",
							"latitude": 24.26865,
							"longitude": 120.55978
						},
						{
							"areaId": "150125",
							"areaName": "武川县",
							"latitude": 41.09289,
							"longitude": 111.45785
						}
					]
				},
				{
					"areaId": "1502",
					"areaName": "包头市",
					"latitude": 40.658168,
					"longitude": 109.840405,
					"children": [{
							"areaId": "150200",
							"areaName": "包头市本级",
							"latitude": 40.658168,
							"longitude": 109.840405
						},
						{
							"areaId": "150202",
							"areaName": "东河区",
							"latitude": 22.969934,
							"longitude": 121.300334
						},
						{
							"areaId": "150203",
							"areaName": "昆都仑区",
							"latitude": 40.64175,
							"longitude": 109.83862
						},
						{
							"areaId": "150204",
							"areaName": "青山区",
							"latitude": 30.63427,
							"longitude": 114.39117
						},
						{
							"areaId": "150205",
							"areaName": "石拐区",
							"latitude": 40.67297,
							"longitude": 110.27322
						},
						{
							"areaId": "150206",
							"areaName": "白云矿区",
							"latitude": 41.76968,
							"longitude": 109.97367
						},
						{
							"areaId": "150207",
							"areaName": "九原区",
							"latitude": 40.60554,
							"longitude": 109.96496
						},
						{
							"areaId": "150221",
							"areaName": "土默特右旗",
							"latitude": 40.5688,
							"longitude": 110.52417
						},
						{
							"areaId": "150222",
							"areaName": "固阳县",
							"latitude": 41.01851,
							"longitude": 110.06372
						},
						{
							"areaId": "150223",
							"areaName": "达尔罕茂明安联合旗",
							"latitude": 41.69875,
							"longitude": 110.43258
						}
					]
				},
				{
					"areaId": "1503",
					"areaName": "乌海市",
					"latitude": 39.673734,
					"longitude": 106.825563,
					"children": [{
							"areaId": "150300",
							"areaName": "乌海市本级",
							"latitude": 39.673734,
							"longitude": 106.825563
						},
						{
							"areaId": "150302",
							"areaName": "海勃湾区",
							"latitude": 39.66955,
							"longitude": 106.8222
						},
						{
							"areaId": "150303",
							"areaName": "海南区",
							"latitude": 39.44128,
							"longitude": 106.88656
						},
						{
							"areaId": "150304",
							"areaName": "乌达区",
							"latitude": 39.505,
							"longitude": 106.72723
						}
					]
				},
				{
					"areaId": "1504",
					"areaName": "赤峰市",
					"latitude": 42.275317,
					"longitude": 118.956806,
					"children": [{
							"areaId": "150400",
							"areaName": "赤峰市本级",
							"latitude": 42.275317,
							"longitude": 118.956806
						},
						{
							"areaId": "150402",
							"areaName": "红山区",
							"latitude": 42.24312,
							"longitude": 118.95755
						},
						{
							"areaId": "150403",
							"areaName": "元宝山区",
							"latitude": 24.760975,
							"longitude": 120.985752
						},
						{
							"areaId": "150404",
							"areaName": "松山区",
							"latitude": 25.049698,
							"longitude": 121.577206
						},
						{
							"areaId": "150421",
							"areaName": "阿鲁科尔沁旗",
							"latitude": 43.87988,
							"longitude": 120.06527
						},
						{
							"areaId": "150422",
							"areaName": "巴林左旗",
							"latitude": 43.97031,
							"longitude": 119.38012
						},
						{
							"areaId": "150423",
							"areaName": "巴林右旗",
							"latitude": 43.53387,
							"longitude": 118.66461
						},
						{
							"areaId": "150424",
							"areaName": "林西县",
							"latitude": 43.61165,
							"longitude": 118.04733
						},
						{
							"areaId": "150425",
							"areaName": "克什克腾旗",
							"latitude": 43.26501,
							"longitude": 117.54562
						},
						{
							"areaId": "150426",
							"areaName": "翁牛特旗",
							"latitude": 42.93147,
							"longitude": 119.03042
						},
						{
							"areaId": "150428",
							"areaName": "喀喇沁旗",
							"latitude": 41.92917,
							"longitude": 118.70144
						},
						{
							"areaId": "150429",
							"areaName": "宁城县",
							"latitude": 41.59661,
							"longitude": 119.34375
						},
						{
							"areaId": "150430",
							"areaName": "敖汉旗",
							"latitude": 42.29071,
							"longitude": 119.92163
						}
					]
				},
				{
					"areaId": "1505",
					"areaName": "通辽市",
					"latitude": 43.617429,
					"longitude": 122.263119,
					"children": [{
							"areaId": "150500",
							"areaName": "通辽市本级",
							"latitude": 43.617429,
							"longitude": 122.263119
						},
						{
							"areaId": "150502",
							"areaName": "科尔沁区",
							"latitude": 43.62257,
							"longitude": 122.25573
						},
						{
							"areaId": "150521",
							"areaName": "科尔沁左翼中旗",
							"latitude": 44.13014,
							"longitude": 123.31912
						},
						{
							"areaId": "150522",
							"areaName": "科尔沁左翼后旗",
							"latitude": 42.94897,
							"longitude": 122.35745
						},
						{
							"areaId": "150523",
							"areaName": "开鲁县",
							"latitude": 43.60003,
							"longitude": 121.31884
						},
						{
							"areaId": "150524",
							"areaName": "库伦旗",
							"latitude": 42.72998,
							"longitude": 121.776
						},
						{
							"areaId": "150525",
							"areaName": "奈曼旗",
							"latitude": 42.84527,
							"longitude": 120.66348
						},
						{
							"areaId": "150526",
							"areaName": "扎鲁特旗",
							"latitude": 44.55592,
							"longitude": 120.91507
						},
						{
							"areaId": "150581",
							"areaName": "霍林郭勒市",
							"latitude": 45.53454,
							"longitude": 119.65429
						}
					]
				},
				{
					"areaId": "1506",
					"areaName": "鄂尔多斯市",
					"latitude": 39.817179,
					"longitude": 109.99029,
					"children": [{
							"areaId": "150600",
							"areaName": "鄂尔多斯市本级",
							"latitude": 39.817179,
							"longitude": 109.99029
						},
						{
							"areaId": "150602",
							"areaName": "东胜区",
							"latitude": 39.82236,
							"longitude": 109.96289
						},
						{
							"areaId": "150621",
							"areaName": "达拉特旗",
							"latitude": 40.4001,
							"longitude": 110.03317
						},
						{
							"areaId": "150622",
							"areaName": "准格尔旗",
							"latitude": 39.86783,
							"longitude": 111.23645
						},
						{
							"areaId": "150623",
							"areaName": "鄂托克前旗",
							"latitude": 38.18396,
							"longitude": 107.48403
						},
						{
							"areaId": "150624",
							"areaName": "鄂托克旗",
							"latitude": 39.09456,
							"longitude": 107.98226
						},
						{
							"areaId": "150625",
							"areaName": "杭锦旗",
							"latitude": 39.84023,
							"longitude": 108.72934
						},
						{
							"areaId": "150626",
							"areaName": "乌审旗",
							"latitude": 38.59092,
							"longitude": 108.8461
						},
						{
							"areaId": "150627",
							"areaName": "伊金霍洛旗",
							"latitude": 39.57393,
							"longitude": 109.74908
						}
					]
				},
				{
					"areaId": "1507",
					"areaName": "呼伦贝尔市",
					"latitude": 49.215333,
					"longitude": 119.758168,
					"children": [{
							"areaId": "150700",
							"areaName": "呼伦贝尔市本级",
							"latitude": 49.215333,
							"longitude": 119.758168
						},
						{
							"areaId": "150702",
							"areaName": "海拉尔区",
							"latitude": 49.2122,
							"longitude": 119.7364
						},
						{
							"areaId": "150721",
							"areaName": "阿荣旗",
							"latitude": 48.12581,
							"longitude": 123.45941
						},
						{
							"areaId": "150722",
							"areaName": "莫力达瓦达斡尔族自治旗",
							"latitude": 48.48055,
							"longitude": 124.51498
						},
						{
							"areaId": "150723",
							"areaName": "鄂伦春自治旗",
							"latitude": 50.59777,
							"longitude": 123.72604
						},
						{
							"areaId": "150724",
							"areaName": "鄂温克族自治旗",
							"latitude": 49.14284,
							"longitude": 119.7565
						},
						{
							"areaId": "150725",
							"areaName": "陈巴尔虎旗",
							"latitude": 49.32684,
							"longitude": 119.42434
						},
						{
							"areaId": "150726",
							"areaName": "新巴尔虎左旗",
							"latitude": 48.21842,
							"longitude": 118.26989
						},
						{
							"areaId": "150727",
							"areaName": "新巴尔虎右旗",
							"latitude": 48.66473,
							"longitude": 116.82366
						},
						{
							"areaId": "150781",
							"areaName": "满洲里市",
							"latitude": 49.58272,
							"longitude": 117.47946
						},
						{
							"areaId": "150782",
							"areaName": "牙克石市",
							"latitude": 49.2856,
							"longitude": 120.7117
						},
						{
							"areaId": "150783",
							"areaName": "扎兰屯市",
							"latitude": 48.01363,
							"longitude": 122.73757
						},
						{
							"areaId": "150784",
							"areaName": "额尔古纳市",
							"latitude": 50.24249,
							"longitude": 120.19094
						},
						{
							"areaId": "150785",
							"areaName": "根河市",
							"latitude": 50.77996,
							"longitude": 121.52197
						}
					]
				},
				{
					"areaId": "1508",
					"areaName": "巴彦淖尔市",
					"latitude": 40.757402,
					"longitude": 107.416959,
					"children": [{
							"areaId": "150800",
							"areaName": "巴彦淖尔市本级",
							"latitude": 40.757402,
							"longitude": 107.416959
						},
						{
							"areaId": "150802",
							"areaName": "临河区",
							"latitude": 40.75827,
							"longitude": 107.42668
						},
						{
							"areaId": "150821",
							"areaName": "五原县",
							"latitude": 41.09631,
							"longitude": 108.26916
						},
						{
							"areaId": "150822",
							"areaName": "磴口县",
							"latitude": 40.33062,
							"longitude": 107.00936
						},
						{
							"areaId": "150823",
							"areaName": "乌拉特前旗",
							"latitude": 40.73649,
							"longitude": 108.65219
						},
						{
							"areaId": "150824",
							"areaName": "乌拉特中旗",
							"latitude": 41.56789,
							"longitude": 108.52587
						},
						{
							"areaId": "150825",
							"areaName": "乌拉特后旗",
							"latitude": 41.43151,
							"longitude": 106.98971
						},
						{
							"areaId": "150826",
							"areaName": "杭锦后旗",
							"latitude": 40.88627,
							"longitude": 107.15133
						}
					]
				},
				{
					"areaId": "1509",
					"areaName": "乌兰察布市",
					"latitude": 41.034126,
					"longitude": 113.114543,
					"children": [{
							"areaId": "150900",
							"areaName": "乌兰察布市本级",
							"latitude": 41.034126,
							"longitude": 113.114543
						},
						{
							"areaId": "150902",
							"areaName": "集宁区",
							"latitude": 41.0353,
							"longitude": 113.11452
						},
						{
							"areaId": "150921",
							"areaName": "卓资县",
							"latitude": 40.89414,
							"longitude": 112.57757
						},
						{
							"areaId": "150922",
							"areaName": "化德县",
							"latitude": 41.90433,
							"longitude": 114.01071
						},
						{
							"areaId": "150923",
							"areaName": "商都县",
							"latitude": 41.56213,
							"longitude": 113.57772
						},
						{
							"areaId": "150924",
							"areaName": "兴和县",
							"latitude": 40.87186,
							"longitude": 113.83395
						},
						{
							"areaId": "150925",
							"areaName": "凉城县",
							"latitude": 40.53346,
							"longitude": 112.49569
						},
						{
							"areaId": "150926",
							"areaName": "察哈尔右翼前旗",
							"latitude": 40.7788,
							"longitude": 113.22131
						},
						{
							"areaId": "150927",
							"areaName": "察哈尔右翼中旗",
							"latitude": 41.27742,
							"longitude": 112.63537
						},
						{
							"areaId": "150928",
							"areaName": "察哈尔右翼后旗",
							"latitude": 41.43554,
							"longitude": 113.19216
						},
						{
							"areaId": "150929",
							"areaName": "四子王旗",
							"latitude": 41.53312,
							"longitude": 111.70654
						},
						{
							"areaId": "150981",
							"areaName": "丰镇市",
							"latitude": 40.4369,
							"longitude": 113.10983
						}
					]
				},
				{
					"areaId": "1522",
					"areaName": "兴安盟",
					"latitude": 46.076268,
					"longitude": 122.070317,
					"children": [{
							"areaId": "152200",
							"areaName": "兴安盟本级",
							"latitude": 46.076268,
							"longitude": 122.070317
						},
						{
							"areaId": "152201",
							"areaName": "乌兰浩特市",
							"latitude": 46.06235,
							"longitude": 122.06378
						},
						{
							"areaId": "152202",
							"areaName": "阿尔山市",
							"latitude": 47.17716,
							"longitude": 119.94317
						},
						{
							"areaId": "152221",
							"areaName": "科尔沁右翼前旗",
							"latitude": 46.0795,
							"longitude": 121.95269
						},
						{
							"areaId": "152222",
							"areaName": "科尔沁右翼中旗",
							"latitude": 45.05605,
							"longitude": 121.46807
						},
						{
							"areaId": "152223",
							"areaName": "扎赉特旗",
							"latitude": 46.7267,
							"longitude": 122.91229
						},
						{
							"areaId": "152224",
							"areaName": "突泉县",
							"latitude": 45.38187,
							"longitude": 121.59396
						}
					]
				},
				{
					"areaId": "1525",
					"areaName": "锡林郭勒盟",
					"latitude": 43.944018,
					"longitude": 116.090996,
					"children": [{
							"areaId": "152500",
							"areaName": "锡林郭勒盟本级",
							"latitude": 43.944018,
							"longitude": 116.090996
						},
						{
							"areaId": "152501",
							"areaName": "二连浩特市",
							"latitude": 43.65303,
							"longitude": 111.98297
						},
						{
							"areaId": "152502",
							"areaName": "锡林浩特市",
							"latitude": 43.93341,
							"longitude": 116.08603
						},
						{
							"areaId": "152522",
							"areaName": "阿巴嘎旗",
							"latitude": 44.02174,
							"longitude": 114.96826
						},
						{
							"areaId": "152523",
							"areaName": "苏尼特左旗",
							"latitude": 43.85687,
							"longitude": 113.6506
						},
						{
							"areaId": "152524",
							"areaName": "苏尼特右旗",
							"latitude": 42.7469,
							"longitude": 112.65741
						},
						{
							"areaId": "152525",
							"areaName": "东乌珠穆沁旗",
							"latitude": 45.51108,
							"longitude": 116.97293
						},
						{
							"areaId": "152526",
							"areaName": "西乌珠穆沁旗",
							"latitude": 44.59623,
							"longitude": 117.60983
						},
						{
							"areaId": "152527",
							"areaName": "太仆寺旗",
							"latitude": 41.87727,
							"longitude": 115.28302
						},
						{
							"areaId": "152528",
							"areaName": "镶黄旗",
							"latitude": 42.23927,
							"longitude": 113.84472
						},
						{
							"areaId": "152529",
							"areaName": "正镶白旗",
							"latitude": 42.30712,
							"longitude": 115.00067
						},
						{
							"areaId": "152530",
							"areaName": "正蓝旗",
							"latitude": 42.25229,
							"longitude": 116.00363
						},
						{
							"areaId": "152531",
							"areaName": "多伦县",
							"latitude": 42.203,
							"longitude": 116.48565
						}
					]
				},
				{
					"areaId": "1529",
					"areaName": "阿拉善盟",
					"latitude": 38.844814,
					"longitude": 105.706422,
					"children": [{
							"areaId": "152900",
							"areaName": "阿拉善盟本级",
							"latitude": 38.844814,
							"longitude": 105.706422
						},
						{
							"areaId": "152921",
							"areaName": "阿拉善左旗",
							"latitude": 38.8293,
							"longitude": 105.67532
						},
						{
							"areaId": "152922",
							"areaName": "阿拉善右旗",
							"latitude": 39.21533,
							"longitude": 101.66705
						},
						{
							"areaId": "152923",
							"areaName": "额济纳旗",
							"latitude": 41.96755,
							"longitude": 101.06887
						}
					]
				}
			]
		},
		{
			"areaId": "21",
			"areaName": "辽宁省",
			"latitude": 41.796767,
			"longitude": 123.429096,
			"children": [{
					"areaId": "2101",
					"areaName": "沈阳市",
					"latitude": 41.796767,
					"longitude": 123.429096,
					"children": [{
							"areaId": "210100",
							"areaName": "沈阳市本级",
							"latitude": 41.796767,
							"longitude": 123.429096
						},
						{
							"areaId": "210102",
							"areaName": "和平区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "210103",
							"areaName": "沈河区",
							"latitude": 41.79625,
							"longitude": 123.45871
						},
						{
							"areaId": "210104",
							"areaName": "大东区",
							"latitude": 41.80539,
							"longitude": 123.46997
						},
						{
							"areaId": "210105",
							"areaName": "皇姑区",
							"latitude": 41.82035,
							"longitude": 123.42527
						},
						{
							"areaId": "210106",
							"areaName": "铁西区",
							"latitude": 43.17456,
							"longitude": 124.37369
						},
						{
							"areaId": "210111",
							"areaName": "苏家屯区",
							"latitude": 41.66475,
							"longitude": 123.34405
						},
						{
							"areaId": "210112",
							"areaName": "东陵区",
							"latitude": 41.71945,
							"longitude": 123.457707
						},
						{
							"areaId": "210113",
							"areaName": "沈北新区",
							"latitude": 42.05297,
							"longitude": 123.52658
						},
						{
							"areaId": "210114",
							"areaName": "于洪区",
							"latitude": 41.794,
							"longitude": 123.30807
						},
						{
							"areaId": "210122",
							"areaName": "辽中县",
							"latitude": 41.796767,
							"longitude": 123.429096
						},
						{
							"areaId": "210123",
							"areaName": "康平县",
							"latitude": 42.75081,
							"longitude": 123.35446
						},
						{
							"areaId": "210124",
							"areaName": "法库县",
							"latitude": 42.50608,
							"longitude": 123.41214
						},
						{
							"areaId": "210181",
							"areaName": "新民市",
							"latitude": 41.99847,
							"longitude": 122.82867
						}
					]
				},
				{
					"areaId": "2102",
					"areaName": "大连市",
					"latitude": 38.91459,
					"longitude": 121.618622,
					"children": [{
							"areaId": "210200",
							"areaName": "大连市本级",
							"latitude": 38.91459,
							"longitude": 121.618622
						},
						{
							"areaId": "210202",
							"areaName": "中山区",
							"latitude": 25.133991,
							"longitude": 121.739132
						},
						{
							"areaId": "210203",
							"areaName": "西岗区",
							"latitude": 38.91469,
							"longitude": 121.61238
						},
						{
							"areaId": "210204",
							"areaName": "沙河口区",
							"latitude": 38.90536,
							"longitude": 121.58017
						},
						{
							"areaId": "210211",
							"areaName": "甘井子区",
							"latitude": 38.95017,
							"longitude": 121.56567
						},
						{
							"areaId": "210212",
							"areaName": "旅顺口区",
							"latitude": 38.85125,
							"longitude": 121.26202
						},
						{
							"areaId": "210213",
							"areaName": "金州区",
							"latitude": 39.1004,
							"longitude": 121.71893
						},
						{
							"areaId": "210224",
							"areaName": "长海县",
							"latitude": 39.27274,
							"longitude": 122.58859
						},
						{
							"areaId": "210281",
							"areaName": "瓦房店市",
							"latitude": 39.62843,
							"longitude": 121.98104
						},
						{
							"areaId": "210282",
							"areaName": "普兰店市",
							"latitude": 38.91459,
							"longitude": 121.618622
						},
						{
							"areaId": "210283",
							"areaName": "庄河市",
							"latitude": 39.68815,
							"longitude": 122.96725
						}
					]
				},
				{
					"areaId": "2103",
					"areaName": "鞍山市",
					"latitude": 41.110626,
					"longitude": 122.995632,
					"children": [{
							"areaId": "210300",
							"areaName": "鞍山市本级",
							"latitude": 41.110626,
							"longitude": 122.995632
						},
						{
							"areaId": "210302",
							"areaName": "铁东区",
							"latitude": 43.16241,
							"longitude": 124.40976
						},
						{
							"areaId": "210303",
							"areaName": "铁西区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "210304",
							"areaName": "立山区",
							"latitude": 41.15008,
							"longitude": 123.02948
						},
						{
							"areaId": "210311",
							"areaName": "千山区",
							"latitude": 41.07507,
							"longitude": 122.96048
						},
						{
							"areaId": "210321",
							"areaName": "台安县",
							"latitude": 41.41265,
							"longitude": 122.43585
						},
						{
							"areaId": "210323",
							"areaName": "岫岩满族自治县",
							"latitude": 40.27996,
							"longitude": 123.28875
						},
						{
							"areaId": "210381",
							"areaName": "海城市",
							"latitude": 40.88142,
							"longitude": 122.68457
						}
					]
				},
				{
					"areaId": "2104",
					"areaName": "抚顺市",
					"latitude": 41.875956,
					"longitude": 123.921109,
					"children": [{
							"areaId": "210400",
							"areaName": "抚顺市本级",
							"latitude": 41.875956,
							"longitude": 123.921109
						},
						{
							"areaId": "210402",
							"areaName": "新抚区",
							"latitude": 41.86205,
							"longitude": 123.91264
						},
						{
							"areaId": "210403",
							"areaName": "东洲区",
							"latitude": 41.8519,
							"longitude": 124.03759
						},
						{
							"areaId": "210404",
							"areaName": "望花区",
							"latitude": 41.85532,
							"longitude": 123.78283
						},
						{
							"areaId": "210411",
							"areaName": "顺城区",
							"latitude": 41.88321,
							"longitude": 123.94506
						},
						{
							"areaId": "210421",
							"areaName": "抚顺县",
							"latitude": 41.71217,
							"longitude": 124.17755
						},
						{
							"areaId": "210422",
							"areaName": "新宾满族自治县",
							"latitude": 41.73409,
							"longitude": 125.04049
						},
						{
							"areaId": "210423",
							"areaName": "清原满族自治县",
							"latitude": 42.10221,
							"longitude": 124.92807
						}
					]
				},
				{
					"areaId": "2105",
					"areaName": "本溪市",
					"latitude": 41.297909,
					"longitude": 123.770519,
					"children": [{
							"areaId": "210500",
							"areaName": "本溪市本级",
							"latitude": 41.297909,
							"longitude": 123.770519
						},
						{
							"areaId": "210502",
							"areaName": "平山区",
							"latitude": 41.2997,
							"longitude": 123.76892
						},
						{
							"areaId": "210503",
							"areaName": "溪湖区",
							"latitude": 23.962315,
							"longitude": 120.479144
						},
						{
							"areaId": "210504",
							"areaName": "明山区",
							"latitude": 41.30827,
							"longitude": 123.81746
						},
						{
							"areaId": "210505",
							"areaName": "南芬区",
							"latitude": 41.1006,
							"longitude": 123.74523
						},
						{
							"areaId": "210521",
							"areaName": "本溪满族自治县",
							"latitude": 41.30059,
							"longitude": 124.12741
						},
						{
							"areaId": "210522",
							"areaName": "桓仁满族自治县",
							"latitude": 41.26798,
							"longitude": 125.36062
						}
					]
				},
				{
					"areaId": "2106",
					"areaName": "丹东市",
					"latitude": 40.124296,
					"longitude": 124.383044,
					"children": [{
							"areaId": "210600",
							"areaName": "丹东市本级",
							"latitude": 40.124296,
							"longitude": 124.383044
						},
						{
							"areaId": "210602",
							"areaName": "元宝区",
							"latitude": 40.13651,
							"longitude": 124.39575
						},
						{
							"areaId": "210603",
							"areaName": "振兴区",
							"latitude": 40.10489,
							"longitude": 124.36035
						},
						{
							"areaId": "210604",
							"areaName": "振安区",
							"latitude": 40.15826,
							"longitude": 124.42816
						},
						{
							"areaId": "210624",
							"areaName": "宽甸满族自治县",
							"latitude": 40.73187,
							"longitude": 124.78247
						},
						{
							"areaId": "210681",
							"areaName": "东港市",
							"latitude": 22.466626,
							"longitude": 120.454489
						},
						{
							"areaId": "210682",
							"areaName": "凤城市",
							"latitude": 40.45302,
							"longitude": 124.06671
						}
					]
				},
				{
					"areaId": "2107",
					"areaName": "锦州市",
					"latitude": 41.119269,
					"longitude": 121.135742,
					"children": [{
							"areaId": "210700",
							"areaName": "锦州市本级",
							"latitude": 41.119269,
							"longitude": 121.135742
						},
						{
							"areaId": "210702",
							"areaName": "古塔区",
							"latitude": 41.11725,
							"longitude": 121.12832
						},
						{
							"areaId": "210703",
							"areaName": "凌河区",
							"latitude": 41.11496,
							"longitude": 121.15089
						},
						{
							"areaId": "210711",
							"areaName": "太和区",
							"latitude": 41.10929,
							"longitude": 121.10354
						},
						{
							"areaId": "210726",
							"areaName": "黑山县",
							"latitude": 41.69417,
							"longitude": 122.12081
						},
						{
							"areaId": "210727",
							"areaName": "义县",
							"latitude": 23.5,
							"longitude": 120.3
						},
						{
							"areaId": "210781",
							"areaName": "凌海市",
							"latitude": 41.1737,
							"longitude": 121.35705
						},
						{
							"areaId": "210782",
							"areaName": "北镇市",
							"latitude": 41.59537,
							"longitude": 121.79858
						}
					]
				},
				{
					"areaId": "2108",
					"areaName": "营口市",
					"latitude": 40.667432,
					"longitude": 122.235151,
					"children": [{
							"areaId": "210800",
							"areaName": "营口市本级",
							"latitude": 40.667432,
							"longitude": 122.235151
						},
						{
							"areaId": "210802",
							"areaName": "站前区",
							"latitude": 40.67266,
							"longitude": 122.25896
						},
						{
							"areaId": "210803",
							"areaName": "西市区",
							"latitude": 40.6664,
							"longitude": 122.20641
						},
						{
							"areaId": "210804",
							"areaName": "鲅鱼圈区",
							"latitude": 40.26865,
							"longitude": 122.13266
						},
						{
							"areaId": "210811",
							"areaName": "老边区",
							"latitude": 40.6803,
							"longitude": 122.37996
						},
						{
							"areaId": "210881",
							"areaName": "盖州市",
							"latitude": 40.40446,
							"longitude": 122.35464
						},
						{
							"areaId": "210882",
							"areaName": "大石桥市",
							"latitude": 40.64567,
							"longitude": 122.50927
						}
					]
				},
				{
					"areaId": "2109",
					"areaName": "阜新市",
					"latitude": 42.011796,
					"longitude": 121.648962,
					"children": [{
							"areaId": "210900",
							"areaName": "阜新市本级",
							"latitude": 42.011796,
							"longitude": 121.648962
						},
						{
							"areaId": "210902",
							"areaName": "海州区",
							"latitude": 34.56986,
							"longitude": 119.13128
						},
						{
							"areaId": "210903",
							"areaName": "新邱区",
							"latitude": 42.09181,
							"longitude": 121.79251
						},
						{
							"areaId": "210904",
							"areaName": "太平区",
							"latitude": 24.126472,
							"longitude": 120.718523
						},
						{
							"areaId": "210905",
							"areaName": "清河门区",
							"latitude": 41.78309,
							"longitude": 121.4161
						},
						{
							"areaId": "210911",
							"areaName": "细河区",
							"latitude": 42.02533,
							"longitude": 121.68013
						},
						{
							"areaId": "210921",
							"areaName": "阜新蒙古族自治县",
							"latitude": 42.0651,
							"longitude": 121.75787
						},
						{
							"areaId": "210922",
							"areaName": "彰武县",
							"latitude": 42.38625,
							"longitude": 122.54022
						}
					]
				},
				{
					"areaId": "2110",
					"areaName": "辽阳市",
					"latitude": 41.269402,
					"longitude": 123.18152,
					"children": [{
							"areaId": "211000",
							"areaName": "辽阳市本级",
							"latitude": 41.269402,
							"longitude": 123.18152
						},
						{
							"areaId": "211002",
							"areaName": "白塔区",
							"latitude": 41.27025,
							"longitude": 123.1747
						},
						{
							"areaId": "211003",
							"areaName": "文圣区",
							"latitude": 41.26267,
							"longitude": 123.18521
						},
						{
							"areaId": "211004",
							"areaName": "宏伟区",
							"latitude": 41.21852,
							"longitude": 123.1929
						},
						{
							"areaId": "211005",
							"areaName": "弓长岭区",
							"latitude": 41.15181,
							"longitude": 123.41963
						},
						{
							"areaId": "211011",
							"areaName": "太子河区",
							"latitude": 41.25337,
							"longitude": 123.18182
						},
						{
							"areaId": "211021",
							"areaName": "辽阳县",
							"latitude": 41.20542,
							"longitude": 123.10574
						},
						{
							"areaId": "211081",
							"areaName": "灯塔市",
							"latitude": 41.42612,
							"longitude": 123.33926
						}
					]
				},
				{
					"areaId": "2111",
					"areaName": "盘锦市",
					"latitude": 41.124484,
					"longitude": 122.06957,
					"children": [{
							"areaId": "211100",
							"areaName": "盘锦市本级",
							"latitude": 41.124484,
							"longitude": 122.06957
						},
						{
							"areaId": "211102",
							"areaName": "双台子区",
							"latitude": 41.1906,
							"longitude": 122.06011
						},
						{
							"areaId": "211103",
							"areaName": "兴隆台区",
							"latitude": 41.12402,
							"longitude": 122.07529
						},
						{
							"areaId": "211121",
							"areaName": "大洼县",
							"latitude": 41.124484,
							"longitude": 122.06957
						},
						{
							"areaId": "211122",
							"areaName": "盘山县",
							"latitude": 41.23805,
							"longitude": 121.99777
						}
					]
				},
				{
					"areaId": "2112",
					"areaName": "铁岭市",
					"latitude": 42.290585,
					"longitude": 123.844279,
					"children": [{
							"areaId": "211200",
							"areaName": "铁岭市本级",
							"latitude": 42.290585,
							"longitude": 123.844279
						},
						{
							"areaId": "211202",
							"areaName": "银州区",
							"latitude": 42.29507,
							"longitude": 123.8573
						},
						{
							"areaId": "211204",
							"areaName": "清河区",
							"latitude": 33.59949,
							"longitude": 119.00778
						},
						{
							"areaId": "211221",
							"areaName": "铁岭县",
							"latitude": 42.22498,
							"longitude": 123.77325
						},
						{
							"areaId": "211223",
							"areaName": "西丰县",
							"latitude": 42.73756,
							"longitude": 124.7304
						},
						{
							"areaId": "211224",
							"areaName": "昌图县",
							"latitude": 42.78428,
							"longitude": 124.11206
						},
						{
							"areaId": "211281",
							"areaName": "调兵山市",
							"latitude": 42.4675,
							"longitude": 123.56689
						},
						{
							"areaId": "211282",
							"areaName": "开原市",
							"latitude": 42.54585,
							"longitude": 124.03945
						}
					]
				},
				{
					"areaId": "2113",
					"areaName": "朝阳市",
					"latitude": 41.576758,
					"longitude": 120.451176,
					"children": [{
							"areaId": "211300",
							"areaName": "朝阳市本级",
							"latitude": 41.576758,
							"longitude": 120.451176
						},
						{
							"areaId": "211302",
							"areaName": "双塔区",
							"latitude": 41.566,
							"longitude": 120.45385
						},
						{
							"areaId": "211303",
							"areaName": "龙城区",
							"latitude": 41.59264,
							"longitude": 120.43719
						},
						{
							"areaId": "211321",
							"areaName": "朝阳县",
							"latitude": 41.4324,
							"longitude": 120.17401
						},
						{
							"areaId": "211322",
							"areaName": "建平县",
							"latitude": 41.40315,
							"longitude": 119.64392
						},
						{
							"areaId": "211324",
							"areaName": "喀喇沁左翼蒙古族自治县",
							"latitude": 41.12801,
							"longitude": 119.74185
						},
						{
							"areaId": "211381",
							"areaName": "北票市",
							"latitude": 41.80196,
							"longitude": 120.76977
						},
						{
							"areaId": "211382",
							"areaName": "凌源市",
							"latitude": 41.24558,
							"longitude": 119.40148
						}
					]
				},
				{
					"areaId": "2114",
					"areaName": "葫芦岛市",
					"latitude": 40.755572,
					"longitude": 120.856394,
					"children": [{
							"areaId": "211400",
							"areaName": "葫芦岛市本级",
							"latitude": 40.755572,
							"longitude": 120.856394
						},
						{
							"areaId": "211402",
							"areaName": "连山区",
							"latitude": 40.75554,
							"longitude": 120.86393
						},
						{
							"areaId": "211403",
							"areaName": "龙港区",
							"latitude": 40.71919,
							"longitude": 120.94866
						},
						{
							"areaId": "211404",
							"areaName": "南票区",
							"latitude": 41.10707,
							"longitude": 120.74978
						},
						{
							"areaId": "211421",
							"areaName": "绥中县",
							"latitude": 40.32552,
							"longitude": 120.34451
						},
						{
							"areaId": "211422",
							"areaName": "建昌县",
							"latitude": 40.82448,
							"longitude": 119.8377
						},
						{
							"areaId": "211481",
							"areaName": "兴城市",
							"latitude": 40.61492,
							"longitude": 120.72537
						}
					]
				}
			]
		},
		{
			"areaId": "22",
			"areaName": "吉林省",
			"latitude": 43.886841,
			"longitude": 125.3245,
			"children": [{
					"areaId": "2201",
					"areaName": "长春市",
					"latitude": 43.886841,
					"longitude": 125.3245,
					"children": [{
							"areaId": "220100",
							"areaName": "长春市本级",
							"latitude": 43.886841,
							"longitude": 125.3245
						},
						{
							"areaId": "220102",
							"areaName": "南关区",
							"latitude": 43.86401,
							"longitude": 125.35035
						},
						{
							"areaId": "220103",
							"areaName": "宽城区",
							"latitude": 43.90182,
							"longitude": 125.32635
						},
						{
							"areaId": "220104",
							"areaName": "朝阳区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "220105",
							"areaName": "二道区",
							"latitude": 43.86501,
							"longitude": 125.37429
						},
						{
							"areaId": "220106",
							"areaName": "绿园区",
							"latitude": 43.88045,
							"longitude": 125.25582
						},
						{
							"areaId": "220112",
							"areaName": "双阳区",
							"latitude": 43.52803,
							"longitude": 125.65631
						},
						{
							"areaId": "220122",
							"areaName": "农安县",
							"latitude": 44.43265,
							"longitude": 125.18481
						},
						{
							"areaId": "220181",
							"areaName": "九台市",
							"latitude": 43.886841,
							"longitude": 125.3245
						},
						{
							"areaId": "220182",
							"areaName": "榆树市",
							"latitude": 44.82523,
							"longitude": 126.55688
						},
						{
							"areaId": "220183",
							"areaName": "德惠市",
							"latitude": 44.53719,
							"longitude": 125.70538
						}
					]
				},
				{
					"areaId": "2202",
					"areaName": "吉林市",
					"latitude": 43.843577,
					"longitude": 126.55302,
					"children": [{
							"areaId": "220200",
							"areaName": "吉林市本级",
							"latitude": 43.843577,
							"longitude": 126.55302
						},
						{
							"areaId": "220202",
							"areaName": "昌邑区",
							"latitude": 43.88183,
							"longitude": 126.57424
						},
						{
							"areaId": "220203",
							"areaName": "龙潭区",
							"latitude": 24.863851,
							"longitude": 121.216392
						},
						{
							"areaId": "220204",
							"areaName": "船营区",
							"latitude": 43.83344,
							"longitude": 126.54096
						},
						{
							"areaId": "220211",
							"areaName": "丰满区",
							"latitude": 43.82236,
							"longitude": 126.56237
						},
						{
							"areaId": "220221",
							"areaName": "永吉县",
							"latitude": 43.67197,
							"longitude": 126.4963
						},
						{
							"areaId": "220281",
							"areaName": "蛟河市",
							"latitude": 43.72696,
							"longitude": 127.34426
						},
						{
							"areaId": "220282",
							"areaName": "桦甸市",
							"latitude": 42.97206,
							"longitude": 126.74624
						},
						{
							"areaId": "220283",
							"areaName": "舒兰市",
							"latitude": 44.40582,
							"longitude": 126.9653
						},
						{
							"areaId": "220284",
							"areaName": "磐石市",
							"latitude": 42.94628,
							"longitude": 126.0625
						}
					]
				},
				{
					"areaId": "2203",
					"areaName": "四平市",
					"latitude": 43.170344,
					"longitude": 124.370785,
					"children": [{
							"areaId": "220300",
							"areaName": "四平市本级",
							"latitude": 43.170344,
							"longitude": 124.370785
						},
						{
							"areaId": "220302",
							"areaName": "铁西区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "220303",
							"areaName": "铁东区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "220322",
							"areaName": "梨树县",
							"latitude": 43.30717,
							"longitude": 124.33563
						},
						{
							"areaId": "220323",
							"areaName": "伊通满族自治县",
							"latitude": 43.34434,
							"longitude": 125.30596
						},
						{
							"areaId": "220381",
							"areaName": "公主岭市",
							"latitude": 43.170344,
							"longitude": 124.370785
						},
						{
							"areaId": "220382",
							"areaName": "双辽市",
							"latitude": 43.52099,
							"longitude": 123.50106
						}
					]
				},
				{
					"areaId": "2204",
					"areaName": "辽源市",
					"latitude": 42.902692,
					"longitude": 125.145349,
					"children": [{
							"areaId": "220400",
							"areaName": "辽源市本级",
							"latitude": 42.902692,
							"longitude": 125.145349
						},
						{
							"areaId": "220402",
							"areaName": "龙山区",
							"latitude": 42.89714,
							"longitude": 125.13641
						},
						{
							"areaId": "220403",
							"areaName": "西安区",
							"latitude": 44.57766,
							"longitude": 129.61616
						},
						{
							"areaId": "220421",
							"areaName": "东丰县",
							"latitude": 42.6783,
							"longitude": 125.53244
						},
						{
							"areaId": "220422",
							"areaName": "东辽县",
							"latitude": 42.92492,
							"longitude": 124.98596
						}
					]
				},
				{
					"areaId": "2205",
					"areaName": "通化市",
					"latitude": 41.721177,
					"longitude": 125.936501,
					"children": [{
							"areaId": "220500",
							"areaName": "通化市本级",
							"latitude": 41.721177,
							"longitude": 125.936501
						},
						{
							"areaId": "220502",
							"areaName": "东昌区",
							"latitude": 41.72849,
							"longitude": 125.9551
						},
						{
							"areaId": "220503",
							"areaName": "二道江区",
							"latitude": 41.7741,
							"longitude": 126.04257
						},
						{
							"areaId": "220521",
							"areaName": "通化县",
							"latitude": 41.67928,
							"longitude": 125.75936
						},
						{
							"areaId": "220523",
							"areaName": "辉南县",
							"latitude": 42.68497,
							"longitude": 126.04684
						},
						{
							"areaId": "220524",
							"areaName": "柳河县",
							"latitude": 42.28468,
							"longitude": 125.74475
						},
						{
							"areaId": "220581",
							"areaName": "梅河口市",
							"latitude": 42.53828,
							"longitude": 125.71041
						},
						{
							"areaId": "220582",
							"areaName": "集安市",
							"latitude": 41.12268,
							"longitude": 126.18829
						}
					]
				},
				{
					"areaId": "2206",
					"areaName": "白山市",
					"latitude": 41.942505,
					"longitude": 126.427839,
					"children": [{
							"areaId": "220600",
							"areaName": "白山市本级",
							"latitude": 41.942505,
							"longitude": 126.427839
						},
						{
							"areaId": "220602",
							"areaName": "八道江区",
							"latitude": 41.945656,
							"longitude": 126.422342
						},
						{
							"areaId": "220605",
							"areaName": "江源区",
							"latitude": 42.05664,
							"longitude": 126.59079
						},
						{
							"areaId": "220621",
							"areaName": "抚松县",
							"latitude": 42.34198,
							"longitude": 127.2803
						},
						{
							"areaId": "220622",
							"areaName": "靖宇县",
							"latitude": 42.38863,
							"longitude": 126.81308
						},
						{
							"areaId": "220623",
							"areaName": "长白朝鲜族自治县",
							"latitude": 41.41996,
							"longitude": 128.20047
						},
						{
							"areaId": "220681",
							"areaName": "临江市",
							"latitude": 41.81142,
							"longitude": 126.91751
						}
					]
				},
				{
					"areaId": "2207",
					"areaName": "松原市",
					"latitude": 45.118243,
					"longitude": 124.823608,
					"children": [{
							"areaId": "220700",
							"areaName": "松原市本级",
							"latitude": 45.118243,
							"longitude": 124.823608
						},
						{
							"areaId": "220702",
							"areaName": "宁江区",
							"latitude": 45.17175,
							"longitude": 124.81689
						},
						{
							"areaId": "220721",
							"areaName": "前郭尔罗斯蒙古族自治县",
							"latitude": 45.11726,
							"longitude": 124.82351
						},
						{
							"areaId": "220722",
							"areaName": "长岭县",
							"latitude": 44.27581,
							"longitude": 123.96725
						},
						{
							"areaId": "220723",
							"areaName": "乾安县",
							"latitude": 45.01068,
							"longitude": 124.02737
						},
						{
							"areaId": "220724",
							"areaName": "扶余县",
							"latitude": 45.118243,
							"longitude": 124.823608
						}
					]
				},
				{
					"areaId": "2208",
					"areaName": "白城市",
					"latitude": 45.619026,
					"longitude": 122.841114,
					"children": [{
							"areaId": "220800",
							"areaName": "白城市本级",
							"latitude": 45.619026,
							"longitude": 122.841114
						},
						{
							"areaId": "220802",
							"areaName": "洮北区",
							"latitude": 45.62167,
							"longitude": 122.85104
						},
						{
							"areaId": "220821",
							"areaName": "镇赉县",
							"latitude": 45.84779,
							"longitude": 123.19924
						},
						{
							"areaId": "220822",
							"areaName": "通榆县",
							"latitude": 44.81388,
							"longitude": 123.08761
						},
						{
							"areaId": "220881",
							"areaName": "洮南市",
							"latitude": 45.33502,
							"longitude": 122.78772
						},
						{
							"areaId": "220882",
							"areaName": "大安市",
							"latitude": 45.50846,
							"longitude": 124.29519
						}
					]
				},
				{
					"areaId": "2224",
					"areaName": "延边朝鲜族自治州",
					"latitude": 42.904823,
					"longitude": 129.513228,
					"children": [{
							"areaId": "222400",
							"areaName": "延边朝鲜族自治州本级",
							"latitude": 42.904823,
							"longitude": 129.513228
						},
						{
							"areaId": "222401",
							"areaName": "延吉市",
							"latitude": 42.90682,
							"longitude": 129.51357
						},
						{
							"areaId": "222402",
							"areaName": "图们市",
							"latitude": 42.96801,
							"longitude": 129.84381
						},
						{
							"areaId": "222403",
							"areaName": "敦化市",
							"latitude": 43.37304,
							"longitude": 128.23242
						},
						{
							"areaId": "222404",
							"areaName": "珲春市",
							"latitude": 42.86242,
							"longitude": 130.36572
						},
						{
							"areaId": "222405",
							"areaName": "龙井市",
							"latitude": 24.19271,
							"longitude": 120.54594
						},
						{
							"areaId": "222406",
							"areaName": "和龙市",
							"latitude": 42.5464,
							"longitude": 129.01077
						},
						{
							"areaId": "222424",
							"areaName": "汪清县",
							"latitude": 43.31278,
							"longitude": 129.77121
						},
						{
							"areaId": "222426",
							"areaName": "安图县",
							"latitude": 43.11533,
							"longitude": 128.90625
						}
					]
				}
			]
		},
		{
			"areaId": "23",
			"areaName": "黑龙江省",
			"latitude": 45.756967,
			"longitude": 126.642464,
			"children": [{
					"areaId": "2301",
					"areaName": "哈尔滨市",
					"latitude": 45.756967,
					"longitude": 126.642464,
					"children": [{
							"areaId": "230100",
							"areaName": "哈尔滨市本级",
							"latitude": 45.756967,
							"longitude": 126.642464
						},
						{
							"areaId": "230102",
							"areaName": "道里区",
							"latitude": 45.75586,
							"longitude": 126.61705
						},
						{
							"areaId": "230103",
							"areaName": "南岗区",
							"latitude": 45.75996,
							"longitude": 126.66854
						},
						{
							"areaId": "230104",
							"areaName": "道外区",
							"latitude": 45.79187,
							"longitude": 126.64938
						},
						{
							"areaId": "230108",
							"areaName": "平房区",
							"latitude": 45.59777,
							"longitude": 126.63729
						},
						{
							"areaId": "230109",
							"areaName": "松北区",
							"latitude": 45.80831,
							"longitude": 126.56276
						},
						{
							"areaId": "230110",
							"areaName": "香坊区",
							"latitude": 45.72383,
							"longitude": 126.67968
						},
						{
							"areaId": "230111",
							"areaName": "呼兰区",
							"latitude": 45.88895,
							"longitude": 126.58792
						},
						{
							"areaId": "230112",
							"areaName": "阿城区",
							"latitude": 45.54144,
							"longitude": 126.97525
						},
						{
							"areaId": "230123",
							"areaName": "依兰县",
							"latitude": 46.3247,
							"longitude": 129.56817
						},
						{
							"areaId": "230124",
							"areaName": "方正县",
							"latitude": 45.85162,
							"longitude": 128.82952
						},
						{
							"areaId": "230125",
							"areaName": "宾县",
							"latitude": 28.68996,
							"longitude": 104.53314
						},
						{
							"areaId": "230126",
							"areaName": "巴彦县",
							"latitude": 46.08148,
							"longitude": 127.40799
						},
						{
							"areaId": "230127",
							"areaName": "木兰县",
							"latitude": 45.94944,
							"longitude": 128.0448
						},
						{
							"areaId": "230128",
							"areaName": "通河县",
							"latitude": 45.99007,
							"longitude": 128.74603
						},
						{
							"areaId": "230129",
							"areaName": "延寿县",
							"latitude": 45.4554,
							"longitude": 128.33419
						},
						{
							"areaId": "230182",
							"areaName": "双城市",
							"latitude": 45.756967,
							"longitude": 126.642464
						},
						{
							"areaId": "230183",
							"areaName": "尚志市",
							"latitude": 45.21736,
							"longitude": 127.96191
						},
						{
							"areaId": "230184",
							"areaName": "五常市",
							"latitude": 44.93184,
							"longitude": 127.16751
						}
					]
				},
				{
					"areaId": "2302",
					"areaName": "齐齐哈尔市",
					"latitude": 47.348079,
					"longitude": 123.953486,
					"children": [{
							"areaId": "230200",
							"areaName": "齐齐哈尔市本级",
							"latitude": 47.348079,
							"longitude": 123.953486
						},
						{
							"areaId": "230202",
							"areaName": "龙沙区",
							"latitude": 47.31776,
							"longitude": 123.95752
						},
						{
							"areaId": "230203",
							"areaName": "建华区",
							"latitude": 47.36718,
							"longitude": 124.0133
						},
						{
							"areaId": "230204",
							"areaName": "铁锋区",
							"latitude": 47.34075,
							"longitude": 123.97821
						},
						{
							"areaId": "230205",
							"areaName": "昂昂溪区",
							"latitude": 47.15513,
							"longitude": 123.82229
						},
						{
							"areaId": "230206",
							"areaName": "富拉尔基区",
							"latitude": 47.20884,
							"longitude": 123.62918
						},
						{
							"areaId": "230207",
							"areaName": "碾子山区",
							"latitude": 47.51662,
							"longitude": 122.88183
						},
						{
							"areaId": "230208",
							"areaName": "梅里斯达斡尔族区",
							"latitude": 47.30946,
							"longitude": 123.75274
						},
						{
							"areaId": "230221",
							"areaName": "龙江县",
							"latitude": 47.33868,
							"longitude": 123.20532
						},
						{
							"areaId": "230223",
							"areaName": "依安县",
							"latitude": 47.8931,
							"longitude": 125.30896
						},
						{
							"areaId": "230224",
							"areaName": "泰来县",
							"latitude": 46.39386,
							"longitude": 123.42285
						},
						{
							"areaId": "230225",
							"areaName": "甘南县",
							"latitude": 47.92437,
							"longitude": 123.50317
						},
						{
							"areaId": "230227",
							"areaName": "富裕县",
							"latitude": 47.77431,
							"longitude": 124.47457
						},
						{
							"areaId": "230229",
							"areaName": "克山县",
							"latitude": 48.03265,
							"longitude": 125.87396
						},
						{
							"areaId": "230230",
							"areaName": "克东县",
							"latitude": 48.03828,
							"longitude": 126.24917
						},
						{
							"areaId": "230231",
							"areaName": "拜泉县",
							"latitude": 47.60817,
							"longitude": 126.09167
						},
						{
							"areaId": "230281",
							"areaName": "讷河市",
							"latitude": 48.48388,
							"longitude": 124.87713
						}
					]
				},
				{
					"areaId": "2303",
					"areaName": "鸡西市",
					"latitude": 45.300046,
					"longitude": 130.975966,
					"children": [{
							"areaId": "230300",
							"areaName": "鸡西市本级",
							"latitude": 45.300046,
							"longitude": 130.975966
						},
						{
							"areaId": "230302",
							"areaName": "鸡冠区",
							"latitude": 45.30396,
							"longitude": 130.98139
						},
						{
							"areaId": "230303",
							"areaName": "恒山区",
							"latitude": 45.21071,
							"longitude": 130.90493
						},
						{
							"areaId": "230304",
							"areaName": "滴道区",
							"latitude": 45.35109,
							"longitude": 130.84841
						},
						{
							"areaId": "230305",
							"areaName": "梨树区",
							"latitude": 45.09037,
							"longitude": 130.69848
						},
						{
							"areaId": "230306",
							"areaName": "城子河区",
							"latitude": 45.33689,
							"longitude": 131.01132
						},
						{
							"areaId": "230307",
							"areaName": "麻山区",
							"latitude": 45.21209,
							"longitude": 130.47811
						},
						{
							"areaId": "230321",
							"areaName": "鸡东县",
							"latitude": 45.26025,
							"longitude": 131.12423
						},
						{
							"areaId": "230381",
							"areaName": "虎林市",
							"latitude": 45.76291,
							"longitude": 132.93679
						},
						{
							"areaId": "230382",
							"areaName": "密山市",
							"latitude": 45.5297,
							"longitude": 131.84625
						}
					]
				},
				{
					"areaId": "2304",
					"areaName": "鹤岗市",
					"latitude": 47.332085,
					"longitude": 130.277487,
					"children": [{
							"areaId": "230400",
							"areaName": "鹤岗市本级",
							"latitude": 47.332085,
							"longitude": 130.277487
						},
						{
							"areaId": "230402",
							"areaName": "向阳区",
							"latitude": 46.80778,
							"longitude": 130.36519
						},
						{
							"areaId": "230403",
							"areaName": "工农区",
							"latitude": 47.31869,
							"longitude": 130.27468
						},
						{
							"areaId": "230404",
							"areaName": "南山区",
							"latitude": 22.53291,
							"longitude": 113.93029
						},
						{
							"areaId": "230405",
							"areaName": "兴安区",
							"latitude": 47.2526,
							"longitude": 130.23965
						},
						{
							"areaId": "230406",
							"areaName": "东山区",
							"latitude": 23.326092,
							"longitude": 120.403984
						},
						{
							"areaId": "230407",
							"areaName": "兴山区",
							"latitude": 47.35776,
							"longitude": 130.29271
						},
						{
							"areaId": "230421",
							"areaName": "萝北县",
							"latitude": 47.57959,
							"longitude": 130.83346
						},
						{
							"areaId": "230422",
							"areaName": "绥滨县",
							"latitude": 47.2903,
							"longitude": 131.86029
						}
					]
				},
				{
					"areaId": "2305",
					"areaName": "双鸭山市",
					"latitude": 46.643442,
					"longitude": 131.157304,
					"children": [{
							"areaId": "230500",
							"areaName": "双鸭山市本级",
							"latitude": 46.643442,
							"longitude": 131.157304
						},
						{
							"areaId": "230502",
							"areaName": "尖山区",
							"latitude": 46.64635,
							"longitude": 131.15841
						},
						{
							"areaId": "230503",
							"areaName": "岭东区",
							"latitude": 46.59043,
							"longitude": 131.16473
						},
						{
							"areaId": "230505",
							"areaName": "四方台区",
							"latitude": 46.59499,
							"longitude": 131.33593
						},
						{
							"areaId": "230506",
							"areaName": "宝山区",
							"latitude": 31.4045,
							"longitude": 121.4891
						},
						{
							"areaId": "230521",
							"areaName": "集贤县",
							"latitude": 46.72678,
							"longitude": 131.14053
						},
						{
							"areaId": "230522",
							"areaName": "友谊县",
							"latitude": 46.76739,
							"longitude": 131.80789
						},
						{
							"areaId": "230523",
							"areaName": "宝清县",
							"latitude": 46.32716,
							"longitude": 132.19695
						},
						{
							"areaId": "230524",
							"areaName": "饶河县",
							"latitude": 46.79899,
							"longitude": 134.01986
						}
					]
				},
				{
					"areaId": "2306",
					"areaName": "大庆市",
					"latitude": 46.590734,
					"longitude": 125.11272,
					"children": [{
							"areaId": "230600",
							"areaName": "大庆市本级",
							"latitude": 46.590734,
							"longitude": 125.11272
						},
						{
							"areaId": "230602",
							"areaName": "萨尔图区",
							"latitude": 46.59359,
							"longitude": 125.08792
						},
						{
							"areaId": "230603",
							"areaName": "龙凤区",
							"latitude": 46.53273,
							"longitude": 125.11657
						},
						{
							"areaId": "230604",
							"areaName": "让胡路区",
							"latitude": 46.6522,
							"longitude": 124.87075
						},
						{
							"areaId": "230605",
							"areaName": "红岗区",
							"latitude": 46.40128,
							"longitude": 124.89248
						},
						{
							"areaId": "230606",
							"areaName": "大同区",
							"latitude": 25.065986,
							"longitude": 121.515514
						},
						{
							"areaId": "230621",
							"areaName": "肇州县",
							"latitude": 45.70414,
							"longitude": 125.27059
						},
						{
							"areaId": "230622",
							"areaName": "肇源县",
							"latitude": 45.52032,
							"longitude": 125.08456
						},
						{
							"areaId": "230623",
							"areaName": "林甸县",
							"latitude": 47.18601,
							"longitude": 124.87564
						},
						{
							"areaId": "230624",
							"areaName": "杜尔伯特蒙古族自治县",
							"latitude": 46.86507,
							"longitude": 124.44937
						}
					]
				},
				{
					"areaId": "2307",
					"areaName": "伊春市",
					"latitude": 47.728,
					"longitude": 128.90752,
					"children": [{
							"areaId": "230700",
							"areaName": "伊春市本级",
							"latitude": 47.728,
							"longitude": 128.90752
						},
						{
							"areaId": "230702",
							"areaName": "伊春区",
							"latitude": 47.728,
							"longitude": 128.90752
						},
						{
							"areaId": "230703",
							"areaName": "南岔区",
							"latitude": 47.728,
							"longitude": 128.90752
						},
						{
							"areaId": "230704",
							"areaName": "友好区",
							"latitude": 47.728,
							"longitude": 128.90752
						},
						{
							"areaId": "230705",
							"areaName": "西林区",
							"latitude": 47.728,
							"longitude": 128.90752
						},
						{
							"areaId": "230706",
							"areaName": "翠峦区",
							"latitude": 47.728,
							"longitude": 128.90752
						},
						{
							"areaId": "230707",
							"areaName": "新青区",
							"latitude": 47.728,
							"longitude": 128.90752
						},
						{
							"areaId": "230708",
							"areaName": "美溪区",
							"latitude": 47.728,
							"longitude": 128.90752
						},
						{
							"areaId": "230709",
							"areaName": "金山屯区",
							"latitude": 47.728,
							"longitude": 128.90752
						},
						{
							"areaId": "230710",
							"areaName": "五营区",
							"latitude": 47.728,
							"longitude": 128.90752
						},
						{
							"areaId": "230711",
							"areaName": "乌马河区",
							"latitude": 47.728,
							"longitude": 128.90752
						},
						{
							"areaId": "230712",
							"areaName": "汤旺河区",
							"latitude": 47.728,
							"longitude": 128.90752
						},
						{
							"areaId": "230713",
							"areaName": "带岭区",
							"latitude": 47.728,
							"longitude": 128.90752
						},
						{
							"areaId": "230714",
							"areaName": "乌伊岭区",
							"latitude": 47.728,
							"longitude": 128.90752
						},
						{
							"areaId": "230715",
							"areaName": "红星区",
							"latitude": 47.728,
							"longitude": 128.90752
						},
						{
							"areaId": "230716",
							"areaName": "上甘岭区",
							"latitude": 47.728,
							"longitude": 128.90752
						},
						{
							"areaId": "230722",
							"areaName": "嘉荫县",
							"latitude": 48.8917,
							"longitude": 130.39825
						},
						{
							"areaId": "230781",
							"areaName": "铁力市",
							"latitude": 46.98571,
							"longitude": 128.0317
						}
					]
				},
				{
					"areaId": "2308",
					"areaName": "佳木斯市",
					"latitude": 46.809606,
					"longitude": 130.361634,
					"children": [{
							"areaId": "230800",
							"areaName": "佳木斯市本级",
							"latitude": 46.809606,
							"longitude": 130.361634
						},
						{
							"areaId": "230803",
							"areaName": "向阳区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "230804",
							"areaName": "前进区",
							"latitude": 46.81401,
							"longitude": 130.37497
						},
						{
							"areaId": "230805",
							"areaName": "东风区",
							"latitude": 46.82257,
							"longitude": 130.40366
						},
						{
							"areaId": "230811",
							"areaName": "郊区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "230822",
							"areaName": "桦南县",
							"latitude": 46.23921,
							"longitude": 130.55361
						},
						{
							"areaId": "230826",
							"areaName": "桦川县",
							"latitude": 47.02297,
							"longitude": 130.71893
						},
						{
							"areaId": "230828",
							"areaName": "汤原县",
							"latitude": 46.72755,
							"longitude": 129.90966
						},
						{
							"areaId": "230833",
							"areaName": "抚远县",
							"latitude": 46.809606,
							"longitude": 130.361634
						},
						{
							"areaId": "230881",
							"areaName": "同江市",
							"latitude": 47.64211,
							"longitude": 132.51095
						},
						{
							"areaId": "230882",
							"areaName": "富锦市",
							"latitude": 47.25132,
							"longitude": 132.03707
						}
					]
				},
				{
					"areaId": "2309",
					"areaName": "七台河市",
					"latitude": 45.771266,
					"longitude": 131.015584,
					"children": [{
							"areaId": "230900",
							"areaName": "七台河市本级",
							"latitude": 45.771266,
							"longitude": 131.015584
						},
						{
							"areaId": "230902",
							"areaName": "新兴区",
							"latitude": 22.631147,
							"longitude": 120.309535
						},
						{
							"areaId": "230903",
							"areaName": "桃山区",
							"latitude": 45.76782,
							"longitude": 131.01786
						},
						{
							"areaId": "230904",
							"areaName": "茄子河区",
							"latitude": 45.78519,
							"longitude": 131.06807
						},
						{
							"areaId": "230921",
							"areaName": "勃利县",
							"latitude": 45.755,
							"longitude": 130.59179
						}
					]
				},
				{
					"areaId": "2310",
					"areaName": "牡丹江市",
					"latitude": 22.125687,
					"longitude": 120.770108,
					"children": [{
							"areaId": "231000",
							"areaName": "牡丹江市本级",
							"latitude": 22.125687,
							"longitude": 120.770108
						},
						{
							"areaId": "231002",
							"areaName": "东安区",
							"latitude": 44.58133,
							"longitude": 129.62665
						},
						{
							"areaId": "231003",
							"areaName": "阳明区",
							"latitude": 44.59603,
							"longitude": 129.63547
						},
						{
							"areaId": "231004",
							"areaName": "爱民区",
							"latitude": 44.59648,
							"longitude": 129.59077
						},
						{
							"areaId": "231005",
							"areaName": "西安区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "231024",
							"areaName": "东宁县",
							"latitude": 22.125687,
							"longitude": 120.770108
						},
						{
							"areaId": "231025",
							"areaName": "林口县",
							"latitude": 25.077531,
							"longitude": 121.391602
						},
						{
							"areaId": "231081",
							"areaName": "绥芬河市",
							"latitude": 44.41249,
							"longitude": 131.15139
						},
						{
							"areaId": "231083",
							"areaName": "海林市",
							"latitude": 44.59,
							"longitude": 129.38156
						},
						{
							"areaId": "231084",
							"areaName": "宁安市",
							"latitude": 44.34016,
							"longitude": 129.48303
						},
						{
							"areaId": "231085",
							"areaName": "穆棱市",
							"latitude": 44.919,
							"longitude": 130.52465
						}
					]
				},
				{
					"areaId": "2311",
					"areaName": "黑河市",
					"latitude": 50.249585,
					"longitude": 127.499023,
					"children": [{
							"areaId": "231100",
							"areaName": "黑河市本级",
							"latitude": 50.249585,
							"longitude": 127.499023
						},
						{
							"areaId": "231102",
							"areaName": "爱辉区",
							"latitude": 50.25202,
							"longitude": 127.50074
						},
						{
							"areaId": "231121",
							"areaName": "嫩江县",
							"latitude": 50.249585,
							"longitude": 127.499023
						},
						{
							"areaId": "231123",
							"areaName": "逊克县",
							"latitude": 49.57983,
							"longitude": 128.47882
						},
						{
							"areaId": "231124",
							"areaName": "孙吴县",
							"latitude": 49.42539,
							"longitude": 127.33599
						},
						{
							"areaId": "231181",
							"areaName": "北安市",
							"latitude": 48.23872,
							"longitude": 126.48193
						},
						{
							"areaId": "231182",
							"areaName": "五大连池市",
							"latitude": 48.51507,
							"longitude": 126.20294
						}
					]
				},
				{
					"areaId": "2312",
					"areaName": "绥化市",
					"latitude": 46.637393,
					"longitude": 126.99293,
					"children": [{
							"areaId": "231200",
							"areaName": "绥化市本级",
							"latitude": 46.637393,
							"longitude": 126.99293
						},
						{
							"areaId": "231202",
							"areaName": "北林区",
							"latitude": 46.63735,
							"longitude": 126.98564
						},
						{
							"areaId": "231221",
							"areaName": "望奎县",
							"latitude": 46.83079,
							"longitude": 126.48187
						},
						{
							"areaId": "231222",
							"areaName": "兰西县",
							"latitude": 46.2525,
							"longitude": 126.28994
						},
						{
							"areaId": "231223",
							"areaName": "青冈县",
							"latitude": 46.68534,
							"longitude": 126.11325
						},
						{
							"areaId": "231224",
							"areaName": "庆安县",
							"latitude": 46.88016,
							"longitude": 127.50753
						},
						{
							"areaId": "231225",
							"areaName": "明水县",
							"latitude": 47.17327,
							"longitude": 125.90594
						},
						{
							"areaId": "231226",
							"areaName": "绥棱县",
							"latitude": 47.24267,
							"longitude": 127.11584
						},
						{
							"areaId": "231281",
							"areaName": "安达市",
							"latitude": 46.4177,
							"longitude": 125.34375
						},
						{
							"areaId": "231282",
							"areaName": "肇东市",
							"latitude": 46.05131,
							"longitude": 125.96243
						},
						{
							"areaId": "231283",
							"areaName": "海伦市",
							"latitude": 47.46093,
							"longitude": 126.9682
						}
					]
				},
				{
					"areaId": "2327",
					"areaName": "大兴安岭地区",
					"latitude": 52.335262,
					"longitude": 124.711526,
					"children": [{
							"areaId": "232700",
							"areaName": "大兴安岭地区本级",
							"latitude": 52.335262,
							"longitude": 124.711526
						},
						{
							"areaId": "232701",
							"areaName": "加格达奇区",
							"latitude": 52.97003,
							"longitude": 122.53759
						},
						{
							"areaId": "232702",
							"areaName": "松岭区",
							"latitude": 52.335262,
							"longitude": 124.711526
						},
						{
							"areaId": "232703",
							"areaName": "新林区",
							"latitude": 52.335262,
							"longitude": 124.711526
						},
						{
							"areaId": "232704",
							"areaName": "呼中区",
							"latitude": 52.335262,
							"longitude": 124.711526
						},
						{
							"areaId": "232721",
							"areaName": "呼玛县",
							"latitude": 51.73112,
							"longitude": 126.66174
						},
						{
							"areaId": "232722",
							"areaName": "塔河县",
							"latitude": 52.33431,
							"longitude": 124.70999
						},
						{
							"areaId": "232723",
							"areaName": "漠河县",
							"latitude": 52.335262,
							"longitude": 124.711526
						}
					]
				},
				{
					"areaId": "2391",
					"areaName": "黑龙江农垦总局",
					"latitude": 45.756967,
					"longitude": 126.642464,
					"children": [{
							"areaId": "239101",
							"areaName": "宝泉岭分局",
							"latitude": 45.756967,
							"longitude": 126.642464
						},
						{
							"areaId": "239102",
							"areaName": "国土资源局",
							"latitude": 45.756967,
							"longitude": 126.642464
						},
						{
							"areaId": "239103",
							"areaName": "红兴隆分局",
							"latitude": 45.756967,
							"longitude": 126.642464
						},
						{
							"areaId": "239104",
							"areaName": "建三江分局",
							"latitude": 45.756967,
							"longitude": 126.642464
						},
						{
							"areaId": "239105",
							"areaName": "牡丹江分局",
							"latitude": 45.756967,
							"longitude": 126.642464
						},
						{
							"areaId": "239106",
							"areaName": "北安分局",
							"latitude": 45.756967,
							"longitude": 126.642464
						},
						{
							"areaId": "239107",
							"areaName": "九三分局",
							"latitude": 45.756967,
							"longitude": 126.642464
						},
						{
							"areaId": "239108",
							"areaName": "齐齐哈尔分局",
							"latitude": 45.756967,
							"longitude": 126.642464
						},
						{
							"areaId": "239109",
							"areaName": "绥化分局",
							"latitude": 45.756967,
							"longitude": 126.642464
						},
						{
							"areaId": "239110",
							"areaName": "哈尔滨分局",
							"latitude": 45.756967,
							"longitude": 126.642464
						},
						{
							"areaId": "239111",
							"areaName": "直属佳南分局",
							"latitude": 45.756967,
							"longitude": 126.642464
						}
					]
				},
				{
					"areaId": "2392",
					"areaName": "黑龙江森工总局",
					"latitude": 45.756967,
					"longitude": 126.642464,
					"children": [{
							"areaId": "239201",
							"areaName": "国土资源局",
							"latitude": 45.756967,
							"longitude": 126.642464
						},
						{
							"areaId": "239202",
							"areaName": "松花江分局",
							"latitude": 45.756967,
							"longitude": 126.642464
						},
						{
							"areaId": "239203",
							"areaName": "牡丹江分局",
							"latitude": 45.756967,
							"longitude": 126.642464
						},
						{
							"areaId": "239204",
							"areaName": "合江分局",
							"latitude": 45.756967,
							"longitude": 126.642464
						}
					]
				},
				{
					"areaId": "2393",
					"areaName": "友谊国土资源局",
					"latitude": 45.756967,
					"longitude": 126.642464,
					"children": [{
						"areaId": "239300",
						"areaName": "友谊国土资源局",
						"latitude": 45.756967,
						"longitude": 126.642464
					}]
				},
				{
					"areaId": "2394",
					"areaName": "五大连池风景名胜区",
					"latitude": 45.756967,
					"longitude": 126.642464,
					"children": [{
						"areaId": "239400",
						"areaName": "五大连池风景名胜区",
						"latitude": 45.756967,
						"longitude": 126.642464
					}]
				}
			]
		},
		{
			"areaId": "31",
			"areaName": "上海市",
			"latitude": 31.231706,
			"longitude": 121.472644,
			"children": [{
					"areaId": "3101",
					"areaName": "上海市市辖区",
					"latitude": 31.231706,
					"longitude": 121.472644,
					"children": [{
							"areaId": "310100",
							"areaName": "上海市本级",
							"latitude": 31.231706,
							"longitude": 121.472644
						},
						{
							"areaId": "310101",
							"areaName": "黄浦区",
							"latitude": 31.22337,
							"longitude": 121.49295
						},
						{
							"areaId": "310103",
							"areaName": "卢湾区",
							"latitude": 31.231706,
							"longitude": 121.472644
						},
						{
							"areaId": "310104",
							"areaName": "徐汇区",
							"latitude": 31.18831,
							"longitude": 121.43676
						},
						{
							"areaId": "310105",
							"areaName": "长宁区",
							"latitude": 31.22036,
							"longitude": 121.42462
						},
						{
							"areaId": "310106",
							"areaName": "静安区",
							"latitude": 31.22884,
							"longitude": 121.4444
						},
						{
							"areaId": "310107",
							"areaName": "普陀区",
							"latitude": 29.94908,
							"longitude": 122.30278
						},
						{
							"areaId": "310108",
							"areaName": "闸北区",
							"latitude": 31.231706,
							"longitude": 121.472644
						},
						{
							"areaId": "310109",
							"areaName": "虹口区",
							"latitude": 31.27788,
							"longitude": 121.48162
						},
						{
							"areaId": "310110",
							"areaName": "杨浦区",
							"latitude": 31.2595,
							"longitude": 121.526
						},
						{
							"areaId": "310112",
							"areaName": "闵行区",
							"latitude": 31.11246,
							"longitude": 121.38162
						},
						{
							"areaId": "310113",
							"areaName": "宝山区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "310114",
							"areaName": "嘉定区",
							"latitude": 31.37473,
							"longitude": 121.2655
						},
						{
							"areaId": "310115",
							"areaName": "浦东新区",
							"latitude": 31.22249,
							"longitude": 121.5447
						},
						{
							"areaId": "310116",
							"areaName": "金山区",
							"latitude": 25.221883,
							"longitude": 121.636427
						},
						{
							"areaId": "310117",
							"areaName": "松江区",
							"latitude": 31.03222,
							"longitude": 121.22879
						},
						{
							"areaId": "310118",
							"areaName": "青浦区",
							"latitude": 31.14974,
							"longitude": 121.12417
						},
						{
							"areaId": "310119",
							"areaName": "南汇区",
							"latitude": 31.231706,
							"longitude": 121.472644
						},
						{
							"areaId": "310120",
							"areaName": "奉贤区",
							"latitude": 30.9179,
							"longitude": 121.47412
						}
					]
				},
				{
					"areaId": "3102",
					"areaName": "上海市所辖县",
					"latitude": 31.231706,
					"longitude": 121.472644,
					"children": [{
						"areaId": "310230",
						"areaName": "崇明县",
						"latitude": 31.231706,
						"longitude": 121.472644
					}]
				}
			]
		},
		{
			"areaId": "32",
			"areaName": "江苏省",
			"latitude": 32.041544,
			"longitude": 118.767413,
			"children": [{
					"areaId": "3201",
					"areaName": "南京市",
					"latitude": 32.041544,
					"longitude": 118.767413,
					"children": [{
							"areaId": "320100",
							"areaName": "南京市本级",
							"latitude": 32.041544,
							"longitude": 118.767413
						},
						{
							"areaId": "320102",
							"areaName": "玄武区",
							"latitude": 32.04856,
							"longitude": 118.79772
						},
						{
							"areaId": "320103",
							"areaName": "白下区",
							"latitude": 32.041544,
							"longitude": 118.767413
						},
						{
							"areaId": "320104",
							"areaName": "秦淮区",
							"latitude": 32.01112,
							"longitude": 118.79815
						},
						{
							"areaId": "320105",
							"areaName": "建邺区",
							"latitude": 32.03096,
							"longitude": 118.76641
						},
						{
							"areaId": "320106",
							"areaName": "鼓楼区",
							"latitude": 34.79517,
							"longitude": 114.35559
						},
						{
							"areaId": "320107",
							"areaName": "下关区",
							"latitude": 32.041544,
							"longitude": 118.767413
						},
						{
							"areaId": "320111",
							"areaName": "浦口区",
							"latitude": 32.05881,
							"longitude": 118.62802
						},
						{
							"areaId": "320113",
							"areaName": "栖霞区",
							"latitude": 32.11352,
							"longitude": 118.88064
						},
						{
							"areaId": "320114",
							"areaName": "雨花台区",
							"latitude": 31.99202,
							"longitude": 118.7799
						},
						{
							"areaId": "320115",
							"areaName": "江宁区",
							"latitude": 31.95263,
							"longitude": 118.8399
						},
						{
							"areaId": "320116",
							"areaName": "六合区",
							"latitude": 32.34222,
							"longitude": 118.8413
						},
						{
							"areaId": "320124",
							"areaName": "溧水县",
							"latitude": 32.041544,
							"longitude": 118.767413
						},
						{
							"areaId": "320125",
							"areaName": "高淳县",
							"latitude": 32.041544,
							"longitude": 118.767413
						}
					]
				},
				{
					"areaId": "3202",
					"areaName": "无锡市",
					"latitude": 31.574729,
					"longitude": 120.301663,
					"children": [{
							"areaId": "320200",
							"areaName": "无锡市本级",
							"latitude": 31.574729,
							"longitude": 120.301663
						},
						{
							"areaId": "320202",
							"areaName": "崇安区",
							"latitude": 31.574729,
							"longitude": 120.301663
						},
						{
							"areaId": "320203",
							"areaName": "南长区",
							"latitude": 31.574729,
							"longitude": 120.301663
						},
						{
							"areaId": "320204",
							"areaName": "北塘区",
							"latitude": 31.574729,
							"longitude": 120.301663
						},
						{
							"areaId": "320205",
							"areaName": "锡山区",
							"latitude": 31.5886,
							"longitude": 120.35699
						},
						{
							"areaId": "320206",
							"areaName": "惠山区",
							"latitude": 31.68088,
							"longitude": 120.29849
						},
						{
							"areaId": "320211",
							"areaName": "滨湖区",
							"latitude": 31.52162,
							"longitude": 120.29461
						},
						{
							"areaId": "320281",
							"areaName": "江阴市",
							"latitude": 31.91996,
							"longitude": 120.2853
						},
						{
							"areaId": "320282",
							"areaName": "宜兴市",
							"latitude": 31.33978,
							"longitude": 119.82357
						}
					]
				},
				{
					"areaId": "3203",
					"areaName": "徐州市",
					"latitude": 34.261792,
					"longitude": 117.184811,
					"children": [{
							"areaId": "320300",
							"areaName": "徐州市本级",
							"latitude": 34.261792,
							"longitude": 117.184811
						},
						{
							"areaId": "320302",
							"areaName": "鼓楼区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "320303",
							"areaName": "云龙区",
							"latitude": 34.24895,
							"longitude": 117.23053
						},
						{
							"areaId": "320304",
							"areaName": "九里区",
							"latitude": 34.261792,
							"longitude": 117.184811
						},
						{
							"areaId": "320305",
							"areaName": "贾汪区",
							"latitude": 34.44264,
							"longitude": 117.45346
						},
						{
							"areaId": "320311",
							"areaName": "泉山区",
							"latitude": 34.24418,
							"longitude": 117.19378
						},
						{
							"areaId": "320321",
							"areaName": "丰县",
							"latitude": 28.43766,
							"longitude": 118.19158
						},
						{
							"areaId": "320322",
							"areaName": "沛县",
							"latitude": 34.72163,
							"longitude": 116.93743
						},
						{
							"areaId": "320323",
							"areaName": "铜山县",
							"latitude": 34.261792,
							"longitude": 117.184811
						},
						{
							"areaId": "320324",
							"areaName": "睢宁县",
							"latitude": 33.91269,
							"longitude": 117.94104
						},
						{
							"areaId": "320381",
							"areaName": "新沂市",
							"latitude": 34.36942,
							"longitude": 118.35452
						},
						{
							"areaId": "320382",
							"areaName": "邳州市",
							"latitude": 34.33329,
							"longitude": 117.95858
						}
					]
				},
				{
					"areaId": "3204",
					"areaName": "常州市",
					"latitude": 31.772752,
					"longitude": 119.946973,
					"children": [{
							"areaId": "320400",
							"areaName": "常州市本级",
							"latitude": 31.772752,
							"longitude": 119.946973
						},
						{
							"areaId": "320402",
							"areaName": "天宁区",
							"latitude": 31.75211,
							"longitude": 119.95132
						},
						{
							"areaId": "320404",
							"areaName": "钟楼区",
							"latitude": 31.80221,
							"longitude": 119.90178
						},
						{
							"areaId": "320405",
							"areaName": "戚墅堰区",
							"latitude": 31.772752,
							"longitude": 119.946973
						},
						{
							"areaId": "320411",
							"areaName": "新北区",
							"latitude": 25.012366,
							"longitude": 121.465746
						},
						{
							"areaId": "320412",
							"areaName": "武进区",
							"latitude": 31.70086,
							"longitude": 119.94244
						},
						{
							"areaId": "320481",
							"areaName": "溧阳市",
							"latitude": 31.41538,
							"longitude": 119.4837
						},
						{
							"areaId": "320482",
							"areaName": "金坛市",
							"latitude": 31.772752,
							"longitude": 119.946973
						}
					]
				},
				{
					"areaId": "3205",
					"areaName": "苏州市",
					"latitude": 31.299379,
					"longitude": 120.619585,
					"children": [{
							"areaId": "320500",
							"areaName": "苏州市本级",
							"latitude": 31.299379,
							"longitude": 120.619585
						},
						{
							"areaId": "320502",
							"areaName": "沧浪区",
							"latitude": 31.299379,
							"longitude": 120.619585
						},
						{
							"areaId": "320503",
							"areaName": "平江区",
							"latitude": 31.299379,
							"longitude": 120.619585
						},
						{
							"areaId": "320504",
							"areaName": "金阊区",
							"latitude": 31.299379,
							"longitude": 120.619585
						},
						{
							"areaId": "320505",
							"areaName": "虎丘区",
							"latitude": 31.2953,
							"longitude": 120.57345
						},
						{
							"areaId": "320506",
							"areaName": "吴中区",
							"latitude": 31.26226,
							"longitude": 120.63211
						},
						{
							"areaId": "320507",
							"areaName": "相城区",
							"latitude": 31.36889,
							"longitude": 120.64239
						},
						{
							"areaId": "320581",
							"areaName": "常熟市",
							"latitude": 31.65374,
							"longitude": 120.75225
						},
						{
							"areaId": "320582",
							"areaName": "张家港市",
							"latitude": 31.87532,
							"longitude": 120.55538
						},
						{
							"areaId": "320583",
							"areaName": "昆山市",
							"latitude": 31.38464,
							"longitude": 120.98074
						},
						{
							"areaId": "320584",
							"areaName": "吴江市",
							"latitude": 31.299379,
							"longitude": 120.619585
						},
						{
							"areaId": "320585",
							"areaName": "太仓市",
							"latitude": 31.4497,
							"longitude": 121.10891
						}
					]
				},
				{
					"areaId": "3206",
					"areaName": "南通市",
					"latitude": 32.016212,
					"longitude": 120.864608,
					"children": [{
							"areaId": "320600",
							"areaName": "南通市本级",
							"latitude": 32.016212,
							"longitude": 120.864608
						},
						{
							"areaId": "320602",
							"areaName": "崇川区",
							"latitude": 32.0098,
							"longitude": 120.8573
						},
						{
							"areaId": "320611",
							"areaName": "港闸区",
							"latitude": 32.03163,
							"longitude": 120.81778
						},
						{
							"areaId": "320621",
							"areaName": "海安县",
							"latitude": 32.016212,
							"longitude": 120.864608
						},
						{
							"areaId": "320623",
							"areaName": "如东县",
							"latitude": 32.31439,
							"longitude": 121.18942
						},
						{
							"areaId": "320681",
							"areaName": "启东市",
							"latitude": 31.81083,
							"longitude": 121.65985
						},
						{
							"areaId": "320682",
							"areaName": "如皋市",
							"latitude": 32.37597,
							"longitude": 120.55969
						},
						{
							"areaId": "320683",
							"areaName": "通州市",
							"latitude": 32.016212,
							"longitude": 120.864608
						},
						{
							"areaId": "320684",
							"areaName": "海门市",
							"latitude": 31.89422,
							"longitude": 121.16995
						}
					]
				},
				{
					"areaId": "3207",
					"areaName": "连云港市",
					"latitude": 34.600018,
					"longitude": 119.178821,
					"children": [{
							"areaId": "320700",
							"areaName": "连云港市本级",
							"latitude": 34.600018,
							"longitude": 119.178821
						},
						{
							"areaId": "320703",
							"areaName": "连云区",
							"latitude": 34.75293,
							"longitude": 119.37304
						},
						{
							"areaId": "320705",
							"areaName": "新浦区",
							"latitude": 34.600018,
							"longitude": 119.178821
						},
						{
							"areaId": "320706",
							"areaName": "海州区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "320721",
							"areaName": "赣榆县",
							"latitude": 34.600018,
							"longitude": 119.178821
						},
						{
							"areaId": "320722",
							"areaName": "东海县",
							"latitude": 34.54215,
							"longitude": 118.77145
						},
						{
							"areaId": "320723",
							"areaName": "灌云县",
							"latitude": 34.28391,
							"longitude": 119.23925
						},
						{
							"areaId": "320724",
							"areaName": "灌南县",
							"latitude": 34.09,
							"longitude": 119.35632
						}
					]
				},
				{
					"areaId": "3208",
					"areaName": "淮安市",
					"latitude": 33.597506,
					"longitude": 119.021265,
					"children": [{
							"areaId": "320800",
							"areaName": "淮安市本级",
							"latitude": 33.597506,
							"longitude": 119.021265
						},
						{
							"areaId": "320802",
							"areaName": "清河区",
							"latitude": 33.597506,
							"longitude": 119.021265
						},
						{
							"areaId": "320803",
							"areaName": "楚州区",
							"latitude": 33.597506,
							"longitude": 119.021265
						},
						{
							"areaId": "320804",
							"areaName": "淮阴区",
							"latitude": 33.63171,
							"longitude": 119.03485
						},
						{
							"areaId": "320811",
							"areaName": "清浦区",
							"latitude": 33.597506,
							"longitude": 119.021265
						},
						{
							"areaId": "320826",
							"areaName": "涟水县",
							"latitude": 33.78094,
							"longitude": 119.26083
						},
						{
							"areaId": "320829",
							"areaName": "洪泽县",
							"latitude": 33.597506,
							"longitude": 119.021265
						},
						{
							"areaId": "320830",
							"areaName": "盱眙县",
							"latitude": 33.01086,
							"longitude": 118.54495
						},
						{
							"areaId": "320831",
							"areaName": "金湖县",
							"latitude": 24.438633,
							"longitude": 118.419743
						}
					]
				},
				{
					"areaId": "3209",
					"areaName": "盐城市",
					"latitude": 33.377631,
					"longitude": 120.139998,
					"children": [{
							"areaId": "320900",
							"areaName": "盐城市本级",
							"latitude": 33.377631,
							"longitude": 120.139998
						},
						{
							"areaId": "320902",
							"areaName": "亭湖区",
							"latitude": 33.37825,
							"longitude": 120.16583
						},
						{
							"areaId": "320903",
							"areaName": "盐都区",
							"latitude": 33.3373,
							"longitude": 120.15441
						},
						{
							"areaId": "320921",
							"areaName": "响水县",
							"latitude": 34.20513,
							"longitude": 119.56985
						},
						{
							"areaId": "320922",
							"areaName": "滨海县",
							"latitude": 33.98972,
							"longitude": 119.82058
						},
						{
							"areaId": "320923",
							"areaName": "阜宁县",
							"latitude": 33.78228,
							"longitude": 119.80175
						},
						{
							"areaId": "320924",
							"areaName": "射阳县",
							"latitude": 33.77636,
							"longitude": 120.26043
						},
						{
							"areaId": "320925",
							"areaName": "建湖县",
							"latitude": 33.47241,
							"longitude": 119.79852
						},
						{
							"areaId": "320981",
							"areaName": "东台市",
							"latitude": 32.85078,
							"longitude": 120.32376
						},
						{
							"areaId": "320982",
							"areaName": "大丰市",
							"latitude": 33.377631,
							"longitude": 120.139998
						}
					]
				},
				{
					"areaId": "3210",
					"areaName": "扬州市",
					"latitude": 32.393159,
					"longitude": 119.421003,
					"children": [{
							"areaId": "321000",
							"areaName": "扬州市本级",
							"latitude": 32.393159,
							"longitude": 119.421003
						},
						{
							"areaId": "321002",
							"areaName": "广陵区",
							"latitude": 32.39472,
							"longitude": 119.43186
						},
						{
							"areaId": "321003",
							"areaName": "邗江区",
							"latitude": 32.3765,
							"longitude": 119.39816
						},
						{
							"areaId": "321011",
							"areaName": "维扬区",
							"latitude": 32.393159,
							"longitude": 119.421003
						},
						{
							"areaId": "321023",
							"areaName": "宝应县",
							"latitude": 33.23549,
							"longitude": 119.31213
						},
						{
							"areaId": "321081",
							"areaName": "仪征市",
							"latitude": 32.27197,
							"longitude": 119.18432
						},
						{
							"areaId": "321084",
							"areaName": "高邮市",
							"latitude": 32.78135,
							"longitude": 119.45965
						},
						{
							"areaId": "321088",
							"areaName": "江都市",
							"latitude": 32.393159,
							"longitude": 119.421003
						}
					]
				},
				{
					"areaId": "3211",
					"areaName": "镇江市",
					"latitude": 32.204402,
					"longitude": 119.452753,
					"children": [{
							"areaId": "321100",
							"areaName": "镇江市本级",
							"latitude": 32.204402,
							"longitude": 119.452753
						},
						{
							"areaId": "321102",
							"areaName": "京口区",
							"latitude": 32.19809,
							"longitude": 119.46947
						},
						{
							"areaId": "321111",
							"areaName": "润州区",
							"latitude": 32.19523,
							"longitude": 119.41134
						},
						{
							"areaId": "321112",
							"areaName": "丹徒区",
							"latitude": 32.13183,
							"longitude": 119.43383
						},
						{
							"areaId": "321181",
							"areaName": "丹阳市",
							"latitude": 31.99121,
							"longitude": 119.57525
						},
						{
							"areaId": "321182",
							"areaName": "扬中市",
							"latitude": 32.2363,
							"longitude": 119.79718
						},
						{
							"areaId": "321183",
							"areaName": "句容市",
							"latitude": 31.95591,
							"longitude": 119.16482
						}
					]
				},
				{
					"areaId": "3212",
					"areaName": "泰州市",
					"latitude": 32.484882,
					"longitude": 119.915176,
					"children": [{
							"areaId": "321200",
							"areaName": "泰州市本级",
							"latitude": 32.484882,
							"longitude": 119.915176
						},
						{
							"areaId": "321202",
							"areaName": "海陵区",
							"latitude": 32.49101,
							"longitude": 119.91942
						},
						{
							"areaId": "321203",
							"areaName": "高港区",
							"latitude": 32.31833,
							"longitude": 119.88089
						},
						{
							"areaId": "321281",
							"areaName": "兴化市",
							"latitude": 32.90944,
							"longitude": 119.85238
						},
						{
							"areaId": "321282",
							"areaName": "靖江市",
							"latitude": 32.01595,
							"longitude": 120.27291
						},
						{
							"areaId": "321283",
							"areaName": "泰兴市",
							"latitude": 32.17187,
							"longitude": 120.05194
						},
						{
							"areaId": "321284",
							"areaName": "姜堰市",
							"latitude": 32.484882,
							"longitude": 119.915176
						}
					]
				},
				{
					"areaId": "3213",
					"areaName": "宿迁市",
					"latitude": 33.945154,
					"longitude": 118.293328,
					"children": [{
							"areaId": "321300",
							"areaName": "宿迁市本级",
							"latitude": 33.945154,
							"longitude": 118.293328
						},
						{
							"areaId": "321302",
							"areaName": "宿城区",
							"latitude": 33.94219,
							"longitude": 118.29141
						},
						{
							"areaId": "321311",
							"areaName": "宿豫区",
							"latitude": 33.94673,
							"longitude": 118.32922
						},
						{
							"areaId": "321322",
							"areaName": "沭阳县",
							"latitude": 34.11446,
							"longitude": 118.76873
						},
						{
							"areaId": "321323",
							"areaName": "泗阳县",
							"latitude": 33.72096,
							"longitude": 118.7033
						},
						{
							"areaId": "321324",
							"areaName": "泗洪县",
							"latitude": 33.45996,
							"longitude": 118.21716
						}
					]
				}
			]
		},
		{
			"areaId": "33",
			"areaName": "浙江省",
			"latitude": 30.287459,
			"longitude": 120.153576,
			"children": [{
					"areaId": "3301",
					"areaName": "杭州市",
					"latitude": 30.287459,
					"longitude": 120.153576,
					"children": [{
							"areaId": "330100",
							"areaName": "杭州市本级",
							"latitude": 30.287459,
							"longitude": 120.153576
						},
						{
							"areaId": "330102",
							"areaName": "上城区",
							"latitude": 30.24255,
							"longitude": 120.16922
						},
						{
							"areaId": "330103",
							"areaName": "下城区",
							"latitude": 30.28153,
							"longitude": 120.18096
						},
						{
							"areaId": "330104",
							"areaName": "江干区",
							"latitude": 30.2572,
							"longitude": 120.20517
						},
						{
							"areaId": "330105",
							"areaName": "拱墅区",
							"latitude": 30.31968,
							"longitude": 120.14209
						},
						{
							"areaId": "330106",
							"areaName": "西湖区",
							"latitude": 23.775291,
							"longitude": 121.003418
						},
						{
							"areaId": "330108",
							"areaName": "滨江区",
							"latitude": 30.20835,
							"longitude": 120.21194
						},
						{
							"areaId": "330110",
							"areaName": "余杭区",
							"latitude": 30.41829,
							"longitude": 120.29986
						},
						{
							"areaId": "330122",
							"areaName": "桐庐县",
							"latitude": 29.79779,
							"longitude": 119.68853
						},
						{
							"areaId": "330127",
							"areaName": "淳安县",
							"latitude": 29.60988,
							"longitude": 119.04257
						},
						{
							"areaId": "330181",
							"areaName": "萧山区",
							"latitude": 30.287459,
							"longitude": 120.153576
						},
						{
							"areaId": "330182",
							"areaName": "建德市",
							"latitude": 29.47603,
							"longitude": 119.28158
						},
						{
							"areaId": "330183",
							"areaName": "富阳市",
							"latitude": 30.287459,
							"longitude": 120.153576
						},
						{
							"areaId": "330185",
							"areaName": "临安市",
							"latitude": 30.287459,
							"longitude": 120.153576
						}
					]
				},
				{
					"areaId": "3302",
					"areaName": "宁波市",
					"latitude": 29.868388,
					"longitude": 121.549792,
					"children": [{
							"areaId": "330200",
							"areaName": "宁波市本级",
							"latitude": 29.868388,
							"longitude": 121.549792
						},
						{
							"areaId": "330203",
							"areaName": "海曙区",
							"latitude": 29.85977,
							"longitude": 121.55106
						},
						{
							"areaId": "330204",
							"areaName": "江东区",
							"latitude": 29.868388,
							"longitude": 121.549792
						},
						{
							"areaId": "330205",
							"areaName": "江北区",
							"latitude": 29.60658,
							"longitude": 106.57434
						},
						{
							"areaId": "330206",
							"areaName": "北仑区",
							"latitude": 29.90069,
							"longitude": 121.84408
						},
						{
							"areaId": "330211",
							"areaName": "镇海区",
							"latitude": 29.94893,
							"longitude": 121.71615
						},
						{
							"areaId": "330212",
							"areaName": "鄞州区",
							"latitude": 29.81614,
							"longitude": 121.54754
						},
						{
							"areaId": "330225",
							"areaName": "象山县",
							"latitude": 29.47758,
							"longitude": 121.86917
						},
						{
							"areaId": "330226",
							"areaName": "宁海县",
							"latitude": 29.2889,
							"longitude": 121.43072
						},
						{
							"areaId": "330281",
							"areaName": "余姚市",
							"latitude": 30.03867,
							"longitude": 121.15341
						},
						{
							"areaId": "330282",
							"areaName": "慈溪市",
							"latitude": 30.16959,
							"longitude": 121.26641
						},
						{
							"areaId": "330283",
							"areaName": "奉化市",
							"latitude": 29.868388,
							"longitude": 121.549792
						}
					]
				},
				{
					"areaId": "3303",
					"areaName": "温州市",
					"latitude": 28.000575,
					"longitude": 120.672111,
					"children": [{
							"areaId": "330300",
							"areaName": "温州市本级",
							"latitude": 28.000575,
							"longitude": 120.672111
						},
						{
							"areaId": "330302",
							"areaName": "鹿城区",
							"latitude": 28.01489,
							"longitude": 120.65505
						},
						{
							"areaId": "330303",
							"areaName": "龙湾区",
							"latitude": 27.91284,
							"longitude": 120.83053
						},
						{
							"areaId": "330304",
							"areaName": "瓯海区",
							"latitude": 28.00714,
							"longitude": 120.63751
						},
						{
							"areaId": "330322",
							"areaName": "洞头县",
							"latitude": 28.000575,
							"longitude": 120.672111
						},
						{
							"areaId": "330324",
							"areaName": "永嘉县",
							"latitude": 28.15456,
							"longitude": 120.69317
						},
						{
							"areaId": "330326",
							"areaName": "平阳县",
							"latitude": 27.66245,
							"longitude": 120.56506
						},
						{
							"areaId": "330327",
							"areaName": "苍南县",
							"latitude": 27.51739,
							"longitude": 120.42608
						},
						{
							"areaId": "330328",
							"areaName": "文成县",
							"latitude": 27.78678,
							"longitude": 120.09063
						},
						{
							"areaId": "330329",
							"areaName": "泰顺县",
							"latitude": 27.55694,
							"longitude": 119.7182
						},
						{
							"areaId": "330381",
							"areaName": "瑞安市",
							"latitude": 27.78041,
							"longitude": 120.65466
						},
						{
							"areaId": "330382",
							"areaName": "乐清市",
							"latitude": 28.12404,
							"longitude": 120.9617
						}
					]
				},
				{
					"areaId": "3304",
					"areaName": "嘉兴市",
					"latitude": 30.762653,
					"longitude": 120.750865,
					"children": [{
							"areaId": "330400",
							"areaName": "嘉兴市本级",
							"latitude": 30.762653,
							"longitude": 120.750865
						},
						{
							"areaId": "330402",
							"areaName": "南湖区",
							"latitude": 30.74865,
							"longitude": 120.78524
						},
						{
							"areaId": "330411",
							"areaName": "秀洲区",
							"latitude": 30.76454,
							"longitude": 120.70867
						},
						{
							"areaId": "330421",
							"areaName": "嘉善县",
							"latitude": 30.82993,
							"longitude": 120.92559
						},
						{
							"areaId": "330424",
							"areaName": "海盐县",
							"latitude": 30.52547,
							"longitude": 120.9457
						},
						{
							"areaId": "330481",
							"areaName": "海宁市",
							"latitude": 30.5097,
							"longitude": 120.6813
						},
						{
							"areaId": "330482",
							"areaName": "平湖市",
							"latitude": 30.69618,
							"longitude": 121.02166
						},
						{
							"areaId": "330483",
							"areaName": "桐乡市",
							"latitude": 30.6302,
							"longitude": 120.56485
						}
					]
				},
				{
					"areaId": "3305",
					"areaName": "湖州市",
					"latitude": 30.867198,
					"longitude": 120.102398,
					"children": [{
							"areaId": "330500",
							"areaName": "湖州市本级",
							"latitude": 30.867198,
							"longitude": 120.102398
						},
						{
							"areaId": "330502",
							"areaName": "吴兴区",
							"latitude": 30.85752,
							"longitude": 120.12548
						},
						{
							"areaId": "330503",
							"areaName": "南浔区",
							"latitude": 30.86686,
							"longitude": 120.42038
						},
						{
							"areaId": "330504",
							"areaName": "湖州经济开发区",
							"latitude": 30.867198,
							"longitude": 120.102398
						},
						{
							"areaId": "330521",
							"areaName": "德清县",
							"latitude": 30.53369,
							"longitude": 119.97836
						},
						{
							"areaId": "330522",
							"areaName": "长兴县",
							"latitude": 31.00606,
							"longitude": 119.90783
						},
						{
							"areaId": "330523",
							"areaName": "安吉县",
							"latitude": 30.63798,
							"longitude": 119.68158
						}
					]
				},
				{
					"areaId": "3306",
					"areaName": "绍兴市",
					"latitude": 29.997117,
					"longitude": 120.582112,
					"children": [{
							"areaId": "330600",
							"areaName": "绍兴市本级",
							"latitude": 29.997117,
							"longitude": 120.582112
						},
						{
							"areaId": "330602",
							"areaName": "越城区",
							"latitude": 29.98895,
							"longitude": 120.5819
						},
						{
							"areaId": "330621",
							"areaName": "绍兴县",
							"latitude": 29.997117,
							"longitude": 120.582112
						},
						{
							"areaId": "330624",
							"areaName": "新昌县",
							"latitude": 29.49991,
							"longitude": 120.90435
						},
						{
							"areaId": "330681",
							"areaName": "诸暨市",
							"latitude": 29.71358,
							"longitude": 120.23629
						},
						{
							"areaId": "330682",
							"areaName": "上虞市",
							"latitude": 29.997117,
							"longitude": 120.582112
						},
						{
							"areaId": "330683",
							"areaName": "嵊州市",
							"latitude": 29.58854,
							"longitude": 120.82174
						}
					]
				},
				{
					"areaId": "3307",
					"areaName": "金华市",
					"latitude": 29.089524,
					"longitude": 119.649506,
					"children": [{
							"areaId": "330700",
							"areaName": "金华市本级",
							"latitude": 29.089524,
							"longitude": 119.649506
						},
						{
							"areaId": "330702",
							"areaName": "婺城区",
							"latitude": 29.09521,
							"longitude": 119.57135
						},
						{
							"areaId": "330721",
							"areaName": "金东区",
							"latitude": 29.089524,
							"longitude": 119.649506
						},
						{
							"areaId": "330723",
							"areaName": "武义县",
							"latitude": 28.89331,
							"longitude": 119.8164
						},
						{
							"areaId": "330726",
							"areaName": "浦江县",
							"latitude": 29.45353,
							"longitude": 119.89181
						},
						{
							"areaId": "330727",
							"areaName": "磐安县",
							"latitude": 29.05733,
							"longitude": 120.45022
						},
						{
							"areaId": "330781",
							"areaName": "兰溪市",
							"latitude": 29.20841,
							"longitude": 119.45965
						},
						{
							"areaId": "330782",
							"areaName": "义乌市",
							"latitude": 29.30558,
							"longitude": 120.0744
						},
						{
							"areaId": "330783",
							"areaName": "东阳市",
							"latitude": 29.28942,
							"longitude": 120.24185
						},
						{
							"areaId": "330784",
							"areaName": "永康市",
							"latitude": 23.026061,
							"longitude": 120.257069
						}
					]
				},
				{
					"areaId": "3308",
					"areaName": "衢州市",
					"latitude": 28.941708,
					"longitude": 118.87263,
					"children": [{
							"areaId": "330800",
							"areaName": "衢州市本级",
							"latitude": 28.941708,
							"longitude": 118.87263
						},
						{
							"areaId": "330802",
							"areaName": "柯城区",
							"latitude": 28.96858,
							"longitude": 118.87109
						},
						{
							"areaId": "330821",
							"areaName": "衢江区",
							"latitude": 28.941708,
							"longitude": 118.87263
						},
						{
							"areaId": "330822",
							"areaName": "常山县",
							"latitude": 28.90191,
							"longitude": 118.51025
						},
						{
							"areaId": "330824",
							"areaName": "开化县",
							"latitude": 29.13785,
							"longitude": 118.41616
						},
						{
							"areaId": "330825",
							"areaName": "龙游县",
							"latitude": 29.02823,
							"longitude": 119.17221
						},
						{
							"areaId": "330881",
							"areaName": "江山市",
							"latitude": 28.7386,
							"longitude": 118.62674
						}
					]
				},
				{
					"areaId": "3309",
					"areaName": "舟山市",
					"latitude": 30.140377,
					"longitude": 122.03064,
					"children": [{
							"areaId": "330900",
							"areaName": "舟山市本级",
							"latitude": 30.140377,
							"longitude": 122.03064
						},
						{
							"areaId": "330902",
							"areaName": "定海区",
							"latitude": 30.01985,
							"longitude": 122.10677
						},
						{
							"areaId": "330903",
							"areaName": "普陀区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "330921",
							"areaName": "岱山县",
							"latitude": 30.277269,
							"longitude": 122.180123
						},
						{
							"areaId": "330922",
							"areaName": "嵊泗县",
							"latitude": 30.72678,
							"longitude": 122.45129
						}
					]
				},
				{
					"areaId": "3310",
					"areaName": "台州市",
					"latitude": 28.661378,
					"longitude": 121.428599,
					"children": [{
							"areaId": "331000",
							"areaName": "台州市本级",
							"latitude": 28.661378,
							"longitude": 121.428599
						},
						{
							"areaId": "331002",
							"areaName": "椒江区",
							"latitude": 28.67301,
							"longitude": 121.44287
						},
						{
							"areaId": "331003",
							"areaName": "黄岩区",
							"latitude": 28.65077,
							"longitude": 121.25891
						},
						{
							"areaId": "331004",
							"areaName": "路桥区",
							"latitude": 28.58016,
							"longitude": 121.37381
						},
						{
							"areaId": "331021",
							"areaName": "玉环县",
							"latitude": 28.661378,
							"longitude": 121.428599
						},
						{
							"areaId": "331022",
							"areaName": "三门县",
							"latitude": 29.1051,
							"longitude": 121.3937
						},
						{
							"areaId": "331023",
							"areaName": "天台县",
							"latitude": 29.1429,
							"longitude": 121.00848
						},
						{
							"areaId": "331024",
							"areaName": "仙居县",
							"latitude": 28.84672,
							"longitude": 120.72872
						},
						{
							"areaId": "331081",
							"areaName": "温岭市",
							"latitude": 28.37176,
							"longitude": 121.38595
						},
						{
							"areaId": "331082",
							"areaName": "临海市",
							"latitude": 28.85603,
							"longitude": 121.13885
						},
						{
							"areaId": "331099",
							"areaName": "台州经济开发区",
							"latitude": 28.661378,
							"longitude": 121.428599
						}
					]
				},
				{
					"areaId": "3311",
					"areaName": "丽水市",
					"latitude": 28.451993,
					"longitude": 119.921786,
					"children": [{
							"areaId": "331100",
							"areaName": "丽水市本级",
							"latitude": 28.451993,
							"longitude": 119.921786
						},
						{
							"areaId": "331102",
							"areaName": "莲都区",
							"latitude": 28.44583,
							"longitude": 119.9127
						},
						{
							"areaId": "331121",
							"areaName": "青田县",
							"latitude": 28.13897,
							"longitude": 120.29028
						},
						{
							"areaId": "331122",
							"areaName": "缙云县",
							"latitude": 28.65944,
							"longitude": 120.09036
						},
						{
							"areaId": "331123",
							"areaName": "遂昌县",
							"latitude": 28.59291,
							"longitude": 119.27606
						},
						{
							"areaId": "331124",
							"areaName": "松阳县",
							"latitude": 28.4494,
							"longitude": 119.48199
						},
						{
							"areaId": "331125",
							"areaName": "云和县",
							"latitude": 28.11643,
							"longitude": 119.57287
						},
						{
							"areaId": "331126",
							"areaName": "庆元县",
							"latitude": 27.61842,
							"longitude": 119.06256
						},
						{
							"areaId": "331127",
							"areaName": "景宁畲族自治县",
							"latitude": 27.97393,
							"longitude": 119.63839
						},
						{
							"areaId": "331181",
							"areaName": "龙泉市",
							"latitude": 28.0743,
							"longitude": 119.14163
						}
					]
				}
			]
		},
		{
			"areaId": "34",
			"areaName": "安徽省",
			"latitude": 31.86119,
			"longitude": 117.283042,
			"children": [{
					"areaId": "3401",
					"areaName": "合肥市",
					"latitude": 31.86119,
					"longitude": 117.283042,
					"children": [{
							"areaId": "340100",
							"areaName": "合肥市本级",
							"latitude": 31.86119,
							"longitude": 117.283042
						},
						{
							"areaId": "340102",
							"areaName": "瑶海区",
							"latitude": 31.85809,
							"longitude": 117.30947
						},
						{
							"areaId": "340103",
							"areaName": "庐阳区",
							"latitude": 31.87874,
							"longitude": 117.26452
						},
						{
							"areaId": "340104",
							"areaName": "蜀山区",
							"latitude": 31.85117,
							"longitude": 117.26104
						},
						{
							"areaId": "340111",
							"areaName": "包河区",
							"latitude": 31.79502,
							"longitude": 117.30984
						},
						{
							"areaId": "340121",
							"areaName": "长丰县",
							"latitude": 32.47959,
							"longitude": 117.16549
						},
						{
							"areaId": "340122",
							"areaName": "肥东县",
							"latitude": 31.88525,
							"longitude": 117.47128
						},
						{
							"areaId": "340123",
							"areaName": "肥西县",
							"latitude": 31.72143,
							"longitude": 117.16845
						}
					]
				},
				{
					"areaId": "3402",
					"areaName": "芜湖市",
					"latitude": 31.326319,
					"longitude": 118.376451,
					"children": [{
							"areaId": "340200",
							"areaName": "芜湖市本级",
							"latitude": 31.326319,
							"longitude": 118.376451
						},
						{
							"areaId": "340202",
							"areaName": "镜湖区",
							"latitude": 31.34038,
							"longitude": 118.38525
						},
						{
							"areaId": "340203",
							"areaName": "弋江区",
							"latitude": 31.31178,
							"longitude": 118.37265
						},
						{
							"areaId": "340207",
							"areaName": "鸠江区",
							"latitude": 31.36928,
							"longitude": 118.39215
						},
						{
							"areaId": "340208",
							"areaName": "三山区",
							"latitude": 31.20703,
							"longitude": 118.22509
						},
						{
							"areaId": "340221",
							"areaName": "湾沚区",
							"latitude": 31.13476,
							"longitude": 118.57525
						},
						{
							"areaId": "340222",
							"areaName": "繁昌县",
							"latitude": 31.08319,
							"longitude": 118.19982
						},
						{
							"areaId": "340223",
							"areaName": "南陵县",
							"latitude": 30.91969,
							"longitude": 118.33688
						}
					]
				},
				{
					"areaId": "3403",
					"areaName": "蚌埠市",
					"latitude": 32.934037,
					"longitude": 117.36237,
					"children": [{
							"areaId": "340300",
							"areaName": "蚌埠市本级",
							"latitude": 32.934037,
							"longitude": 117.36237
						},
						{
							"areaId": "340302",
							"areaName": "龙子湖区",
							"latitude": 32.94301,
							"longitude": 117.39379
						},
						{
							"areaId": "340303",
							"areaName": "蚌山区",
							"latitude": 32.94411,
							"longitude": 117.36767
						},
						{
							"areaId": "340304",
							"areaName": "禹会区",
							"latitude": 32.93336,
							"longitude": 117.35315
						},
						{
							"areaId": "340311",
							"areaName": "淮上区",
							"latitude": 32.96423,
							"longitude": 117.35983
						},
						{
							"areaId": "340321",
							"areaName": "怀远县",
							"latitude": 32.97007,
							"longitude": 117.20507
						},
						{
							"areaId": "340322",
							"areaName": "五河县",
							"latitude": 33.14457,
							"longitude": 117.89144
						},
						{
							"areaId": "340323",
							"areaName": "固镇县",
							"latitude": 33.31803,
							"longitude": 117.31558
						}
					]
				},
				{
					"areaId": "3404",
					"areaName": "淮南市",
					"latitude": 32.645947,
					"longitude": 117.025449,
					"children": [{
							"areaId": "340400",
							"areaName": "淮南市本级",
							"latitude": 32.645947,
							"longitude": 117.025449
						},
						{
							"areaId": "340402",
							"areaName": "大通区",
							"latitude": 32.63265,
							"longitude": 117.05255
						},
						{
							"areaId": "340403",
							"areaName": "田家庵区",
							"latitude": 32.64697,
							"longitude": 117.01739
						},
						{
							"areaId": "340404",
							"areaName": "谢家集区",
							"latitude": 32.59818,
							"longitude": 116.86377
						},
						{
							"areaId": "340405",
							"areaName": "八公山区",
							"latitude": 32.62941,
							"longitude": 116.83694
						},
						{
							"areaId": "340406",
							"areaName": "潘集区",
							"latitude": 32.78287,
							"longitude": 116.81622
						},
						{
							"areaId": "340421",
							"areaName": "凤台县",
							"latitude": 32.70752,
							"longitude": 116.71569
						}
					]
				},
				{
					"areaId": "3405",
					"areaName": "马鞍山市",
					"latitude": 31.689362,
					"longitude": 118.507906,
					"children": [{
							"areaId": "340500",
							"areaName": "马鞍山市本级",
							"latitude": 31.689362,
							"longitude": 118.507906
						},
						{
							"areaId": "340502",
							"areaName": "金家庄区",
							"latitude": 31.689362,
							"longitude": 118.507906
						},
						{
							"areaId": "340503",
							"areaName": "花山区",
							"latitude": 31.7001,
							"longitude": 118.51231
						},
						{
							"areaId": "340504",
							"areaName": "雨山区",
							"latitude": 31.68219,
							"longitude": 118.49869
						},
						{
							"areaId": "340521",
							"areaName": "当涂县",
							"latitude": 31.57098,
							"longitude": 118.49786
						}
					]
				},
				{
					"areaId": "3406",
					"areaName": "淮北市",
					"latitude": 33.971707,
					"longitude": 116.794664,
					"children": [{
							"areaId": "340600",
							"areaName": "淮北市本级",
							"latitude": 33.971707,
							"longitude": 116.794664
						},
						{
							"areaId": "340602",
							"areaName": "杜集区",
							"latitude": 33.99363,
							"longitude": 116.82998
						},
						{
							"areaId": "340603",
							"areaName": "相山区",
							"latitude": 33.95979,
							"longitude": 116.79464
						},
						{
							"areaId": "340604",
							"areaName": "烈山区",
							"latitude": 33.89355,
							"longitude": 116.81448
						},
						{
							"areaId": "340621",
							"areaName": "濉溪县",
							"latitude": 33.91455,
							"longitude": 116.76785
						}
					]
				},
				{
					"areaId": "3407",
					"areaName": "铜陵市",
					"latitude": 30.95365,
					"longitude": 117.79113,
					"children": [{
							"areaId": "340700",
							"areaName": "铜陵市本级",
							"latitude": 30.95365,
							"longitude": 117.79113
						},
						{
							"areaId": "340702",
							"areaName": "铜官山区",
							"latitude": 30.95365,
							"longitude": 117.79113
						},
						{
							"areaId": "340703",
							"areaName": "狮子山区",
							"latitude": 30.95365,
							"longitude": 117.79113
						},
						{
							"areaId": "340711",
							"areaName": "郊区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "340721",
							"areaName": "铜陵县",
							"latitude": 30.95365,
							"longitude": 117.79113
						}
					]
				},
				{
					"areaId": "3408",
					"areaName": "安庆市",
					"latitude": 30.524816,
					"longitude": 117.053571,
					"children": [{
							"areaId": "340800",
							"areaName": "安庆市本级",
							"latitude": 30.524816,
							"longitude": 117.053571
						},
						{
							"areaId": "340802",
							"areaName": "迎江区",
							"latitude": 30.50421,
							"longitude": 117.0493
						},
						{
							"areaId": "340803",
							"areaName": "大观区",
							"latitude": 30.51216,
							"longitude": 117.03426
						},
						{
							"areaId": "340811",
							"areaName": "宜秀区",
							"latitude": 30.50783,
							"longitude": 117.06127
						},
						{
							"areaId": "340822",
							"areaName": "怀宁县",
							"latitude": 30.73376,
							"longitude": 116.82968
						},
						{
							"areaId": "340823",
							"areaName": "枞阳县",
							"latitude": 30.524816,
							"longitude": 117.053571
						},
						{
							"areaId": "340824",
							"areaName": "潜山县",
							"latitude": 30.524816,
							"longitude": 117.053571
						},
						{
							"areaId": "340825",
							"areaName": "太湖县",
							"latitude": 30.4541,
							"longitude": 116.3088
						},
						{
							"areaId": "340826",
							"areaName": "宿松县",
							"latitude": 30.1536,
							"longitude": 116.12915
						},
						{
							"areaId": "340827",
							"areaName": "望江县",
							"latitude": 30.12585,
							"longitude": 116.68814
						},
						{
							"areaId": "340828",
							"areaName": "岳西县",
							"latitude": 30.84983,
							"longitude": 116.35995
						},
						{
							"areaId": "340881",
							"areaName": "桐城市",
							"latitude": 31.05216,
							"longitude": 116.95071
						}
					]
				},
				{
					"areaId": "3410",
					"areaName": "黄山市",
					"latitude": 29.709239,
					"longitude": 118.317325,
					"children": [{
							"areaId": "341000",
							"areaName": "黄山市本级",
							"latitude": 29.709239,
							"longitude": 118.317325
						},
						{
							"areaId": "341002",
							"areaName": "屯溪区",
							"latitude": 29.71138,
							"longitude": 118.33368
						},
						{
							"areaId": "341003",
							"areaName": "黄山区",
							"latitude": 30.2729,
							"longitude": 118.1416
						},
						{
							"areaId": "341004",
							"areaName": "徽州区",
							"latitude": 29.82784,
							"longitude": 118.33654
						},
						{
							"areaId": "341021",
							"areaName": "歙县",
							"latitude": 29.86745,
							"longitude": 118.43676
						},
						{
							"areaId": "341022",
							"areaName": "休宁县",
							"latitude": 29.78607,
							"longitude": 118.18136
						},
						{
							"areaId": "341023",
							"areaName": "黟县",
							"latitude": 29.92588,
							"longitude": 117.94137
						},
						{
							"areaId": "341024",
							"areaName": "祁门县",
							"latitude": 29.85723,
							"longitude": 117.71847
						}
					]
				},
				{
					"areaId": "3411",
					"areaName": "滁州市",
					"latitude": 32.303627,
					"longitude": 118.316264,
					"children": [{
							"areaId": "341100",
							"areaName": "滁州市本级",
							"latitude": 32.303627,
							"longitude": 118.316264
						},
						{
							"areaId": "341102",
							"areaName": "琅琊区",
							"latitude": 32.29521,
							"longitude": 118.30538
						},
						{
							"areaId": "341103",
							"areaName": "南谯区",
							"latitude": 32.31861,
							"longitude": 118.31222
						},
						{
							"areaId": "341122",
							"areaName": "来安县",
							"latitude": 32.45176,
							"longitude": 118.43438
						},
						{
							"areaId": "341124",
							"areaName": "全椒县",
							"latitude": 32.08524,
							"longitude": 118.27291
						},
						{
							"areaId": "341125",
							"areaName": "定远县",
							"latitude": 32.52488,
							"longitude": 117.68035
						},
						{
							"areaId": "341126",
							"areaName": "凤阳县",
							"latitude": 32.86507,
							"longitude": 117.56454
						},
						{
							"areaId": "341181",
							"areaName": "天长市",
							"latitude": 32.69124,
							"longitude": 118.99868
						},
						{
							"areaId": "341182",
							"areaName": "明光市",
							"latitude": 32.77819,
							"longitude": 117.99093
						}
					]
				},
				{
					"areaId": "3412",
					"areaName": "阜阳市",
					"latitude": 32.896969,
					"longitude": 115.819729,
					"children": [{
							"areaId": "341200",
							"areaName": "阜阳市本级",
							"latitude": 32.896969,
							"longitude": 115.819729
						},
						{
							"areaId": "341202",
							"areaName": "颍州区",
							"latitude": 32.88346,
							"longitude": 115.80694
						},
						{
							"areaId": "341203",
							"areaName": "颍东区",
							"latitude": 32.91296,
							"longitude": 115.85659
						},
						{
							"areaId": "341204",
							"areaName": "颍泉区",
							"latitude": 32.9249,
							"longitude": 115.80712
						},
						{
							"areaId": "341221",
							"areaName": "临泉县",
							"latitude": 33.06758,
							"longitude": 115.26232
						},
						{
							"areaId": "341222",
							"areaName": "太和县",
							"latitude": 33.16025,
							"longitude": 115.62191
						},
						{
							"areaId": "341225",
							"areaName": "阜南县",
							"latitude": 32.63551,
							"longitude": 115.58563
						},
						{
							"areaId": "341226",
							"areaName": "颍上县",
							"latitude": 32.62998,
							"longitude": 116.26458
						},
						{
							"areaId": "341282",
							"areaName": "界首市",
							"latitude": 33.25714,
							"longitude": 115.37445
						}
					]
				},
				{
					"areaId": "3413",
					"areaName": "宿州市",
					"latitude": 33.633891,
					"longitude": 116.984084,
					"children": [{
							"areaId": "341300",
							"areaName": "宿州市本级",
							"latitude": 33.633891,
							"longitude": 116.984084
						},
						{
							"areaId": "341302",
							"areaName": "埇桥区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "341321",
							"areaName": "砀山县",
							"latitude": 34.42356,
							"longitude": 116.35363
						},
						{
							"areaId": "341322",
							"areaName": "萧县",
							"latitude": 34.1879,
							"longitude": 116.94546
						},
						{
							"areaId": "341323",
							"areaName": "灵璧县",
							"latitude": 33.54339,
							"longitude": 117.55813
						},
						{
							"areaId": "341324",
							"areaName": "泗县",
							"latitude": 33.48295,
							"longitude": 117.91033
						}
					]
				},
				{
					"areaId": "3414",
					"areaName": "巢湖市",
					"latitude": 31.86119,
					"longitude": 117.283042,
					"children": [{
							"areaId": "341400",
							"areaName": "巢湖市本级",
							"latitude": 31.86119,
							"longitude": 117.283042
						},
						{
							"areaId": "341402",
							"areaName": "居巢区",
							"latitude": 31.86119,
							"longitude": 117.283042
						},
						{
							"areaId": "341421",
							"areaName": "庐江县",
							"latitude": 31.86119,
							"longitude": 117.283042
						},
						{
							"areaId": "341422",
							"areaName": "无为县",
							"latitude": 31.86119,
							"longitude": 117.283042
						},
						{
							"areaId": "341423",
							"areaName": "含山县",
							"latitude": 31.86119,
							"longitude": 117.283042
						},
						{
							"areaId": "341424",
							"areaName": "和县",
							"latitude": 31.86119,
							"longitude": 117.283042
						}
					]
				},
				{
					"areaId": "3415",
					"areaName": "六安市",
					"latitude": 31.752889,
					"longitude": 116.507676,
					"children": [{
							"areaId": "341500",
							"areaName": "六安市本级",
							"latitude": 31.752889,
							"longitude": 116.507676
						},
						{
							"areaId": "341502",
							"areaName": "金安区",
							"latitude": 31.75573,
							"longitude": 116.50912
						},
						{
							"areaId": "341503",
							"areaName": "裕安区",
							"latitude": 31.73787,
							"longitude": 116.47985
						},
						{
							"areaId": "341521",
							"areaName": "寿县",
							"latitude": 31.752889,
							"longitude": 116.507676
						},
						{
							"areaId": "341522",
							"areaName": "霍邱县",
							"latitude": 32.353,
							"longitude": 116.27795
						},
						{
							"areaId": "341523",
							"areaName": "舒城县",
							"latitude": 31.46413,
							"longitude": 116.94491
						},
						{
							"areaId": "341524",
							"areaName": "金寨县",
							"latitude": 31.7351,
							"longitude": 115.93463
						},
						{
							"areaId": "341525",
							"areaName": "霍山县",
							"latitude": 31.3929,
							"longitude": 116.33291
						}
					]
				},
				{
					"areaId": "3416",
					"areaName": "亳州市",
					"latitude": 33.869338,
					"longitude": 115.782939,
					"children": [{
							"areaId": "341600",
							"areaName": "亳州市本级",
							"latitude": 33.869338,
							"longitude": 115.782939
						},
						{
							"areaId": "341602",
							"areaName": "谯城区",
							"latitude": 33.87532,
							"longitude": 115.77941
						},
						{
							"areaId": "341621",
							"areaName": "涡阳县",
							"latitude": 33.50911,
							"longitude": 116.21682
						},
						{
							"areaId": "341622",
							"areaName": "蒙城县",
							"latitude": 33.26477,
							"longitude": 116.5646
						},
						{
							"areaId": "341623",
							"areaName": "利辛县",
							"latitude": 33.14198,
							"longitude": 116.208
						}
					]
				},
				{
					"areaId": "3417",
					"areaName": "池州市",
					"latitude": 30.656037,
					"longitude": 117.489157,
					"children": [{
							"areaId": "341700",
							"areaName": "池州市本级",
							"latitude": 30.656037,
							"longitude": 117.489157
						},
						{
							"areaId": "341702",
							"areaName": "贵池区",
							"latitude": 30.65283,
							"longitude": 117.48722
						},
						{
							"areaId": "341721",
							"areaName": "东至县",
							"latitude": 30.0969,
							"longitude": 117.02719
						},
						{
							"areaId": "341722",
							"areaName": "石台县",
							"latitude": 30.21042,
							"longitude": 117.48666
						},
						{
							"areaId": "341723",
							"areaName": "青阳县",
							"latitude": 30.63932,
							"longitude": 117.84744
						}
					]
				},
				{
					"areaId": "3418",
					"areaName": "宣城市",
					"latitude": 30.945667,
					"longitude": 118.757995,
					"children": [{
							"areaId": "341800",
							"areaName": "宣城市本级",
							"latitude": 30.945667,
							"longitude": 118.757995
						},
						{
							"areaId": "341802",
							"areaName": "宣州区",
							"latitude": 30.94439,
							"longitude": 118.75462
						},
						{
							"areaId": "341821",
							"areaName": "郎溪县",
							"latitude": 31.12599,
							"longitude": 119.17923
						},
						{
							"areaId": "341822",
							"areaName": "广德县",
							"latitude": 30.945667,
							"longitude": 118.757995
						},
						{
							"areaId": "341823",
							"areaName": "泾县",
							"latitude": 30.69498,
							"longitude": 118.41964
						},
						{
							"areaId": "341824",
							"areaName": "绩溪县",
							"latitude": 30.07069,
							"longitude": 118.59765
						},
						{
							"areaId": "341825",
							"areaName": "旌德县",
							"latitude": 30.28898,
							"longitude": 118.54299
						},
						{
							"areaId": "341881",
							"areaName": "宁国市",
							"latitude": 30.6238,
							"longitude": 118.98349
						}
					]
				}
			]
		},
		{
			"areaId": "35",
			"areaName": "福建省",
			"latitude": 26.075302,
			"longitude": 119.306239,
			"children": [{
					"areaId": "3501",
					"areaName": "福州市",
					"latitude": 26.075302,
					"longitude": 119.306239,
					"children": [{
							"areaId": "350100",
							"areaName": "福州市本级",
							"latitude": 26.075302,
							"longitude": 119.306239
						},
						{
							"areaId": "350102",
							"areaName": "鼓楼区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "350103",
							"areaName": "台江区",
							"latitude": 26.06204,
							"longitude": 119.30899
						},
						{
							"areaId": "350104",
							"areaName": "仓山区",
							"latitude": 26.04335,
							"longitude": 119.31543
						},
						{
							"areaId": "350105",
							"areaName": "马尾区",
							"latitude": 25.98942,
							"longitude": 119.4555
						},
						{
							"areaId": "350111",
							"areaName": "晋安区",
							"latitude": 26.0818,
							"longitude": 119.32828
						},
						{
							"areaId": "350121",
							"areaName": "闽侯县",
							"latitude": 26.15014,
							"longitude": 119.13388
						},
						{
							"areaId": "350122",
							"areaName": "连江县",
							"latitude": 26.197364,
							"longitude": 119.539704
						},
						{
							"areaId": "350123",
							"areaName": "罗源县",
							"latitude": 26.48752,
							"longitude": 119.5509
						},
						{
							"areaId": "350124",
							"areaName": "闽清县",
							"latitude": 26.21901,
							"longitude": 118.8623
						},
						{
							"areaId": "350125",
							"areaName": "永泰县",
							"latitude": 25.86816,
							"longitude": 118.936
						},
						{
							"areaId": "350128",
							"areaName": "平潭县",
							"latitude": 25.503672,
							"longitude": 119.791197
						},
						{
							"areaId": "350181",
							"areaName": "福清市",
							"latitude": 25.72086,
							"longitude": 119.38507
						},
						{
							"areaId": "350182",
							"areaName": "长乐市",
							"latitude": 26.075302,
							"longitude": 119.306239
						}
					]
				},
				{
					"areaId": "3502",
					"areaName": "厦门市",
					"latitude": 24.490474,
					"longitude": 118.11022,
					"children": [{
							"areaId": "350200",
							"areaName": "厦门市本级",
							"latitude": 24.490474,
							"longitude": 118.11022
						},
						{
							"areaId": "350203",
							"areaName": "思明区",
							"latitude": 24.44543,
							"longitude": 118.08233
						},
						{
							"areaId": "350205",
							"areaName": "海沧区",
							"latitude": 24.48461,
							"longitude": 118.03289
						},
						{
							"areaId": "350206",
							"areaName": "湖里区",
							"latitude": 24.51253,
							"longitude": 118.14621
						},
						{
							"areaId": "350211",
							"areaName": "集美区",
							"latitude": 24.57584,
							"longitude": 118.09719
						},
						{
							"areaId": "350212",
							"areaName": "同安区",
							"latitude": 24.72308,
							"longitude": 118.15197
						},
						{
							"areaId": "350213",
							"areaName": "翔安区",
							"latitude": 24.61863,
							"longitude": 118.24783
						}
					]
				},
				{
					"areaId": "3503",
					"areaName": "莆田市",
					"latitude": 25.431011,
					"longitude": 119.007558,
					"children": [{
							"areaId": "350300",
							"areaName": "莆田市本级",
							"latitude": 25.431011,
							"longitude": 119.007558
						},
						{
							"areaId": "350302",
							"areaName": "城厢区",
							"latitude": 25.41872,
							"longitude": 118.99462
						},
						{
							"areaId": "350303",
							"areaName": "涵江区",
							"latitude": 25.45876,
							"longitude": 119.11621
						},
						{
							"areaId": "350304",
							"areaName": "荔城区",
							"latitude": 25.43369,
							"longitude": 119.01339
						},
						{
							"areaId": "350305",
							"areaName": "秀屿区",
							"latitude": 25.31831,
							"longitude": 119.10553
						},
						{
							"areaId": "350322",
							"areaName": "仙游县",
							"latitude": 25.36214,
							"longitude": 118.69177
						}
					]
				},
				{
					"areaId": "3504",
					"areaName": "三明市",
					"latitude": 26.265444,
					"longitude": 117.635001,
					"children": [{
							"areaId": "350400",
							"areaName": "三明市本级",
							"latitude": 26.265444,
							"longitude": 117.635001
						},
						{
							"areaId": "350402",
							"areaName": "梅列区",
							"latitude": 26.27171,
							"longitude": 117.64585
						},
						{
							"areaId": "350403",
							"areaName": "三元区",
							"latitude": 26.23372,
							"longitude": 117.60788
						},
						{
							"areaId": "350421",
							"areaName": "明溪县",
							"latitude": 26.35294,
							"longitude": 117.20498
						},
						{
							"areaId": "350423",
							"areaName": "清流县",
							"latitude": 26.17144,
							"longitude": 116.8146
						},
						{
							"areaId": "350424",
							"areaName": "宁化县",
							"latitude": 26.25874,
							"longitude": 116.66101
						},
						{
							"areaId": "350425",
							"areaName": "大田县",
							"latitude": 25.6926,
							"longitude": 117.8471
						},
						{
							"areaId": "350426",
							"areaName": "尤溪县",
							"latitude": 26.17002,
							"longitude": 118.19049
						},
						{
							"areaId": "350427",
							"areaName": "沙县",
							"latitude": 26.39615,
							"longitude": 117.79266
						},
						{
							"areaId": "350428",
							"areaName": "将乐县",
							"latitude": 26.72837,
							"longitude": 117.47317
						},
						{
							"areaId": "350429",
							"areaName": "泰宁县",
							"latitude": 26.9001,
							"longitude": 117.17578
						},
						{
							"areaId": "350430",
							"areaName": "建宁县",
							"latitude": 26.83091,
							"longitude": 116.84603
						},
						{
							"areaId": "350481",
							"areaName": "永安市",
							"latitude": 22.81858,
							"longitude": 120.225308
						}
					]
				},
				{
					"areaId": "3505",
					"areaName": "泉州市",
					"latitude": 24.908853,
					"longitude": 118.589421,
					"children": [{
							"areaId": "350500",
							"areaName": "泉州市本级",
							"latitude": 24.908853,
							"longitude": 118.589421
						},
						{
							"areaId": "350502",
							"areaName": "鲤城区",
							"latitude": 24.88741,
							"longitude": 118.56591
						},
						{
							"areaId": "350503",
							"areaName": "丰泽区",
							"latitude": 24.89119,
							"longitude": 118.61328
						},
						{
							"areaId": "350504",
							"areaName": "洛江区",
							"latitude": 24.93984,
							"longitude": 118.67111
						},
						{
							"areaId": "350505",
							"areaName": "泉港区",
							"latitude": 25.12005,
							"longitude": 118.91586
						},
						{
							"areaId": "350521",
							"areaName": "惠安县",
							"latitude": 25.03059,
							"longitude": 118.79687
						},
						{
							"areaId": "350524",
							"areaName": "安溪县",
							"latitude": 25.05627,
							"longitude": 118.18719
						},
						{
							"areaId": "350525",
							"areaName": "永春县",
							"latitude": 25.32183,
							"longitude": 118.29437
						},
						{
							"areaId": "350526",
							"areaName": "德化县",
							"latitude": 25.49224,
							"longitude": 118.24176
						},
						{
							"areaId": "350527",
							"areaName": "金门县",
							"latitude": 24.908853,
							"longitude": 118.589421
						},
						{
							"areaId": "350581",
							"areaName": "石狮市",
							"latitude": 24.73242,
							"longitude": 118.64779
						},
						{
							"areaId": "350582",
							"areaName": "晋江市",
							"latitude": 24.78141,
							"longitude": 118.55194
						},
						{
							"areaId": "350583",
							"areaName": "南安市",
							"latitude": 24.96055,
							"longitude": 118.38589
						}
					]
				},
				{
					"areaId": "3506",
					"areaName": "漳州市",
					"latitude": 24.510897,
					"longitude": 117.661801,
					"children": [{
							"areaId": "350600",
							"areaName": "漳州市本级",
							"latitude": 24.510897,
							"longitude": 117.661801
						},
						{
							"areaId": "350602",
							"areaName": "芗城区",
							"latitude": 24.51081,
							"longitude": 117.65402
						},
						{
							"areaId": "350603",
							"areaName": "龙文区",
							"latitude": 24.50323,
							"longitude": 117.70971
						},
						{
							"areaId": "350622",
							"areaName": "云霄县",
							"latitude": 23.95534,
							"longitude": 117.34051
						},
						{
							"areaId": "350623",
							"areaName": "漳浦县",
							"latitude": 24.11706,
							"longitude": 117.61367
						},
						{
							"areaId": "350624",
							"areaName": "诏安县",
							"latitude": 23.71148,
							"longitude": 117.17501
						},
						{
							"areaId": "350625",
							"areaName": "长泰县",
							"latitude": 24.62526,
							"longitude": 117.75924
						},
						{
							"areaId": "350626",
							"areaName": "东山县",
							"latitude": 23.70109,
							"longitude": 117.42822
						},
						{
							"areaId": "350627",
							"areaName": "南靖县",
							"latitude": 24.51448,
							"longitude": 117.35736
						},
						{
							"areaId": "350628",
							"areaName": "平和县",
							"latitude": 24.36395,
							"longitude": 117.3124
						},
						{
							"areaId": "350629",
							"areaName": "华安县",
							"latitude": 25.00563,
							"longitude": 117.54077
						},
						{
							"areaId": "350681",
							"areaName": "龙海市",
							"latitude": 24.44655,
							"longitude": 117.81802
						}
					]
				},
				{
					"areaId": "3507",
					"areaName": "南平市",
					"latitude": 26.635627,
					"longitude": 118.178459,
					"children": [{
							"areaId": "350700",
							"areaName": "南平市本级",
							"latitude": 26.635627,
							"longitude": 118.178459
						},
						{
							"areaId": "350702",
							"areaName": "延平区",
							"latitude": 22.902358,
							"longitude": 121.084499
						},
						{
							"areaId": "350721",
							"areaName": "顺昌县",
							"latitude": 26.79298,
							"longitude": 117.8103
						},
						{
							"areaId": "350722",
							"areaName": "浦城县",
							"latitude": 27.91888,
							"longitude": 118.54007
						},
						{
							"areaId": "350723",
							"areaName": "光泽县",
							"latitude": 27.54231,
							"longitude": 117.33346
						},
						{
							"areaId": "350724",
							"areaName": "松溪县",
							"latitude": 27.52624,
							"longitude": 118.78533
						},
						{
							"areaId": "350725",
							"areaName": "政和县",
							"latitude": 27.36769,
							"longitude": 118.85571
						},
						{
							"areaId": "350781",
							"areaName": "邵武市",
							"latitude": 27.34033,
							"longitude": 117.4924
						},
						{
							"areaId": "350782",
							"areaName": "武夷山市",
							"latitude": 27.75543,
							"longitude": 118.03665
						},
						{
							"areaId": "350783",
							"areaName": "建瓯市",
							"latitude": 27.02301,
							"longitude": 118.29766
						},
						{
							"areaId": "350784",
							"areaName": "建阳市",
							"latitude": 26.635627,
							"longitude": 118.178459
						}
					]
				},
				{
					"areaId": "3508",
					"areaName": "龙岩市",
					"latitude": 25.091603,
					"longitude": 117.02978,
					"children": [{
							"areaId": "350800",
							"areaName": "龙岩市本级",
							"latitude": 25.091603,
							"longitude": 117.02978
						},
						{
							"areaId": "350802",
							"areaName": "新罗区",
							"latitude": 25.09834,
							"longitude": 117.03693
						},
						{
							"areaId": "350821",
							"areaName": "长汀县",
							"latitude": 25.82773,
							"longitude": 116.35888
						},
						{
							"areaId": "350822",
							"areaName": "永定县",
							"latitude": 25.091603,
							"longitude": 117.02978
						},
						{
							"areaId": "350823",
							"areaName": "上杭县",
							"latitude": 25.04943,
							"longitude": 116.42022
						},
						{
							"areaId": "350824",
							"areaName": "武平县",
							"latitude": 25.09244,
							"longitude": 116.10229
						},
						{
							"areaId": "350825",
							"areaName": "连城县",
							"latitude": 25.7103,
							"longitude": 116.75454
						},
						{
							"areaId": "350881",
							"areaName": "漳平市",
							"latitude": 25.29109,
							"longitude": 117.41992
						}
					]
				},
				{
					"areaId": "3509",
					"areaName": "宁德市",
					"latitude": 26.65924,
					"longitude": 119.527082,
					"children": [{
							"areaId": "350900",
							"areaName": "宁德市本级",
							"latitude": 26.65924,
							"longitude": 119.527082
						},
						{
							"areaId": "350902",
							"areaName": "蕉城区",
							"latitude": 26.66048,
							"longitude": 119.52643
						},
						{
							"areaId": "350921",
							"areaName": "霞浦县",
							"latitude": 26.88578,
							"longitude": 119.99893
						},
						{
							"areaId": "350922",
							"areaName": "古田县",
							"latitude": 26.57682,
							"longitude": 118.74688
						},
						{
							"areaId": "350923",
							"areaName": "屏南县",
							"latitude": 26.91099,
							"longitude": 118.98861
						},
						{
							"areaId": "350924",
							"areaName": "寿宁县",
							"latitude": 27.45996,
							"longitude": 119.5039
						},
						{
							"areaId": "350925",
							"areaName": "周宁县",
							"latitude": 27.10664,
							"longitude": 119.33837
						},
						{
							"areaId": "350926",
							"areaName": "柘荣县",
							"latitude": 27.23543,
							"longitude": 119.89971
						},
						{
							"areaId": "350981",
							"areaName": "福安市",
							"latitude": 27.08673,
							"longitude": 119.6495
						},
						{
							"areaId": "350982",
							"areaName": "福鼎市",
							"latitude": 27.3243,
							"longitude": 120.21664
						}
					]
				}
			]
		},
		{
			"areaId": "36",
			"areaName": "江西省",
			"latitude": 28.676493,
			"longitude": 115.892151,
			"children": [{
					"areaId": "3601",
					"areaName": "南昌市",
					"latitude": 28.676493,
					"longitude": 115.892151,
					"children": [{
							"areaId": "360100",
							"areaName": "南昌市本级",
							"latitude": 28.676493,
							"longitude": 115.892151
						},
						{
							"areaId": "360102",
							"areaName": "东湖区",
							"latitude": 28.68505,
							"longitude": 115.8988
						},
						{
							"areaId": "360103",
							"areaName": "西湖区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "360104",
							"areaName": "青云谱区",
							"latitude": 28.63199,
							"longitude": 115.915
						},
						{
							"areaId": "360105",
							"areaName": "湾里区",
							"latitude": 28.676493,
							"longitude": 115.892151
						},
						{
							"areaId": "360111",
							"areaName": "青山湖区",
							"latitude": 28.68206,
							"longitude": 115.9617
						},
						{
							"areaId": "360121",
							"areaName": "南昌县",
							"latitude": 28.54559,
							"longitude": 115.94393
						},
						{
							"areaId": "360122",
							"areaName": "新建县",
							"latitude": 28.676493,
							"longitude": 115.892151
						},
						{
							"areaId": "360123",
							"areaName": "安义县",
							"latitude": 28.84602,
							"longitude": 115.54879
						},
						{
							"areaId": "360124",
							"areaName": "进贤县",
							"latitude": 28.37679,
							"longitude": 116.24087
						}
					]
				},
				{
					"areaId": "3602",
					"areaName": "景德镇市",
					"latitude": 29.29256,
					"longitude": 117.214664,
					"children": [{
							"areaId": "360200",
							"areaName": "景德镇市本级",
							"latitude": 29.29256,
							"longitude": 117.214664
						},
						{
							"areaId": "360202",
							"areaName": "昌江区",
							"latitude": 29.27321,
							"longitude": 117.18359
						},
						{
							"areaId": "360203",
							"areaName": "珠山区",
							"latitude": 29.30127,
							"longitude": 117.20233
						},
						{
							"areaId": "360222",
							"areaName": "浮梁县",
							"latitude": 29.35156,
							"longitude": 117.21517
						},
						{
							"areaId": "360281",
							"areaName": "乐平市",
							"latitude": 28.96295,
							"longitude": 117.12887
						}
					]
				},
				{
					"areaId": "3603",
					"areaName": "萍乡市",
					"latitude": 27.622946,
					"longitude": 113.852186,
					"children": [{
							"areaId": "360300",
							"areaName": "萍乡市本级",
							"latitude": 27.622946,
							"longitude": 113.852186
						},
						{
							"areaId": "360302",
							"areaName": "安源区",
							"latitude": 27.61653,
							"longitude": 113.89135
						},
						{
							"areaId": "360313",
							"areaName": "湘东区",
							"latitude": 27.64007,
							"longitude": 113.73294
						},
						{
							"areaId": "360321",
							"areaName": "莲花县",
							"latitude": 27.12866,
							"longitude": 113.96142
						},
						{
							"areaId": "360322",
							"areaName": "上栗县",
							"latitude": 27.87467,
							"longitude": 113.79403
						},
						{
							"areaId": "360323",
							"areaName": "芦溪县",
							"latitude": 27.63063,
							"longitude": 114.02951
						}
					]
				},
				{
					"areaId": "3604",
					"areaName": "九江市",
					"latitude": 29.60852,
					"longitude": 115.91128,
					"children": [{
							"areaId": "360400",
							"areaName": "九江市本级",
							"latitude": 29.60852,
							"longitude": 115.91128
						},
						{
							"areaId": "360402",
							"areaName": "庐山区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "360403",
							"areaName": "浔阳区",
							"latitude": 29.72786,
							"longitude": 115.98986
						},
						{
							"areaId": "360421",
							"areaName": "九江县",
							"latitude": 29.60852,
							"longitude": 115.91128
						},
						{
							"areaId": "360423",
							"areaName": "武宁县",
							"latitude": 29.2584,
							"longitude": 115.10061
						},
						{
							"areaId": "360424",
							"areaName": "修水县",
							"latitude": 29.02539,
							"longitude": 114.54684
						},
						{
							"areaId": "360425",
							"areaName": "永修县",
							"latitude": 29.02093,
							"longitude": 115.80911
						},
						{
							"areaId": "360426",
							"areaName": "德安县",
							"latitude": 29.31341,
							"longitude": 115.75601
						},
						{
							"areaId": "360427",
							"areaName": "星子县",
							"latitude": 29.60852,
							"longitude": 115.91128
						},
						{
							"areaId": "360428",
							"areaName": "都昌县",
							"latitude": 29.27327,
							"longitude": 116.20401
						},
						{
							"areaId": "360429",
							"areaName": "湖口县",
							"latitude": 24.903943,
							"longitude": 121.043691
						},
						{
							"areaId": "360430",
							"areaName": "彭泽县",
							"latitude": 29.89589,
							"longitude": 116.55011
						},
						{
							"areaId": "360481",
							"areaName": "瑞昌市",
							"latitude": 29.67183,
							"longitude": 115.66705
						},
						{
							"areaId": "360482",
							"areaName": "共青城市",
							"latitude": 29.238785,
							"longitude": 115.801939
						}
					]
				},
				{
					"areaId": "3605",
					"areaName": "新余市",
					"latitude": 27.810834,
					"longitude": 114.930835,
					"children": [{
							"areaId": "360500",
							"areaName": "新余市本级",
							"latitude": 27.810834,
							"longitude": 114.930835
						},
						{
							"areaId": "360502",
							"areaName": "渝水区",
							"latitude": 27.80098,
							"longitude": 114.944
						},
						{
							"areaId": "360521",
							"areaName": "分宜县",
							"latitude": 27.81475,
							"longitude": 114.69189
						}
					]
				},
				{
					"areaId": "3606",
					"areaName": "鹰潭市",
					"latitude": 28.238638,
					"longitude": 117.033838,
					"children": [{
							"areaId": "360600",
							"areaName": "鹰潭市本级",
							"latitude": 28.238638,
							"longitude": 117.033838
						},
						{
							"areaId": "360602",
							"areaName": "月湖区",
							"latitude": 28.23913,
							"longitude": 117.03732
						},
						{
							"areaId": "360622",
							"areaName": "余江县",
							"latitude": 28.238638,
							"longitude": 117.033838
						},
						{
							"areaId": "360681",
							"areaName": "贵溪市",
							"latitude": 28.2926,
							"longitude": 117.24246
						}
					]
				},
				{
					"areaId": "3607",
					"areaName": "赣州市",
					"latitude": 25.85097,
					"longitude": 114.940278,
					"children": [{
							"areaId": "360700",
							"areaName": "赣州市本级",
							"latitude": 25.85097,
							"longitude": 114.940278
						},
						{
							"areaId": "360702",
							"areaName": "章贡区",
							"latitude": 25.8624,
							"longitude": 114.94284
						},
						{
							"areaId": "360721",
							"areaName": "赣县",
							"latitude": 25.85097,
							"longitude": 114.940278
						},
						{
							"areaId": "360722",
							"areaName": "信丰县",
							"latitude": 25.38612,
							"longitude": 114.92279
						},
						{
							"areaId": "360723",
							"areaName": "大余县",
							"latitude": 25.39561,
							"longitude": 114.35757
						},
						{
							"areaId": "360724",
							"areaName": "上犹县",
							"latitude": 25.79567,
							"longitude": 114.54138
						},
						{
							"areaId": "360725",
							"areaName": "崇义县",
							"latitude": 25.68186,
							"longitude": 114.30835
						},
						{
							"areaId": "360726",
							"areaName": "安远县",
							"latitude": 25.1371,
							"longitude": 115.39483
						},
						{
							"areaId": "360727",
							"areaName": "龙南县",
							"latitude": 25.85097,
							"longitude": 114.940278
						},
						{
							"areaId": "360728",
							"areaName": "定南县",
							"latitude": 24.78395,
							"longitude": 115.02713
						},
						{
							"areaId": "360729",
							"areaName": "全南县",
							"latitude": 24.74324,
							"longitude": 114.5292
						},
						{
							"areaId": "360730",
							"areaName": "宁都县",
							"latitude": 26.47227,
							"longitude": 116.01565
						},
						{
							"areaId": "360731",
							"areaName": "于都县",
							"latitude": 25.95257,
							"longitude": 115.41415
						},
						{
							"areaId": "360732",
							"areaName": "兴国县",
							"latitude": 26.33776,
							"longitude": 115.36309
						},
						{
							"areaId": "360733",
							"areaName": "会昌县",
							"latitude": 25.60068,
							"longitude": 115.78555
						},
						{
							"areaId": "360734",
							"areaName": "寻乌县",
							"latitude": 24.95513,
							"longitude": 115.64852
						},
						{
							"areaId": "360735",
							"areaName": "石城县",
							"latitude": 26.32617,
							"longitude": 116.3442
						},
						{
							"areaId": "360781",
							"areaName": "瑞金市",
							"latitude": 25.88557,
							"longitude": 116.02703
						},
						{
							"areaId": "360782",
							"areaName": "南康市",
							"latitude": 25.85097,
							"longitude": 114.940278
						}
					]
				},
				{
					"areaId": "3608",
					"areaName": "吉安市",
					"latitude": 23.961635,
					"longitude": 121.568005,
					"children": [{
							"areaId": "360800",
							"areaName": "吉安市本级",
							"latitude": 23.961635,
							"longitude": 121.568005
						},
						{
							"areaId": "360802",
							"areaName": "吉州区",
							"latitude": 27.10669,
							"longitude": 114.97598
						},
						{
							"areaId": "360803",
							"areaName": "青原区",
							"latitude": 27.10577,
							"longitude": 115.01747
						},
						{
							"areaId": "360821",
							"areaName": "吉安县",
							"latitude": 27.04048,
							"longitude": 114.90695
						},
						{
							"areaId": "360822",
							"areaName": "吉水县",
							"latitude": 27.21071,
							"longitude": 115.1343
						},
						{
							"areaId": "360823",
							"areaName": "峡江县",
							"latitude": 27.576,
							"longitude": 115.31723
						},
						{
							"areaId": "360824",
							"areaName": "新干县",
							"latitude": 27.74092,
							"longitude": 115.39306
						},
						{
							"areaId": "360825",
							"areaName": "永丰县",
							"latitude": 27.31785,
							"longitude": 115.44238
						},
						{
							"areaId": "360826",
							"areaName": "泰和县",
							"latitude": 26.79113,
							"longitude": 114.90789
						},
						{
							"areaId": "360827",
							"areaName": "遂川县",
							"latitude": 26.32598,
							"longitude": 114.51629
						},
						{
							"areaId": "360828",
							"areaName": "万安县",
							"latitude": 26.45931,
							"longitude": 114.78659
						},
						{
							"areaId": "360829",
							"areaName": "安福县",
							"latitude": 27.39276,
							"longitude": 114.61956
						},
						{
							"areaId": "360830",
							"areaName": "永新县",
							"latitude": 26.94488,
							"longitude": 114.24246
						},
						{
							"areaId": "360881",
							"areaName": "井冈山市",
							"latitude": 22.796762,
							"longitude": 120.29582
						}
					]
				},
				{
					"areaId": "3609",
					"areaName": "宜春市",
					"latitude": 27.8043,
					"longitude": 114.391136,
					"children": [{
							"areaId": "360900",
							"areaName": "宜春市本级",
							"latitude": 27.8043,
							"longitude": 114.391136
						},
						{
							"areaId": "360902",
							"areaName": "袁州区",
							"latitude": 27.79649,
							"longitude": 114.38246
						},
						{
							"areaId": "360921",
							"areaName": "奉新县",
							"latitude": 28.6879,
							"longitude": 115.40036
						},
						{
							"areaId": "360922",
							"areaName": "万载县",
							"latitude": 28.10656,
							"longitude": 114.4458
						},
						{
							"areaId": "360923",
							"areaName": "上高县",
							"latitude": 28.23423,
							"longitude": 114.92459
						},
						{
							"areaId": "360924",
							"areaName": "宜丰县",
							"latitude": 28.38555,
							"longitude": 114.7803
						},
						{
							"areaId": "360925",
							"areaName": "靖安县",
							"latitude": 28.86167,
							"longitude": 115.36279
						},
						{
							"areaId": "360926",
							"areaName": "铜鼓县",
							"latitude": 28.52311,
							"longitude": 114.37036
						},
						{
							"areaId": "360981",
							"areaName": "丰城市",
							"latitude": 28.15918,
							"longitude": 115.77114
						},
						{
							"areaId": "360982",
							"areaName": "樟树市",
							"latitude": 28.05332,
							"longitude": 115.5465
						},
						{
							"areaId": "360983",
							"areaName": "高安市",
							"latitude": 28.4178,
							"longitude": 115.3753
						}
					]
				},
				{
					"areaId": "3610",
					"areaName": "抚州市",
					"latitude": 27.98385,
					"longitude": 116.358351,
					"children": [{
							"areaId": "361000",
							"areaName": "抚州市本级",
							"latitude": 27.98385,
							"longitude": 116.358351
						},
						{
							"areaId": "361002",
							"areaName": "临川区",
							"latitude": 27.97721,
							"longitude": 116.35919
						},
						{
							"areaId": "361021",
							"areaName": "南城县",
							"latitude": 27.55381,
							"longitude": 116.64419
						},
						{
							"areaId": "361022",
							"areaName": "黎川县",
							"latitude": 27.28232,
							"longitude": 116.90771
						},
						{
							"areaId": "361023",
							"areaName": "南丰县",
							"latitude": 27.21842,
							"longitude": 116.5256
						},
						{
							"areaId": "361024",
							"areaName": "崇仁县",
							"latitude": 27.75962,
							"longitude": 116.06021
						},
						{
							"areaId": "361025",
							"areaName": "乐安县",
							"latitude": 27.42812,
							"longitude": 115.83108
						},
						{
							"areaId": "361026",
							"areaName": "宜黄县",
							"latitude": 27.55487,
							"longitude": 116.23626
						},
						{
							"areaId": "361027",
							"areaName": "金溪县",
							"latitude": 27.90753,
							"longitude": 116.77392
						},
						{
							"areaId": "361028",
							"areaName": "资溪县",
							"latitude": 27.70493,
							"longitude": 117.06939
						},
						{
							"areaId": "361029",
							"areaName": "东乡县",
							"latitude": 27.98385,
							"longitude": 116.358351
						},
						{
							"areaId": "361030",
							"areaName": "广昌县",
							"latitude": 26.8341,
							"longitude": 116.32547
						}
					]
				},
				{
					"areaId": "3611",
					"areaName": "上饶市",
					"latitude": 28.44856,
					"longitude": 117.90884,
					"children": [{
							"areaId": "361100",
							"areaName": "上饶市本级",
							"latitude": 28.44856,
							"longitude": 117.90884
						},
						{
							"areaId": "361102",
							"areaName": "信州区",
							"latitude": 28.43121,
							"longitude": 117.96682
						},
						{
							"areaId": "361121",
							"areaName": "上饶县",
							"latitude": 28.44856,
							"longitude": 117.90884
						},
						{
							"areaId": "361122",
							"areaName": "广丰县",
							"latitude": 28.44856,
							"longitude": 117.90884
						},
						{
							"areaId": "361123",
							"areaName": "玉山县",
							"latitude": 28.6818,
							"longitude": 118.24462
						},
						{
							"areaId": "361124",
							"areaName": "铅山县",
							"latitude": 28.31549,
							"longitude": 117.70996
						},
						{
							"areaId": "361125",
							"areaName": "横峰县",
							"latitude": 28.40716,
							"longitude": 117.5964
						},
						{
							"areaId": "361126",
							"areaName": "弋阳县",
							"latitude": 28.37451,
							"longitude": 117.45929
						},
						{
							"areaId": "361127",
							"areaName": "余干县",
							"latitude": 28.70206,
							"longitude": 116.69555
						},
						{
							"areaId": "361128",
							"areaName": "鄱阳县",
							"latitude": 29.0118,
							"longitude": 116.69967
						},
						{
							"areaId": "361129",
							"areaName": "万年县",
							"latitude": 28.69537,
							"longitude": 117.06884
						},
						{
							"areaId": "361130",
							"areaName": "婺源县",
							"latitude": 29.24841,
							"longitude": 117.86105
						},
						{
							"areaId": "361181",
							"areaName": "德兴市",
							"latitude": 28.94736,
							"longitude": 117.57919
						}
					]
				}
			]
		},
		{
			"areaId": "37",
			"areaName": "山东省",
			"latitude": 36.675807,
			"longitude": 117.000923,
			"children": [{
					"areaId": "3701",
					"areaName": "济南市",
					"latitude": 36.675807,
					"longitude": 117.000923,
					"children": [{
							"areaId": "370100",
							"areaName": "济南市本级",
							"latitude": 36.675807,
							"longitude": 117.000923
						},
						{
							"areaId": "370102",
							"areaName": "历下区",
							"latitude": 36.66661,
							"longitude": 117.0768
						},
						{
							"areaId": "370103",
							"areaName": "市中区",
							"latitude": 29.55543,
							"longitude": 103.76159
						},
						{
							"areaId": "370104",
							"areaName": "槐荫区",
							"latitude": 36.65136,
							"longitude": 116.90075
						},
						{
							"areaId": "370105",
							"areaName": "天桥区",
							"latitude": 36.67801,
							"longitude": 116.98749
						},
						{
							"areaId": "370112",
							"areaName": "历城区",
							"latitude": 36.67995,
							"longitude": 117.06509
						},
						{
							"areaId": "370113",
							"areaName": "长清区",
							"latitude": 36.55352,
							"longitude": 116.75192
						},
						{
							"areaId": "370124",
							"areaName": "平阴县",
							"latitude": 36.28955,
							"longitude": 116.45587
						},
						{
							"areaId": "370125",
							"areaName": "济阳县",
							"latitude": 36.675807,
							"longitude": 117.000923
						},
						{
							"areaId": "370126",
							"areaName": "商河县",
							"latitude": 37.31119,
							"longitude": 117.15722
						},
						{
							"areaId": "370181",
							"areaName": "章丘市",
							"latitude": 36.675807,
							"longitude": 117.000923
						}
					]
				},
				{
					"areaId": "3702",
					"areaName": "青岛市",
					"latitude": 36.094406,
					"longitude": 120.369557,
					"children": [{
							"areaId": "370200",
							"areaName": "青岛市本级",
							"latitude": 36.094406,
							"longitude": 120.369557
						},
						{
							"areaId": "370202",
							"areaName": "市南区",
							"latitude": 36.06671,
							"longitude": 120.38773
						},
						{
							"areaId": "370203",
							"areaName": "市北区",
							"latitude": 36.08734,
							"longitude": 120.37469
						},
						{
							"areaId": "370205",
							"areaName": "四方区",
							"latitude": 36.094406,
							"longitude": 120.369557
						},
						{
							"areaId": "370211",
							"areaName": "黄岛区",
							"latitude": 35.96065,
							"longitude": 120.19775
						},
						{
							"areaId": "370212",
							"areaName": "崂山区",
							"latitude": 36.10717,
							"longitude": 120.46923
						},
						{
							"areaId": "370213",
							"areaName": "李沧区",
							"latitude": 36.14502,
							"longitude": 120.43286
						},
						{
							"areaId": "370214",
							"areaName": "城阳区",
							"latitude": 36.30735,
							"longitude": 120.39621
						},
						{
							"areaId": "370281",
							"areaName": "胶州市",
							"latitude": 36.26442,
							"longitude": 120.0335
						},
						{
							"areaId": "370282",
							"areaName": "即墨市",
							"latitude": 36.094406,
							"longitude": 120.369557
						},
						{
							"areaId": "370283",
							"areaName": "平度市",
							"latitude": 36.78688,
							"longitude": 119.95996
						},
						{
							"areaId": "370284",
							"areaName": "胶南市",
							"latitude": 36.094406,
							"longitude": 120.369557
						},
						{
							"areaId": "370285",
							"areaName": "莱西市",
							"latitude": 36.88804,
							"longitude": 120.51773
						}
					]
				},
				{
					"areaId": "3703",
					"areaName": "淄博市",
					"latitude": 36.814939,
					"longitude": 118.047648,
					"children": [{
							"areaId": "370300",
							"areaName": "淄博市本级",
							"latitude": 36.814939,
							"longitude": 118.047648
						},
						{
							"areaId": "370302",
							"areaName": "淄川区",
							"latitude": 36.64339,
							"longitude": 117.96655
						},
						{
							"areaId": "370303",
							"areaName": "张店区",
							"latitude": 36.80676,
							"longitude": 118.01788
						},
						{
							"areaId": "370304",
							"areaName": "博山区",
							"latitude": 36.49469,
							"longitude": 117.86166
						},
						{
							"areaId": "370305",
							"areaName": "临淄区",
							"latitude": 36.8259,
							"longitude": 118.30966
						},
						{
							"areaId": "370306",
							"areaName": "周村区",
							"latitude": 36.80322,
							"longitude": 117.86969
						},
						{
							"areaId": "370321",
							"areaName": "桓台县",
							"latitude": 36.96036,
							"longitude": 118.09698
						},
						{
							"areaId": "370322",
							"areaName": "高青县",
							"latitude": 37.17197,
							"longitude": 117.82708
						},
						{
							"areaId": "370323",
							"areaName": "沂源县",
							"latitude": 36.18536,
							"longitude": 118.17105
						}
					]
				},
				{
					"areaId": "3704",
					"areaName": "枣庄市",
					"latitude": 34.856424,
					"longitude": 117.557964,
					"children": [{
							"areaId": "370400",
							"areaName": "枣庄市本级",
							"latitude": 34.856424,
							"longitude": 117.557964
						},
						{
							"areaId": "370402",
							"areaName": "市中区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "370403",
							"areaName": "薛城区",
							"latitude": 34.79498,
							"longitude": 117.26318
						},
						{
							"areaId": "370404",
							"areaName": "峄城区",
							"latitude": 34.77225,
							"longitude": 117.59057
						},
						{
							"areaId": "370405",
							"areaName": "台儿庄区",
							"latitude": 34.56363,
							"longitude": 117.73452
						},
						{
							"areaId": "370406",
							"areaName": "山亭区",
							"latitude": 35.09541,
							"longitude": 117.4663
						},
						{
							"areaId": "370481",
							"areaName": "滕州市",
							"latitude": 35.10534,
							"longitude": 117.165
						}
					]
				},
				{
					"areaId": "3705",
					"areaName": "东营市",
					"latitude": 37.461266,
					"longitude": 118.4963,
					"children": [{
							"areaId": "370500",
							"areaName": "东营市本级",
							"latitude": 37.461266,
							"longitude": 118.4963
						},
						{
							"areaId": "370502",
							"areaName": "东营区",
							"latitude": 37.44875,
							"longitude": 118.5816
						},
						{
							"areaId": "370503",
							"areaName": "河口区",
							"latitude": 37.88541,
							"longitude": 118.5249
						},
						{
							"areaId": "370521",
							"areaName": "垦利县",
							"latitude": 37.461266,
							"longitude": 118.4963
						},
						{
							"areaId": "370522",
							"areaName": "利津县",
							"latitude": 37.49157,
							"longitude": 118.25637
						},
						{
							"areaId": "370523",
							"areaName": "广饶县",
							"latitude": 37.05381,
							"longitude": 118.40704
						}
					]
				},
				{
					"areaId": "3706",
					"areaName": "烟台市",
					"latitude": 37.539297,
					"longitude": 121.391382,
					"children": [{
							"areaId": "370600",
							"areaName": "烟台市本级",
							"latitude": 37.539297,
							"longitude": 121.391382
						},
						{
							"areaId": "370602",
							"areaName": "芝罘区",
							"latitude": 37.54064,
							"longitude": 121.40023
						},
						{
							"areaId": "370611",
							"areaName": "福山区",
							"latitude": 37.49841,
							"longitude": 121.26812
						},
						{
							"areaId": "370612",
							"areaName": "牟平区",
							"latitude": 37.38846,
							"longitude": 121.60067
						},
						{
							"areaId": "370613",
							"areaName": "莱山区",
							"latitude": 37.51165,
							"longitude": 121.44512
						},
						{
							"areaId": "370634",
							"areaName": "长岛县",
							"latitude": 37.539297,
							"longitude": 121.391382
						},
						{
							"areaId": "370681",
							"areaName": "龙口市",
							"latitude": 37.64064,
							"longitude": 120.50634
						},
						{
							"areaId": "370682",
							"areaName": "莱阳市",
							"latitude": 36.98012,
							"longitude": 120.71066
						},
						{
							"areaId": "370683",
							"areaName": "莱州市",
							"latitude": 37.17806,
							"longitude": 119.94137
						},
						{
							"areaId": "370684",
							"areaName": "蓬莱市",
							"latitude": 37.539297,
							"longitude": 121.391382
						},
						{
							"areaId": "370685",
							"areaName": "招远市",
							"latitude": 37.36269,
							"longitude": 120.40481
						},
						{
							"areaId": "370686",
							"areaName": "栖霞市",
							"latitude": 37.33571,
							"longitude": 120.85025
						},
						{
							"areaId": "370687",
							"areaName": "海阳市",
							"latitude": 36.77622,
							"longitude": 121.15976
						}
					]
				},
				{
					"areaId": "3707",
					"areaName": "潍坊市",
					"latitude": 36.70925,
					"longitude": 119.107078,
					"children": [{
							"areaId": "370700",
							"areaName": "潍坊市本级",
							"latitude": 36.70925,
							"longitude": 119.107078
						},
						{
							"areaId": "370702",
							"areaName": "潍城区",
							"latitude": 36.7139,
							"longitude": 119.10582
						},
						{
							"areaId": "370703",
							"areaName": "寒亭区",
							"latitude": 36.77504,
							"longitude": 119.21832
						},
						{
							"areaId": "370704",
							"areaName": "坊子区",
							"latitude": 36.65218,
							"longitude": 119.16476
						},
						{
							"areaId": "370705",
							"areaName": "奎文区",
							"latitude": 36.70723,
							"longitude": 119.12532
						},
						{
							"areaId": "370724",
							"areaName": "临朐县",
							"latitude": 36.51216,
							"longitude": 118.544
						},
						{
							"areaId": "370725",
							"areaName": "昌乐县",
							"latitude": 36.7078,
							"longitude": 118.83017
						},
						{
							"areaId": "370781",
							"areaName": "青州市",
							"latitude": 36.68505,
							"longitude": 118.47915
						},
						{
							"areaId": "370782",
							"areaName": "诸城市",
							"latitude": 35.99662,
							"longitude": 119.40988
						},
						{
							"areaId": "370783",
							"areaName": "寿光市",
							"latitude": 36.88128,
							"longitude": 118.74047
						},
						{
							"areaId": "370784",
							"areaName": "安丘市",
							"latitude": 36.47847,
							"longitude": 119.2189
						},
						{
							"areaId": "370785",
							"areaName": "高密市",
							"latitude": 36.38397,
							"longitude": 119.75701
						},
						{
							"areaId": "370786",
							"areaName": "昌邑市",
							"latitude": 36.86008,
							"longitude": 119.39767
						}
					]
				},
				{
					"areaId": "3708",
					"areaName": "济宁市",
					"latitude": 35.415393,
					"longitude": 116.587245,
					"children": [{
							"areaId": "370800",
							"areaName": "济宁市本级",
							"latitude": 35.415393,
							"longitude": 116.587245
						},
						{
							"areaId": "370802",
							"areaName": "市中区",
							"latitude": 35.415393,
							"longitude": 116.587245
						},
						{
							"areaId": "370811",
							"areaName": "任城区",
							"latitude": 35.40659,
							"longitude": 116.59504
						},
						{
							"areaId": "370826",
							"areaName": "微山县",
							"latitude": 34.80712,
							"longitude": 117.12875
						},
						{
							"areaId": "370827",
							"areaName": "鱼台县",
							"latitude": 34.99674,
							"longitude": 116.64761
						},
						{
							"areaId": "370828",
							"areaName": "金乡县",
							"latitude": 35.065,
							"longitude": 116.31146
						},
						{
							"areaId": "370829",
							"areaName": "嘉祥县",
							"latitude": 35.40836,
							"longitude": 116.34249
						},
						{
							"areaId": "370830",
							"areaName": "汶上县",
							"latitude": 35.73295,
							"longitude": 116.48742
						},
						{
							"areaId": "370831",
							"areaName": "泗水县",
							"latitude": 35.66113,
							"longitude": 117.27948
						},
						{
							"areaId": "370832",
							"areaName": "梁山县",
							"latitude": 35.80322,
							"longitude": 116.09683
						},
						{
							"areaId": "370881",
							"areaName": "曲阜市",
							"latitude": 35.58091,
							"longitude": 116.98645
						},
						{
							"areaId": "370882",
							"areaName": "兖州市",
							"latitude": 35.415393,
							"longitude": 116.587245
						},
						{
							"areaId": "370883",
							"areaName": "邹城市",
							"latitude": 35.40531,
							"longitude": 116.97335
						}
					]
				},
				{
					"areaId": "3709",
					"areaName": "泰安市",
					"latitude": 24.4426,
					"longitude": 120.904441,
					"children": [{
							"areaId": "370900",
							"areaName": "泰安市本级",
							"latitude": 24.4426,
							"longitude": 120.904441
						},
						{
							"areaId": "370902",
							"areaName": "泰山区",
							"latitude": 25.058864,
							"longitude": 121.430811
						},
						{
							"areaId": "370911",
							"areaName": "岱岳区",
							"latitude": 36.1875,
							"longitude": 117.04174
						},
						{
							"areaId": "370921",
							"areaName": "宁阳县",
							"latitude": 35.7599,
							"longitude": 116.80542
						},
						{
							"areaId": "370923",
							"areaName": "东平县",
							"latitude": 35.93792,
							"longitude": 116.47113
						},
						{
							"areaId": "370982",
							"areaName": "新泰市",
							"latitude": 35.90887,
							"longitude": 117.76959
						},
						{
							"areaId": "370983",
							"areaName": "肥城市",
							"latitude": 36.18247,
							"longitude": 116.76815
						}
					]
				},
				{
					"areaId": "3710",
					"areaName": "威海市",
					"latitude": 37.509691,
					"longitude": 122.116394,
					"children": [{
							"areaId": "371000",
							"areaName": "威海市本级",
							"latitude": 37.509691,
							"longitude": 122.116394
						},
						{
							"areaId": "371002",
							"areaName": "环翠区",
							"latitude": 37.50199,
							"longitude": 122.12344
						},
						{
							"areaId": "371081",
							"areaName": "文登市",
							"latitude": 37.509691,
							"longitude": 122.116394
						},
						{
							"areaId": "371082",
							"areaName": "荣成市",
							"latitude": 37.1652,
							"longitude": 122.48773
						},
						{
							"areaId": "371083",
							"areaName": "乳山市",
							"latitude": 36.91918,
							"longitude": 121.53814
						}
					]
				},
				{
					"areaId": "3711",
					"areaName": "日照市",
					"latitude": 35.428588,
					"longitude": 119.461208,
					"children": [{
							"areaId": "371100",
							"areaName": "日照市本级",
							"latitude": 35.428588,
							"longitude": 119.461208
						},
						{
							"areaId": "371102",
							"areaName": "东港区",
							"latitude": 35.42541,
							"longitude": 119.46237
						},
						{
							"areaId": "371103",
							"areaName": "岚山区",
							"latitude": 35.12203,
							"longitude": 119.31884
						},
						{
							"areaId": "371121",
							"areaName": "五莲县",
							"latitude": 35.75004,
							"longitude": 119.207
						},
						{
							"areaId": "371122",
							"areaName": "莒县",
							"latitude": 35.58054,
							"longitude": 118.83789
						}
					]
				},
				{
					"areaId": "3712",
					"areaName": "莱芜市",
					"latitude": 36.675807,
					"longitude": 117.000923,
					"children": [{
							"areaId": "371200",
							"areaName": "莱芜市本级",
							"latitude": 36.675807,
							"longitude": 117.000923
						},
						{
							"areaId": "371202",
							"areaName": "莱城区",
							"latitude": 36.675807,
							"longitude": 117.000923
						},
						{
							"areaId": "371203",
							"areaName": "钢城区",
							"latitude": 36.675807,
							"longitude": 117.000923
						}
					]
				},
				{
					"areaId": "3713",
					"areaName": "临沂市",
					"latitude": 35.065282,
					"longitude": 118.326443,
					"children": [{
							"areaId": "371300",
							"areaName": "临沂市本级",
							"latitude": 35.065282,
							"longitude": 118.326443
						},
						{
							"areaId": "371302",
							"areaName": "兰山区",
							"latitude": 35.06872,
							"longitude": 118.34817
						},
						{
							"areaId": "371311",
							"areaName": "罗庄区",
							"latitude": 34.99627,
							"longitude": 118.28466
						},
						{
							"areaId": "371312",
							"areaName": "河东区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "371321",
							"areaName": "沂南县",
							"latitude": 35.55131,
							"longitude": 118.47061
						},
						{
							"areaId": "371322",
							"areaName": "郯城县",
							"latitude": 34.61354,
							"longitude": 118.36712
						},
						{
							"areaId": "371323",
							"areaName": "沂水县",
							"latitude": 35.78731,
							"longitude": 118.63009
						},
						{
							"areaId": "371324",
							"areaName": "苍山县",
							"latitude": 34.738315,
							"longitude": 117.856592
						},
						{
							"areaId": "371325",
							"areaName": "费县",
							"latitude": 35.26562,
							"longitude": 117.97836
						},
						{
							"areaId": "371326",
							"areaName": "平邑县",
							"latitude": 35.50573,
							"longitude": 117.63867
						},
						{
							"areaId": "371327",
							"areaName": "莒南县",
							"latitude": 35.17539,
							"longitude": 118.83227
						},
						{
							"areaId": "371328",
							"areaName": "蒙阴县",
							"latitude": 35.70996,
							"longitude": 117.94592
						},
						{
							"areaId": "371329",
							"areaName": "临沭县",
							"latitude": 34.92091,
							"longitude": 118.65267
						}
					]
				},
				{
					"areaId": "3714",
					"areaName": "德州市",
					"latitude": 37.453968,
					"longitude": 116.307428,
					"children": [{
							"areaId": "371400",
							"areaName": "德州市本级",
							"latitude": 37.453968,
							"longitude": 116.307428
						},
						{
							"areaId": "371402",
							"areaName": "德城区",
							"latitude": 37.45126,
							"longitude": 116.29943
						},
						{
							"areaId": "371421",
							"areaName": "陵县",
							"latitude": 37.453968,
							"longitude": 116.307428
						},
						{
							"areaId": "371422",
							"areaName": "宁津县",
							"latitude": 37.65301,
							"longitude": 116.79702
						},
						{
							"areaId": "371423",
							"areaName": "庆云县",
							"latitude": 37.77616,
							"longitude": 117.38635
						},
						{
							"areaId": "371424",
							"areaName": "临邑县",
							"latitude": 37.19053,
							"longitude": 116.86547
						},
						{
							"areaId": "371425",
							"areaName": "齐河县",
							"latitude": 36.79532,
							"longitude": 116.75515
						},
						{
							"areaId": "371426",
							"areaName": "平原县",
							"latitude": 37.16632,
							"longitude": 116.43432
						},
						{
							"areaId": "371427",
							"areaName": "夏津县",
							"latitude": 36.94852,
							"longitude": 116.0017
						},
						{
							"areaId": "371428",
							"areaName": "武城县",
							"latitude": 37.21403,
							"longitude": 116.07009
						},
						{
							"areaId": "371481",
							"areaName": "乐陵市",
							"latitude": 37.73164,
							"longitude": 117.23141
						},
						{
							"areaId": "371482",
							"areaName": "禹城市",
							"latitude": 36.93444,
							"longitude": 116.64309
						}
					]
				},
				{
					"areaId": "3715",
					"areaName": "聊城市",
					"latitude": 36.456013,
					"longitude": 115.980367,
					"children": [{
							"areaId": "371500",
							"areaName": "聊城市本级",
							"latitude": 36.456013,
							"longitude": 115.980367
						},
						{
							"areaId": "371502",
							"areaName": "东昌府区",
							"latitude": 36.44458,
							"longitude": 115.97383
						},
						{
							"areaId": "371521",
							"areaName": "阳谷县",
							"latitude": 36.11444,
							"longitude": 115.79126
						},
						{
							"areaId": "371522",
							"areaName": "莘县",
							"latitude": 36.23423,
							"longitude": 115.6697
						},
						{
							"areaId": "371523",
							"areaName": "茌平县",
							"latitude": 36.456013,
							"longitude": 115.980367
						},
						{
							"areaId": "371524",
							"areaName": "东阿县",
							"latitude": 36.33209,
							"longitude": 116.25012
						},
						{
							"areaId": "371525",
							"areaName": "冠县",
							"latitude": 36.48429,
							"longitude": 115.44195
						},
						{
							"areaId": "371526",
							"areaName": "高唐县",
							"latitude": 36.86535,
							"longitude": 116.23172
						},
						{
							"areaId": "371581",
							"areaName": "临清市",
							"latitude": 36.83945,
							"longitude": 115.70629
						}
					]
				},
				{
					"areaId": "3716",
					"areaName": "滨州市",
					"latitude": 37.383542,
					"longitude": 118.016974,
					"children": [{
							"areaId": "371600",
							"areaName": "滨州市本级",
							"latitude": 37.383542,
							"longitude": 118.016974
						},
						{
							"areaId": "371602",
							"areaName": "滨城区",
							"latitude": 37.38524,
							"longitude": 118.02026
						},
						{
							"areaId": "371621",
							"areaName": "惠民县",
							"latitude": 37.49013,
							"longitude": 117.51113
						},
						{
							"areaId": "371622",
							"areaName": "阳信县",
							"latitude": 37.64198,
							"longitude": 117.58139
						},
						{
							"areaId": "371623",
							"areaName": "无棣县",
							"latitude": 37.74009,
							"longitude": 117.61395
						},
						{
							"areaId": "371624",
							"areaName": "沾化县",
							"latitude": 37.383542,
							"longitude": 118.016974
						},
						{
							"areaId": "371625",
							"areaName": "博兴县",
							"latitude": 37.14316,
							"longitude": 118.1336
						},
						{
							"areaId": "371626",
							"areaName": "邹平县",
							"latitude": 37.383542,
							"longitude": 118.016974
						}
					]
				},
				{
					"areaId": "3717",
					"areaName": "菏泽市",
					"latitude": 35.246531,
					"longitude": 115.469381,
					"children": [{
							"areaId": "371700",
							"areaName": "菏泽市本级",
							"latitude": 35.246531,
							"longitude": 115.469381
						},
						{
							"areaId": "371702",
							"areaName": "牡丹区",
							"latitude": 35.25091,
							"longitude": 115.41662
						},
						{
							"areaId": "371721",
							"areaName": "曹县",
							"latitude": 34.82659,
							"longitude": 115.54226
						},
						{
							"areaId": "371722",
							"areaName": "单县",
							"latitude": 34.79514,
							"longitude": 116.08703
						},
						{
							"areaId": "371723",
							"areaName": "成武县",
							"latitude": 34.95332,
							"longitude": 115.8897
						},
						{
							"areaId": "371724",
							"areaName": "巨野县",
							"latitude": 35.39788,
							"longitude": 116.09497
						},
						{
							"areaId": "371725",
							"areaName": "郓城县",
							"latitude": 35.60044,
							"longitude": 115.94439
						},
						{
							"areaId": "371726",
							"areaName": "鄄城县",
							"latitude": 35.56412,
							"longitude": 115.50997
						},
						{
							"areaId": "371727",
							"areaName": "定陶县",
							"latitude": 35.246531,
							"longitude": 115.469381
						},
						{
							"areaId": "371728",
							"areaName": "东明县",
							"latitude": 35.28906,
							"longitude": 115.09079
						}
					]
				}
			]
		},
		{
			"areaId": "41",
			"areaName": "河南省",
			"latitude": 34.757975,
			"longitude": 113.665412,
			"children": [{
					"areaId": "4101",
					"areaName": "郑州市",
					"latitude": 34.757975,
					"longitude": 113.665412,
					"children": [{
							"areaId": "410100",
							"areaName": "郑州市本级",
							"latitude": 34.757975,
							"longitude": 113.665412
						},
						{
							"areaId": "410102",
							"areaName": "中原区",
							"latitude": 34.74827,
							"longitude": 113.61333
						},
						{
							"areaId": "410103",
							"areaName": "二七区",
							"latitude": 34.72336,
							"longitude": 113.63931
						},
						{
							"areaId": "410104",
							"areaName": "管城回族区",
							"latitude": 34.75383,
							"longitude": 113.67734
						},
						{
							"areaId": "410105",
							"areaName": "金水区",
							"latitude": 34.80028,
							"longitude": 113.66057
						},
						{
							"areaId": "410106",
							"areaName": "上街区",
							"latitude": 34.80276,
							"longitude": 113.30897
						},
						{
							"areaId": "410108",
							"areaName": "惠济区",
							"latitude": 34.86735,
							"longitude": 113.61688
						},
						{
							"areaId": "410122",
							"areaName": "中牟县",
							"latitude": 34.71899,
							"longitude": 113.97619
						},
						{
							"areaId": "410181",
							"areaName": "巩义市",
							"latitude": 34.74794,
							"longitude": 113.022
						},
						{
							"areaId": "410182",
							"areaName": "荥阳市",
							"latitude": 34.78759,
							"longitude": 113.38345
						},
						{
							"areaId": "410183",
							"areaName": "新密市",
							"latitude": 34.53704,
							"longitude": 113.3869
						},
						{
							"areaId": "410184",
							"areaName": "新郑市",
							"latitude": 34.3955,
							"longitude": 113.73645
						},
						{
							"areaId": "410185",
							"areaName": "登封市",
							"latitude": 34.45345,
							"longitude": 113.05023
						}
					]
				},
				{
					"areaId": "4102",
					"areaName": "开封市",
					"latitude": 34.797049,
					"longitude": 114.341447,
					"children": [{
							"areaId": "410200",
							"areaName": "开封市本级",
							"latitude": 34.797049,
							"longitude": 114.341447
						},
						{
							"areaId": "410202",
							"areaName": "龙亭区",
							"latitude": 34.79995,
							"longitude": 114.35484
						},
						{
							"areaId": "410203",
							"areaName": "顺河回族区",
							"latitude": 34.79586,
							"longitude": 114.36123
						},
						{
							"areaId": "410204",
							"areaName": "鼓楼区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "410205",
							"areaName": "禹王台区",
							"latitude": 34.77693,
							"longitude": 114.34787
						},
						{
							"areaId": "410211",
							"areaName": "金明区",
							"latitude": 34.797049,
							"longitude": 114.341447
						},
						{
							"areaId": "410221",
							"areaName": "杞县",
							"latitude": 34.55033,
							"longitude": 114.7828
						},
						{
							"areaId": "410222",
							"areaName": "通许县",
							"latitude": 34.47522,
							"longitude": 114.46716
						},
						{
							"areaId": "410223",
							"areaName": "尉氏县",
							"latitude": 34.41223,
							"longitude": 114.19284
						},
						{
							"areaId": "410224",
							"areaName": "开封县",
							"latitude": 34.797049,
							"longitude": 114.341447
						},
						{
							"areaId": "410225",
							"areaName": "兰考县",
							"latitude": 34.8235,
							"longitude": 114.81961
						}
					]
				},
				{
					"areaId": "4103",
					"areaName": "洛阳市",
					"latitude": 34.663041,
					"longitude": 112.434468,
					"children": [{
							"areaId": "410300",
							"areaName": "洛阳市本级",
							"latitude": 34.663041,
							"longitude": 112.434468
						},
						{
							"areaId": "410302",
							"areaName": "老城区",
							"latitude": 34.68364,
							"longitude": 112.46902
						},
						{
							"areaId": "410303",
							"areaName": "西工区",
							"latitude": 34.67,
							"longitude": 112.4371
						},
						{
							"areaId": "410304",
							"areaName": "瀍河回族区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "410305",
							"areaName": "涧西区",
							"latitude": 34.65823,
							"longitude": 112.39588
						},
						{
							"areaId": "410306",
							"areaName": "吉利区",
							"latitude": 34.90088,
							"longitude": 112.58905
						},
						{
							"areaId": "410311",
							"areaName": "洛龙区",
							"latitude": 34.61866,
							"longitude": 112.46412
						},
						{
							"areaId": "410322",
							"areaName": "孟津县",
							"latitude": 34.826,
							"longitude": 112.44351
						},
						{
							"areaId": "410323",
							"areaName": "新安县",
							"latitude": 34.72814,
							"longitude": 112.13238
						},
						{
							"areaId": "410324",
							"areaName": "栾川县",
							"latitude": 33.78576,
							"longitude": 111.61779
						},
						{
							"areaId": "410325",
							"areaName": "嵩县",
							"latitude": 34.13466,
							"longitude": 112.08526
						},
						{
							"areaId": "410326",
							"areaName": "汝阳县",
							"latitude": 34.15387,
							"longitude": 112.47314
						},
						{
							"areaId": "410327",
							"areaName": "宜阳县",
							"latitude": 34.51523,
							"longitude": 112.17907
						},
						{
							"areaId": "410328",
							"areaName": "洛宁县",
							"latitude": 34.38913,
							"longitude": 111.65087
						},
						{
							"areaId": "410329",
							"areaName": "伊川县",
							"latitude": 34.42205,
							"longitude": 112.42947
						},
						{
							"areaId": "410381",
							"areaName": "偃师市",
							"latitude": 34.7281,
							"longitude": 112.7922
						}
					]
				},
				{
					"areaId": "4104",
					"areaName": "平顶山市",
					"latitude": 33.735241,
					"longitude": 113.307718,
					"children": [{
							"areaId": "410400",
							"areaName": "平顶山市本级",
							"latitude": 33.735241,
							"longitude": 113.307718
						},
						{
							"areaId": "410402",
							"areaName": "新华区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "410403",
							"areaName": "卫东区",
							"latitude": 33.73472,
							"longitude": 113.33511
						},
						{
							"areaId": "410404",
							"areaName": "石龙区",
							"latitude": 23.107444,
							"longitude": 113.876381
						},
						{
							"areaId": "410411",
							"areaName": "湛河区",
							"latitude": 33.7362,
							"longitude": 113.29252
						},
						{
							"areaId": "410421",
							"areaName": "宝丰县",
							"latitude": 33.86916,
							"longitude": 113.05493
						},
						{
							"areaId": "410422",
							"areaName": "叶县",
							"latitude": 33.62225,
							"longitude": 113.35104
						},
						{
							"areaId": "410423",
							"areaName": "鲁山县",
							"latitude": 33.73879,
							"longitude": 112.9057
						},
						{
							"areaId": "410425",
							"areaName": "郏县",
							"latitude": 33.97072,
							"longitude": 113.21588
						},
						{
							"areaId": "410481",
							"areaName": "舞钢市",
							"latitude": 33.2938,
							"longitude": 113.52417
						},
						{
							"areaId": "410482",
							"areaName": "汝州市",
							"latitude": 34.16135,
							"longitude": 112.84301
						}
					]
				},
				{
					"areaId": "4105",
					"areaName": "安阳市",
					"latitude": 36.103442,
					"longitude": 114.352482,
					"children": [{
							"areaId": "410500",
							"areaName": "安阳市本级",
							"latitude": 36.103442,
							"longitude": 114.352482
						},
						{
							"areaId": "410502",
							"areaName": "文峰区",
							"latitude": 36.09046,
							"longitude": 114.35708
						},
						{
							"areaId": "410503",
							"areaName": "北关区",
							"latitude": 36.11872,
							"longitude": 114.35735
						},
						{
							"areaId": "410505",
							"areaName": "殷都区",
							"latitude": 36.1099,
							"longitude": 114.3034
						},
						{
							"areaId": "410506",
							"areaName": "龙安区",
							"latitude": 36.11904,
							"longitude": 114.34814
						},
						{
							"areaId": "410522",
							"areaName": "安阳县",
							"latitude": 36.06695,
							"longitude": 114.36605
						},
						{
							"areaId": "410523",
							"areaName": "汤阴县",
							"latitude": 35.92152,
							"longitude": 114.35839
						},
						{
							"areaId": "410526",
							"areaName": "滑县",
							"latitude": 35.5807,
							"longitude": 114.52066
						},
						{
							"areaId": "410527",
							"areaName": "内黄县",
							"latitude": 35.95269,
							"longitude": 114.90673
						},
						{
							"areaId": "410581",
							"areaName": "林州市",
							"latitude": 36.07804,
							"longitude": 113.81558
						}
					]
				},
				{
					"areaId": "4106",
					"areaName": "鹤壁市",
					"latitude": 35.748236,
					"longitude": 114.295444,
					"children": [{
							"areaId": "410600",
							"areaName": "鹤壁市本级",
							"latitude": 35.748236,
							"longitude": 114.295444
						},
						{
							"areaId": "410602",
							"areaName": "鹤山区",
							"latitude": 35.95458,
							"longitude": 114.16336
						},
						{
							"areaId": "410603",
							"areaName": "山城区",
							"latitude": 35.89773,
							"longitude": 114.18443
						},
						{
							"areaId": "410611",
							"areaName": "淇滨区",
							"latitude": 35.74127,
							"longitude": 114.29867
						},
						{
							"areaId": "410621",
							"areaName": "浚县",
							"latitude": 35.67085,
							"longitude": 114.54879
						},
						{
							"areaId": "410622",
							"areaName": "淇县",
							"latitude": 35.60782,
							"longitude": 114.1976
						}
					]
				},
				{
					"areaId": "4107",
					"areaName": "新乡市",
					"latitude": 35.302616,
					"longitude": 113.883991,
					"children": [{
							"areaId": "410700",
							"areaName": "新乡市本级",
							"latitude": 35.302616,
							"longitude": 113.883991
						},
						{
							"areaId": "410702",
							"areaName": "红旗区",
							"latitude": 35.30367,
							"longitude": 113.87523
						},
						{
							"areaId": "410703",
							"areaName": "卫滨区",
							"latitude": 35.30211,
							"longitude": 113.86578
						},
						{
							"areaId": "410704",
							"areaName": "凤泉区",
							"latitude": 35.38399,
							"longitude": 113.91507
						},
						{
							"areaId": "410711",
							"areaName": "牧野区",
							"latitude": 35.3149,
							"longitude": 113.9086
						},
						{
							"areaId": "410721",
							"areaName": "新乡县",
							"latitude": 35.19075,
							"longitude": 113.80511
						},
						{
							"areaId": "410724",
							"areaName": "获嘉县",
							"latitude": 35.26521,
							"longitude": 113.66159
						},
						{
							"areaId": "410725",
							"areaName": "原阳县",
							"latitude": 35.06565,
							"longitude": 113.93994
						},
						{
							"areaId": "410726",
							"areaName": "延津县",
							"latitude": 35.14327,
							"longitude": 114.20266
						},
						{
							"areaId": "410727",
							"areaName": "封丘县",
							"latitude": 35.04166,
							"longitude": 114.41915
						},
						{
							"areaId": "410728",
							"areaName": "长垣县",
							"latitude": 35.302616,
							"longitude": 113.883991
						},
						{
							"areaId": "410781",
							"areaName": "卫辉市",
							"latitude": 35.39843,
							"longitude": 114.06454
						},
						{
							"areaId": "410782",
							"areaName": "辉县市",
							"latitude": 35.46307,
							"longitude": 113.8067
						}
					]
				},
				{
					"areaId": "4108",
					"areaName": "焦作市",
					"latitude": 35.23904,
					"longitude": 113.238266,
					"children": [{
							"areaId": "410800",
							"areaName": "焦作市本级",
							"latitude": 35.23904,
							"longitude": 113.238266
						},
						{
							"areaId": "410802",
							"areaName": "解放区",
							"latitude": 35.24023,
							"longitude": 113.22933
						},
						{
							"areaId": "410803",
							"areaName": "中站区",
							"latitude": 35.23665,
							"longitude": 113.18315
						},
						{
							"areaId": "410804",
							"areaName": "马村区",
							"latitude": 35.26908,
							"longitude": 113.3187
						},
						{
							"areaId": "410811",
							"areaName": "山阳区",
							"latitude": 35.21436,
							"longitude": 113.25464
						},
						{
							"areaId": "410821",
							"areaName": "修武县",
							"latitude": 35.22357,
							"longitude": 113.44775
						},
						{
							"areaId": "410822",
							"areaName": "博爱县",
							"latitude": 35.16943,
							"longitude": 113.06698
						},
						{
							"areaId": "410823",
							"areaName": "武陟县",
							"latitude": 35.09505,
							"longitude": 113.39718
						},
						{
							"areaId": "410825",
							"areaName": "温县",
							"latitude": 34.94022,
							"longitude": 113.08065
						},
						{
							"areaId": "410881",
							"areaName": "济源市",
							"latitude": 35.23904,
							"longitude": 113.238266
						},
						{
							"areaId": "410882",
							"areaName": "沁阳市",
							"latitude": 35.08935,
							"longitude": 112.94494
						},
						{
							"areaId": "410883",
							"areaName": "孟州市",
							"latitude": 34.9071,
							"longitude": 112.79138
						}
					]
				},
				{
					"areaId": "4109",
					"areaName": "濮阳市",
					"latitude": 35.768234,
					"longitude": 115.041299,
					"children": [{
							"areaId": "410900",
							"areaName": "濮阳市本级",
							"latitude": 35.768234,
							"longitude": 115.041299
						},
						{
							"areaId": "410902",
							"areaName": "华龙区",
							"latitude": 35.77736,
							"longitude": 115.07446
						},
						{
							"areaId": "410922",
							"areaName": "清丰县",
							"latitude": 35.88507,
							"longitude": 115.10415
						},
						{
							"areaId": "410923",
							"areaName": "南乐县",
							"latitude": 36.07686,
							"longitude": 115.20639
						},
						{
							"areaId": "410926",
							"areaName": "范县",
							"latitude": 35.85178,
							"longitude": 115.50405
						},
						{
							"areaId": "410927",
							"areaName": "台前县",
							"latitude": 35.96923,
							"longitude": 115.87158
						},
						{
							"areaId": "410928",
							"areaName": "濮阳县",
							"latitude": 35.70745,
							"longitude": 115.03057
						}
					]
				},
				{
					"areaId": "4110",
					"areaName": "许昌市",
					"latitude": 34.00406,
					"longitude": 113.84707,
					"children": [{
							"areaId": "411000",
							"areaName": "许昌市本级",
							"latitude": 34.00406,
							"longitude": 113.84707
						},
						{
							"areaId": "411002",
							"areaName": "魏都区",
							"latitude": 34.02544,
							"longitude": 113.8227
						},
						{
							"areaId": "411023",
							"areaName": "许昌县",
							"latitude": 34.00406,
							"longitude": 113.84707
						},
						{
							"areaId": "411024",
							"areaName": "鄢陵县",
							"latitude": 34.10317,
							"longitude": 114.18795
						},
						{
							"areaId": "411025",
							"areaName": "襄城县",
							"latitude": 33.84928,
							"longitude": 113.48196
						},
						{
							"areaId": "411081",
							"areaName": "禹州市",
							"latitude": 34.14054,
							"longitude": 113.48803
						},
						{
							"areaId": "411082",
							"areaName": "长葛市",
							"latitude": 34.21846,
							"longitude": 113.77328
						}
					]
				},
				{
					"areaId": "4111",
					"areaName": "漯河市",
					"latitude": 33.575855,
					"longitude": 114.026405,
					"children": [{
							"areaId": "411100",
							"areaName": "漯河市本级",
							"latitude": 33.575855,
							"longitude": 114.026405
						},
						{
							"areaId": "411102",
							"areaName": "源汇区",
							"latitude": 33.55627,
							"longitude": 114.00647
						},
						{
							"areaId": "411103",
							"areaName": "郾城区",
							"latitude": 33.58723,
							"longitude": 114.00694
						},
						{
							"areaId": "411104",
							"areaName": "召陵区",
							"latitude": 33.58601,
							"longitude": 114.09399
						},
						{
							"areaId": "411121",
							"areaName": "舞阳县",
							"latitude": 33.43243,
							"longitude": 113.59848
						},
						{
							"areaId": "411122",
							"areaName": "临颍县",
							"latitude": 33.81123,
							"longitude": 113.93661
						}
					]
				},
				{
					"areaId": "4112",
					"areaName": "三门峡市",
					"latitude": 34.777338,
					"longitude": 111.194099,
					"children": [{
							"areaId": "411200",
							"areaName": "三门峡市本级",
							"latitude": 34.777338,
							"longitude": 111.194099
						},
						{
							"areaId": "411202",
							"areaName": "湖滨区",
							"latitude": 34.77872,
							"longitude": 111.20006
						},
						{
							"areaId": "411221",
							"areaName": "渑池县",
							"latitude": 34.76725,
							"longitude": 111.76184
						},
						{
							"areaId": "411222",
							"areaName": "陕县",
							"latitude": 34.777338,
							"longitude": 111.194099
						},
						{
							"areaId": "411224",
							"areaName": "卢氏县",
							"latitude": 34.05436,
							"longitude": 111.04782
						},
						{
							"areaId": "411281",
							"areaName": "义马市",
							"latitude": 34.74721,
							"longitude": 111.87445
						},
						{
							"areaId": "411282",
							"areaName": "灵宝市",
							"latitude": 34.51682,
							"longitude": 110.8945
						}
					]
				},
				{
					"areaId": "4113",
					"areaName": "南阳市",
					"latitude": 32.999082,
					"longitude": 112.540918,
					"children": [{
							"areaId": "411300",
							"areaName": "南阳市本级",
							"latitude": 32.999082,
							"longitude": 112.540918
						},
						{
							"areaId": "411302",
							"areaName": "宛城区",
							"latitude": 33.00378,
							"longitude": 112.53955
						},
						{
							"areaId": "411303",
							"areaName": "卧龙区",
							"latitude": 32.98615,
							"longitude": 112.53479
						},
						{
							"areaId": "411321",
							"areaName": "南召县",
							"latitude": 33.49098,
							"longitude": 112.43194
						},
						{
							"areaId": "411322",
							"areaName": "方城县",
							"latitude": 33.25453,
							"longitude": 113.01269
						},
						{
							"areaId": "411323",
							"areaName": "西峡县",
							"latitude": 33.29772,
							"longitude": 111.48187
						},
						{
							"areaId": "411324",
							"areaName": "镇平县",
							"latitude": 33.03629,
							"longitude": 112.2398
						},
						{
							"areaId": "411325",
							"areaName": "内乡县",
							"latitude": 33.04671,
							"longitude": 111.84957
						},
						{
							"areaId": "411326",
							"areaName": "淅川县",
							"latitude": 33.13708,
							"longitude": 111.48663
						},
						{
							"areaId": "411327",
							"areaName": "社旗县",
							"latitude": 33.05503,
							"longitude": 112.94656
						},
						{
							"areaId": "411328",
							"areaName": "唐河县",
							"latitude": 32.69453,
							"longitude": 112.83609
						},
						{
							"areaId": "411329",
							"areaName": "新野县",
							"latitude": 32.51698,
							"longitude": 112.36151
						},
						{
							"areaId": "411330",
							"areaName": "桐柏县",
							"latitude": 32.37917,
							"longitude": 113.42886
						},
						{
							"areaId": "411381",
							"areaName": "邓州市",
							"latitude": 32.68577,
							"longitude": 112.0896
						}
					]
				},
				{
					"areaId": "4114",
					"areaName": "商丘市",
					"latitude": 34.437054,
					"longitude": 115.650497,
					"children": [{
							"areaId": "411400",
							"areaName": "商丘市本级",
							"latitude": 34.437054,
							"longitude": 115.650497
						},
						{
							"areaId": "411402",
							"areaName": "梁园区",
							"latitude": 34.44341,
							"longitude": 115.64487
						},
						{
							"areaId": "411403",
							"areaName": "睢阳区",
							"latitude": 34.38804,
							"longitude": 115.65338
						},
						{
							"areaId": "411421",
							"areaName": "民权县",
							"latitude": 34.64931,
							"longitude": 115.14621
						},
						{
							"areaId": "411422",
							"areaName": "睢县",
							"latitude": 34.44539,
							"longitude": 115.07168
						},
						{
							"areaId": "411423",
							"areaName": "宁陵县",
							"latitude": 34.45463,
							"longitude": 115.30511
						},
						{
							"areaId": "411424",
							"areaName": "柘城县",
							"latitude": 34.0911,
							"longitude": 115.30538
						},
						{
							"areaId": "411425",
							"areaName": "虞城县",
							"latitude": 34.40189,
							"longitude": 115.86337
						},
						{
							"areaId": "411426",
							"areaName": "夏邑县",
							"latitude": 34.23242,
							"longitude": 116.13348
						},
						{
							"areaId": "411481",
							"areaName": "永城市",
							"latitude": 33.92911,
							"longitude": 116.44943
						}
					]
				},
				{
					"areaId": "4115",
					"areaName": "信阳市",
					"latitude": 32.123274,
					"longitude": 114.075031,
					"children": [{
							"areaId": "411500",
							"areaName": "信阳市本级",
							"latitude": 32.123274,
							"longitude": 114.075031
						},
						{
							"areaId": "411502",
							"areaName": "浉河区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "411503",
							"areaName": "平桥区",
							"latitude": 32.10095,
							"longitude": 114.12435
						},
						{
							"areaId": "411521",
							"areaName": "罗山县",
							"latitude": 32.20277,
							"longitude": 114.5314
						},
						{
							"areaId": "411522",
							"areaName": "光山县",
							"latitude": 32.00992,
							"longitude": 114.91873
						},
						{
							"areaId": "411523",
							"areaName": "新县",
							"latitude": 31.64386,
							"longitude": 114.87924
						},
						{
							"areaId": "411524",
							"areaName": "商城县",
							"latitude": 31.79986,
							"longitude": 115.40856
						},
						{
							"areaId": "411525",
							"areaName": "固始县",
							"latitude": 32.18011,
							"longitude": 115.68298
						},
						{
							"areaId": "411526",
							"areaName": "潢川县",
							"latitude": 32.13763,
							"longitude": 115.04696
						},
						{
							"areaId": "411527",
							"areaName": "淮滨县",
							"latitude": 32.46614,
							"longitude": 115.4205
						},
						{
							"areaId": "411528",
							"areaName": "息县",
							"latitude": 32.34279,
							"longitude": 114.7402
						}
					]
				},
				{
					"areaId": "4116",
					"areaName": "周口市",
					"latitude": 33.620357,
					"longitude": 114.649653,
					"children": [{
							"areaId": "411600",
							"areaName": "周口市本级",
							"latitude": 33.620357,
							"longitude": 114.649653
						},
						{
							"areaId": "411602",
							"areaName": "川汇区",
							"latitude": 33.6256,
							"longitude": 114.64202
						},
						{
							"areaId": "411621",
							"areaName": "扶沟县",
							"latitude": 34.05999,
							"longitude": 114.39477
						},
						{
							"areaId": "411622",
							"areaName": "西华县",
							"latitude": 34.51255,
							"longitude": 109.77185
						},
						{
							"areaId": "411623",
							"areaName": "商水县",
							"latitude": 33.53912,
							"longitude": 114.60604
						},
						{
							"areaId": "411624",
							"areaName": "沈丘县",
							"latitude": 33.40936,
							"longitude": 115.09851
						},
						{
							"areaId": "411625",
							"areaName": "郸城县",
							"latitude": 33.64485,
							"longitude": 115.17715
						},
						{
							"areaId": "411626",
							"areaName": "淮阳县",
							"latitude": 33.620357,
							"longitude": 114.649653
						},
						{
							"areaId": "411627",
							"areaName": "太康县",
							"latitude": 34.06376,
							"longitude": 114.83773
						},
						{
							"areaId": "411628",
							"areaName": "鹿邑县",
							"latitude": 33.85931,
							"longitude": 115.48553
						},
						{
							"areaId": "411681",
							"areaName": "项城市",
							"latitude": 33.4672,
							"longitude": 114.87558
						}
					]
				},
				{
					"areaId": "4117",
					"areaName": "驻马店市",
					"latitude": 32.980169,
					"longitude": 114.024736,
					"children": [{
							"areaId": "411700",
							"areaName": "驻马店市本级",
							"latitude": 32.980169,
							"longitude": 114.024736
						},
						{
							"areaId": "411702",
							"areaName": "驿城区",
							"latitude": 32.97316,
							"longitude": 113.99377
						},
						{
							"areaId": "411721",
							"areaName": "西平县",
							"latitude": 33.3845,
							"longitude": 114.02322
						},
						{
							"areaId": "411722",
							"areaName": "上蔡县",
							"latitude": 33.26825,
							"longitude": 114.26825
						},
						{
							"areaId": "411723",
							"areaName": "平舆县",
							"latitude": 32.95727,
							"longitude": 114.63552
						},
						{
							"areaId": "411724",
							"areaName": "正阳县",
							"latitude": 32.6039,
							"longitude": 114.38952
						},
						{
							"areaId": "411725",
							"areaName": "确山县",
							"latitude": 32.80281,
							"longitude": 114.02917
						},
						{
							"areaId": "411726",
							"areaName": "泌阳县",
							"latitude": 32.71781,
							"longitude": 113.32681
						},
						{
							"areaId": "411727",
							"areaName": "汝南县",
							"latitude": 33.00461,
							"longitude": 114.36138
						},
						{
							"areaId": "411728",
							"areaName": "遂平县",
							"latitude": 33.14571,
							"longitude": 114.01297
						},
						{
							"areaId": "411729",
							"areaName": "新蔡县",
							"latitude": 32.7502,
							"longitude": 114.98199
						}
					]
				}
			]
		},
		{
			"areaId": "42",
			"areaName": "湖北省",
			"latitude": 30.584355,
			"longitude": 114.298572,
			"children": [{
					"areaId": "4201",
					"areaName": "武汉市",
					"latitude": 30.584355,
					"longitude": 114.298572,
					"children": [{
							"areaId": "420100",
							"areaName": "武汉市本级",
							"latitude": 30.584355,
							"longitude": 114.298572
						},
						{
							"areaId": "420102",
							"areaName": "江岸区",
							"latitude": 30.59982,
							"longitude": 114.30943
						},
						{
							"areaId": "420103",
							"areaName": "江汉区",
							"latitude": 30.60146,
							"longitude": 114.27093
						},
						{
							"areaId": "420104",
							"areaName": "硚口区",
							"latitude": 30.56945,
							"longitude": 114.26422
						},
						{
							"areaId": "420105",
							"areaName": "汉阳区",
							"latitude": 30.54915,
							"longitude": 114.27478
						},
						{
							"areaId": "420106",
							"areaName": "武昌区",
							"latitude": 30.55389,
							"longitude": 114.31589
						},
						{
							"areaId": "420107",
							"areaName": "青山区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "420111",
							"areaName": "洪山区",
							"latitude": 30.49989,
							"longitude": 114.34375
						},
						{
							"areaId": "420112",
							"areaName": "东西湖区",
							"latitude": 30.61989,
							"longitude": 114.13708
						},
						{
							"areaId": "420113",
							"areaName": "汉南区",
							"latitude": 30.30879,
							"longitude": 114.08462
						},
						{
							"areaId": "420114",
							"areaName": "蔡甸区",
							"latitude": 30.58197,
							"longitude": 114.02929
						},
						{
							"areaId": "420115",
							"areaName": "江夏区",
							"latitude": 30.34653,
							"longitude": 114.31301
						},
						{
							"areaId": "420116",
							"areaName": "黄陂区",
							"latitude": 30.88151,
							"longitude": 114.37512
						},
						{
							"areaId": "420117",
							"areaName": "新洲区",
							"latitude": 30.84145,
							"longitude": 114.80136
						}
					]
				},
				{
					"areaId": "4202",
					"areaName": "黄石市",
					"latitude": 30.220074,
					"longitude": 115.077048,
					"children": [{
							"areaId": "420200",
							"areaName": "黄石市本级",
							"latitude": 30.220074,
							"longitude": 115.077048
						},
						{
							"areaId": "420202",
							"areaName": "黄石港区",
							"latitude": 30.22279,
							"longitude": 115.06604
						},
						{
							"areaId": "420203",
							"areaName": "西塞山区",
							"latitude": 30.20487,
							"longitude": 115.11016
						},
						{
							"areaId": "420204",
							"areaName": "下陆区",
							"latitude": 30.17368,
							"longitude": 114.96112
						},
						{
							"areaId": "420205",
							"areaName": "铁山区",
							"latitude": 30.20678,
							"longitude": 114.90109
						},
						{
							"areaId": "420222",
							"areaName": "阳新县",
							"latitude": 29.83038,
							"longitude": 115.21527
						},
						{
							"areaId": "420281",
							"areaName": "大冶市",
							"latitude": 30.09438,
							"longitude": 114.97174
						}
					]
				},
				{
					"areaId": "4203",
					"areaName": "十堰市",
					"latitude": 32.647017,
					"longitude": 110.785239,
					"children": [{
							"areaId": "420300",
							"areaName": "十堰市本级",
							"latitude": 32.647017,
							"longitude": 110.785239
						},
						{
							"areaId": "420302",
							"areaName": "茅箭区",
							"latitude": 32.59153,
							"longitude": 110.81341
						},
						{
							"areaId": "420303",
							"areaName": "张湾区",
							"latitude": 32.65195,
							"longitude": 110.77067
						},
						{
							"areaId": "420321",
							"areaName": "郧县",
							"latitude": 32.647017,
							"longitude": 110.785239
						},
						{
							"areaId": "420322",
							"areaName": "郧西县",
							"latitude": 32.99349,
							"longitude": 110.42556
						},
						{
							"areaId": "420323",
							"areaName": "竹山县",
							"latitude": 23.757655,
							"longitude": 120.672007
						},
						{
							"areaId": "420324",
							"areaName": "竹溪县",
							"latitude": 32.31901,
							"longitude": 109.71798
						},
						{
							"areaId": "420325",
							"areaName": "房县",
							"latitude": 32.05794,
							"longitude": 110.74386
						},
						{
							"areaId": "420381",
							"areaName": "丹江口市",
							"latitude": 32.54085,
							"longitude": 111.51525
						}
					]
				},
				{
					"areaId": "4205",
					"areaName": "宜昌市",
					"latitude": 30.702636,
					"longitude": 111.290843,
					"children": [{
							"areaId": "420500",
							"areaName": "宜昌市本级",
							"latitude": 30.702636,
							"longitude": 111.290843
						},
						{
							"areaId": "420502",
							"areaName": "西陵区",
							"latitude": 30.71077,
							"longitude": 111.28573
						},
						{
							"areaId": "420503",
							"areaName": "伍家岗区",
							"latitude": 30.64434,
							"longitude": 111.3609
						},
						{
							"areaId": "420504",
							"areaName": "点军区",
							"latitude": 30.6934,
							"longitude": 111.26828
						},
						{
							"areaId": "420505",
							"areaName": "猇亭区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "420506",
							"areaName": "夷陵区",
							"latitude": 30.76881,
							"longitude": 111.3262
						},
						{
							"areaId": "420525",
							"areaName": "远安县",
							"latitude": 31.05989,
							"longitude": 111.6416
						},
						{
							"areaId": "420526",
							"areaName": "兴山县",
							"latitude": 31.34686,
							"longitude": 110.74951
						},
						{
							"areaId": "420527",
							"areaName": "秭归县",
							"latitude": 30.82702,
							"longitude": 110.98156
						},
						{
							"areaId": "420528",
							"areaName": "长阳土家族自治县",
							"latitude": 30.47052,
							"longitude": 111.20105
						},
						{
							"areaId": "420529",
							"areaName": "五峰土家族自治县",
							"latitude": 23.775291,
							"longitude": 121.003418
						},
						{
							"areaId": "420581",
							"areaName": "宜都市",
							"latitude": 30.37807,
							"longitude": 111.45025
						},
						{
							"areaId": "420582",
							"areaName": "当阳市",
							"latitude": 30.8208,
							"longitude": 111.78912
						},
						{
							"areaId": "420583",
							"areaName": "枝江市",
							"latitude": 30.42612,
							"longitude": 111.76855
						}
					]
				},
				{
					"areaId": "4206",
					"areaName": "襄樊市",
					"latitude": 32.042426,
					"longitude": 112.144146,
					"children": [{
							"areaId": "420600",
							"areaName": "襄樊市本级",
							"latitude": 32.042426,
							"longitude": 112.144146
						},
						{
							"areaId": "420602",
							"areaName": "襄城区",
							"latitude": 32.01017,
							"longitude": 112.13372
						},
						{
							"areaId": "420606",
							"areaName": "樊城区",
							"latitude": 32.04482,
							"longitude": 112.13546
						},
						{
							"areaId": "420607",
							"areaName": "襄阳区",
							"latitude": 32.015088,
							"longitude": 112.150327
						},
						{
							"areaId": "420624",
							"areaName": "南漳县",
							"latitude": 31.77653,
							"longitude": 111.84603
						},
						{
							"areaId": "420625",
							"areaName": "谷城县",
							"latitude": 32.26377,
							"longitude": 111.65267
						},
						{
							"areaId": "420626",
							"areaName": "保康县",
							"latitude": 31.87874,
							"longitude": 111.26138
						},
						{
							"areaId": "420682",
							"areaName": "老河口市",
							"latitude": 32.38476,
							"longitude": 111.67117
						},
						{
							"areaId": "420683",
							"areaName": "枣阳市",
							"latitude": 32.13142,
							"longitude": 112.77444
						},
						{
							"areaId": "420684",
							"areaName": "宜城市",
							"latitude": 31.71972,
							"longitude": 112.25772
						}
					]
				},
				{
					"areaId": "4207",
					"areaName": "鄂州市",
					"latitude": 30.396536,
					"longitude": 114.890593,
					"children": [{
							"areaId": "420700",
							"areaName": "鄂州市本级",
							"latitude": 30.396536,
							"longitude": 114.890593
						},
						{
							"areaId": "420702",
							"areaName": "梁子湖区",
							"latitude": 30.10003,
							"longitude": 114.68463
						},
						{
							"areaId": "420703",
							"areaName": "华容区",
							"latitude": 30.53328,
							"longitude": 114.73568
						},
						{
							"areaId": "420704",
							"areaName": "鄂城区",
							"latitude": 30.40024,
							"longitude": 114.89158
						}
					]
				},
				{
					"areaId": "4208",
					"areaName": "荆门市",
					"latitude": 31.03542,
					"longitude": 112.204251,
					"children": [{
							"areaId": "420800",
							"areaName": "荆门市本级",
							"latitude": 31.03542,
							"longitude": 112.204251
						},
						{
							"areaId": "420802",
							"areaName": "东宝区",
							"latitude": 31.05192,
							"longitude": 112.20147
						},
						{
							"areaId": "420804",
							"areaName": "掇刀区",
							"latitude": 30.97316,
							"longitude": 112.208
						},
						{
							"areaId": "420821",
							"areaName": "京山县",
							"latitude": 31.03542,
							"longitude": 112.204251
						},
						{
							"areaId": "420822",
							"areaName": "沙洋县",
							"latitude": 30.70916,
							"longitude": 112.58853
						},
						{
							"areaId": "420881",
							"areaName": "钟祥市",
							"latitude": 31.1678,
							"longitude": 112.58932
						}
					]
				},
				{
					"areaId": "4209",
					"areaName": "孝感市",
					"latitude": 30.926423,
					"longitude": 113.926655,
					"children": [{
							"areaId": "420900",
							"areaName": "孝感市本级",
							"latitude": 30.926423,
							"longitude": 113.926655
						},
						{
							"areaId": "420902",
							"areaName": "孝南区",
							"latitude": 30.9168,
							"longitude": 113.91111
						},
						{
							"areaId": "420921",
							"areaName": "孝昌县",
							"latitude": 31.25799,
							"longitude": 113.99795
						},
						{
							"areaId": "420922",
							"areaName": "大悟县",
							"latitude": 31.56176,
							"longitude": 114.12564
						},
						{
							"areaId": "420923",
							"areaName": "云梦县",
							"latitude": 31.02093,
							"longitude": 113.75289
						},
						{
							"areaId": "420981",
							"areaName": "应城市",
							"latitude": 30.92834,
							"longitude": 113.57287
						},
						{
							"areaId": "420982",
							"areaName": "安陆市",
							"latitude": 31.25693,
							"longitude": 113.68557
						},
						{
							"areaId": "420984",
							"areaName": "汉川市",
							"latitude": 30.66117,
							"longitude": 113.83898
						}
					]
				},
				{
					"areaId": "4210",
					"areaName": "荆州市",
					"latitude": 30.326857,
					"longitude": 112.23813,
					"children": [{
							"areaId": "421000",
							"areaName": "荆州市本级",
							"latitude": 30.326857,
							"longitude": 112.23813
						},
						{
							"areaId": "421002",
							"areaName": "沙市区",
							"latitude": 30.31107,
							"longitude": 112.25543
						},
						{
							"areaId": "421003",
							"areaName": "荆州区",
							"latitude": 30.35264,
							"longitude": 112.19006
						},
						{
							"areaId": "421022",
							"areaName": "公安县",
							"latitude": 30.05902,
							"longitude": 112.23242
						},
						{
							"areaId": "421023",
							"areaName": "监利县",
							"latitude": 29.81494,
							"longitude": 112.89462
						},
						{
							"areaId": "421024",
							"areaName": "江陵县",
							"latitude": 30.04174,
							"longitude": 112.42468
						},
						{
							"areaId": "421081",
							"areaName": "石首市",
							"latitude": 29.72127,
							"longitude": 112.42636
						},
						{
							"areaId": "421083",
							"areaName": "洪湖市",
							"latitude": 29.827,
							"longitude": 113.47598
						},
						{
							"areaId": "421087",
							"areaName": "松滋市",
							"latitude": 30.16965,
							"longitude": 111.76739
						}
					]
				},
				{
					"areaId": "4211",
					"areaName": "黄冈市",
					"latitude": 30.447711,
					"longitude": 114.879365,
					"children": [{
							"areaId": "421100",
							"areaName": "黄冈市本级",
							"latitude": 30.447711,
							"longitude": 114.879365
						},
						{
							"areaId": "421102",
							"areaName": "黄州区",
							"latitude": 30.43436,
							"longitude": 114.88008
						},
						{
							"areaId": "421121",
							"areaName": "团风县",
							"latitude": 30.64359,
							"longitude": 114.87228
						},
						{
							"areaId": "421122",
							"areaName": "红安县",
							"latitude": 31.28668,
							"longitude": 114.6224
						},
						{
							"areaId": "421123",
							"areaName": "罗田县",
							"latitude": 30.78255,
							"longitude": 115.39971
						},
						{
							"areaId": "421124",
							"areaName": "英山县",
							"latitude": 30.73516,
							"longitude": 115.68142
						},
						{
							"areaId": "421125",
							"areaName": "浠水县",
							"latitude": 30.45265,
							"longitude": 115.26913
						},
						{
							"areaId": "421126",
							"areaName": "蕲春县",
							"latitude": 30.22613,
							"longitude": 115.43615
						},
						{
							"areaId": "421127",
							"areaName": "黄梅县",
							"latitude": 30.07033,
							"longitude": 115.94427
						},
						{
							"areaId": "421181",
							"areaName": "麻城市",
							"latitude": 31.17228,
							"longitude": 115.00988
						},
						{
							"areaId": "421182",
							"areaName": "武穴市",
							"latitude": 29.84446,
							"longitude": 115.55975
						}
					]
				},
				{
					"areaId": "4212",
					"areaName": "咸宁市",
					"latitude": 29.832798,
					"longitude": 114.328963,
					"children": [{
							"areaId": "421200",
							"areaName": "咸宁市本级",
							"latitude": 29.832798,
							"longitude": 114.328963
						},
						{
							"areaId": "421202",
							"areaName": "咸安区",
							"latitude": 29.8529,
							"longitude": 114.29872
						},
						{
							"areaId": "421221",
							"areaName": "嘉鱼县",
							"latitude": 29.97054,
							"longitude": 113.93927
						},
						{
							"areaId": "421222",
							"areaName": "通城县",
							"latitude": 29.24568,
							"longitude": 113.81582
						},
						{
							"areaId": "421223",
							"areaName": "崇阳县",
							"latitude": 29.55564,
							"longitude": 114.03982
						},
						{
							"areaId": "421224",
							"areaName": "通山县",
							"latitude": 29.6063,
							"longitude": 114.48239
						},
						{
							"areaId": "421281",
							"areaName": "赤壁市",
							"latitude": 29.72454,
							"longitude": 113.90039
						}
					]
				},
				{
					"areaId": "4213",
					"areaName": "随州市",
					"latitude": 31.717497,
					"longitude": 113.37377,
					"children": [{
							"areaId": "421300",
							"areaName": "随州市本级",
							"latitude": 31.717497,
							"longitude": 113.37377
						},
						{
							"areaId": "421302",
							"areaName": "曾都区",
							"latitude": 31.717497,
							"longitude": 113.37377
						},
						{
							"areaId": "421321",
							"areaName": "随县",
							"latitude": 31.6179,
							"longitude": 113.82663
						},
						{
							"areaId": "421381",
							"areaName": "广水市",
							"latitude": 31.6179,
							"longitude": 113.82663
						}
					]
				},
				{
					"areaId": "4228",
					"areaName": "恩施土家族苗族自治州",
					"latitude": 30.283114,
					"longitude": 109.48699,
					"children": [{
							"areaId": "422800",
							"areaName": "恩施土家族苗族自治州本级",
							"latitude": 30.283114,
							"longitude": 109.48699
						},
						{
							"areaId": "422801",
							"areaName": "恩施市",
							"latitude": 30.29502,
							"longitude": 109.47942
						},
						{
							"areaId": "422802",
							"areaName": "利川市",
							"latitude": 30.29117,
							"longitude": 108.93591
						},
						{
							"areaId": "422822",
							"areaName": "建始县",
							"latitude": 30.60209,
							"longitude": 109.72207
						},
						{
							"areaId": "422823",
							"areaName": "巴东县",
							"latitude": 31.04233,
							"longitude": 110.34066
						},
						{
							"areaId": "422825",
							"areaName": "宣恩县",
							"latitude": 29.98714,
							"longitude": 109.49179
						},
						{
							"areaId": "422826",
							"areaName": "咸丰县",
							"latitude": 29.67983,
							"longitude": 109.152
						},
						{
							"areaId": "422827",
							"areaName": "来凤县",
							"latitude": 29.49373,
							"longitude": 109.40716
						},
						{
							"areaId": "422828",
							"areaName": "鹤峰县",
							"latitude": 29.89072,
							"longitude": 110.03091
						}
					]
				},
				{
					"areaId": "4290",
					"areaName": "省直辖县级行政单位",
					"latitude": 0,
					"longitude": 0,
					"children": [{
							"areaId": "429000",
							"areaName": "省直辖县级行政单位本级",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "429004",
							"areaName": "仙桃市",
							"latitude": 30.364953,
							"longitude": 113.453974
						},
						{
							"areaId": "429005",
							"areaName": "潜江市",
							"latitude": 30.421215,
							"longitude": 112.896866
						},
						{
							"areaId": "429006",
							"areaName": "天门市",
							"latitude": 30.653061,
							"longitude": 113.165862
						},
						{
							"areaId": "429021",
							"areaName": "神农架林区",
							"latitude": 31.744449,
							"longitude": 110.671525
						}
					]
				}
			]
		},
		{
			"areaId": "43",
			"areaName": "湖南省",
			"latitude": 28.19409,
			"longitude": 112.982279,
			"children": [{
					"areaId": "4301",
					"areaName": "长沙市",
					"latitude": 28.19409,
					"longitude": 112.982279,
					"children": [{
							"areaId": "430100",
							"areaName": "长沙市本级",
							"latitude": 28.19409,
							"longitude": 112.982279
						},
						{
							"areaId": "430102",
							"areaName": "芙蓉区",
							"latitude": 28.1844,
							"longitude": 113.03176
						},
						{
							"areaId": "430103",
							"areaName": "天心区",
							"latitude": 28.1127,
							"longitude": 112.98991
						},
						{
							"areaId": "430104",
							"areaName": "岳麓区",
							"latitude": 28.2351,
							"longitude": 112.93133
						},
						{
							"areaId": "430105",
							"areaName": "开福区",
							"latitude": 28.25585,
							"longitude": 112.98623
						},
						{
							"areaId": "430111",
							"areaName": "雨花区",
							"latitude": 28.13541,
							"longitude": 113.03567
						},
						{
							"areaId": "430121",
							"areaName": "长沙县",
							"latitude": 28.24595,
							"longitude": 113.08071
						},
						{
							"areaId": "430122",
							"areaName": "望城县",
							"latitude": 28.19409,
							"longitude": 112.982279
						},
						{
							"areaId": "430124",
							"areaName": "宁乡县",
							"latitude": 28.19409,
							"longitude": 112.982279
						},
						{
							"areaId": "430181",
							"areaName": "浏阳市",
							"latitude": 28.16375,
							"longitude": 113.64312
						}
					]
				},
				{
					"areaId": "4302",
					"areaName": "株洲市",
					"latitude": 27.69826,
					"longitude": 113.14428,
					"children": [{
							"areaId": "430200",
							"areaName": "株洲市本级",
							"latitude": 27.69826,
							"longitude": 113.14428
						},
						{
							"areaId": "430202",
							"areaName": "荷塘区",
							"latitude": 27.85569,
							"longitude": 113.17315
						},
						{
							"areaId": "430203",
							"areaName": "芦淞区",
							"latitude": 27.78525,
							"longitude": 113.15562
						},
						{
							"areaId": "430204",
							"areaName": "石峰区",
							"latitude": 27.87552,
							"longitude": 113.11776
						},
						{
							"areaId": "430211",
							"areaName": "天元区",
							"latitude": 27.83103,
							"longitude": 113.12335
						},
						{
							"areaId": "430221",
							"areaName": "株洲县",
							"latitude": 27.69826,
							"longitude": 113.14428
						},
						{
							"areaId": "430223",
							"areaName": "攸县",
							"latitude": 27.00352,
							"longitude": 113.34365
						},
						{
							"areaId": "430224",
							"areaName": "茶陵县",
							"latitude": 26.7915,
							"longitude": 113.54364
						},
						{
							"areaId": "430225",
							"areaName": "炎陵县",
							"latitude": 26.48818,
							"longitude": 113.77163
						},
						{
							"areaId": "430281",
							"areaName": "醴陵市",
							"latitude": 27.64615,
							"longitude": 113.49704
						}
					]
				},
				{
					"areaId": "4303",
					"areaName": "湘潭市",
					"latitude": 27.846725,
					"longitude": 112.925083,
					"children": [{
							"areaId": "430300",
							"areaName": "湘潭市本级",
							"latitude": 27.846725,
							"longitude": 112.925083
						},
						{
							"areaId": "430302",
							"areaName": "雨湖区",
							"latitude": 27.86859,
							"longitude": 112.90399
						},
						{
							"areaId": "430304",
							"areaName": "岳塘区",
							"latitude": 27.85784,
							"longitude": 112.9606
						},
						{
							"areaId": "430321",
							"areaName": "湘潭县",
							"latitude": 27.77893,
							"longitude": 112.9508
						},
						{
							"areaId": "430381",
							"areaName": "湘乡市",
							"latitude": 27.73543,
							"longitude": 112.53512
						},
						{
							"areaId": "430382",
							"areaName": "韶山市",
							"latitude": 27.91503,
							"longitude": 112.52655
						}
					]
				},
				{
					"areaId": "4304",
					"areaName": "衡阳市",
					"latitude": 26.900358,
					"longitude": 112.607693,
					"children": [{
							"areaId": "430400",
							"areaName": "衡阳市本级",
							"latitude": 26.900358,
							"longitude": 112.607693
						},
						{
							"areaId": "430405",
							"areaName": "珠晖区",
							"latitude": 26.89361,
							"longitude": 112.62054
						},
						{
							"areaId": "430406",
							"areaName": "雁峰区",
							"latitude": 26.88866,
							"longitude": 112.61654
						},
						{
							"areaId": "430407",
							"areaName": "石鼓区",
							"latitude": 26.90232,
							"longitude": 112.61069
						},
						{
							"areaId": "430408",
							"areaName": "蒸湘区",
							"latitude": 26.89651,
							"longitude": 112.6033
						},
						{
							"areaId": "430412",
							"areaName": "南岳区",
							"latitude": 27.23262,
							"longitude": 112.7384
						},
						{
							"areaId": "430421",
							"areaName": "衡阳县",
							"latitude": 26.9706,
							"longitude": 112.37088
						},
						{
							"areaId": "430422",
							"areaName": "衡南县",
							"latitude": 26.73828,
							"longitude": 112.67788
						},
						{
							"areaId": "430423",
							"areaName": "衡山县",
							"latitude": 27.23134,
							"longitude": 112.86776
						},
						{
							"areaId": "430424",
							"areaName": "衡东县",
							"latitude": 27.08093,
							"longitude": 112.94833
						},
						{
							"areaId": "430426",
							"areaName": "祁东县",
							"latitude": 26.79964,
							"longitude": 112.09039
						},
						{
							"areaId": "430481",
							"areaName": "耒阳市",
							"latitude": 26.42132,
							"longitude": 112.85998
						},
						{
							"areaId": "430482",
							"areaName": "常宁市",
							"latitude": 26.40692,
							"longitude": 112.4009
						}
					]
				},
				{
					"areaId": "4305",
					"areaName": "邵阳市",
					"latitude": 27.237842,
					"longitude": 111.46923,
					"children": [{
							"areaId": "430500",
							"areaName": "邵阳市本级",
							"latitude": 27.237842,
							"longitude": 111.46923
						},
						{
							"areaId": "430502",
							"areaName": "双清区",
							"latitude": 27.23291,
							"longitude": 111.49715
						},
						{
							"areaId": "430503",
							"areaName": "大祥区",
							"latitude": 27.23332,
							"longitude": 111.45412
						},
						{
							"areaId": "430511",
							"areaName": "北塔区",
							"latitude": 27.24648,
							"longitude": 111.45219
						},
						{
							"areaId": "430521",
							"areaName": "邵东县",
							"latitude": 27.237842,
							"longitude": 111.46923
						},
						{
							"areaId": "430522",
							"areaName": "新邵县",
							"latitude": 27.32169,
							"longitude": 111.46066
						},
						{
							"areaId": "430523",
							"areaName": "邵阳县",
							"latitude": 26.99143,
							"longitude": 111.27459
						},
						{
							"areaId": "430524",
							"areaName": "隆回县",
							"latitude": 27.10937,
							"longitude": 111.03216
						},
						{
							"areaId": "430525",
							"areaName": "洞口县",
							"latitude": 27.05462,
							"longitude": 110.57388
						},
						{
							"areaId": "430527",
							"areaName": "绥宁县",
							"latitude": 26.58636,
							"longitude": 110.15576
						},
						{
							"areaId": "430528",
							"areaName": "新宁县",
							"latitude": 26.42936,
							"longitude": 110.85131
						},
						{
							"areaId": "430529",
							"areaName": "城步苗族自治县",
							"latitude": 26.39048,
							"longitude": 110.3222
						},
						{
							"areaId": "430581",
							"areaName": "武冈市",
							"latitude": 26.72817,
							"longitude": 110.63281
						}
					]
				},
				{
					"areaId": "4306",
					"areaName": "岳阳市",
					"latitude": 29.37029,
					"longitude": 113.132855,
					"children": [{
							"areaId": "430600",
							"areaName": "岳阳市本级",
							"latitude": 29.37029,
							"longitude": 113.132855
						},
						{
							"areaId": "430602",
							"areaName": "岳阳楼区",
							"latitude": 29.3719,
							"longitude": 113.12942
						},
						{
							"areaId": "430603",
							"areaName": "云溪区",
							"latitude": 29.47357,
							"longitude": 113.27713
						},
						{
							"areaId": "430611",
							"areaName": "君山区",
							"latitude": 29.45941,
							"longitude": 113.00439
						},
						{
							"areaId": "430621",
							"areaName": "岳阳县",
							"latitude": 29.14314,
							"longitude": 113.11987
						},
						{
							"areaId": "430623",
							"areaName": "华容县",
							"latitude": 29.53019,
							"longitude": 112.54089
						},
						{
							"areaId": "430624",
							"areaName": "湘阴县",
							"latitude": 28.68922,
							"longitude": 112.90911
						},
						{
							"areaId": "430626",
							"areaName": "平江县",
							"latitude": 28.70664,
							"longitude": 113.58105
						},
						{
							"areaId": "430681",
							"areaName": "汨罗市",
							"latitude": 28.80631,
							"longitude": 113.06707
						},
						{
							"areaId": "430682",
							"areaName": "临湘市",
							"latitude": 29.47701,
							"longitude": 113.4501
						}
					]
				},
				{
					"areaId": "4307",
					"areaName": "常德市",
					"latitude": 29.040225,
					"longitude": 111.691347,
					"children": [{
							"areaId": "430700",
							"areaName": "常德市本级",
							"latitude": 29.040225,
							"longitude": 111.691347
						},
						{
							"areaId": "430702",
							"areaName": "武陵区",
							"latitude": 29.02876,
							"longitude": 111.69791
						},
						{
							"areaId": "430703",
							"areaName": "鼎城区",
							"latitude": 29.01859,
							"longitude": 111.68078
						},
						{
							"areaId": "430721",
							"areaName": "安乡县",
							"latitude": 29.41326,
							"longitude": 112.16732
						},
						{
							"areaId": "430722",
							"areaName": "汉寿县",
							"latitude": 28.90299,
							"longitude": 111.96691
						},
						{
							"areaId": "430723",
							"areaName": "澧县",
							"latitude": 29.63317,
							"longitude": 111.75866
						},
						{
							"areaId": "430724",
							"areaName": "临澧县",
							"latitude": 29.44163,
							"longitude": 111.65161
						},
						{
							"areaId": "430725",
							"areaName": "桃源县",
							"latitude": 23.159137,
							"longitude": 120.760049
						},
						{
							"areaId": "430726",
							"areaName": "石门县",
							"latitude": 25.290412,
							"longitude": 121.568491
						},
						{
							"areaId": "430781",
							"areaName": "津市市",
							"latitude": 29.60563,
							"longitude": 111.87756
						}
					]
				},
				{
					"areaId": "4308",
					"areaName": "张家界市",
					"latitude": 29.127401,
					"longitude": 110.479921,
					"children": [{
							"areaId": "430800",
							"areaName": "张家界市本级",
							"latitude": 29.127401,
							"longitude": 110.479921
						},
						{
							"areaId": "430802",
							"areaName": "永定区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "430811",
							"areaName": "武陵源区",
							"latitude": 29.34574,
							"longitude": 110.55026
						},
						{
							"areaId": "430821",
							"areaName": "慈利县",
							"latitude": 29.42989,
							"longitude": 111.13946
						},
						{
							"areaId": "430822",
							"areaName": "桑植县",
							"latitude": 29.39815,
							"longitude": 110.16308
						}
					]
				},
				{
					"areaId": "4309",
					"areaName": "益阳市",
					"latitude": 28.570066,
					"longitude": 112.355042,
					"children": [{
							"areaId": "430900",
							"areaName": "益阳市本级",
							"latitude": 28.570066,
							"longitude": 112.355042
						},
						{
							"areaId": "430902",
							"areaName": "资阳区",
							"latitude": 28.59095,
							"longitude": 112.32447
						},
						{
							"areaId": "430903",
							"areaName": "赫山区",
							"latitude": 28.57425,
							"longitude": 112.37265
						},
						{
							"areaId": "430921",
							"areaName": "南县",
							"latitude": 30.1912,
							"longitude": 105.84005
						},
						{
							"areaId": "430922",
							"areaName": "桃江县",
							"latitude": 28.51814,
							"longitude": 112.1557
						},
						{
							"areaId": "430923",
							"areaName": "安化县",
							"latitude": 28.37424,
							"longitude": 111.21298
						},
						{
							"areaId": "430981",
							"areaName": "沅江市",
							"latitude": 28.84403,
							"longitude": 112.35427
						}
					]
				},
				{
					"areaId": "4310",
					"areaName": "郴州市",
					"latitude": 25.793589,
					"longitude": 113.032067,
					"children": [{
							"areaId": "431000",
							"areaName": "郴州市本级",
							"latitude": 25.793589,
							"longitude": 113.032067
						},
						{
							"areaId": "431002",
							"areaName": "北湖区",
							"latitude": 25.78405,
							"longitude": 113.01103
						},
						{
							"areaId": "431003",
							"areaName": "苏仙区",
							"latitude": 25.80045,
							"longitude": 113.04226
						},
						{
							"areaId": "431021",
							"areaName": "桂阳县",
							"latitude": 25.75406,
							"longitude": 112.73364
						},
						{
							"areaId": "431022",
							"areaName": "宜章县",
							"latitude": 25.39931,
							"longitude": 112.95147
						},
						{
							"areaId": "431023",
							"areaName": "永兴县",
							"latitude": 26.12646,
							"longitude": 113.11242
						},
						{
							"areaId": "431024",
							"areaName": "嘉禾县",
							"latitude": 25.58795,
							"longitude": 112.36935
						},
						{
							"areaId": "431025",
							"areaName": "临武县",
							"latitude": 25.27602,
							"longitude": 112.56369
						},
						{
							"areaId": "431026",
							"areaName": "汝城县",
							"latitude": 25.55204,
							"longitude": 113.68582
						},
						{
							"areaId": "431027",
							"areaName": "桂东县",
							"latitude": 26.07987,
							"longitude": 113.9468
						},
						{
							"areaId": "431028",
							"areaName": "安仁县",
							"latitude": 26.70931,
							"longitude": 113.26944
						},
						{
							"areaId": "431081",
							"areaName": "资兴市",
							"latitude": 25.97668,
							"longitude": 113.23724
						}
					]
				},
				{
					"areaId": "4311",
					"areaName": "永州市",
					"latitude": 26.434516,
					"longitude": 111.608019,
					"children": [{
							"areaId": "431100",
							"areaName": "永州市本级",
							"latitude": 26.434516,
							"longitude": 111.608019
						},
						{
							"areaId": "431102",
							"areaName": "零陵区",
							"latitude": 26.22109,
							"longitude": 111.62103
						},
						{
							"areaId": "431103",
							"areaName": "冷水滩区",
							"latitude": 26.46107,
							"longitude": 111.59214
						},
						{
							"areaId": "431121",
							"areaName": "祁阳县",
							"latitude": 26.58009,
							"longitude": 111.84011
						},
						{
							"areaId": "431122",
							"areaName": "东安县",
							"latitude": 26.39202,
							"longitude": 111.3164
						},
						{
							"areaId": "431123",
							"areaName": "双牌县",
							"latitude": 25.95988,
							"longitude": 111.65927
						},
						{
							"areaId": "431124",
							"areaName": "道县",
							"latitude": 25.52766,
							"longitude": 111.60195
						},
						{
							"areaId": "431125",
							"areaName": "江永县",
							"latitude": 25.27233,
							"longitude": 111.34082
						},
						{
							"areaId": "431126",
							"areaName": "宁远县",
							"latitude": 25.56913,
							"longitude": 111.94625
						},
						{
							"areaId": "431127",
							"areaName": "蓝山县",
							"latitude": 25.36794,
							"longitude": 112.19363
						},
						{
							"areaId": "431128",
							"areaName": "新田县",
							"latitude": 25.9095,
							"longitude": 112.22103
						},
						{
							"areaId": "431129",
							"areaName": "江华瑶族自治县",
							"latitude": 25.1845,
							"longitude": 111.58847
						}
					]
				},
				{
					"areaId": "4312",
					"areaName": "怀化市",
					"latitude": 27.550082,
					"longitude": 109.97824,
					"children": [{
							"areaId": "431200",
							"areaName": "怀化市本级",
							"latitude": 27.550082,
							"longitude": 109.97824
						},
						{
							"areaId": "431202",
							"areaName": "鹤城区",
							"latitude": 27.54942,
							"longitude": 109.96509
						},
						{
							"areaId": "431221",
							"areaName": "中方县",
							"latitude": 27.43988,
							"longitude": 109.94497
						},
						{
							"areaId": "431222",
							"areaName": "沅陵县",
							"latitude": 28.45548,
							"longitude": 110.39633
						},
						{
							"areaId": "431223",
							"areaName": "辰溪县",
							"latitude": 28.00406,
							"longitude": 110.18942
						},
						{
							"areaId": "431224",
							"areaName": "溆浦县",
							"latitude": 27.90836,
							"longitude": 110.59384
						},
						{
							"areaId": "431225",
							"areaName": "会同县",
							"latitude": 26.88716,
							"longitude": 109.73568
						},
						{
							"areaId": "431226",
							"areaName": "麻阳苗族自治县",
							"latitude": 27.866,
							"longitude": 109.80194
						},
						{
							"areaId": "431227",
							"areaName": "新晃侗族自治县",
							"latitude": 27.35937,
							"longitude": 109.17166
						},
						{
							"areaId": "431228",
							"areaName": "芷江侗族自治县",
							"latitude": 27.44297,
							"longitude": 109.6849
						},
						{
							"areaId": "431229",
							"areaName": "靖州苗族侗族自治县",
							"latitude": 26.57651,
							"longitude": 109.69821
						},
						{
							"areaId": "431230",
							"areaName": "通道侗族自治县",
							"latitude": 26.1571,
							"longitude": 109.78515
						},
						{
							"areaId": "431281",
							"areaName": "洪江市",
							"latitude": 27.20922,
							"longitude": 109.83651
						}
					]
				},
				{
					"areaId": "4313",
					"areaName": "娄底市",
					"latitude": 27.728136,
					"longitude": 112.008497,
					"children": [{
							"areaId": "431300",
							"areaName": "娄底市本级",
							"latitude": 27.728136,
							"longitude": 112.008497
						},
						{
							"areaId": "431302",
							"areaName": "娄星区",
							"latitude": 27.72992,
							"longitude": 112.00193
						},
						{
							"areaId": "431321",
							"areaName": "双峰县",
							"latitude": 27.45418,
							"longitude": 112.19921
						},
						{
							"areaId": "431322",
							"areaName": "新化县",
							"latitude": 23.038533,
							"longitude": 120.310807
						},
						{
							"areaId": "431381",
							"areaName": "冷水江市",
							"latitude": 27.68147,
							"longitude": 111.43554
						},
						{
							"areaId": "431382",
							"areaName": "涟源市",
							"latitude": 27.68831,
							"longitude": 111.67233
						}
					]
				},
				{
					"areaId": "4331",
					"areaName": "湘西土家族苗族自治州",
					"latitude": 28.314296,
					"longitude": 109.739735,
					"children": [{
							"areaId": "433100",
							"areaName": "湘西土家族苗族自治州本级",
							"latitude": 28.314296,
							"longitude": 109.739735
						},
						{
							"areaId": "433101",
							"areaName": "吉首市",
							"latitude": 28.26247,
							"longitude": 109.69799
						},
						{
							"areaId": "433122",
							"areaName": "泸溪县",
							"latitude": 28.2205,
							"longitude": 110.21682
						},
						{
							"areaId": "433123",
							"areaName": "凤凰县",
							"latitude": 27.94822,
							"longitude": 109.60156
						},
						{
							"areaId": "433124",
							"areaName": "花垣县",
							"latitude": 28.5721,
							"longitude": 109.48217
						},
						{
							"areaId": "433125",
							"areaName": "保靖县",
							"latitude": 28.69997,
							"longitude": 109.66049
						},
						{
							"areaId": "433126",
							"areaName": "古丈县",
							"latitude": 28.61944,
							"longitude": 109.94812
						},
						{
							"areaId": "433127",
							"areaName": "永顺县",
							"latitude": 29.00103,
							"longitude": 109.85266
						},
						{
							"areaId": "433130",
							"areaName": "龙山县",
							"latitude": 29.45693,
							"longitude": 109.4432
						}
					]
				}
			]
		},
		{
			"areaId": "44",
			"areaName": "广东省",
			"latitude": 23.125178,
			"longitude": 113.280637,
			"children": [{
					"areaId": "4401",
					"areaName": "广州市",
					"latitude": 23.125178,
					"longitude": 113.280637,
					"children": [{
							"areaId": "440100",
							"areaName": "广州市本级",
							"latitude": 23.125178,
							"longitude": 113.280637
						},
						{
							"areaId": "440103",
							"areaName": "荔湾区",
							"latitude": 23.12592,
							"longitude": 113.2442
						},
						{
							"areaId": "440104",
							"areaName": "越秀区",
							"latitude": 23.12897,
							"longitude": 113.26683
						},
						{
							"areaId": "440105",
							"areaName": "海珠区",
							"latitude": 23.10379,
							"longitude": 113.26197
						},
						{
							"areaId": "440106",
							"areaName": "天河区",
							"latitude": 23.12467,
							"longitude": 113.36112
						},
						{
							"areaId": "440111",
							"areaName": "白云区",
							"latitude": 26.68284,
							"longitude": 106.63088
						},
						{
							"areaId": "440112",
							"areaName": "黄埔区",
							"latitude": 23.10642,
							"longitude": 113.45895
						},
						{
							"areaId": "440113",
							"areaName": "番禺区",
							"latitude": 22.93599,
							"longitude": 113.38397
						},
						{
							"areaId": "440114",
							"areaName": "花都区",
							"latitude": 23.40358,
							"longitude": 113.22033
						},
						{
							"areaId": "440115",
							"areaName": "南沙区",
							"latitude": 22.77144,
							"longitude": 113.60845
						},
						{
							"areaId": "440116",
							"areaName": "萝岗区",
							"latitude": 23.125178,
							"longitude": 113.280637
						},
						{
							"areaId": "440183",
							"areaName": "增城市",
							"latitude": 23.125178,
							"longitude": 113.280637
						},
						{
							"areaId": "440184",
							"areaName": "从化市",
							"latitude": 23.125178,
							"longitude": 113.280637
						}
					]
				},
				{
					"areaId": "4402",
					"areaName": "韶关市",
					"latitude": 24.801322,
					"longitude": 113.591544,
					"children": [{
							"areaId": "440200",
							"areaName": "韶关市本级",
							"latitude": 24.801322,
							"longitude": 113.591544
						},
						{
							"areaId": "440203",
							"areaName": "武江区",
							"latitude": 24.79264,
							"longitude": 113.58767
						},
						{
							"areaId": "440204",
							"areaName": "浈江区",
							"latitude": 24.80438,
							"longitude": 113.61109
						},
						{
							"areaId": "440205",
							"areaName": "曲江区",
							"latitude": 24.67915,
							"longitude": 113.60165
						},
						{
							"areaId": "440222",
							"areaName": "始兴县",
							"latitude": 24.94759,
							"longitude": 114.06799
						},
						{
							"areaId": "440224",
							"areaName": "仁化县",
							"latitude": 25.08742,
							"longitude": 113.74737
						},
						{
							"areaId": "440229",
							"areaName": "翁源县",
							"latitude": 24.3495,
							"longitude": 114.13385
						},
						{
							"areaId": "440232",
							"areaName": "乳源瑶族自治县",
							"latitude": 24.77803,
							"longitude": 113.27734
						},
						{
							"areaId": "440233",
							"areaName": "新丰县",
							"latitude": 24.8996,
							"longitude": 120.983006
						},
						{
							"areaId": "440281",
							"areaName": "乐昌市",
							"latitude": 25.12799,
							"longitude": 113.35653
						},
						{
							"areaId": "440282",
							"areaName": "南雄市",
							"latitude": 25.11706,
							"longitude": 114.30966
						}
					]
				},
				{
					"areaId": "4403",
					"areaName": "深圳市",
					"latitude": 22.547,
					"longitude": 114.085947,
					"children": [{
							"areaId": "440300",
							"areaName": "深圳市本级",
							"latitude": 22.547,
							"longitude": 114.085947
						},
						{
							"areaId": "440303",
							"areaName": "罗湖区",
							"latitude": 22.54836,
							"longitude": 114.13116
						},
						{
							"areaId": "440304",
							"areaName": "福田区",
							"latitude": 22.52245,
							"longitude": 114.05571
						},
						{
							"areaId": "440305",
							"areaName": "南山区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "440306",
							"areaName": "宝安区",
							"latitude": 22.55371,
							"longitude": 113.88311
						},
						{
							"areaId": "440307",
							"areaName": "龙岗区",
							"latitude": 22.71986,
							"longitude": 114.24771
						},
						{
							"areaId": "440308",
							"areaName": "盐田区",
							"latitude": 22.5578,
							"longitude": 114.23733
						}
					]
				},
				{
					"areaId": "4404",
					"areaName": "珠海市",
					"latitude": 22.255899,
					"longitude": 113.552724,
					"children": [{
							"areaId": "440400",
							"areaName": "珠海市本级",
							"latitude": 22.255899,
							"longitude": 113.552724
						},
						{
							"areaId": "440402",
							"areaName": "香洲区",
							"latitude": 22.26654,
							"longitude": 113.5435
						},
						{
							"areaId": "440403",
							"areaName": "斗门区",
							"latitude": 22.20898,
							"longitude": 113.29644
						},
						{
							"areaId": "440404",
							"areaName": "金湾区",
							"latitude": 22.14691,
							"longitude": 113.36361
						}
					]
				},
				{
					"areaId": "4405",
					"areaName": "汕头市",
					"latitude": 23.37102,
					"longitude": 116.708463,
					"children": [{
							"areaId": "440500",
							"areaName": "汕头市本级",
							"latitude": 23.37102,
							"longitude": 116.708463
						},
						{
							"areaId": "440507",
							"areaName": "龙湖区",
							"latitude": 23.37166,
							"longitude": 116.71641
						},
						{
							"areaId": "440511",
							"areaName": "金平区",
							"latitude": 23.36637,
							"longitude": 116.70364
						},
						{
							"areaId": "440512",
							"areaName": "濠江区",
							"latitude": 23.28588,
							"longitude": 116.72659
						},
						{
							"areaId": "440513",
							"areaName": "潮阳区",
							"latitude": 23.26485,
							"longitude": 116.6015
						},
						{
							"areaId": "440514",
							"areaName": "潮南区",
							"latitude": 23.25,
							"longitude": 116.43188
						},
						{
							"areaId": "440515",
							"areaName": "澄海区",
							"latitude": 23.46728,
							"longitude": 116.75589
						},
						{
							"areaId": "440523",
							"areaName": "南澳县",
							"latitude": 24.465393,
							"longitude": 121.79981
						}
					]
				},
				{
					"areaId": "4406",
					"areaName": "佛山市",
					"latitude": 23.028762,
					"longitude": 113.122717,
					"children": [{
							"areaId": "440600",
							"areaName": "佛山市本级",
							"latitude": 23.028762,
							"longitude": 113.122717
						},
						{
							"areaId": "440604",
							"areaName": "禅城区",
							"latitude": 23.00842,
							"longitude": 113.1228
						},
						{
							"areaId": "440605",
							"areaName": "南海区",
							"latitude": 23.02877,
							"longitude": 113.14299
						},
						{
							"areaId": "440606",
							"areaName": "顺德区",
							"latitude": 22.80452,
							"longitude": 113.29394
						},
						{
							"areaId": "440607",
							"areaName": "三水区",
							"latitude": 23.15564,
							"longitude": 112.89703
						},
						{
							"areaId": "440608",
							"areaName": "高明区",
							"latitude": 22.90022,
							"longitude": 112.89254
						}
					]
				},
				{
					"areaId": "4407",
					"areaName": "江门市",
					"latitude": 22.590431,
					"longitude": 113.094942,
					"children": [{
							"areaId": "440700",
							"areaName": "江门市本级",
							"latitude": 22.590431,
							"longitude": 113.094942
						},
						{
							"areaId": "440703",
							"areaName": "蓬江区",
							"latitude": 22.59515,
							"longitude": 113.07849
						},
						{
							"areaId": "440704",
							"areaName": "江海区",
							"latitude": 22.56024,
							"longitude": 113.11099
						},
						{
							"areaId": "440705",
							"areaName": "新会区",
							"latitude": 22.45876,
							"longitude": 113.03225
						},
						{
							"areaId": "440781",
							"areaName": "台山市",
							"latitude": 22.2515,
							"longitude": 112.79382
						},
						{
							"areaId": "440783",
							"areaName": "开平市",
							"latitude": 22.37622,
							"longitude": 112.69842
						},
						{
							"areaId": "440784",
							"areaName": "鹤山市",
							"latitude": 22.76523,
							"longitude": 112.96429
						},
						{
							"areaId": "440785",
							"areaName": "恩平市",
							"latitude": 22.18288,
							"longitude": 112.30496
						}
					]
				},
				{
					"areaId": "4408",
					"areaName": "湛江市",
					"latitude": 21.195338,
					"longitude": 110.405529,
					"children": [{
							"areaId": "440800",
							"areaName": "湛江市本级",
							"latitude": 21.195338,
							"longitude": 110.405529
						},
						{
							"areaId": "440802",
							"areaName": "赤坎区",
							"latitude": 21.26606,
							"longitude": 110.36592
						},
						{
							"areaId": "440803",
							"areaName": "霞山区",
							"latitude": 21.19181,
							"longitude": 110.39822
						},
						{
							"areaId": "440804",
							"areaName": "坡头区",
							"latitude": 21.24472,
							"longitude": 110.45533
						},
						{
							"areaId": "440811",
							"areaName": "麻章区",
							"latitude": 21.26333,
							"longitude": 110.3342
						},
						{
							"areaId": "440823",
							"areaName": "遂溪县",
							"latitude": 21.37721,
							"longitude": 110.25003
						},
						{
							"areaId": "440825",
							"areaName": "徐闻县",
							"latitude": 20.32812,
							"longitude": 110.17379
						},
						{
							"areaId": "440881",
							"areaName": "廉江市",
							"latitude": 21.60917,
							"longitude": 110.28442
						},
						{
							"areaId": "440882",
							"areaName": "雷州市",
							"latitude": 20.91428,
							"longitude": 110.10092
						},
						{
							"areaId": "440883",
							"areaName": "吴川市",
							"latitude": 21.44584,
							"longitude": 110.77703
						}
					]
				},
				{
					"areaId": "4409",
					"areaName": "茂名市",
					"latitude": 21.659751,
					"longitude": 110.919229,
					"children": [{
							"areaId": "440900",
							"areaName": "茂名市本级",
							"latitude": 21.659751,
							"longitude": 110.919229
						},
						{
							"areaId": "440902",
							"areaName": "茂南区",
							"latitude": 21.64103,
							"longitude": 110.9187
						},
						{
							"areaId": "440903",
							"areaName": "茂港区",
							"latitude": 21.659751,
							"longitude": 110.919229
						},
						{
							"areaId": "440923",
							"areaName": "电白县",
							"latitude": 21.659751,
							"longitude": 110.919229
						},
						{
							"areaId": "440981",
							"areaName": "高州市",
							"latitude": 21.92057,
							"longitude": 110.85519
						},
						{
							"areaId": "440982",
							"areaName": "化州市",
							"latitude": 21.66394,
							"longitude": 110.63949
						},
						{
							"areaId": "440983",
							"areaName": "信宜市",
							"latitude": 22.35351,
							"longitude": 110.94647
						}
					]
				},
				{
					"areaId": "4412",
					"areaName": "肇庆市",
					"latitude": 23.051546,
					"longitude": 112.472529,
					"children": [{
							"areaId": "441200",
							"areaName": "肇庆市本级",
							"latitude": 23.051546,
							"longitude": 112.472529
						},
						{
							"areaId": "441202",
							"areaName": "端州区",
							"latitude": 23.0519,
							"longitude": 112.48495
						},
						{
							"areaId": "441203",
							"areaName": "鼎湖区",
							"latitude": 23.15846,
							"longitude": 112.56643
						},
						{
							"areaId": "441223",
							"areaName": "广宁县",
							"latitude": 23.6346,
							"longitude": 112.44064
						},
						{
							"areaId": "441224",
							"areaName": "怀集县",
							"latitude": 23.90918,
							"longitude": 112.18396
						},
						{
							"areaId": "441225",
							"areaName": "封开县",
							"latitude": 31.16095,
							"longitude": 108.39306
						},
						{
							"areaId": "441226",
							"areaName": "德庆县",
							"latitude": 29.65002,
							"longitude": 91.00033
						},
						{
							"areaId": "441283",
							"areaName": "高要市",
							"latitude": 23.051546,
							"longitude": 112.472529
						},
						{
							"areaId": "441284",
							"areaName": "四会市",
							"latitude": 23.32686,
							"longitude": 112.73416
						}
					]
				},
				{
					"areaId": "4413",
					"areaName": "惠州市",
					"latitude": 23.079404,
					"longitude": 114.412599,
					"children": [{
							"areaId": "441300",
							"areaName": "惠州市本级",
							"latitude": 23.079404,
							"longitude": 114.412599
						},
						{
							"areaId": "441302",
							"areaName": "惠城区",
							"latitude": 23.08377,
							"longitude": 114.3828
						},
						{
							"areaId": "441303",
							"areaName": "惠阳区",
							"latitude": 22.78845,
							"longitude": 114.45639
						},
						{
							"areaId": "441322",
							"areaName": "博罗县",
							"latitude": 23.17307,
							"longitude": 114.28964
						},
						{
							"areaId": "441323",
							"areaName": "惠东县",
							"latitude": 22.98484,
							"longitude": 114.72009
						},
						{
							"areaId": "441324",
							"areaName": "龙门县",
							"latitude": 23.72758,
							"longitude": 114.25479
						}
					]
				},
				{
					"areaId": "4414",
					"areaName": "梅州市",
					"latitude": 24.299112,
					"longitude": 116.117582,
					"children": [{
							"areaId": "441400",
							"areaName": "梅州市本级",
							"latitude": 24.299112,
							"longitude": 116.117582
						},
						{
							"areaId": "441402",
							"areaName": "梅江区",
							"latitude": 24.31062,
							"longitude": 116.11663
						},
						{
							"areaId": "441421",
							"areaName": "梅县",
							"latitude": 24.299112,
							"longitude": 116.117582
						},
						{
							"areaId": "441422",
							"areaName": "大埔县",
							"latitude": 22.445653,
							"longitude": 114.171743
						},
						{
							"areaId": "441423",
							"areaName": "丰顺县",
							"latitude": 23.74094,
							"longitude": 116.18219
						},
						{
							"areaId": "441424",
							"areaName": "五华县",
							"latitude": 23.92417,
							"longitude": 115.77893
						},
						{
							"areaId": "441426",
							"areaName": "平远县",
							"latitude": 24.57116,
							"longitude": 115.89556
						},
						{
							"areaId": "441427",
							"areaName": "蕉岭县",
							"latitude": 24.65732,
							"longitude": 116.17089
						},
						{
							"areaId": "441481",
							"areaName": "兴宁市",
							"latitude": 24.14001,
							"longitude": 115.73141
						}
					]
				},
				{
					"areaId": "4415",
					"areaName": "汕尾市",
					"latitude": 22.774485,
					"longitude": 115.364238,
					"children": [{
							"areaId": "441500",
							"areaName": "汕尾市本级",
							"latitude": 22.774485,
							"longitude": 115.364238
						},
						{
							"areaId": "441502",
							"areaName": "城区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "441521",
							"areaName": "海丰县",
							"latitude": 22.96653,
							"longitude": 115.32336
						},
						{
							"areaId": "441523",
							"areaName": "陆河县",
							"latitude": 23.30365,
							"longitude": 115.65597
						},
						{
							"areaId": "441581",
							"areaName": "陆丰市",
							"latitude": 22.94335,
							"longitude": 115.64813
						}
					]
				},
				{
					"areaId": "4416",
					"areaName": "河源市",
					"latitude": 23.746266,
					"longitude": 114.697802,
					"children": [{
							"areaId": "441600",
							"areaName": "河源市本级",
							"latitude": 23.746266,
							"longitude": 114.697802
						},
						{
							"areaId": "441602",
							"areaName": "源城区",
							"latitude": 23.7341,
							"longitude": 114.70242
						},
						{
							"areaId": "441621",
							"areaName": "紫金县",
							"latitude": 23.63867,
							"longitude": 115.18365
						},
						{
							"areaId": "441622",
							"areaName": "龙川县",
							"latitude": 24.10142,
							"longitude": 115.26025
						},
						{
							"areaId": "441623",
							"areaName": "连平县",
							"latitude": 24.37156,
							"longitude": 114.49026
						},
						{
							"areaId": "441624",
							"areaName": "和平县",
							"latitude": 24.44319,
							"longitude": 114.93841
						},
						{
							"areaId": "441625",
							"areaName": "东源县",
							"latitude": 23.78835,
							"longitude": 114.74633
						}
					]
				},
				{
					"areaId": "4417",
					"areaName": "阳江市",
					"latitude": 21.859222,
					"longitude": 111.975107,
					"children": [{
							"areaId": "441700",
							"areaName": "阳江市本级",
							"latitude": 21.859222,
							"longitude": 111.975107
						},
						{
							"areaId": "441702",
							"areaName": "江城区",
							"latitude": 21.86193,
							"longitude": 111.95488
						},
						{
							"areaId": "441721",
							"areaName": "阳西县",
							"latitude": 21.75234,
							"longitude": 111.61785
						},
						{
							"areaId": "441723",
							"areaName": "阳东县",
							"latitude": 21.859222,
							"longitude": 111.975107
						},
						{
							"areaId": "441781",
							"areaName": "阳春市",
							"latitude": 22.17232,
							"longitude": 111.78854
						}
					]
				},
				{
					"areaId": "4418",
					"areaName": "清远市",
					"latitude": 23.704188,
					"longitude": 113.036779,
					"children": [{
							"areaId": "441800",
							"areaName": "清远市本级",
							"latitude": 23.704188,
							"longitude": 113.036779
						},
						{
							"areaId": "441802",
							"areaName": "清城区",
							"latitude": 23.69784,
							"longitude": 113.06265
						},
						{
							"areaId": "441821",
							"areaName": "佛冈县",
							"latitude": 23.87231,
							"longitude": 113.53286
						},
						{
							"areaId": "441823",
							"areaName": "阳山县",
							"latitude": 24.46516,
							"longitude": 112.64129
						},
						{
							"areaId": "441825",
							"areaName": "连山壮族瑶族自治县",
							"latitude": 24.56807,
							"longitude": 112.0802
						},
						{
							"areaId": "441826",
							"areaName": "连南瑶族自治县",
							"latitude": 24.71726,
							"longitude": 112.28842
						},
						{
							"areaId": "441827",
							"areaName": "清新县",
							"latitude": 23.704188,
							"longitude": 113.036779
						},
						{
							"areaId": "441881",
							"areaName": "英德市",
							"latitude": 24.18571,
							"longitude": 113.415
						},
						{
							"areaId": "441882",
							"areaName": "连州市",
							"latitude": 24.77913,
							"longitude": 112.38153
						}
					]
				},
				{
					"areaId": "4419",
					"areaName": "东莞市",
					"latitude": 23.048884,
					"longitude": 113.760234,
					"children": [{
						"areaId": "441900",
						"areaName": "东莞市本级",
						"latitude": 23.048884,
						"longitude": 113.760234
					}]
				},
				{
					"areaId": "4420",
					"areaName": "中山市",
					"latitude": 22.521113,
					"longitude": 113.382391,
					"children": [{
						"areaId": "442000",
						"areaName": "中山市本级",
						"latitude": 22.521113,
						"longitude": 113.382391
					}]
				},
				{
					"areaId": "4451",
					"areaName": "潮州市",
					"latitude": 22.550536,
					"longitude": 120.542854,
					"children": [{
							"areaId": "445100",
							"areaName": "潮州市本级",
							"latitude": 22.550536,
							"longitude": 120.542854
						},
						{
							"areaId": "445102",
							"areaName": "湘桥区",
							"latitude": 23.67451,
							"longitude": 116.62805
						},
						{
							"areaId": "445121",
							"areaName": "潮安县",
							"latitude": 22.550536,
							"longitude": 120.542854
						},
						{
							"areaId": "445122",
							"areaName": "饶平县",
							"latitude": 23.66994,
							"longitude": 117.00692
						}
					]
				},
				{
					"areaId": "4452",
					"areaName": "揭阳市",
					"latitude": 23.543778,
					"longitude": 116.355733,
					"children": [{
							"areaId": "445200",
							"areaName": "揭阳市本级",
							"latitude": 23.543778,
							"longitude": 116.355733
						},
						{
							"areaId": "445202",
							"areaName": "榕城区",
							"latitude": 23.52508,
							"longitude": 116.3671
						},
						{
							"areaId": "445221",
							"areaName": "揭东县",
							"latitude": 23.543778,
							"longitude": 116.355733
						},
						{
							"areaId": "445222",
							"areaName": "揭西县",
							"latitude": 23.42714,
							"longitude": 115.83883
						},
						{
							"areaId": "445224",
							"areaName": "惠来县",
							"latitude": 23.03289,
							"longitude": 116.29599
						},
						{
							"areaId": "445281",
							"areaName": "普宁市",
							"latitude": 23.29732,
							"longitude": 116.16564
						}
					]
				},
				{
					"areaId": "4453",
					"areaName": "云浮市",
					"latitude": 22.929801,
					"longitude": 112.044439,
					"children": [{
							"areaId": "445300",
							"areaName": "云浮市本级",
							"latitude": 22.929801,
							"longitude": 112.044439
						},
						{
							"areaId": "445302",
							"areaName": "云城区",
							"latitude": 22.92996,
							"longitude": 112.03908
						},
						{
							"areaId": "445321",
							"areaName": "新兴县",
							"latitude": 22.69734,
							"longitude": 112.23019
						},
						{
							"areaId": "445322",
							"areaName": "郁南县",
							"latitude": 23.23307,
							"longitude": 111.53387
						},
						{
							"areaId": "445323",
							"areaName": "云安县",
							"latitude": 22.929801,
							"longitude": 112.044439
						},
						{
							"areaId": "445381",
							"areaName": "罗定市",
							"latitude": 22.76967,
							"longitude": 111.56979
						}
					]
				}
			]
		},
		{
			"areaId": "45",
			"areaName": "广西",
			"latitude": 22.82402,
			"longitude": 108.320004,
			"children": [{
					"areaId": "4501",
					"areaName": "南宁市",
					"latitude": 22.82402,
					"longitude": 108.320004,
					"children": [{
							"areaId": "450100",
							"areaName": "南宁市本级",
							"latitude": 22.82402,
							"longitude": 108.320004
						},
						{
							"areaId": "450102",
							"areaName": "兴宁区",
							"latitude": 22.85355,
							"longitude": 108.36694
						},
						{
							"areaId": "450103",
							"areaName": "青秀区",
							"latitude": 22.78511,
							"longitude": 108.49545
						},
						{
							"areaId": "450105",
							"areaName": "江南区",
							"latitude": 22.78127,
							"longitude": 108.27325
						},
						{
							"areaId": "450107",
							"areaName": "西乡塘区",
							"latitude": 22.83386,
							"longitude": 108.31347
						},
						{
							"areaId": "450108",
							"areaName": "良庆区",
							"latitude": 22.74914,
							"longitude": 108.41284
						},
						{
							"areaId": "450109",
							"areaName": "邕宁区",
							"latitude": 22.75628,
							"longitude": 108.48684
						},
						{
							"areaId": "450122",
							"areaName": "武鸣县",
							"latitude": 22.82402,
							"longitude": 108.320004
						},
						{
							"areaId": "450123",
							"areaName": "隆安县",
							"latitude": 23.17336,
							"longitude": 107.69192
						},
						{
							"areaId": "450124",
							"areaName": "马山县",
							"latitude": 23.70931,
							"longitude": 108.17697
						},
						{
							"areaId": "450125",
							"areaName": "上林县",
							"latitude": 23.432,
							"longitude": 108.60522
						},
						{
							"areaId": "450126",
							"areaName": "宾阳县",
							"latitude": 23.2196,
							"longitude": 108.81185
						},
						{
							"areaId": "450127",
							"areaName": "横县",
							"latitude": 22.68448,
							"longitude": 109.26608
						}
					]
				},
				{
					"areaId": "4502",
					"areaName": "柳州市",
					"latitude": 24.314617,
					"longitude": 109.411703,
					"children": [{
							"areaId": "450200",
							"areaName": "柳州市本级",
							"latitude": 24.314617,
							"longitude": 109.411703
						},
						{
							"areaId": "450202",
							"areaName": "城中区",
							"latitude": 36.62279,
							"longitude": 101.78394
						},
						{
							"areaId": "450203",
							"areaName": "鱼峰区",
							"latitude": 24.31868,
							"longitude": 109.4533
						},
						{
							"areaId": "450204",
							"areaName": "柳南区",
							"latitude": 24.33599,
							"longitude": 109.38548
						},
						{
							"areaId": "450205",
							"areaName": "柳北区",
							"latitude": 24.36267,
							"longitude": 109.40202
						},
						{
							"areaId": "450221",
							"areaName": "柳江县",
							"latitude": 24.314617,
							"longitude": 109.411703
						},
						{
							"areaId": "450222",
							"areaName": "柳城县",
							"latitude": 24.64951,
							"longitude": 109.23877
						},
						{
							"areaId": "450223",
							"areaName": "鹿寨县",
							"latitude": 24.47306,
							"longitude": 109.75177
						},
						{
							"areaId": "450224",
							"areaName": "融安县",
							"latitude": 25.22465,
							"longitude": 109.39761
						},
						{
							"areaId": "450225",
							"areaName": "融水苗族自治县",
							"latitude": 25.06628,
							"longitude": 109.25634
						},
						{
							"areaId": "450226",
							"areaName": "三江侗族自治县",
							"latitude": 25.78428,
							"longitude": 109.60446
						}
					]
				},
				{
					"areaId": "4503",
					"areaName": "桂林市",
					"latitude": 25.274215,
					"longitude": 110.299121,
					"children": [{
							"areaId": "450300",
							"areaName": "桂林市本级",
							"latitude": 25.274215,
							"longitude": 110.299121
						},
						{
							"areaId": "450302",
							"areaName": "秀峰区",
							"latitude": 25.28249,
							"longitude": 110.28915
						},
						{
							"areaId": "450303",
							"areaName": "叠彩区",
							"latitude": 25.31381,
							"longitude": 110.30195
						},
						{
							"areaId": "450304",
							"areaName": "象山区",
							"latitude": 25.26168,
							"longitude": 110.28108
						},
						{
							"areaId": "450305",
							"areaName": "七星区",
							"latitude": 25.2525,
							"longitude": 110.31793
						},
						{
							"areaId": "450311",
							"areaName": "雁山区",
							"latitude": 25.06038,
							"longitude": 110.30911
						},
						{
							"areaId": "450321",
							"areaName": "阳朔县",
							"latitude": 24.77579,
							"longitude": 110.49475
						},
						{
							"areaId": "450322",
							"areaName": "临桂县",
							"latitude": 25.274215,
							"longitude": 110.299121
						},
						{
							"areaId": "450323",
							"areaName": "灵川县",
							"latitude": 25.41292,
							"longitude": 110.32949
						},
						{
							"areaId": "450324",
							"areaName": "全州县",
							"latitude": 25.92799,
							"longitude": 111.07211
						},
						{
							"areaId": "450325",
							"areaName": "兴安县",
							"latitude": 25.61167,
							"longitude": 110.67144
						},
						{
							"areaId": "450326",
							"areaName": "永福县",
							"latitude": 24.98004,
							"longitude": 109.98333
						},
						{
							"areaId": "450327",
							"areaName": "灌阳县",
							"latitude": 25.48803,
							"longitude": 111.15954
						},
						{
							"areaId": "450328",
							"areaName": "龙胜各族自治县",
							"latitude": 25.79614,
							"longitude": 110.01226
						},
						{
							"areaId": "450329",
							"areaName": "资源县",
							"latitude": 26.04237,
							"longitude": 110.65255
						},
						{
							"areaId": "450330",
							"areaName": "平乐县",
							"latitude": 24.63242,
							"longitude": 110.64175
						},
						{
							"areaId": "450331",
							"areaName": "荔蒲县",
							"latitude": 25.274215,
							"longitude": 110.299121
						},
						{
							"areaId": "450332",
							"areaName": "恭城瑶族自治县",
							"latitude": 24.83286,
							"longitude": 110.83035
						}
					]
				},
				{
					"areaId": "4504",
					"areaName": "梧州市",
					"latitude": 23.472309,
					"longitude": 111.316229,
					"children": [{
							"areaId": "450400",
							"areaName": "梧州市本级",
							"latitude": 23.472309,
							"longitude": 111.316229
						},
						{
							"areaId": "450403",
							"areaName": "万秀区",
							"latitude": 23.47298,
							"longitude": 111.32052
						},
						{
							"areaId": "450404",
							"areaName": "蝶山区",
							"latitude": 23.472309,
							"longitude": 111.316229
						},
						{
							"areaId": "450405",
							"areaName": "长洲区",
							"latitude": 23.48573,
							"longitude": 111.27494
						},
						{
							"areaId": "450421",
							"areaName": "苍梧县",
							"latitude": 23.42049,
							"longitude": 111.24533
						},
						{
							"areaId": "450422",
							"areaName": "藤县",
							"latitude": 23.37605,
							"longitude": 110.91418
						},
						{
							"areaId": "450423",
							"areaName": "蒙山县",
							"latitude": 24.20168,
							"longitude": 110.52221
						},
						{
							"areaId": "450481",
							"areaName": "岑溪市",
							"latitude": 22.9191,
							"longitude": 110.99594
						}
					]
				},
				{
					"areaId": "4505",
					"areaName": "北海市",
					"latitude": 21.473343,
					"longitude": 109.119254,
					"children": [{
							"areaId": "450500",
							"areaName": "北海市本级",
							"latitude": 21.473343,
							"longitude": 109.119254
						},
						{
							"areaId": "450502",
							"areaName": "海城区",
							"latitude": 21.47501,
							"longitude": 109.11744
						},
						{
							"areaId": "450503",
							"areaName": "银海区",
							"latitude": 21.4783,
							"longitude": 109.13029
						},
						{
							"areaId": "450512",
							"areaName": "铁山港区",
							"latitude": 21.59661,
							"longitude": 109.45578
						},
						{
							"areaId": "450521",
							"areaName": "合浦县",
							"latitude": 21.66601,
							"longitude": 109.20068
						}
					]
				},
				{
					"areaId": "4506",
					"areaName": "防城港市",
					"latitude": 21.614631,
					"longitude": 108.345478,
					"children": [{
							"areaId": "450600",
							"areaName": "防城港市本级",
							"latitude": 21.614631,
							"longitude": 108.345478
						},
						{
							"areaId": "450602",
							"areaName": "港口区",
							"latitude": 21.64342,
							"longitude": 108.38022
						},
						{
							"areaId": "450603",
							"areaName": "防城区",
							"latitude": 21.76464,
							"longitude": 108.35726
						},
						{
							"areaId": "450621",
							"areaName": "上思县",
							"latitude": 22.14957,
							"longitude": 107.9823
						},
						{
							"areaId": "450681",
							"areaName": "东兴市",
							"latitude": 21.54713,
							"longitude": 107.97204
						}
					]
				},
				{
					"areaId": "4507",
					"areaName": "钦州市",
					"latitude": 21.967127,
					"longitude": 108.624175,
					"children": [{
							"areaId": "450700",
							"areaName": "钦州市本级",
							"latitude": 21.967127,
							"longitude": 108.624175
						},
						{
							"areaId": "450702",
							"areaName": "钦南区",
							"latitude": 21.95137,
							"longitude": 108.61775
						},
						{
							"areaId": "450703",
							"areaName": "钦北区",
							"latitude": 21.95127,
							"longitude": 108.63037
						},
						{
							"areaId": "450721",
							"areaName": "灵山县",
							"latitude": 22.4165,
							"longitude": 109.29153
						},
						{
							"areaId": "450722",
							"areaName": "浦北县",
							"latitude": 22.26888,
							"longitude": 109.55572
						}
					]
				},
				{
					"areaId": "4508",
					"areaName": "贵港市",
					"latitude": 23.0936,
					"longitude": 109.602146,
					"children": [{
							"areaId": "450800",
							"areaName": "贵港市本级",
							"latitude": 23.0936,
							"longitude": 109.602146
						},
						{
							"areaId": "450802",
							"areaName": "港北区",
							"latitude": 23.11153,
							"longitude": 109.57224
						},
						{
							"areaId": "450803",
							"areaName": "港南区",
							"latitude": 23.07226,
							"longitude": 109.60617
						},
						{
							"areaId": "450804",
							"areaName": "覃塘区",
							"latitude": 23.12677,
							"longitude": 109.44293
						},
						{
							"areaId": "450821",
							"areaName": "平南县",
							"latitude": 23.54201,
							"longitude": 110.39062
						},
						{
							"areaId": "450881",
							"areaName": "桂平市",
							"latitude": 23.39339,
							"longitude": 110.08105
						}
					]
				},
				{
					"areaId": "4509",
					"areaName": "玉林市",
					"latitude": 22.63136,
					"longitude": 110.154393,
					"children": [{
							"areaId": "450900",
							"areaName": "玉林市本级",
							"latitude": 22.63136,
							"longitude": 110.154393
						},
						{
							"areaId": "450902",
							"areaName": "玉州区",
							"latitude": 22.6281,
							"longitude": 110.15114
						},
						{
							"areaId": "450921",
							"areaName": "容县",
							"latitude": 22.85701,
							"longitude": 110.55593
						},
						{
							"areaId": "450922",
							"areaName": "陆川县",
							"latitude": 22.32454,
							"longitude": 110.26413
						},
						{
							"areaId": "450923",
							"areaName": "博白县",
							"latitude": 22.27286,
							"longitude": 109.97744
						},
						{
							"areaId": "450924",
							"areaName": "兴业县",
							"latitude": 22.74237,
							"longitude": 109.87612
						},
						{
							"areaId": "450981",
							"areaName": "北流市",
							"latitude": 22.70817,
							"longitude": 110.35302
						}
					]
				},
				{
					"areaId": "4510",
					"areaName": "百色市",
					"latitude": 23.897742,
					"longitude": 106.616285,
					"children": [{
							"areaId": "451000",
							"areaName": "百色市本级",
							"latitude": 23.897742,
							"longitude": 106.616285
						},
						{
							"areaId": "451002",
							"areaName": "右江区",
							"latitude": 23.9009,
							"longitude": 106.61764
						},
						{
							"areaId": "451021",
							"areaName": "田阳县",
							"latitude": 23.897742,
							"longitude": 106.616285
						},
						{
							"areaId": "451022",
							"areaName": "田东县",
							"latitude": 23.60003,
							"longitude": 107.12432
						},
						{
							"areaId": "451023",
							"areaName": "平果县",
							"latitude": 23.897742,
							"longitude": 106.616285
						},
						{
							"areaId": "451024",
							"areaName": "德保县",
							"latitude": 23.32515,
							"longitude": 106.61917
						},
						{
							"areaId": "451025",
							"areaName": "靖西县",
							"latitude": 23.897742,
							"longitude": 106.616285
						},
						{
							"areaId": "451026",
							"areaName": "那坡县",
							"latitude": 23.40649,
							"longitude": 105.84191
						},
						{
							"areaId": "451027",
							"areaName": "凌云县",
							"latitude": 24.34747,
							"longitude": 106.56155
						},
						{
							"areaId": "451028",
							"areaName": "乐业县",
							"latitude": 24.78295,
							"longitude": 106.56124
						},
						{
							"areaId": "451029",
							"areaName": "田林县",
							"latitude": 24.29207,
							"longitude": 106.22882
						},
						{
							"areaId": "451030",
							"areaName": "西林县",
							"latitude": 24.48966,
							"longitude": 105.09722
						},
						{
							"areaId": "451031",
							"areaName": "隆林各族自治县",
							"latitude": 24.77036,
							"longitude": 105.34295
						}
					]
				},
				{
					"areaId": "4511",
					"areaName": "贺州市",
					"latitude": 24.414141,
					"longitude": 111.552056,
					"children": [{
							"areaId": "451100",
							"areaName": "贺州市本级",
							"latitude": 24.414141,
							"longitude": 111.552056
						},
						{
							"areaId": "451102",
							"areaName": "八步区",
							"latitude": 24.41179,
							"longitude": 111.55225
						},
						{
							"areaId": "451121",
							"areaName": "昭平县",
							"latitude": 24.1701,
							"longitude": 110.81082
						},
						{
							"areaId": "451122",
							"areaName": "钟山县",
							"latitude": 24.52482,
							"longitude": 111.30459
						},
						{
							"areaId": "451123",
							"areaName": "富川瑶族自治县",
							"latitude": 24.81431,
							"longitude": 111.27767
						}
					]
				},
				{
					"areaId": "4512",
					"areaName": "河池市",
					"latitude": 24.695899,
					"longitude": 108.062105,
					"children": [{
							"areaId": "451200",
							"areaName": "河池市本级",
							"latitude": 24.695899,
							"longitude": 108.062105
						},
						{
							"areaId": "451202",
							"areaName": "金城江区",
							"latitude": 24.416667,
							"longitude": 118.316667
						},
						{
							"areaId": "451221",
							"areaName": "南丹县",
							"latitude": 24.9776,
							"longitude": 107.54562
						},
						{
							"areaId": "451222",
							"areaName": "天峨县",
							"latitude": 24.99593,
							"longitude": 107.17205
						},
						{
							"areaId": "451223",
							"areaName": "凤山县",
							"latitude": 22.626945,
							"longitude": 120.356892
						},
						{
							"areaId": "451224",
							"areaName": "东兰县",
							"latitude": 24.51053,
							"longitude": 107.37527
						},
						{
							"areaId": "451225",
							"areaName": "罗城仫佬族自治县",
							"latitude": 24.77923,
							"longitude": 108.90777
						},
						{
							"areaId": "451226",
							"areaName": "环江毛南族自治县",
							"latitude": 24.82916,
							"longitude": 108.26055
						},
						{
							"areaId": "451227",
							"areaName": "巴马瑶族自治县",
							"latitude": 24.14135,
							"longitude": 107.25308
						},
						{
							"areaId": "451228",
							"areaName": "都安瑶族自治县",
							"latitude": 23.93245,
							"longitude": 108.10116
						},
						{
							"areaId": "451229",
							"areaName": "大化瑶族自治县",
							"latitude": 23.74487,
							"longitude": 107.9985
						},
						{
							"areaId": "451281",
							"areaName": "宜州市",
							"latitude": 24.695899,
							"longitude": 108.062105
						}
					]
				},
				{
					"areaId": "4513",
					"areaName": "来宾市",
					"latitude": 23.733766,
					"longitude": 109.229772,
					"children": [{
							"areaId": "451300",
							"areaName": "来宾市本级",
							"latitude": 23.733766,
							"longitude": 109.229772
						},
						{
							"areaId": "451302",
							"areaName": "兴宾区",
							"latitude": 23.72731,
							"longitude": 109.23471
						},
						{
							"areaId": "451321",
							"areaName": "忻城县",
							"latitude": 24.06862,
							"longitude": 108.66357
						},
						{
							"areaId": "451322",
							"areaName": "象州县",
							"latitude": 23.97355,
							"longitude": 109.6994
						},
						{
							"areaId": "451323",
							"areaName": "武宣县",
							"latitude": 23.59474,
							"longitude": 109.66284
						},
						{
							"areaId": "451324",
							"areaName": "金秀瑶族自治县",
							"latitude": 24.12929,
							"longitude": 110.19079
						},
						{
							"areaId": "451381",
							"areaName": "合山市",
							"latitude": 23.80619,
							"longitude": 108.88586
						}
					]
				},
				{
					"areaId": "4514",
					"areaName": "崇左市",
					"latitude": 22.404108,
					"longitude": 107.353926,
					"children": [{
							"areaId": "451400",
							"areaName": "崇左市本级",
							"latitude": 22.404108,
							"longitude": 107.353926
						},
						{
							"areaId": "451402",
							"areaName": "江洲区",
							"latitude": 22.41135,
							"longitude": 107.34747
						},
						{
							"areaId": "451421",
							"areaName": "扶绥县",
							"latitude": 22.63413,
							"longitude": 107.90405
						},
						{
							"areaId": "451422",
							"areaName": "宁明县",
							"latitude": 22.13655,
							"longitude": 107.07299
						},
						{
							"areaId": "451423",
							"areaName": "龙州县",
							"latitude": 22.33937,
							"longitude": 106.85415
						},
						{
							"areaId": "451424",
							"areaName": "大新县",
							"latitude": 22.83412,
							"longitude": 107.19821
						},
						{
							"areaId": "451425",
							"areaName": "天等县",
							"latitude": 23.077,
							"longitude": 107.13998
						},
						{
							"areaId": "451481",
							"areaName": "凭祥市",
							"latitude": 22.10573,
							"longitude": 106.75534
						}
					]
				}
			]
		},
		{
			"areaId": "46",
			"areaName": "海南省",
			"latitude": 20.031971,
			"longitude": 110.33119,
			"children": [{
					"areaId": "4601",
					"areaName": "海口市",
					"latitude": 20.031971,
					"longitude": 110.33119,
					"children": [{
							"areaId": "460100",
							"areaName": "海口市本级",
							"latitude": 20.031971,
							"longitude": 110.33119
						},
						{
							"areaId": "460105",
							"areaName": "秀英区",
							"latitude": 20.00752,
							"longitude": 110.29345
						},
						{
							"areaId": "460106",
							"areaName": "龙华区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "460107",
							"areaName": "琼山区",
							"latitude": 20.00321,
							"longitude": 110.35418
						},
						{
							"areaId": "460108",
							"areaName": "美兰区",
							"latitude": 20.02864,
							"longitude": 110.36908
						}
					]
				},
				{
					"areaId": "4602",
					"areaName": "三亚市",
					"latitude": 18.247872,
					"longitude": 109.508268,
					"children": [{
						"areaId": "460200",
						"areaName": "三亚市本级",
						"latitude": 18.247872,
						"longitude": 109.508268
					}]
				},
				{
					"areaId": "4690",
					"areaName": "省直辖县级行政单位",
					"latitude": 0,
					"longitude": 0,
					"children": [{
							"areaId": "469000",
							"areaName": "省直辖县级行政单位本级",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "469001",
							"areaName": "五指山市",
							"latitude": 18.776921,
							"longitude": 109.516662
						},
						{
							"areaId": "469002",
							"areaName": "琼海市",
							"latitude": 19.246011,
							"longitude": 110.466785
						},
						{
							"areaId": "469003",
							"areaName": "儋州市",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "469005",
							"areaName": "文昌市",
							"latitude": 19.612986,
							"longitude": 110.753975
						},
						{
							"areaId": "469006",
							"areaName": "万宁市",
							"latitude": 18.796216,
							"longitude": 110.388793
						},
						{
							"areaId": "469007",
							"areaName": "东方市",
							"latitude": 19.10198,
							"longitude": 108.653789
						},
						{
							"areaId": "469021",
							"areaName": "定安县",
							"latitude": 19.699211,
							"longitude": 110.323959
						},
						{
							"areaId": "469022",
							"areaName": "屯昌县",
							"latitude": 19.362916,
							"longitude": 110.102773
						},
						{
							"areaId": "469023",
							"areaName": "澄迈县",
							"latitude": 19.737095,
							"longitude": 110.007147
						},
						{
							"areaId": "469024",
							"areaName": "临高县",
							"latitude": 19.908293,
							"longitude": 109.687697
						},
						{
							"areaId": "469025",
							"areaName": "白沙黎族自治县",
							"latitude": 23.66606,
							"longitude": 119.597919
						},
						{
							"areaId": "469026",
							"areaName": "昌江黎族自治县",
							"latitude": 19.260968,
							"longitude": 109.053351
						},
						{
							"areaId": "469027",
							"areaName": "乐东黎族自治县",
							"latitude": 18.74758,
							"longitude": 109.175444
						},
						{
							"areaId": "469028",
							"areaName": "陵水黎族自治县",
							"latitude": 18.505006,
							"longitude": 110.037218
						},
						{
							"areaId": "469029",
							"areaName": "保亭黎族苗族自治县",
							"latitude": 18.636371,
							"longitude": 109.70245
						},
						{
							"areaId": "469030",
							"areaName": "琼中黎族苗族自治县",
							"latitude": 19.03557,
							"longitude": 109.839996
						},
						{
							"areaId": "469031",
							"areaName": "西沙群岛",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "469032",
							"areaName": "南沙群岛",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "469033",
							"areaName": "中沙群岛的岛礁及其海域",
							"latitude": 0,
							"longitude": 0
						}
					]
				}
			]
		},
		{
			"areaId": "50",
			"areaName": "重庆市",
			"latitude": 29.533155,
			"longitude": 106.504962,
			"children": [{
					"areaId": "5001",
					"areaName": "重庆市市辖区",
					"latitude": 29.533155,
					"longitude": 106.504962,
					"children": [{
							"areaId": "500100",
							"areaName": "重庆市本级",
							"latitude": 29.533155,
							"longitude": 106.504962
						},
						{
							"areaId": "500101",
							"areaName": "万州区",
							"latitude": 30.80788,
							"longitude": 108.40869
						},
						{
							"areaId": "500102",
							"areaName": "涪陵区",
							"latitude": 29.70292,
							"longitude": 107.39007
						},
						{
							"areaId": "500103",
							"areaName": "渝中区",
							"latitude": 29.55279,
							"longitude": 106.56901
						},
						{
							"areaId": "500104",
							"areaName": "大渡口区",
							"latitude": 29.48447,
							"longitude": 106.48262
						},
						{
							"areaId": "500105",
							"areaName": "江北区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "500106",
							"areaName": "沙坪坝区",
							"latitude": 29.54113,
							"longitude": 106.45752
						},
						{
							"areaId": "500107",
							"areaName": "九龙坡区",
							"latitude": 22.327115,
							"longitude": 114.17495
						},
						{
							"areaId": "500108",
							"areaName": "南岸区",
							"latitude": 29.52311,
							"longitude": 106.56347
						},
						{
							"areaId": "500109",
							"areaName": "北碚区",
							"latitude": 29.80574,
							"longitude": 106.39614
						},
						{
							"areaId": "500110",
							"areaName": "万盛区",
							"latitude": 28.960656,
							"longitude": 106.926779
						},
						{
							"areaId": "500111",
							"areaName": "双桥区",
							"latitude": 29.484025,
							"longitude": 105.768121
						},
						{
							"areaId": "500112",
							"areaName": "渝北区",
							"latitude": 29.7182,
							"longitude": 106.6307
						},
						{
							"areaId": "500113",
							"areaName": "巴南区",
							"latitude": 29.38311,
							"longitude": 106.52365
						},
						{
							"areaId": "500114",
							"areaName": "黔江区",
							"latitude": 29.5332,
							"longitude": 108.7709
						},
						{
							"areaId": "500115",
							"areaName": "长寿区",
							"latitude": 29.85359,
							"longitude": 107.08166
						},
						{
							"areaId": "500116",
							"areaName": "江津区",
							"latitude": 29.29008,
							"longitude": 106.25912
						},
						{
							"areaId": "500117",
							"areaName": "合川区",
							"latitude": 29.97227,
							"longitude": 106.27633
						},
						{
							"areaId": "500118",
							"areaName": "永川区",
							"latitude": 29.35593,
							"longitude": 105.927
						},
						{
							"areaId": "500119",
							"areaName": "南川区",
							"latitude": 29.15751,
							"longitude": 107.09936
						}
					]
				},
				{
					"areaId": "5002",
					"areaName": "重庆市所辖县",
					"latitude": 29.533155,
					"longitude": 106.504962,
					"children": [{
							"areaId": "500222",
							"areaName": "綦江县",
							"latitude": 29.533155,
							"longitude": 106.504962
						},
						{
							"areaId": "500223",
							"areaName": "潼南县",
							"latitude": 29.533155,
							"longitude": 106.504962
						},
						{
							"areaId": "500224",
							"areaName": "铜梁县",
							"latitude": 29.533155,
							"longitude": 106.504962
						},
						{
							"areaId": "500225",
							"areaName": "大足县",
							"latitude": 29.533155,
							"longitude": 106.504962
						},
						{
							"areaId": "500226",
							"areaName": "荣昌县",
							"latitude": 29.533155,
							"longitude": 106.504962
						},
						{
							"areaId": "500227",
							"areaName": "璧山县",
							"latitude": 29.533155,
							"longitude": 106.504962
						},
						{
							"areaId": "500228",
							"areaName": "梁平县",
							"latitude": 29.533155,
							"longitude": 106.504962
						},
						{
							"areaId": "500229",
							"areaName": "城口县",
							"latitude": 31.94801,
							"longitude": 108.66513
						},
						{
							"areaId": "500230",
							"areaName": "丰都县",
							"latitude": 29.86348,
							"longitude": 107.73098
						},
						{
							"areaId": "500231",
							"areaName": "垫江县",
							"latitude": 30.33359,
							"longitude": 107.35446
						},
						{
							"areaId": "500232",
							"areaName": "武隆县",
							"latitude": 29.533155,
							"longitude": 106.504962
						},
						{
							"areaId": "500233",
							"areaName": "忠县",
							"latitude": 30.28898,
							"longitude": 108.03689
						},
						{
							"areaId": "500234",
							"areaName": "开县",
							"latitude": 29.533155,
							"longitude": 106.504962
						},
						{
							"areaId": "500235",
							"areaName": "云阳县",
							"latitude": 30.93062,
							"longitude": 108.69726
						},
						{
							"areaId": "500236",
							"areaName": "奉节县",
							"latitude": 31.01825,
							"longitude": 109.46478
						},
						{
							"areaId": "500237",
							"areaName": "巫山县",
							"latitude": 31.07458,
							"longitude": 109.87814
						},
						{
							"areaId": "500238",
							"areaName": "巫溪县",
							"latitude": 31.39756,
							"longitude": 109.63128
						},
						{
							"areaId": "500240",
							"areaName": "石柱土家族自治县",
							"latitude": 30.00054,
							"longitude": 108.11389
						},
						{
							"areaId": "500241",
							"areaName": "秀山土家族苗族自治县",
							"latitude": 28.45062,
							"longitude": 108.98861
						},
						{
							"areaId": "500242",
							"areaName": "酉阳土家族苗族自治县",
							"latitude": 28.8446,
							"longitude": 108.77212
						},
						{
							"areaId": "500243",
							"areaName": "彭水苗族土家族自治县",
							"latitude": 29.29516,
							"longitude": 108.16638
						}
					]
				}
			]
		},
		{
			"areaId": "51",
			"areaName": "四川省",
			"latitude": 30.659462,
			"longitude": 104.065735,
			"children": [{
					"areaId": "5101",
					"areaName": "成都市",
					"latitude": 30.659462,
					"longitude": 104.065735,
					"children": [{
							"areaId": "510100",
							"areaName": "成都市本级",
							"latitude": 30.659462,
							"longitude": 104.065735
						},
						{
							"areaId": "510104",
							"areaName": "锦江区",
							"latitude": 30.65614,
							"longitude": 104.08347
						},
						{
							"areaId": "510105",
							"areaName": "青羊区",
							"latitude": 30.67387,
							"longitude": 104.06151
						},
						{
							"areaId": "510106",
							"areaName": "金牛区",
							"latitude": 30.69126,
							"longitude": 104.05114
						},
						{
							"areaId": "510107",
							"areaName": "武侯区",
							"latitude": 30.64235,
							"longitude": 104.04303
						},
						{
							"areaId": "510108",
							"areaName": "成华区",
							"latitude": 30.65993,
							"longitude": 104.10193
						},
						{
							"areaId": "510112",
							"areaName": "龙泉驿区",
							"latitude": 30.55658,
							"longitude": 104.27462
						},
						{
							"areaId": "510113",
							"areaName": "青白江区",
							"latitude": 30.87841,
							"longitude": 104.251
						},
						{
							"areaId": "510114",
							"areaName": "新都区",
							"latitude": 30.82314,
							"longitude": 104.15921
						},
						{
							"areaId": "510115",
							"areaName": "温江区",
							"latitude": 30.68444,
							"longitude": 103.84881
						},
						{
							"areaId": "510121",
							"areaName": "金堂县",
							"latitude": 30.86195,
							"longitude": 104.41195
						},
						{
							"areaId": "510122",
							"areaName": "双流县",
							"latitude": 30.659462,
							"longitude": 104.065735
						},
						{
							"areaId": "510124",
							"areaName": "郫县",
							"latitude": 30.659462,
							"longitude": 104.065735
						},
						{
							"areaId": "510129",
							"areaName": "大邑县",
							"latitude": 30.58738,
							"longitude": 103.52075
						},
						{
							"areaId": "510131",
							"areaName": "蒲江县",
							"latitude": 30.19667,
							"longitude": 103.50616
						},
						{
							"areaId": "510132",
							"areaName": "新津县",
							"latitude": 30.659462,
							"longitude": 104.065735
						},
						{
							"areaId": "510181",
							"areaName": "都江堰市",
							"latitude": 30.99825,
							"longitude": 103.61941
						},
						{
							"areaId": "510182",
							"areaName": "彭州市",
							"latitude": 30.99011,
							"longitude": 103.958
						},
						{
							"areaId": "510183",
							"areaName": "邛崃市",
							"latitude": 30.41489,
							"longitude": 103.46283
						},
						{
							"areaId": "510184",
							"areaName": "崇州市",
							"latitude": 30.63014,
							"longitude": 103.67285
						}
					]
				},
				{
					"areaId": "5103",
					"areaName": "自贡市",
					"latitude": 29.352765,
					"longitude": 104.773447,
					"children": [{
							"areaId": "510300",
							"areaName": "自贡市本级",
							"latitude": 29.352765,
							"longitude": 104.773447
						},
						{
							"areaId": "510302",
							"areaName": "自流井区",
							"latitude": 29.33745,
							"longitude": 104.77719
						},
						{
							"areaId": "510303",
							"areaName": "贡井区",
							"latitude": 29.34576,
							"longitude": 104.71536
						},
						{
							"areaId": "510304",
							"areaName": "大安区",
							"latitude": 24.34607,
							"longitude": 120.58652
						},
						{
							"areaId": "510311",
							"areaName": "沿滩区",
							"latitude": 29.26611,
							"longitude": 104.88012
						},
						{
							"areaId": "510321",
							"areaName": "荣县",
							"latitude": 29.44445,
							"longitude": 104.4176
						},
						{
							"areaId": "510322",
							"areaName": "富顺县",
							"latitude": 29.18123,
							"longitude": 104.97491
						}
					]
				},
				{
					"areaId": "5104",
					"areaName": "攀枝花市",
					"latitude": 26.580446,
					"longitude": 101.716007,
					"children": [{
							"areaId": "510400",
							"areaName": "攀枝花市本级",
							"latitude": 26.580446,
							"longitude": 101.716007
						},
						{
							"areaId": "510402",
							"areaName": "东区",
							"latitude": 22.262755,
							"longitude": 114.255993
						},
						{
							"areaId": "510403",
							"areaName": "西区",
							"latitude": 22.281981,
							"longitude": 114.154374
						},
						{
							"areaId": "510411",
							"areaName": "仁和区",
							"latitude": 26.49841,
							"longitude": 101.73812
						},
						{
							"areaId": "510421",
							"areaName": "米易县",
							"latitude": 26.88718,
							"longitude": 102.11132
						},
						{
							"areaId": "510422",
							"areaName": "盐边县",
							"latitude": 26.68847,
							"longitude": 101.85446
						}
					]
				},
				{
					"areaId": "5105",
					"areaName": "泸州市",
					"latitude": 28.889138,
					"longitude": 105.443348,
					"children": [{
							"areaId": "510500",
							"areaName": "泸州市本级",
							"latitude": 28.889138,
							"longitude": 105.443348
						},
						{
							"areaId": "510502",
							"areaName": "江阳区",
							"latitude": 28.88934,
							"longitude": 105.45336
						},
						{
							"areaId": "510503",
							"areaName": "纳溪区",
							"latitude": 28.77343,
							"longitude": 105.37255
						},
						{
							"areaId": "510504",
							"areaName": "龙马潭区",
							"latitude": 28.91308,
							"longitude": 105.43774
						},
						{
							"areaId": "510521",
							"areaName": "泸县",
							"latitude": 29.15041,
							"longitude": 105.38192
						},
						{
							"areaId": "510522",
							"areaName": "合江县",
							"latitude": 28.81005,
							"longitude": 105.8352
						},
						{
							"areaId": "510524",
							"areaName": "叙永县",
							"latitude": 28.15586,
							"longitude": 105.44473
						},
						{
							"areaId": "510525",
							"areaName": "古蔺县",
							"latitude": 28.03867,
							"longitude": 105.81347
						}
					]
				},
				{
					"areaId": "5106",
					"areaName": "德阳市",
					"latitude": 31.127991,
					"longitude": 104.398651,
					"children": [{
							"areaId": "510600",
							"areaName": "德阳市本级",
							"latitude": 31.127991,
							"longitude": 104.398651
						},
						{
							"areaId": "510603",
							"areaName": "旌阳区",
							"latitude": 31.13906,
							"longitude": 104.39367
						},
						{
							"areaId": "510623",
							"areaName": "中江县",
							"latitude": 31.03297,
							"longitude": 104.67861
						},
						{
							"areaId": "510626",
							"areaName": "罗江县",
							"latitude": 31.127991,
							"longitude": 104.398651
						},
						{
							"areaId": "510681",
							"areaName": "广汉市",
							"latitude": 30.97686,
							"longitude": 104.28234
						},
						{
							"areaId": "510682",
							"areaName": "什邡市",
							"latitude": 31.1264,
							"longitude": 104.16754
						},
						{
							"areaId": "510683",
							"areaName": "绵竹市",
							"latitude": 31.33772,
							"longitude": 104.22076
						}
					]
				},
				{
					"areaId": "5107",
					"areaName": "绵阳市",
					"latitude": 31.46402,
					"longitude": 104.741722,
					"children": [{
							"areaId": "510700",
							"areaName": "绵阳市本级",
							"latitude": 31.46402,
							"longitude": 104.741722
						},
						{
							"areaId": "510703",
							"areaName": "涪城区",
							"latitude": 31.45522,
							"longitude": 104.75719
						},
						{
							"areaId": "510704",
							"areaName": "游仙区",
							"latitude": 31.46574,
							"longitude": 104.77092
						},
						{
							"areaId": "510722",
							"areaName": "三台县",
							"latitude": 31.09179,
							"longitude": 105.09079
						},
						{
							"areaId": "510723",
							"areaName": "盐亭县",
							"latitude": 31.22176,
							"longitude": 105.3898
						},
						{
							"areaId": "510724",
							"areaName": "安县",
							"latitude": 31.46402,
							"longitude": 104.741722
						},
						{
							"areaId": "510725",
							"areaName": "梓潼县",
							"latitude": 31.6359,
							"longitude": 105.16183
						},
						{
							"areaId": "510726",
							"areaName": "北川羌族自治县",
							"latitude": 31.83286,
							"longitude": 104.46408
						},
						{
							"areaId": "510727",
							"areaName": "平武县",
							"latitude": 32.40791,
							"longitude": 104.52862
						},
						{
							"areaId": "510781",
							"areaName": "江油市",
							"latitude": 31.77775,
							"longitude": 104.74539
						}
					]
				},
				{
					"areaId": "5108",
					"areaName": "广元市",
					"latitude": 32.433668,
					"longitude": 105.829757,
					"children": [{
							"areaId": "510800",
							"areaName": "广元市本级",
							"latitude": 32.433668,
							"longitude": 105.829757
						},
						{
							"areaId": "510802",
							"areaName": "市中区",
							"latitude": 32.432276,
							"longitude": 105.826194
						},
						{
							"areaId": "510811",
							"areaName": "元坝区",
							"latitude": 32.386518,
							"longitude": 105.640491
						},
						{
							"areaId": "510812",
							"areaName": "朝天区",
							"latitude": 32.64398,
							"longitude": 105.89273
						},
						{
							"areaId": "510821",
							"areaName": "旺苍县",
							"latitude": 32.22845,
							"longitude": 106.29022
						},
						{
							"areaId": "510822",
							"areaName": "青川县",
							"latitude": 32.58563,
							"longitude": 105.2391
						},
						{
							"areaId": "510823",
							"areaName": "剑阁县",
							"latitude": 32.28845,
							"longitude": 105.5252
						},
						{
							"areaId": "510824",
							"areaName": "苍溪县",
							"latitude": 31.73209,
							"longitude": 105.936
						}
					]
				},
				{
					"areaId": "5109",
					"areaName": "遂宁市",
					"latitude": 30.513311,
					"longitude": 105.571331,
					"children": [{
							"areaId": "510900",
							"areaName": "遂宁市本级",
							"latitude": 30.513311,
							"longitude": 105.571331
						},
						{
							"areaId": "510903",
							"areaName": "船山区",
							"latitude": 30.49991,
							"longitude": 105.5809
						},
						{
							"areaId": "510904",
							"areaName": "安居区",
							"latitude": 30.35778,
							"longitude": 105.46402
						},
						{
							"areaId": "510921",
							"areaName": "蓬溪县",
							"latitude": 30.75775,
							"longitude": 105.70752
						},
						{
							"areaId": "510922",
							"areaName": "射洪县",
							"latitude": 30.513311,
							"longitude": 105.571331
						},
						{
							"areaId": "510923",
							"areaName": "大英县",
							"latitude": 30.59434,
							"longitude": 105.24346
						}
					]
				},
				{
					"areaId": "5110",
					"areaName": "内江市",
					"latitude": 29.58708,
					"longitude": 105.066138,
					"children": [{
							"areaId": "511000",
							"areaName": "内江市本级",
							"latitude": 29.58708,
							"longitude": 105.066138
						},
						{
							"areaId": "511002",
							"areaName": "市中区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "511011",
							"areaName": "东兴区",
							"latitude": 29.59278,
							"longitude": 105.07554
						},
						{
							"areaId": "511024",
							"areaName": "威远县",
							"latitude": 29.52823,
							"longitude": 104.66955
						},
						{
							"areaId": "511025",
							"areaName": "资中县",
							"latitude": 29.76409,
							"longitude": 104.85205
						},
						{
							"areaId": "511028",
							"areaName": "隆昌县",
							"latitude": 29.58708,
							"longitude": 105.066138
						}
					]
				},
				{
					"areaId": "5111",
					"areaName": "乐山市",
					"latitude": 29.582024,
					"longitude": 103.761263,
					"children": [{
							"areaId": "511100",
							"areaName": "乐山市本级",
							"latitude": 29.582024,
							"longitude": 103.761263
						},
						{
							"areaId": "511102",
							"areaName": "市中区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "511111",
							"areaName": "沙湾区",
							"latitude": 29.41194,
							"longitude": 103.54873
						},
						{
							"areaId": "511112",
							"areaName": "五通桥区",
							"latitude": 29.40344,
							"longitude": 103.82345
						},
						{
							"areaId": "511113",
							"areaName": "金口河区",
							"latitude": 29.24578,
							"longitude": 103.07858
						},
						{
							"areaId": "511123",
							"areaName": "犍为县",
							"latitude": 29.20973,
							"longitude": 103.94989
						},
						{
							"areaId": "511124",
							"areaName": "井研县",
							"latitude": 29.65228,
							"longitude": 104.07019
						},
						{
							"areaId": "511126",
							"areaName": "夹江县",
							"latitude": 29.73868,
							"longitude": 103.57199
						},
						{
							"areaId": "511129",
							"areaName": "沐川县",
							"latitude": 28.95646,
							"longitude": 103.90353
						},
						{
							"areaId": "511132",
							"areaName": "峨边彝族自治县",
							"latitude": 29.23004,
							"longitude": 103.26339
						},
						{
							"areaId": "511133",
							"areaName": "马边彝族自治县",
							"latitude": 28.83593,
							"longitude": 103.54617
						},
						{
							"areaId": "511181",
							"areaName": "峨眉山市",
							"latitude": 24.686127,
							"longitude": 121.015291
						}
					]
				},
				{
					"areaId": "5113",
					"areaName": "南充市",
					"latitude": 30.795281,
					"longitude": 106.082974,
					"children": [{
							"areaId": "511300",
							"areaName": "南充市本级",
							"latitude": 30.795281,
							"longitude": 106.082974
						},
						{
							"areaId": "511302",
							"areaName": "顺庆区",
							"latitude": 30.79642,
							"longitude": 106.09216
						},
						{
							"areaId": "511303",
							"areaName": "高坪区",
							"latitude": 30.78162,
							"longitude": 106.11894
						},
						{
							"areaId": "511304",
							"areaName": "嘉陵区",
							"latitude": 30.75848,
							"longitude": 106.07141
						},
						{
							"areaId": "511321",
							"areaName": "南部县",
							"latitude": 31.35451,
							"longitude": 106.06738
						},
						{
							"areaId": "511322",
							"areaName": "营山县",
							"latitude": 31.07747,
							"longitude": 106.56637
						},
						{
							"areaId": "511323",
							"areaName": "蓬安县",
							"latitude": 31.02964,
							"longitude": 106.41262
						},
						{
							"areaId": "511324",
							"areaName": "仪陇县",
							"latitude": 31.27628,
							"longitude": 106.29974
						},
						{
							"areaId": "511325",
							"areaName": "西充县",
							"latitude": 30.9969,
							"longitude": 105.89996
						},
						{
							"areaId": "511381",
							"areaName": "阆中市",
							"latitude": 31.55832,
							"longitude": 106.00494
						}
					]
				},
				{
					"areaId": "5114",
					"areaName": "眉山市",
					"latitude": 30.048318,
					"longitude": 103.831788,
					"children": [{
							"areaId": "511400",
							"areaName": "眉山市本级",
							"latitude": 30.048318,
							"longitude": 103.831788
						},
						{
							"areaId": "511402",
							"areaName": "东坡区",
							"latitude": 30.04219,
							"longitude": 103.832
						},
						{
							"areaId": "511421",
							"areaName": "仁寿县",
							"latitude": 29.99599,
							"longitude": 104.13412
						},
						{
							"areaId": "511422",
							"areaName": "彭山县",
							"latitude": 30.048318,
							"longitude": 103.831788
						},
						{
							"areaId": "511423",
							"areaName": "洪雅县",
							"latitude": 29.90661,
							"longitude": 103.37313
						},
						{
							"areaId": "511424",
							"areaName": "丹棱县",
							"latitude": 30.01562,
							"longitude": 103.51339
						},
						{
							"areaId": "511425",
							"areaName": "青神县",
							"latitude": 29.83235,
							"longitude": 103.84771
						}
					]
				},
				{
					"areaId": "5115",
					"areaName": "宜宾市",
					"latitude": 28.760189,
					"longitude": 104.630825,
					"children": [{
							"areaId": "511500",
							"areaName": "宜宾市本级",
							"latitude": 28.760189,
							"longitude": 104.630825
						},
						{
							"areaId": "511502",
							"areaName": "翠屏区",
							"latitude": 28.76566,
							"longitude": 104.61978
						},
						{
							"areaId": "511521",
							"areaName": "宜宾县",
							"latitude": 28.760189,
							"longitude": 104.630825
						},
						{
							"areaId": "511522",
							"areaName": "南溪县",
							"latitude": 28.760189,
							"longitude": 104.630825
						},
						{
							"areaId": "511523",
							"areaName": "江安县",
							"latitude": 28.72385,
							"longitude": 105.06683
						},
						{
							"areaId": "511524",
							"areaName": "长宁县",
							"latitude": 28.57777,
							"longitude": 104.9252
						},
						{
							"areaId": "511525",
							"areaName": "高县",
							"latitude": 28.43619,
							"longitude": 104.51754
						},
						{
							"areaId": "511526",
							"areaName": "珙县",
							"latitude": 28.44512,
							"longitude": 104.71398
						},
						{
							"areaId": "511527",
							"areaName": "筠连县",
							"latitude": 28.16495,
							"longitude": 104.51217
						},
						{
							"areaId": "511528",
							"areaName": "兴文县",
							"latitude": 28.3044,
							"longitude": 105.23675
						},
						{
							"areaId": "511529",
							"areaName": "屏山县",
							"latitude": 28.64369,
							"longitude": 104.16293
						}
					]
				},
				{
					"areaId": "5116",
					"areaName": "广安市",
					"latitude": 30.456398,
					"longitude": 106.633369,
					"children": [{
							"areaId": "511600",
							"areaName": "广安市本级",
							"latitude": 30.456398,
							"longitude": 106.633369
						},
						{
							"areaId": "511602",
							"areaName": "广安区",
							"latitude": 30.47389,
							"longitude": 106.64163
						},
						{
							"areaId": "511621",
							"areaName": "岳池县",
							"latitude": 30.53918,
							"longitude": 106.44079
						},
						{
							"areaId": "511622",
							"areaName": "武胜县",
							"latitude": 30.34932,
							"longitude": 106.29592
						},
						{
							"areaId": "511623",
							"areaName": "邻水县",
							"latitude": 30.33449,
							"longitude": 106.92968
						},
						{
							"areaId": "511681",
							"areaName": "华蓥市",
							"latitude": 30.39007,
							"longitude": 106.78466
						}
					]
				},
				{
					"areaId": "5117",
					"areaName": "达州市",
					"latitude": 31.209484,
					"longitude": 107.502262,
					"children": [{
							"areaId": "511700",
							"areaName": "达州市本级",
							"latitude": 31.209484,
							"longitude": 107.502262
						},
						{
							"areaId": "511702",
							"areaName": "通川区",
							"latitude": 31.21469,
							"longitude": 107.50456
						},
						{
							"areaId": "511721",
							"areaName": "达县",
							"latitude": 31.209484,
							"longitude": 107.502262
						},
						{
							"areaId": "511722",
							"areaName": "宣汉县",
							"latitude": 31.35516,
							"longitude": 107.72775
						},
						{
							"areaId": "511723",
							"areaName": "开江县",
							"latitude": 31.0841,
							"longitude": 107.86889
						},
						{
							"areaId": "511724",
							"areaName": "大竹县",
							"latitude": 30.74147,
							"longitude": 107.20855
						},
						{
							"areaId": "511725",
							"areaName": "渠县",
							"latitude": 30.8376,
							"longitude": 106.97381
						},
						{
							"areaId": "511781",
							"areaName": "万源市",
							"latitude": 32.08091,
							"longitude": 108.03598
						}
					]
				},
				{
					"areaId": "5118",
					"areaName": "雅安市",
					"latitude": 29.987722,
					"longitude": 103.001033,
					"children": [{
							"areaId": "511800",
							"areaName": "雅安市本级",
							"latitude": 29.987722,
							"longitude": 103.001033
						},
						{
							"areaId": "511802",
							"areaName": "雨城区",
							"latitude": 30.00531,
							"longitude": 103.03305
						},
						{
							"areaId": "511821",
							"areaName": "名山县",
							"latitude": 29.987722,
							"longitude": 103.001033
						},
						{
							"areaId": "511822",
							"areaName": "荥经县",
							"latitude": 29.79402,
							"longitude": 102.84652
						},
						{
							"areaId": "511823",
							"areaName": "汉源县",
							"latitude": 29.35168,
							"longitude": 102.6784
						},
						{
							"areaId": "511824",
							"areaName": "石棉县",
							"latitude": 29.22796,
							"longitude": 102.35943
						},
						{
							"areaId": "511825",
							"areaName": "天全县",
							"latitude": 30.06754,
							"longitude": 102.75906
						},
						{
							"areaId": "511826",
							"areaName": "芦山县",
							"latitude": 30.14369,
							"longitude": 102.92791
						},
						{
							"areaId": "511827",
							"areaName": "宝兴县",
							"latitude": 30.36836,
							"longitude": 102.81555
						}
					]
				},
				{
					"areaId": "5119",
					"areaName": "巴中市",
					"latitude": 31.858809,
					"longitude": 106.753669,
					"children": [{
							"areaId": "511900",
							"areaName": "巴中市本级",
							"latitude": 31.858809,
							"longitude": 106.753669
						},
						{
							"areaId": "511902",
							"areaName": "巴州区",
							"latitude": 31.85125,
							"longitude": 106.76889
						},
						{
							"areaId": "511921",
							"areaName": "通江县",
							"latitude": 31.91294,
							"longitude": 107.24398
						},
						{
							"areaId": "511922",
							"areaName": "南江县",
							"latitude": 32.35335,
							"longitude": 106.84164
						},
						{
							"areaId": "511923",
							"areaName": "平昌县",
							"latitude": 31.5594,
							"longitude": 107.10424
						}
					]
				},
				{
					"areaId": "5120",
					"areaName": "资阳市",
					"latitude": 30.122211,
					"longitude": 104.641917,
					"children": [{
							"areaId": "512000",
							"areaName": "资阳市本级",
							"latitude": 30.122211,
							"longitude": 104.641917
						},
						{
							"areaId": "512002",
							"areaName": "雁江区",
							"latitude": 30.11525,
							"longitude": 104.65216
						},
						{
							"areaId": "512021",
							"areaName": "安岳县",
							"latitude": 30.09786,
							"longitude": 105.3363
						},
						{
							"areaId": "512022",
							"areaName": "乐至县",
							"latitude": 30.27227,
							"longitude": 105.03207
						},
						{
							"areaId": "512081",
							"areaName": "简阳市",
							"latitude": 30.122211,
							"longitude": 104.641917
						}
					]
				},
				{
					"areaId": "5132",
					"areaName": "阿坝藏族羌族自治州",
					"latitude": 31.899792,
					"longitude": 102.221374,
					"children": [{
							"areaId": "513200",
							"areaName": "阿坝藏族羌族自治州本级",
							"latitude": 31.899792,
							"longitude": 102.221374
						},
						{
							"areaId": "513221",
							"areaName": "汶川县",
							"latitude": 31.47326,
							"longitude": 103.59079
						},
						{
							"areaId": "513222",
							"areaName": "理县",
							"latitude": 31.43603,
							"longitude": 103.17175
						},
						{
							"areaId": "513223",
							"areaName": "茂县",
							"latitude": 31.682,
							"longitude": 103.85372
						},
						{
							"areaId": "513224",
							"areaName": "松潘县",
							"latitude": 32.63871,
							"longitude": 103.59924
						},
						{
							"areaId": "513225",
							"areaName": "九寨沟县",
							"latitude": 33.26318,
							"longitude": 104.23672
						},
						{
							"areaId": "513226",
							"areaName": "金川县",
							"latitude": 31.47623,
							"longitude": 102.06555
						},
						{
							"areaId": "513227",
							"areaName": "小金县",
							"latitude": 30.99934,
							"longitude": 102.36499
						},
						{
							"areaId": "513228",
							"areaName": "黑水县",
							"latitude": 32.06184,
							"longitude": 102.99176
						},
						{
							"areaId": "513229",
							"areaName": "马尔康县",
							"latitude": 31.899792,
							"longitude": 102.221374
						},
						{
							"areaId": "513230",
							"areaName": "壤塘县",
							"latitude": 32.26578,
							"longitude": 100.9783
						},
						{
							"areaId": "513231",
							"areaName": "阿坝县",
							"latitude": 32.90301,
							"longitude": 101.70632
						},
						{
							"areaId": "513232",
							"areaName": "若尔盖县",
							"latitude": 33.57432,
							"longitude": 102.9598
						},
						{
							"areaId": "513233",
							"areaName": "红原县",
							"latitude": 32.78989,
							"longitude": 102.54525
						}
					]
				},
				{
					"areaId": "5133",
					"areaName": "甘孜藏族自治州",
					"latitude": 30.050663,
					"longitude": 101.963815,
					"children": [{
							"areaId": "513300",
							"areaName": "甘孜藏族自治州本级",
							"latitude": 30.050663,
							"longitude": 101.963815
						},
						{
							"areaId": "513321",
							"areaName": "康定县",
							"latitude": 30.050663,
							"longitude": 101.963815
						},
						{
							"areaId": "513322",
							"areaName": "泸定县",
							"latitude": 29.91475,
							"longitude": 102.23507
						},
						{
							"areaId": "513323",
							"areaName": "丹巴县",
							"latitude": 30.87656,
							"longitude": 101.88424
						},
						{
							"areaId": "513324",
							"areaName": "九龙县",
							"latitude": 29.00091,
							"longitude": 101.50848
						},
						{
							"areaId": "513325",
							"areaName": "雅江县",
							"latitude": 30.03281,
							"longitude": 101.01492
						},
						{
							"areaId": "513326",
							"areaName": "道孚县",
							"latitude": 30.98046,
							"longitude": 101.12554
						},
						{
							"areaId": "513327",
							"areaName": "炉霍县",
							"latitude": 31.3917,
							"longitude": 100.67681
						},
						{
							"areaId": "513328",
							"areaName": "甘孜县",
							"latitude": 31.62672,
							"longitude": 99.99307
						},
						{
							"areaId": "513329",
							"areaName": "新龙县",
							"latitude": 30.94067,
							"longitude": 100.3125
						},
						{
							"areaId": "513330",
							"areaName": "德格县",
							"latitude": 31.80615,
							"longitude": 98.58078
						},
						{
							"areaId": "513331",
							"areaName": "白玉县",
							"latitude": 31.20902,
							"longitude": 98.82568
						},
						{
							"areaId": "513332",
							"areaName": "石渠县",
							"latitude": 32.97884,
							"longitude": 98.10156
						},
						{
							"areaId": "513333",
							"areaName": "色达县",
							"latitude": 32.26839,
							"longitude": 100.33224
						},
						{
							"areaId": "513334",
							"areaName": "理塘县",
							"latitude": 29.99674,
							"longitude": 100.27005
						},
						{
							"areaId": "513335",
							"areaName": "巴塘县",
							"latitude": 30.00423,
							"longitude": 99.10409
						},
						{
							"areaId": "513336",
							"areaName": "乡城县",
							"latitude": 28.93554,
							"longitude": 99.79943
						},
						{
							"areaId": "513337",
							"areaName": "稻城县",
							"latitude": 29.0379,
							"longitude": 100.29809
						},
						{
							"areaId": "513338",
							"areaName": "得荣县",
							"latitude": 28.71297,
							"longitude": 99.28628
						}
					]
				},
				{
					"areaId": "5134",
					"areaName": "凉山彝族自治州",
					"latitude": 27.886762,
					"longitude": 102.258746,
					"children": [{
							"areaId": "513400",
							"areaName": "凉山彝族自治州本级",
							"latitude": 27.886762,
							"longitude": 102.258746
						},
						{
							"areaId": "513401",
							"areaName": "西昌市",
							"latitude": 27.89524,
							"longitude": 102.26413
						},
						{
							"areaId": "513422",
							"areaName": "木里藏族自治县",
							"latitude": 27.92875,
							"longitude": 101.2796
						},
						{
							"areaId": "513423",
							"areaName": "盐源县",
							"latitude": 27.42177,
							"longitude": 101.5097
						},
						{
							"areaId": "513424",
							"areaName": "德昌县",
							"latitude": 27.40482,
							"longitude": 102.18017
						},
						{
							"areaId": "513425",
							"areaName": "会理县",
							"latitude": 26.65627,
							"longitude": 102.24539
						},
						{
							"areaId": "513426",
							"areaName": "会东县",
							"latitude": 26.63429,
							"longitude": 102.57815
						},
						{
							"areaId": "513427",
							"areaName": "宁南县",
							"latitude": 27.06567,
							"longitude": 102.76116
						},
						{
							"areaId": "513428",
							"areaName": "普格县",
							"latitude": 27.37485,
							"longitude": 102.54055
						},
						{
							"areaId": "513429",
							"areaName": "布拖县",
							"latitude": 27.7079,
							"longitude": 102.81234
						},
						{
							"areaId": "513430",
							"areaName": "金阳县",
							"latitude": 27.69698,
							"longitude": 103.24774
						},
						{
							"areaId": "513431",
							"areaName": "昭觉县",
							"latitude": 28.01155,
							"longitude": 102.84661
						},
						{
							"areaId": "513432",
							"areaName": "喜德县",
							"latitude": 28.30739,
							"longitude": 102.41336
						},
						{
							"areaId": "513433",
							"areaName": "冕宁县",
							"latitude": 28.55161,
							"longitude": 102.17108
						},
						{
							"areaId": "513434",
							"areaName": "越西县",
							"latitude": 28.64133,
							"longitude": 102.5079
						},
						{
							"areaId": "513435",
							"areaName": "甘洛县",
							"latitude": 28.96624,
							"longitude": 102.77154
						},
						{
							"areaId": "513436",
							"areaName": "美姑县",
							"latitude": 28.32596,
							"longitude": 103.13116
						},
						{
							"areaId": "513437",
							"areaName": "雷波县",
							"latitude": 28.26407,
							"longitude": 103.57287
						}
					]
				}
			]
		},
		{
			"areaId": "52",
			"areaName": "贵州省",
			"latitude": 26.578343,
			"longitude": 106.713478,
			"children": [{
					"areaId": "5201",
					"areaName": "贵阳市",
					"latitude": 26.578343,
					"longitude": 106.713478,
					"children": [{
							"areaId": "520100",
							"areaName": "贵阳市本级",
							"latitude": 26.578343,
							"longitude": 106.713478
						},
						{
							"areaId": "520102",
							"areaName": "南明区",
							"latitude": 26.56819,
							"longitude": 106.7145
						},
						{
							"areaId": "520103",
							"areaName": "云岩区",
							"latitude": 26.60484,
							"longitude": 106.72485
						},
						{
							"areaId": "520111",
							"areaName": "花溪区",
							"latitude": 26.43343,
							"longitude": 106.67688
						},
						{
							"areaId": "520112",
							"areaName": "乌当区",
							"latitude": 26.6302,
							"longitude": 106.7521
						},
						{
							"areaId": "520113",
							"areaName": "白云区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "520114",
							"areaName": "小河区",
							"latitude": 26.578343,
							"longitude": 106.713478
						},
						{
							"areaId": "520121",
							"areaName": "开阳县",
							"latitude": 27.05533,
							"longitude": 106.9692
						},
						{
							"areaId": "520122",
							"areaName": "息烽县",
							"latitude": 27.09346,
							"longitude": 106.738
						},
						{
							"areaId": "520123",
							"areaName": "修文县",
							"latitude": 26.83783,
							"longitude": 106.59487
						},
						{
							"areaId": "520181",
							"areaName": "清镇市",
							"latitude": 26.55261,
							"longitude": 106.46862
						}
					]
				},
				{
					"areaId": "5202",
					"areaName": "六盘水市",
					"latitude": 26.584643,
					"longitude": 104.846743,
					"children": [{
							"areaId": "520200",
							"areaName": "六盘水市本级",
							"latitude": 26.584643,
							"longitude": 104.846743
						},
						{
							"areaId": "520201",
							"areaName": "钟山区",
							"latitude": 26.57699,
							"longitude": 104.87848
						},
						{
							"areaId": "520203",
							"areaName": "六枝特区",
							"latitude": 26.20117,
							"longitude": 105.48062
						},
						{
							"areaId": "520221",
							"areaName": "水城县",
							"latitude": 26.54785,
							"longitude": 104.95764
						},
						{
							"areaId": "520222",
							"areaName": "盘县",
							"latitude": 26.584643,
							"longitude": 104.846743
						}
					]
				},
				{
					"areaId": "5203",
					"areaName": "遵义市",
					"latitude": 27.706626,
					"longitude": 106.937265,
					"children": [{
							"areaId": "520300",
							"areaName": "遵义市本级",
							"latitude": 27.706626,
							"longitude": 106.937265
						},
						{
							"areaId": "520302",
							"areaName": "红花岗区",
							"latitude": 27.64471,
							"longitude": 106.89404
						},
						{
							"areaId": "520303",
							"areaName": "汇川区",
							"latitude": 27.70625,
							"longitude": 106.9393
						},
						{
							"areaId": "520321",
							"areaName": "遵义县",
							"latitude": 27.706626,
							"longitude": 106.937265
						},
						{
							"areaId": "520322",
							"areaName": "桐梓县",
							"latitude": 28.13806,
							"longitude": 106.82568
						},
						{
							"areaId": "520323",
							"areaName": "绥阳县",
							"latitude": 27.94702,
							"longitude": 107.19064
						},
						{
							"areaId": "520324",
							"areaName": "正安县",
							"latitude": 28.5512,
							"longitude": 107.44357
						},
						{
							"areaId": "520325",
							"areaName": "道真仡佬族苗族自治县",
							"latitude": 28.864,
							"longitude": 107.61152
						},
						{
							"areaId": "520326",
							"areaName": "务川仡佬族苗族自治县",
							"latitude": 28.52227,
							"longitude": 107.88935
						},
						{
							"areaId": "520327",
							"areaName": "凤冈县",
							"latitude": 27.95461,
							"longitude": 107.71682
						},
						{
							"areaId": "520328",
							"areaName": "湄潭县",
							"latitude": 27.76676,
							"longitude": 107.48779
						},
						{
							"areaId": "520329",
							"areaName": "余庆县",
							"latitude": 27.22532,
							"longitude": 107.88821
						},
						{
							"areaId": "520330",
							"areaName": "习水县",
							"latitude": 28.31976,
							"longitude": 106.21267
						},
						{
							"areaId": "520381",
							"areaName": "赤水市",
							"latitude": 28.58921,
							"longitude": 105.69845
						},
						{
							"areaId": "520382",
							"areaName": "仁怀市",
							"latitude": 27.79231,
							"longitude": 106.40152
						}
					]
				},
				{
					"areaId": "5204",
					"areaName": "安顺市",
					"latitude": 26.245544,
					"longitude": 105.932188,
					"children": [{
							"areaId": "520400",
							"areaName": "安顺市本级",
							"latitude": 26.245544,
							"longitude": 105.932188
						},
						{
							"areaId": "520402",
							"areaName": "西秀区",
							"latitude": 26.24491,
							"longitude": 105.96585
						},
						{
							"areaId": "520421",
							"areaName": "平坝县",
							"latitude": 26.245544,
							"longitude": 105.932188
						},
						{
							"areaId": "520422",
							"areaName": "普定县",
							"latitude": 26.30141,
							"longitude": 105.74285
						},
						{
							"areaId": "520423",
							"areaName": "镇宁布依族苗族自治县",
							"latitude": 26.05533,
							"longitude": 105.76513
						},
						{
							"areaId": "520424",
							"areaName": "关岭布依族苗族自治县",
							"latitude": 25.94248,
							"longitude": 105.61883
						},
						{
							"areaId": "520425",
							"areaName": "紫云苗族布依族自治县",
							"latitude": 25.75258,
							"longitude": 106.08364
						}
					]
				},
				{
					"areaId": "5222",
					"areaName": "铜仁地区",
					"latitude": 26.578343,
					"longitude": 106.713478,
					"children": [{
							"areaId": "522200",
							"areaName": "铜仁地区本级",
							"latitude": 26.578343,
							"longitude": 106.713478
						},
						{
							"areaId": "522201",
							"areaName": "铜仁市",
							"latitude": 26.578343,
							"longitude": 106.713478
						},
						{
							"areaId": "522222",
							"areaName": "江口县",
							"latitude": 26.578343,
							"longitude": 106.713478
						},
						{
							"areaId": "522223",
							"areaName": "玉屏侗族自治县",
							"latitude": 26.578343,
							"longitude": 106.713478
						},
						{
							"areaId": "522224",
							"areaName": "石阡县",
							"latitude": 26.578343,
							"longitude": 106.713478
						},
						{
							"areaId": "522225",
							"areaName": "思南县",
							"latitude": 26.578343,
							"longitude": 106.713478
						},
						{
							"areaId": "522226",
							"areaName": "印江土家族苗族自治县",
							"latitude": 26.578343,
							"longitude": 106.713478
						},
						{
							"areaId": "522227",
							"areaName": "德江县",
							"latitude": 26.578343,
							"longitude": 106.713478
						},
						{
							"areaId": "522228",
							"areaName": "沿河土家族自治县",
							"latitude": 26.578343,
							"longitude": 106.713478
						},
						{
							"areaId": "522229",
							"areaName": "松桃苗族自治县",
							"latitude": 26.578343,
							"longitude": 106.713478
						},
						{
							"areaId": "522230",
							"areaName": "万山特区",
							"latitude": 26.578343,
							"longitude": 106.713478
						}
					]
				},
				{
					"areaId": "5223",
					"areaName": "黔西南布依族苗族自治州",
					"latitude": 25.08812,
					"longitude": 104.897971,
					"children": [{
							"areaId": "522300",
							"areaName": "黔西南布依族苗族自治州本级",
							"latitude": 25.08812,
							"longitude": 104.897971
						},
						{
							"areaId": "522301",
							"areaName": "兴义市",
							"latitude": 25.09205,
							"longitude": 104.89548
						},
						{
							"areaId": "522322",
							"areaName": "兴仁县",
							"latitude": 25.08812,
							"longitude": 104.897971
						},
						{
							"areaId": "522323",
							"areaName": "普安县",
							"latitude": 25.78603,
							"longitude": 104.95529
						},
						{
							"areaId": "522324",
							"areaName": "晴隆县",
							"latitude": 25.83522,
							"longitude": 105.2192
						},
						{
							"areaId": "522325",
							"areaName": "贞丰县",
							"latitude": 25.38464,
							"longitude": 105.65454
						},
						{
							"areaId": "522326",
							"areaName": "望谟县",
							"latitude": 25.17822,
							"longitude": 106.09957
						},
						{
							"areaId": "522327",
							"areaName": "册亨县",
							"latitude": 24.98376,
							"longitude": 105.8124
						},
						{
							"areaId": "522328",
							"areaName": "安龙县",
							"latitude": 25.09818,
							"longitude": 105.44268
						}
					]
				},
				{
					"areaId": "5224",
					"areaName": "毕节地区",
					"latitude": 26.578343,
					"longitude": 106.713478,
					"children": [{
							"areaId": "522400",
							"areaName": "毕节地区本级",
							"latitude": 26.578343,
							"longitude": 106.713478
						},
						{
							"areaId": "522401",
							"areaName": "毕节市",
							"latitude": 26.578343,
							"longitude": 106.713478
						},
						{
							"areaId": "522422",
							"areaName": "大方县",
							"latitude": 26.578343,
							"longitude": 106.713478
						},
						{
							"areaId": "522423",
							"areaName": "黔西县",
							"latitude": 26.578343,
							"longitude": 106.713478
						},
						{
							"areaId": "522424",
							"areaName": "金沙县",
							"latitude": 26.578343,
							"longitude": 106.713478
						},
						{
							"areaId": "522425",
							"areaName": "织金县",
							"latitude": 26.578343,
							"longitude": 106.713478
						},
						{
							"areaId": "522426",
							"areaName": "纳雍县",
							"latitude": 26.578343,
							"longitude": 106.713478
						},
						{
							"areaId": "522427",
							"areaName": "威宁彝族回族苗族自治县",
							"latitude": 26.578343,
							"longitude": 106.713478
						},
						{
							"areaId": "522428",
							"areaName": "赫章县",
							"latitude": 26.578343,
							"longitude": 106.713478
						}
					]
				},
				{
					"areaId": "5226",
					"areaName": "黔东南苗族侗族自治州",
					"latitude": 26.583352,
					"longitude": 107.977488,
					"children": [{
							"areaId": "522600",
							"areaName": "黔东南苗族侗族自治州本级",
							"latitude": 26.583352,
							"longitude": 107.977488
						},
						{
							"areaId": "522601",
							"areaName": "凯里市",
							"latitude": 26.56689,
							"longitude": 107.98132
						},
						{
							"areaId": "522622",
							"areaName": "黄平县",
							"latitude": 26.89573,
							"longitude": 107.90179
						},
						{
							"areaId": "522623",
							"areaName": "施秉县",
							"latitude": 27.03495,
							"longitude": 108.12597
						},
						{
							"areaId": "522624",
							"areaName": "三穗县",
							"latitude": 26.94765,
							"longitude": 108.67132
						},
						{
							"areaId": "522625",
							"areaName": "镇远县",
							"latitude": 27.04933,
							"longitude": 108.42721
						},
						{
							"areaId": "522626",
							"areaName": "岑巩县",
							"latitude": 27.17539,
							"longitude": 108.81884
						},
						{
							"areaId": "522627",
							"areaName": "天柱县",
							"latitude": 26.90781,
							"longitude": 109.20718
						},
						{
							"areaId": "522628",
							"areaName": "锦屏县",
							"latitude": 26.67635,
							"longitude": 109.19982
						},
						{
							"areaId": "522629",
							"areaName": "剑河县",
							"latitude": 26.6525,
							"longitude": 108.5913
						},
						{
							"areaId": "522630",
							"areaName": "台江县",
							"latitude": 26.66916,
							"longitude": 108.31814
						},
						{
							"areaId": "522631",
							"areaName": "黎平县",
							"latitude": 26.23114,
							"longitude": 109.13607
						},
						{
							"areaId": "522632",
							"areaName": "榕江县",
							"latitude": 25.92421,
							"longitude": 108.52072
						},
						{
							"areaId": "522633",
							"areaName": "从江县",
							"latitude": 25.75415,
							"longitude": 108.90527
						},
						{
							"areaId": "522634",
							"areaName": "雷山县",
							"latitude": 26.38385,
							"longitude": 108.07745
						},
						{
							"areaId": "522635",
							"areaName": "麻江县",
							"latitude": 26.49235,
							"longitude": 107.59155
						},
						{
							"areaId": "522636",
							"areaName": "丹寨县",
							"latitude": 26.19816,
							"longitude": 107.79718
						}
					]
				},
				{
					"areaId": "5227",
					"areaName": "黔南布依族苗族自治州",
					"latitude": 26.258219,
					"longitude": 107.517156,
					"children": [{
							"areaId": "522700",
							"areaName": "黔南布依族苗族自治州本级",
							"latitude": 26.258219,
							"longitude": 107.517156
						},
						{
							"areaId": "522701",
							"areaName": "都匀市",
							"latitude": 26.2594,
							"longitude": 107.51872
						},
						{
							"areaId": "522702",
							"areaName": "福泉市",
							"latitude": 26.67989,
							"longitude": 107.51715
						},
						{
							"areaId": "522722",
							"areaName": "荔波县",
							"latitude": 25.4139,
							"longitude": 107.88592
						},
						{
							"areaId": "522723",
							"areaName": "贵定县",
							"latitude": 26.57812,
							"longitude": 107.23654
						},
						{
							"areaId": "522725",
							"areaName": "瓮安县",
							"latitude": 27.06813,
							"longitude": 107.4757
						},
						{
							"areaId": "522726",
							"areaName": "独山县",
							"latitude": 25.8245,
							"longitude": 107.54101
						},
						{
							"areaId": "522727",
							"areaName": "平塘县",
							"latitude": 25.83294,
							"longitude": 107.32428
						},
						{
							"areaId": "522728",
							"areaName": "罗甸县",
							"latitude": 25.42586,
							"longitude": 106.75186
						},
						{
							"areaId": "522729",
							"areaName": "长顺县",
							"latitude": 26.02299,
							"longitude": 106.45217
						},
						{
							"areaId": "522730",
							"areaName": "龙里县",
							"latitude": 26.45076,
							"longitude": 106.97662
						},
						{
							"areaId": "522731",
							"areaName": "惠水县",
							"latitude": 26.13389,
							"longitude": 106.65911
						},
						{
							"areaId": "522732",
							"areaName": "三都水族自治县",
							"latitude": 25.98562,
							"longitude": 107.87464
						}
					]
				}
			]
		},
		{
			"areaId": "53",
			"areaName": "云南省",
			"latitude": 25.040609,
			"longitude": 102.712251,
			"children": [{
					"areaId": "5301",
					"areaName": "昆明市",
					"latitude": 25.040609,
					"longitude": 102.712251,
					"children": [{
							"areaId": "530100",
							"areaName": "昆明市本级",
							"latitude": 25.040609,
							"longitude": 102.712251
						},
						{
							"areaId": "530102",
							"areaName": "五华区",
							"latitude": 25.03521,
							"longitude": 102.70786
						},
						{
							"areaId": "530103",
							"areaName": "盘龙区",
							"latitude": 25.04053,
							"longitude": 102.71994
						},
						{
							"areaId": "530111",
							"areaName": "官渡区",
							"latitude": 25.01497,
							"longitude": 102.74362
						},
						{
							"areaId": "530112",
							"areaName": "西山区",
							"latitude": 25.03796,
							"longitude": 102.66464
						},
						{
							"areaId": "530113",
							"areaName": "东川区",
							"latitude": 26.083,
							"longitude": 103.18832
						},
						{
							"areaId": "530121",
							"areaName": "呈贡县",
							"latitude": 25.040609,
							"longitude": 102.712251
						},
						{
							"areaId": "530122",
							"areaName": "晋宁县",
							"latitude": 25.040609,
							"longitude": 102.712251
						},
						{
							"areaId": "530124",
							"areaName": "富民县",
							"latitude": 25.22119,
							"longitude": 102.4985
						},
						{
							"areaId": "530125",
							"areaName": "宜良县",
							"latitude": 24.91705,
							"longitude": 103.14117
						},
						{
							"areaId": "530126",
							"areaName": "石林彝族自治县",
							"latitude": 24.75897,
							"longitude": 103.27148
						},
						{
							"areaId": "530127",
							"areaName": "嵩明县",
							"latitude": 25.33986,
							"longitude": 103.03729
						},
						{
							"areaId": "530128",
							"areaName": "禄劝彝族苗族自治县",
							"latitude": 25.55387,
							"longitude": 102.4671
						},
						{
							"areaId": "530129",
							"areaName": "寻甸回族彝族自治县",
							"latitude": 25.55961,
							"longitude": 103.2557
						},
						{
							"areaId": "530181",
							"areaName": "安宁市",
							"latitude": 24.91652,
							"longitude": 102.46972
						}
					]
				},
				{
					"areaId": "5303",
					"areaName": "曲靖市",
					"latitude": 25.501557,
					"longitude": 103.797851,
					"children": [{
							"areaId": "530300",
							"areaName": "曲靖市本级",
							"latitude": 25.501557,
							"longitude": 103.797851
						},
						{
							"areaId": "530302",
							"areaName": "麒麟区",
							"latitude": 25.49515,
							"longitude": 103.80504
						},
						{
							"areaId": "530321",
							"areaName": "马龙县",
							"latitude": 25.501557,
							"longitude": 103.797851
						},
						{
							"areaId": "530322",
							"areaName": "陆良县",
							"latitude": 25.02335,
							"longitude": 103.6665
						},
						{
							"areaId": "530323",
							"areaName": "师宗县",
							"latitude": 24.82822,
							"longitude": 103.99084
						},
						{
							"areaId": "530324",
							"areaName": "罗平县",
							"latitude": 24.88444,
							"longitude": 104.30859
						},
						{
							"areaId": "530325",
							"areaName": "富源县",
							"latitude": 25.66587,
							"longitude": 104.25387
						},
						{
							"areaId": "530326",
							"areaName": "会泽县",
							"latitude": 26.41076,
							"longitude": 103.30017
						},
						{
							"areaId": "530328",
							"areaName": "沾益县",
							"latitude": 25.501557,
							"longitude": 103.797851
						},
						{
							"areaId": "530381",
							"areaName": "宣威市",
							"latitude": 26.2173,
							"longitude": 104.10409
						}
					]
				},
				{
					"areaId": "5304",
					"areaName": "玉溪市",
					"latitude": 24.350461,
					"longitude": 102.543907,
					"children": [{
							"areaId": "530400",
							"areaName": "玉溪市本级",
							"latitude": 24.350461,
							"longitude": 102.543907
						},
						{
							"areaId": "530402",
							"areaName": "红塔区",
							"latitude": 24.35411,
							"longitude": 102.5449
						},
						{
							"areaId": "530421",
							"areaName": "江川县",
							"latitude": 24.350461,
							"longitude": 102.543907
						},
						{
							"areaId": "530422",
							"areaName": "澄江县",
							"latitude": 24.350461,
							"longitude": 102.543907
						},
						{
							"areaId": "530423",
							"areaName": "通海县",
							"latitude": 24.11362,
							"longitude": 102.76641
						},
						{
							"areaId": "530424",
							"areaName": "华宁县",
							"latitude": 24.1926,
							"longitude": 102.92831
						},
						{
							"areaId": "530425",
							"areaName": "易门县",
							"latitude": 24.67122,
							"longitude": 102.16354
						},
						{
							"areaId": "530426",
							"areaName": "峨山彝族自治县",
							"latitude": 24.16904,
							"longitude": 102.40576
						},
						{
							"areaId": "530427",
							"areaName": "新平彝族傣族自治县",
							"latitude": 24.06886,
							"longitude": 101.98895
						},
						{
							"areaId": "530428",
							"areaName": "元江哈尼族彝族傣族自治县",
							"latitude": 23.59655,
							"longitude": 101.99812
						}
					]
				},
				{
					"areaId": "5305",
					"areaName": "保山市",
					"latitude": 25.111802,
					"longitude": 99.167133,
					"children": [{
							"areaId": "530500",
							"areaName": "保山市本级",
							"latitude": 25.111802,
							"longitude": 99.167133
						},
						{
							"areaId": "530502",
							"areaName": "隆阳区",
							"latitude": 25.11163,
							"longitude": 99.16334
						},
						{
							"areaId": "530521",
							"areaName": "施甸县",
							"latitude": 24.72418,
							"longitude": 99.18768
						},
						{
							"areaId": "530522",
							"areaName": "腾冲县",
							"latitude": 25.111802,
							"longitude": 99.167133
						},
						{
							"areaId": "530523",
							"areaName": "龙陵县",
							"latitude": 24.58746,
							"longitude": 98.69024
						},
						{
							"areaId": "530524",
							"areaName": "昌宁县",
							"latitude": 24.82763,
							"longitude": 99.6036
						}
					]
				},
				{
					"areaId": "5306",
					"areaName": "昭通市",
					"latitude": 27.336999,
					"longitude": 103.717216,
					"children": [{
							"areaId": "530600",
							"areaName": "昭通市本级",
							"latitude": 27.336999,
							"longitude": 103.717216
						},
						{
							"areaId": "530602",
							"areaName": "昭阳区",
							"latitude": 27.31998,
							"longitude": 103.70654
						},
						{
							"areaId": "530621",
							"areaName": "鲁甸县",
							"latitude": 27.19238,
							"longitude": 103.54721
						},
						{
							"areaId": "530622",
							"areaName": "巧家县",
							"latitude": 26.91237,
							"longitude": 102.92416
						},
						{
							"areaId": "530623",
							"areaName": "盐津县",
							"latitude": 28.10856,
							"longitude": 104.23461
						},
						{
							"areaId": "530624",
							"areaName": "大关县",
							"latitude": 27.7488,
							"longitude": 103.89254
						},
						{
							"areaId": "530625",
							"areaName": "永善县",
							"latitude": 28.2279,
							"longitude": 103.63504
						},
						{
							"areaId": "530626",
							"areaName": "绥江县",
							"latitude": 28.59661,
							"longitude": 103.94937
						},
						{
							"areaId": "530627",
							"areaName": "镇雄县",
							"latitude": 27.43981,
							"longitude": 104.87258
						},
						{
							"areaId": "530628",
							"areaName": "彝良县",
							"latitude": 27.62809,
							"longitude": 104.04983
						},
						{
							"areaId": "530629",
							"areaName": "威信县",
							"latitude": 27.84065,
							"longitude": 105.04754
						},
						{
							"areaId": "530630",
							"areaName": "水富县",
							"latitude": 27.336999,
							"longitude": 103.717216
						}
					]
				},
				{
					"areaId": "5307",
					"areaName": "丽江市",
					"latitude": 26.872108,
					"longitude": 100.233026,
					"children": [{
							"areaId": "530700",
							"areaName": "丽江市本级",
							"latitude": 26.872108,
							"longitude": 100.233026
						},
						{
							"areaId": "530702",
							"areaName": "古城区",
							"latitude": 26.87697,
							"longitude": 100.2257
						},
						{
							"areaId": "530721",
							"areaName": "玉龙纳西族自治县",
							"latitude": 26.82149,
							"longitude": 100.2369
						},
						{
							"areaId": "530722",
							"areaName": "永胜县",
							"latitude": 26.68591,
							"longitude": 100.74667
						},
						{
							"areaId": "530723",
							"areaName": "华坪县",
							"latitude": 26.62967,
							"longitude": 101.26562
						},
						{
							"areaId": "530724",
							"areaName": "宁蒗彝族自治县",
							"latitude": 27.28179,
							"longitude": 100.8507
						}
					]
				},
				{
					"areaId": "5308",
					"areaName": "普洱市",
					"latitude": 22.777321,
					"longitude": 100.972344,
					"children": [{
							"areaId": "530800",
							"areaName": "普洱市本级",
							"latitude": 22.777321,
							"longitude": 100.972344
						},
						{
							"areaId": "530802",
							"areaName": "思茅区",
							"latitude": 22.78691,
							"longitude": 100.97716
						},
						{
							"areaId": "530821",
							"areaName": "宁洱哈尼族彝族自治县",
							"latitude": 23.06341,
							"longitude": 101.04653
						},
						{
							"areaId": "530822",
							"areaName": "墨江哈尼族自治县",
							"latitude": 23.43214,
							"longitude": 101.69171
						},
						{
							"areaId": "530823",
							"areaName": "景东彝族自治县",
							"latitude": 24.44791,
							"longitude": 100.83599
						},
						{
							"areaId": "530824",
							"areaName": "景谷傣族彝族自治县",
							"latitude": 23.49705,
							"longitude": 100.70251
						},
						{
							"areaId": "530825",
							"areaName": "镇沅彝族哈尼族拉祜族自治县",
							"latitude": 24.00557,
							"longitude": 101.10675
						},
						{
							"areaId": "530826",
							"areaName": "江城哈尼族彝族自治县",
							"latitude": 22.58424,
							"longitude": 101.85788
						},
						{
							"areaId": "530827",
							"areaName": "孟连傣族拉祜族佤族自治县",
							"latitude": 22.32922,
							"longitude": 99.58424
						},
						{
							"areaId": "530828",
							"areaName": "澜沧拉祜族自治县",
							"latitude": 22.55474,
							"longitude": 99.93591
						},
						{
							"areaId": "530829",
							"areaName": "西盟佤族自治县",
							"latitude": 22.64774,
							"longitude": 99.59869
						}
					]
				},
				{
					"areaId": "5309",
					"areaName": "临沧市",
					"latitude": 23.886567,
					"longitude": 100.08697,
					"children": [{
							"areaId": "530900",
							"areaName": "临沧市本级",
							"latitude": 23.886567,
							"longitude": 100.08697
						},
						{
							"areaId": "530902",
							"areaName": "临翔区",
							"latitude": 23.89497,
							"longitude": 100.08242
						},
						{
							"areaId": "530921",
							"areaName": "凤庆县",
							"latitude": 24.58034,
							"longitude": 99.92837
						},
						{
							"areaId": "530922",
							"areaName": "云县",
							"latitude": 24.44675,
							"longitude": 100.12808
						},
						{
							"areaId": "530923",
							"areaName": "永德县",
							"latitude": 24.0276,
							"longitude": 99.25326
						},
						{
							"areaId": "530924",
							"areaName": "镇康县",
							"latitude": 23.76241,
							"longitude": 98.8255
						},
						{
							"areaId": "530925",
							"areaName": "双江拉祜族佤族布朗族傣族自治县",
							"latitude": 23.47349,
							"longitude": 99.82769
						},
						{
							"areaId": "530926",
							"areaName": "耿马傣族佤族自治县",
							"latitude": 23.53776,
							"longitude": 99.39785
						},
						{
							"areaId": "530927",
							"areaName": "沧源佤族自治县",
							"latitude": 23.14821,
							"longitude": 99.24545
						}
					]
				},
				{
					"areaId": "5323",
					"areaName": "楚雄彝族自治州",
					"latitude": 25.041988,
					"longitude": 101.546046,
					"children": [{
							"areaId": "532300",
							"areaName": "楚雄彝族自治州本级",
							"latitude": 25.041988,
							"longitude": 101.546046
						},
						{
							"areaId": "532301",
							"areaName": "楚雄市",
							"latitude": 25.0329,
							"longitude": 101.54615
						},
						{
							"areaId": "532322",
							"areaName": "双柏县",
							"latitude": 24.68882,
							"longitude": 101.64205
						},
						{
							"areaId": "532323",
							"areaName": "牟定县",
							"latitude": 25.31551,
							"longitude": 101.54
						},
						{
							"areaId": "532324",
							"areaName": "南华县",
							"latitude": 25.19293,
							"longitude": 101.27313
						},
						{
							"areaId": "532325",
							"areaName": "姚安县",
							"latitude": 25.50467,
							"longitude": 101.24279
						},
						{
							"areaId": "532326",
							"areaName": "大姚县",
							"latitude": 25.72218,
							"longitude": 101.32397
						},
						{
							"areaId": "532327",
							"areaName": "永仁县",
							"latitude": 26.05794,
							"longitude": 101.6716
						},
						{
							"areaId": "532328",
							"areaName": "元谋县",
							"latitude": 25.70438,
							"longitude": 101.87728
						},
						{
							"areaId": "532329",
							"areaName": "武定县",
							"latitude": 25.5295,
							"longitude": 102.4038
						},
						{
							"areaId": "532331",
							"areaName": "禄丰县",
							"latitude": 25.14815,
							"longitude": 102.07797
						}
					]
				},
				{
					"areaId": "5325",
					"areaName": "红河哈尼族彝族自治州",
					"latitude": 23.366775,
					"longitude": 103.384182,
					"children": [{
							"areaId": "532500",
							"areaName": "红河哈尼族彝族自治州本级",
							"latitude": 23.366775,
							"longitude": 103.384182
						},
						{
							"areaId": "532501",
							"areaName": "个旧市",
							"latitude": 23.35894,
							"longitude": 103.15966
						},
						{
							"areaId": "532502",
							"areaName": "开远市",
							"latitude": 23.71012,
							"longitude": 103.26986
						},
						{
							"areaId": "532522",
							"areaName": "蒙自县",
							"latitude": 23.366775,
							"longitude": 103.384182
						},
						{
							"areaId": "532523",
							"areaName": "屏边苗族自治县",
							"latitude": 22.98425,
							"longitude": 103.68554
						},
						{
							"areaId": "532524",
							"areaName": "建水县",
							"latitude": 23.63472,
							"longitude": 102.82656
						},
						{
							"areaId": "532525",
							"areaName": "石屏县",
							"latitude": 23.71441,
							"longitude": 102.49408
						},
						{
							"areaId": "532526",
							"areaName": "弥勒县",
							"latitude": 23.366775,
							"longitude": 103.384182
						},
						{
							"areaId": "532527",
							"areaName": "泸西县",
							"latitude": 24.52854,
							"longitude": 103.76373
						},
						{
							"areaId": "532528",
							"areaName": "元阳县",
							"latitude": 23.22281,
							"longitude": 102.83261
						},
						{
							"areaId": "532529",
							"areaName": "红河县",
							"latitude": 23.36767,
							"longitude": 102.42059
						},
						{
							"areaId": "532530",
							"areaName": "金平苗族瑶族傣族自治县",
							"latitude": 22.77959,
							"longitude": 103.22651
						},
						{
							"areaId": "532531",
							"areaName": "绿春县",
							"latitude": 22.99371,
							"longitude": 102.39672
						},
						{
							"areaId": "532532",
							"areaName": "河口瑶族自治县",
							"latitude": 22.52929,
							"longitude": 103.93936
						}
					]
				},
				{
					"areaId": "5326",
					"areaName": "文山壮族苗族自治州",
					"latitude": 24.989786,
					"longitude": 121.570458,
					"children": [{
							"areaId": "532600",
							"areaName": "文山壮族苗族自治州本级",
							"latitude": 24.989786,
							"longitude": 121.570458
						},
						{
							"areaId": "532621",
							"areaName": "文山县",
							"latitude": 24.989786,
							"longitude": 121.570458
						},
						{
							"areaId": "532622",
							"areaName": "砚山县",
							"latitude": 23.60723,
							"longitude": 104.33306
						},
						{
							"areaId": "532623",
							"areaName": "西畴县",
							"latitude": 23.43941,
							"longitude": 104.67419
						},
						{
							"areaId": "532624",
							"areaName": "麻栗坡县",
							"latitude": 23.12028,
							"longitude": 104.70132
						},
						{
							"areaId": "532625",
							"areaName": "马关县",
							"latitude": 23.01293,
							"longitude": 104.39514
						},
						{
							"areaId": "532626",
							"areaName": "丘北县",
							"latitude": 24.03957,
							"longitude": 104.19256
						},
						{
							"areaId": "532627",
							"areaName": "广南县",
							"latitude": 24.0464,
							"longitude": 105.05511
						},
						{
							"areaId": "532628",
							"areaName": "富宁县",
							"latitude": 23.62536,
							"longitude": 105.63085
						}
					]
				},
				{
					"areaId": "5328",
					"areaName": "西双版纳傣族自治州",
					"latitude": 22.001724,
					"longitude": 100.797941,
					"children": [{
							"areaId": "532800",
							"areaName": "西双版纳傣族自治州本级",
							"latitude": 22.001724,
							"longitude": 100.797941
						},
						{
							"areaId": "532801",
							"areaName": "景洪市",
							"latitude": 22.01071,
							"longitude": 100.79977
						},
						{
							"areaId": "532822",
							"areaName": "勐海县",
							"latitude": 21.96175,
							"longitude": 100.44931
						},
						{
							"areaId": "532823",
							"areaName": "勐腊县",
							"latitude": 21.48162,
							"longitude": 101.56488
						}
					]
				},
				{
					"areaId": "5329",
					"areaName": "大理白族自治州",
					"latitude": 25.592765,
					"longitude": 100.240037,
					"children": [{
							"areaId": "532900",
							"areaName": "大理白族自治州本级",
							"latitude": 25.592765,
							"longitude": 100.240037
						},
						{
							"areaId": "532901",
							"areaName": "大理市",
							"latitude": 25.59157,
							"longitude": 100.22998
						},
						{
							"areaId": "532922",
							"areaName": "漾濞彝族自治县",
							"latitude": 25.6652,
							"longitude": 99.95474
						},
						{
							"areaId": "532923",
							"areaName": "祥云县",
							"latitude": 25.47342,
							"longitude": 100.55761
						},
						{
							"areaId": "532924",
							"areaName": "宾川县",
							"latitude": 25.83144,
							"longitude": 100.57666
						},
						{
							"areaId": "532925",
							"areaName": "弥渡县",
							"latitude": 25.34179,
							"longitude": 100.49075
						},
						{
							"areaId": "532926",
							"areaName": "南涧彝族自治县",
							"latitude": 25.04349,
							"longitude": 100.50964
						},
						{
							"areaId": "532927",
							"areaName": "巍山彝族回族自治县",
							"latitude": 25.23197,
							"longitude": 100.30612
						},
						{
							"areaId": "532928",
							"areaName": "永平县",
							"latitude": 25.46451,
							"longitude": 99.54095
						},
						{
							"areaId": "532929",
							"areaName": "云龙县",
							"latitude": 25.88505,
							"longitude": 99.37255
						},
						{
							"areaId": "532930",
							"areaName": "洱源县",
							"latitude": 26.10829,
							"longitude": 99.94903
						},
						{
							"areaId": "532931",
							"areaName": "剑川县",
							"latitude": 26.53688,
							"longitude": 99.90545
						},
						{
							"areaId": "532932",
							"areaName": "鹤庆县",
							"latitude": 26.55798,
							"longitude": 100.17697
						}
					]
				},
				{
					"areaId": "5331",
					"areaName": "德宏傣族景颇族自治州",
					"latitude": 24.436694,
					"longitude": 98.578363,
					"children": [{
							"areaId": "533100",
							"areaName": "德宏傣族景颇族自治州本级",
							"latitude": 24.436694,
							"longitude": 98.578363
						},
						{
							"areaId": "533102",
							"areaName": "瑞丽市",
							"latitude": 24.01277,
							"longitude": 97.85183
						},
						{
							"areaId": "533103",
							"areaName": "潞西市",
							"latitude": 24.433735,
							"longitude": 98.588641
						},
						{
							"areaId": "533122",
							"areaName": "梁河县",
							"latitude": 24.80658,
							"longitude": 98.29705
						},
						{
							"areaId": "533123",
							"areaName": "盈江县",
							"latitude": 24.70579,
							"longitude": 97.93179
						},
						{
							"areaId": "533124",
							"areaName": "陇川县",
							"latitude": 24.18302,
							"longitude": 97.79199
						}
					]
				},
				{
					"areaId": "5333",
					"areaName": "怒江傈僳族自治州",
					"latitude": 25.850949,
					"longitude": 98.854304,
					"children": [{
							"areaId": "533300",
							"areaName": "怒江傈僳族自治州本级",
							"latitude": 25.850949,
							"longitude": 98.854304
						},
						{
							"areaId": "533321",
							"areaName": "泸水县",
							"latitude": 25.850949,
							"longitude": 98.854304
						},
						{
							"areaId": "533323",
							"areaName": "福贡县",
							"latitude": 26.90366,
							"longitude": 98.86969
						},
						{
							"areaId": "533324",
							"areaName": "贡山独龙族怒族自治县",
							"latitude": 27.74088,
							"longitude": 98.66583
						},
						{
							"areaId": "533325",
							"areaName": "兰坪白族普米族自治县",
							"latitude": 26.45251,
							"longitude": 99.41891
						}
					]
				},
				{
					"areaId": "5334",
					"areaName": "迪庆藏族自治州",
					"latitude": 27.826853,
					"longitude": 99.706463,
					"children": [{
							"areaId": "533400",
							"areaName": "迪庆藏族自治州本级",
							"latitude": 27.826853,
							"longitude": 99.706463
						},
						{
							"areaId": "533421",
							"areaName": "香格里拉县",
							"latitude": 27.826853,
							"longitude": 99.706463
						},
						{
							"areaId": "533422",
							"areaName": "德钦县",
							"latitude": 28.4863,
							"longitude": 98.91082
						},
						{
							"areaId": "533423",
							"areaName": "维西傈僳族自治县",
							"latitude": 27.1793,
							"longitude": 99.28402
						}
					]
				}
			]
		},
		{
			"areaId": "54",
			"areaName": "西藏",
			"latitude": 29.660361,
			"longitude": 91.132212,
			"children": [{
					"areaId": "5401",
					"areaName": "拉萨市",
					"latitude": 29.660361,
					"longitude": 91.132212,
					"children": [{
							"areaId": "540100",
							"areaName": "拉萨市本级",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "540102",
							"areaName": "城关区",
							"latitude": 36.05725,
							"longitude": 103.8252
						},
						{
							"areaId": "540121",
							"areaName": "林周县",
							"latitude": 29.89445,
							"longitude": 91.2586
						},
						{
							"areaId": "540122",
							"areaName": "当雄县",
							"latitude": 30.48309,
							"longitude": 91.10076
						},
						{
							"areaId": "540123",
							"areaName": "尼木县",
							"latitude": 29.43353,
							"longitude": 90.16378
						},
						{
							"areaId": "540124",
							"areaName": "曲水县",
							"latitude": 29.35636,
							"longitude": 90.73187
						},
						{
							"areaId": "540125",
							"areaName": "堆龙德庆县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "540126",
							"areaName": "达孜县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "540127",
							"areaName": "墨竹工卡县",
							"latitude": 29.83614,
							"longitude": 91.72814
						}
					]
				},
				{
					"areaId": "5421",
					"areaName": "昌都地区",
					"latitude": 29.660361,
					"longitude": 91.132212,
					"children": [{
							"areaId": "542100",
							"areaName": "昌都地区本级",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542121",
							"areaName": "昌都县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542122",
							"areaName": "江达县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542123",
							"areaName": "贡觉县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542124",
							"areaName": "类乌齐县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542125",
							"areaName": "丁青县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542126",
							"areaName": "察雅县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542127",
							"areaName": "八宿县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542128",
							"areaName": "左贡县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542129",
							"areaName": "芒康县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542132",
							"areaName": "洛隆县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542133",
							"areaName": "边坝县",
							"latitude": 29.660361,
							"longitude": 91.132212
						}
					]
				},
				{
					"areaId": "5422",
					"areaName": "山南地区",
					"latitude": 29.660361,
					"longitude": 91.132212,
					"children": [{
							"areaId": "542200",
							"areaName": "山南地区本级",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542221",
							"areaName": "乃东县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542222",
							"areaName": "扎囊县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542223",
							"areaName": "贡嘎县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542224",
							"areaName": "桑日县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542225",
							"areaName": "琼结县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542226",
							"areaName": "曲松县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542227",
							"areaName": "措美县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542228",
							"areaName": "洛扎县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542229",
							"areaName": "加查县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542231",
							"areaName": "隆子县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542232",
							"areaName": "错那县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542233",
							"areaName": "浪卡子县",
							"latitude": 29.660361,
							"longitude": 91.132212
						}
					]
				},
				{
					"areaId": "5423",
					"areaName": "日喀则地区",
					"latitude": 29.660361,
					"longitude": 91.132212,
					"children": [{
							"areaId": "542300",
							"areaName": "日喀则地区本级",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542301",
							"areaName": "日喀则市",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542322",
							"areaName": "南木林县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542323",
							"areaName": "江孜县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542324",
							"areaName": "定日县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542325",
							"areaName": "萨迦县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542326",
							"areaName": "拉孜县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542327",
							"areaName": "昂仁县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542328",
							"areaName": "谢通门县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542329",
							"areaName": "白朗县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542330",
							"areaName": "仁布县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542331",
							"areaName": "康马县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542332",
							"areaName": "定结县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542333",
							"areaName": "仲巴县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542334",
							"areaName": "亚东县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542335",
							"areaName": "吉隆县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542336",
							"areaName": "聂拉木县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542337",
							"areaName": "萨嘎县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542338",
							"areaName": "岗巴县",
							"latitude": 29.660361,
							"longitude": 91.132212
						}
					]
				},
				{
					"areaId": "5424",
					"areaName": "那曲地区",
					"latitude": 29.660361,
					"longitude": 91.132212,
					"children": [{
							"areaId": "542400",
							"areaName": "那曲地区本级",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542421",
							"areaName": "那曲县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542422",
							"areaName": "嘉黎县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542423",
							"areaName": "比如县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542424",
							"areaName": "聂荣县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542425",
							"areaName": "安多县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542426",
							"areaName": "申扎县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542427",
							"areaName": "索县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542428",
							"areaName": "班戈县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542429",
							"areaName": "巴青县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542430",
							"areaName": "尼玛县",
							"latitude": 29.660361,
							"longitude": 91.132212
						}
					]
				},
				{
					"areaId": "5425",
					"areaName": "阿里地区",
					"latitude": 32.503187,
					"longitude": 80.105498,
					"children": [{
							"areaId": "542500",
							"areaName": "阿里地区本级",
							"latitude": 32.503187,
							"longitude": 80.105498
						},
						{
							"areaId": "542521",
							"areaName": "普兰县",
							"latitude": 30.30002,
							"longitude": 81.177
						},
						{
							"areaId": "542522",
							"areaName": "札达县",
							"latitude": 31.48345,
							"longitude": 79.80255
						},
						{
							"areaId": "542523",
							"areaName": "噶尔县",
							"latitude": 32.50024,
							"longitude": 80.09579
						},
						{
							"areaId": "542524",
							"areaName": "日土县",
							"latitude": 33.38741,
							"longitude": 79.7131
						},
						{
							"areaId": "542525",
							"areaName": "革吉县",
							"latitude": 32.3964,
							"longitude": 81.151
						},
						{
							"areaId": "542526",
							"areaName": "改则县",
							"latitude": 32.30446,
							"longitude": 84.06295
						},
						{
							"areaId": "542527",
							"areaName": "措勤县",
							"latitude": 31.02095,
							"longitude": 85.16616
						}
					]
				},
				{
					"areaId": "5426",
					"areaName": "林芝地区",
					"latitude": 29.660361,
					"longitude": 91.132212,
					"children": [{
							"areaId": "542600",
							"areaName": "林芝地区本级",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542621",
							"areaName": "林芝县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542622",
							"areaName": "工布江达县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542623",
							"areaName": "米林县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542624",
							"areaName": "墨脱县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542625",
							"areaName": "波密县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542626",
							"areaName": "察隅县",
							"latitude": 29.660361,
							"longitude": 91.132212
						},
						{
							"areaId": "542627",
							"areaName": "朗县",
							"latitude": 29.660361,
							"longitude": 91.132212
						}
					]
				}
			]
		},
		{
			"areaId": "61",
			"areaName": "陕西省",
			"latitude": 34.263161,
			"longitude": 108.948024,
			"children": [{
					"areaId": "6101",
					"areaName": "西安市",
					"latitude": 34.263161,
					"longitude": 108.948024,
					"children": [{
							"areaId": "610100",
							"areaName": "西安市本级",
							"latitude": 34.263161,
							"longitude": 108.948024
						},
						{
							"areaId": "610102",
							"areaName": "新城区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "610103",
							"areaName": "碑林区",
							"latitude": 34.2304,
							"longitude": 108.93426
						},
						{
							"areaId": "610104",
							"areaName": "莲湖区",
							"latitude": 34.26709,
							"longitude": 108.9401
						},
						{
							"areaId": "610111",
							"areaName": "灞桥区",
							"latitude": 34.27264,
							"longitude": 109.06451
						},
						{
							"areaId": "610112",
							"areaName": "未央区",
							"latitude": 34.29296,
							"longitude": 108.94683
						},
						{
							"areaId": "610113",
							"areaName": "雁塔区",
							"latitude": 34.22245,
							"longitude": 108.94866
						},
						{
							"areaId": "610114",
							"areaName": "阎良区",
							"latitude": 34.66221,
							"longitude": 109.22616
						},
						{
							"areaId": "610115",
							"areaName": "临潼区",
							"latitude": 34.36665,
							"longitude": 109.21417
						},
						{
							"areaId": "610116",
							"areaName": "长安区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "610122",
							"areaName": "蓝田县",
							"latitude": 34.15128,
							"longitude": 109.32339
						},
						{
							"areaId": "610124",
							"areaName": "周至县",
							"latitude": 34.16337,
							"longitude": 108.22207
						},
						{
							"areaId": "610125",
							"areaName": "户县",
							"latitude": 34.263161,
							"longitude": 108.948024
						},
						{
							"areaId": "610126",
							"areaName": "高陵县",
							"latitude": 34.263161,
							"longitude": 108.948024
						}
					]
				},
				{
					"areaId": "6102",
					"areaName": "铜川市",
					"latitude": 34.90892,
					"longitude": 108.963122,
					"children": [{
							"areaId": "610200",
							"areaName": "铜川市本级",
							"latitude": 34.90892,
							"longitude": 108.963122
						},
						{
							"areaId": "610202",
							"areaName": "王益区",
							"latitude": 35.06896,
							"longitude": 109.07564
						},
						{
							"areaId": "610203",
							"areaName": "印台区",
							"latitude": 35.1169,
							"longitude": 109.10208
						},
						{
							"areaId": "610204",
							"areaName": "耀州区",
							"latitude": 34.91308,
							"longitude": 108.98556
						},
						{
							"areaId": "610222",
							"areaName": "宜君县",
							"latitude": 35.40108,
							"longitude": 109.11813
						}
					]
				},
				{
					"areaId": "6103",
					"areaName": "宝鸡市",
					"latitude": 34.369315,
					"longitude": 107.14487,
					"children": [{
							"areaId": "610300",
							"areaName": "宝鸡市本级",
							"latitude": 34.369315,
							"longitude": 107.14487
						},
						{
							"areaId": "610302",
							"areaName": "渭滨区",
							"latitude": 34.37116,
							"longitude": 107.14991
						},
						{
							"areaId": "610303",
							"areaName": "金台区",
							"latitude": 34.37612,
							"longitude": 107.14691
						},
						{
							"areaId": "610304",
							"areaName": "陈仓区",
							"latitude": 34.35451,
							"longitude": 107.38742
						},
						{
							"areaId": "610322",
							"areaName": "凤翔县",
							"latitude": 34.52321,
							"longitude": 107.39645
						},
						{
							"areaId": "610323",
							"areaName": "岐山县",
							"latitude": 34.44378,
							"longitude": 107.62173
						},
						{
							"areaId": "610324",
							"areaName": "扶风县",
							"latitude": 34.37524,
							"longitude": 107.90017
						},
						{
							"areaId": "610326",
							"areaName": "眉县",
							"latitude": 34.27569,
							"longitude": 107.75079
						},
						{
							"areaId": "610327",
							"areaName": "陇县",
							"latitude": 34.89404,
							"longitude": 106.85946
						},
						{
							"areaId": "610328",
							"areaName": "千阳县",
							"latitude": 34.64219,
							"longitude": 107.13043
						},
						{
							"areaId": "610329",
							"areaName": "麟游县",
							"latitude": 34.67844,
							"longitude": 107.79623
						},
						{
							"areaId": "610330",
							"areaName": "凤县",
							"latitude": 33.91172,
							"longitude": 106.52356
						},
						{
							"areaId": "610331",
							"areaName": "太白县",
							"latitude": 34.06207,
							"longitude": 107.31646
						}
					]
				},
				{
					"areaId": "6104",
					"areaName": "咸阳市",
					"latitude": 34.333439,
					"longitude": 108.705117,
					"children": [{
							"areaId": "610400",
							"areaName": "咸阳市本级",
							"latitude": 34.333439,
							"longitude": 108.705117
						},
						{
							"areaId": "610402",
							"areaName": "秦都区",
							"latitude": 34.33804,
							"longitude": 108.71493
						},
						{
							"areaId": "610403",
							"areaName": "杨凌区",
							"latitude": 34.270434,
							"longitude": 108.083481
						},
						{
							"areaId": "610404",
							"areaName": "渭城区",
							"latitude": 34.33198,
							"longitude": 108.72227
						},
						{
							"areaId": "610422",
							"areaName": "三原县",
							"latitude": 34.61556,
							"longitude": 108.93194
						},
						{
							"areaId": "610423",
							"areaName": "泾阳县",
							"latitude": 34.52705,
							"longitude": 108.84259
						},
						{
							"areaId": "610424",
							"areaName": "乾县",
							"latitude": 34.52946,
							"longitude": 108.24231
						},
						{
							"areaId": "610425",
							"areaName": "礼泉县",
							"latitude": 34.48455,
							"longitude": 108.4263
						},
						{
							"areaId": "610426",
							"areaName": "永寿县",
							"latitude": 34.69081,
							"longitude": 108.14474
						},
						{
							"areaId": "610427",
							"areaName": "彬县",
							"latitude": 34.333439,
							"longitude": 108.705117
						},
						{
							"areaId": "610428",
							"areaName": "长武县",
							"latitude": 35.2067,
							"longitude": 107.7951
						},
						{
							"areaId": "610429",
							"areaName": "旬邑县",
							"latitude": 35.11338,
							"longitude": 108.3341
						},
						{
							"areaId": "610430",
							"areaName": "淳化县",
							"latitude": 34.79886,
							"longitude": 108.58026
						},
						{
							"areaId": "610431",
							"areaName": "武功县",
							"latitude": 34.26003,
							"longitude": 108.20434
						},
						{
							"areaId": "610481",
							"areaName": "兴平市",
							"latitude": 34.29785,
							"longitude": 108.49057
						}
					]
				},
				{
					"areaId": "6105",
					"areaName": "渭南市",
					"latitude": 34.499381,
					"longitude": 109.502882,
					"children": [{
							"areaId": "610500",
							"areaName": "渭南市本级",
							"latitude": 34.499381,
							"longitude": 109.502882
						},
						{
							"areaId": "610502",
							"areaName": "临渭区",
							"latitude": 34.49822,
							"longitude": 109.49296
						},
						{
							"areaId": "610521",
							"areaName": "华县",
							"latitude": 34.499381,
							"longitude": 109.502882
						},
						{
							"areaId": "610522",
							"areaName": "潼关县",
							"latitude": 34.54284,
							"longitude": 110.24362
						},
						{
							"areaId": "610523",
							"areaName": "大荔县",
							"latitude": 34.79565,
							"longitude": 109.94216
						},
						{
							"areaId": "610524",
							"areaName": "合阳县",
							"latitude": 35.23805,
							"longitude": 110.14862
						},
						{
							"areaId": "610525",
							"areaName": "澄城县",
							"latitude": 35.18396,
							"longitude": 109.93444
						},
						{
							"areaId": "610526",
							"areaName": "蒲城县",
							"latitude": 34.9568,
							"longitude": 109.5903
						},
						{
							"areaId": "610527",
							"areaName": "白水县",
							"latitude": 35.17863,
							"longitude": 109.59286
						},
						{
							"areaId": "610528",
							"areaName": "富平县",
							"latitude": 34.75109,
							"longitude": 109.1802
						},
						{
							"areaId": "610581",
							"areaName": "韩城市",
							"latitude": 35.47926,
							"longitude": 110.44238
						},
						{
							"areaId": "610582",
							"areaName": "华阴市",
							"latitude": 34.56608,
							"longitude": 110.08752
						}
					]
				},
				{
					"areaId": "6106",
					"areaName": "延安市",
					"latitude": 36.596537,
					"longitude": 109.49081,
					"children": [{
							"areaId": "610600",
							"areaName": "延安市本级",
							"latitude": 36.596537,
							"longitude": 109.49081
						},
						{
							"areaId": "610602",
							"areaName": "宝塔区",
							"latitude": 36.59154,
							"longitude": 109.49336
						},
						{
							"areaId": "610621",
							"areaName": "延长县",
							"latitude": 36.57904,
							"longitude": 110.01083
						},
						{
							"areaId": "610622",
							"areaName": "延川县",
							"latitude": 36.87817,
							"longitude": 110.19415
						},
						{
							"areaId": "610623",
							"areaName": "子长县",
							"latitude": 36.596537,
							"longitude": 109.49081
						},
						{
							"areaId": "610624",
							"areaName": "安塞县",
							"latitude": 36.596537,
							"longitude": 109.49081
						},
						{
							"areaId": "610625",
							"areaName": "志丹县",
							"latitude": 36.82177,
							"longitude": 108.76815
						},
						{
							"areaId": "610626",
							"areaName": "吴起县",
							"latitude": 36.92785,
							"longitude": 108.17611
						},
						{
							"areaId": "610627",
							"areaName": "甘泉县",
							"latitude": 36.27754,
							"longitude": 109.35012
						},
						{
							"areaId": "610628",
							"areaName": "富县",
							"latitude": 35.98803,
							"longitude": 109.37927
						},
						{
							"areaId": "610629",
							"areaName": "洛川县",
							"latitude": 35.76076,
							"longitude": 109.43286
						},
						{
							"areaId": "610630",
							"areaName": "宜川县",
							"latitude": 36.04732,
							"longitude": 110.17196
						},
						{
							"areaId": "610631",
							"areaName": "黄龙县",
							"latitude": 35.58349,
							"longitude": 109.84259
						},
						{
							"areaId": "610632",
							"areaName": "黄陵县",
							"latitude": 35.58357,
							"longitude": 109.26333
						}
					]
				},
				{
					"areaId": "6107",
					"areaName": "汉中市",
					"latitude": 33.077668,
					"longitude": 107.028621,
					"children": [{
							"areaId": "610700",
							"areaName": "汉中市本级",
							"latitude": 33.077668,
							"longitude": 107.028621
						},
						{
							"areaId": "610702",
							"areaName": "汉台区",
							"latitude": 33.06774,
							"longitude": 107.03187
						},
						{
							"areaId": "610721",
							"areaName": "南郑县",
							"latitude": 33.077668,
							"longitude": 107.028621
						},
						{
							"areaId": "610722",
							"areaName": "城固县",
							"latitude": 33.15661,
							"longitude": 107.33367
						},
						{
							"areaId": "610723",
							"areaName": "洋县",
							"latitude": 33.22102,
							"longitude": 107.54672
						},
						{
							"areaId": "610724",
							"areaName": "西乡县",
							"latitude": 32.98411,
							"longitude": 107.76867
						},
						{
							"areaId": "610725",
							"areaName": "勉县",
							"latitude": 33.15273,
							"longitude": 106.67584
						},
						{
							"areaId": "610726",
							"areaName": "宁强县",
							"latitude": 32.82881,
							"longitude": 106.25958
						},
						{
							"areaId": "610727",
							"areaName": "略阳县",
							"latitude": 33.33009,
							"longitude": 106.15399
						},
						{
							"areaId": "610728",
							"areaName": "镇巴县",
							"latitude": 32.53487,
							"longitude": 107.89648
						},
						{
							"areaId": "610729",
							"areaName": "留坝县",
							"latitude": 33.61606,
							"longitude": 106.92233
						},
						{
							"areaId": "610730",
							"areaName": "佛坪县",
							"latitude": 33.52496,
							"longitude": 107.98974
						}
					]
				},
				{
					"areaId": "6108",
					"areaName": "榆林市",
					"latitude": 38.290162,
					"longitude": 109.741193,
					"children": [{
							"areaId": "610800",
							"areaName": "榆林市本级",
							"latitude": 38.290162,
							"longitude": 109.741193
						},
						{
							"areaId": "610802",
							"areaName": "榆阳区",
							"latitude": 38.27843,
							"longitude": 109.73473
						},
						{
							"areaId": "610821",
							"areaName": "神木县",
							"latitude": 38.290162,
							"longitude": 109.741193
						},
						{
							"areaId": "610822",
							"areaName": "府谷县",
							"latitude": 39.02805,
							"longitude": 111.06723
						},
						{
							"areaId": "610823",
							"areaName": "横山县",
							"latitude": 38.290162,
							"longitude": 109.741193
						},
						{
							"areaId": "610824",
							"areaName": "靖边县",
							"latitude": 37.59938,
							"longitude": 108.79412
						},
						{
							"areaId": "610825",
							"areaName": "定边县",
							"latitude": 37.59037,
							"longitude": 107.59793
						},
						{
							"areaId": "610826",
							"areaName": "绥德县",
							"latitude": 37.49778,
							"longitude": 110.26126
						},
						{
							"areaId": "610827",
							"areaName": "米脂县",
							"latitude": 37.75529,
							"longitude": 110.18417
						},
						{
							"areaId": "610828",
							"areaName": "佳县",
							"latitude": 38.02248,
							"longitude": 110.49362
						},
						{
							"areaId": "610829",
							"areaName": "吴堡县",
							"latitude": 37.45709,
							"longitude": 110.74533
						},
						{
							"areaId": "610830",
							"areaName": "清涧县",
							"latitude": 37.08854,
							"longitude": 110.12173
						},
						{
							"areaId": "610831",
							"areaName": "子洲县",
							"latitude": 37.61238,
							"longitude": 110.03488
						}
					]
				},
				{
					"areaId": "6109",
					"areaName": "安康市",
					"latitude": 32.6903,
					"longitude": 109.029273,
					"children": [{
							"areaId": "610900",
							"areaName": "安康市本级",
							"latitude": 32.6903,
							"longitude": 109.029273
						},
						{
							"areaId": "610902",
							"areaName": "汉滨区",
							"latitude": 32.69517,
							"longitude": 109.02683
						},
						{
							"areaId": "610921",
							"areaName": "汉阴县",
							"latitude": 32.89129,
							"longitude": 108.51098
						},
						{
							"areaId": "610922",
							"areaName": "石泉县",
							"latitude": 33.03971,
							"longitude": 108.24755
						},
						{
							"areaId": "610923",
							"areaName": "宁陕县",
							"latitude": 33.31726,
							"longitude": 108.31515
						},
						{
							"areaId": "610924",
							"areaName": "紫阳县",
							"latitude": 32.52115,
							"longitude": 108.5368
						},
						{
							"areaId": "610925",
							"areaName": "岚皋县",
							"latitude": 32.30794,
							"longitude": 108.90289
						},
						{
							"areaId": "610926",
							"areaName": "平利县",
							"latitude": 32.39111,
							"longitude": 109.35775
						},
						{
							"areaId": "610927",
							"areaName": "镇坪县",
							"latitude": 31.8833,
							"longitude": 109.52456
						},
						{
							"areaId": "610928",
							"areaName": "旬阳县",
							"latitude": 32.83207,
							"longitude": 109.3619
						},
						{
							"areaId": "610929",
							"areaName": "白河县",
							"latitude": 23.351221,
							"longitude": 120.41581
						}
					]
				},
				{
					"areaId": "6110",
					"areaName": "商洛市",
					"latitude": 33.868319,
					"longitude": 109.939776,
					"children": [{
							"areaId": "611000",
							"areaName": "商洛市本级",
							"latitude": 33.868319,
							"longitude": 109.939776
						},
						{
							"areaId": "611002",
							"areaName": "商州区",
							"latitude": 33.8627,
							"longitude": 109.94126
						},
						{
							"areaId": "611021",
							"areaName": "洛南县",
							"latitude": 34.08994,
							"longitude": 110.14645
						},
						{
							"areaId": "611022",
							"areaName": "丹凤县",
							"latitude": 33.69468,
							"longitude": 110.33486
						},
						{
							"areaId": "611023",
							"areaName": "商南县",
							"latitude": 33.52581,
							"longitude": 110.88375
						},
						{
							"areaId": "611024",
							"areaName": "山阳县",
							"latitude": 33.52931,
							"longitude": 109.88784
						},
						{
							"areaId": "611025",
							"areaName": "镇安县",
							"latitude": 33.42366,
							"longitude": 109.15374
						},
						{
							"areaId": "611026",
							"areaName": "柞水县",
							"latitude": 33.6831,
							"longitude": 109.11105
						}
					]
				}
			]
		},
		{
			"areaId": "62",
			"areaName": "甘肃省",
			"latitude": 36.058039,
			"longitude": 103.823557,
			"children": [{
					"areaId": "6201",
					"areaName": "兰州市",
					"latitude": 36.058039,
					"longitude": 103.823557,
					"children": [{
							"areaId": "620100",
							"areaName": "兰州市本级",
							"latitude": 36.058039,
							"longitude": 103.823557
						},
						{
							"areaId": "620102",
							"areaName": "城关区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "620103",
							"areaName": "七里河区",
							"latitude": 36.06585,
							"longitude": 103.78564
						},
						{
							"areaId": "620104",
							"areaName": "西固区",
							"latitude": 36.08858,
							"longitude": 103.62811
						},
						{
							"areaId": "620105",
							"areaName": "安宁区",
							"latitude": 36.10384,
							"longitude": 103.7189
						},
						{
							"areaId": "620111",
							"areaName": "红古区",
							"latitude": 36.34537,
							"longitude": 102.85955
						},
						{
							"areaId": "620121",
							"areaName": "永登县",
							"latitude": 36.73522,
							"longitude": 103.26055
						},
						{
							"areaId": "620122",
							"areaName": "皋兰县",
							"latitude": 36.33215,
							"longitude": 103.94506
						},
						{
							"areaId": "620123",
							"areaName": "榆中县",
							"latitude": 35.84415,
							"longitude": 104.1145
						}
					]
				},
				{
					"areaId": "6202",
					"areaName": "嘉峪关市",
					"latitude": 39.786529,
					"longitude": 98.277304,
					"children": [{
						"areaId": "620200",
						"areaName": "嘉峪关市本级",
						"latitude": 39.786529,
						"longitude": 98.277304
					}]
				},
				{
					"areaId": "6203",
					"areaName": "金昌市",
					"latitude": 38.514238,
					"longitude": 102.187888,
					"children": [{
							"areaId": "620300",
							"areaName": "金昌市本级",
							"latitude": 38.514238,
							"longitude": 102.187888
						},
						{
							"areaId": "620302",
							"areaName": "金川区",
							"latitude": 38.52101,
							"longitude": 102.19376
						},
						{
							"areaId": "620321",
							"areaName": "永昌县",
							"latitude": 38.24711,
							"longitude": 101.97222
						}
					]
				},
				{
					"areaId": "6204",
					"areaName": "白银市",
					"latitude": 36.54568,
					"longitude": 104.173606,
					"children": [{
							"areaId": "620400",
							"areaName": "白银市本级",
							"latitude": 36.54568,
							"longitude": 104.173606
						},
						{
							"areaId": "620402",
							"areaName": "白银区",
							"latitude": 36.54411,
							"longitude": 104.17355
						},
						{
							"areaId": "620403",
							"areaName": "平川区",
							"latitude": 36.7277,
							"longitude": 104.82498
						},
						{
							"areaId": "620421",
							"areaName": "靖远县",
							"latitude": 36.56602,
							"longitude": 104.68325
						},
						{
							"areaId": "620422",
							"areaName": "会宁县",
							"latitude": 35.69626,
							"longitude": 105.05297
						},
						{
							"areaId": "620423",
							"areaName": "景泰县",
							"latitude": 37.18359,
							"longitude": 104.06295
						}
					]
				},
				{
					"areaId": "6205",
					"areaName": "天水市",
					"latitude": 34.578529,
					"longitude": 105.724998,
					"children": [{
							"areaId": "620500",
							"areaName": "天水市本级",
							"latitude": 34.578529,
							"longitude": 105.724998
						},
						{
							"areaId": "620502",
							"areaName": "秦州区",
							"latitude": 34.58089,
							"longitude": 105.72421
						},
						{
							"areaId": "620503",
							"areaName": "麦积区",
							"latitude": 34.57069,
							"longitude": 105.89013
						},
						{
							"areaId": "620521",
							"areaName": "清水县",
							"latitude": 34.75032,
							"longitude": 106.13671
						},
						{
							"areaId": "620522",
							"areaName": "秦安县",
							"latitude": 34.85894,
							"longitude": 105.66955
						},
						{
							"areaId": "620523",
							"areaName": "甘谷县",
							"latitude": 34.73665,
							"longitude": 105.33291
						},
						{
							"areaId": "620524",
							"areaName": "武山县",
							"latitude": 34.72123,
							"longitude": 104.88382
						},
						{
							"areaId": "620525",
							"areaName": "张家川回族自治县",
							"latitude": 34.99582,
							"longitude": 106.21582
						}
					]
				},
				{
					"areaId": "6206",
					"areaName": "武威市",
					"latitude": 37.929996,
					"longitude": 102.634697,
					"children": [{
							"areaId": "620600",
							"areaName": "武威市本级",
							"latitude": 37.929996,
							"longitude": 102.634697
						},
						{
							"areaId": "620602",
							"areaName": "凉州区",
							"latitude": 37.92832,
							"longitude": 102.64203
						},
						{
							"areaId": "620621",
							"areaName": "民勤县",
							"latitude": 38.62487,
							"longitude": 103.09011
						},
						{
							"areaId": "620622",
							"areaName": "古浪县",
							"latitude": 37.46508,
							"longitude": 102.89154
						},
						{
							"areaId": "620623",
							"areaName": "天祝藏族自治县",
							"latitude": 36.97715,
							"longitude": 103.1361
						}
					]
				},
				{
					"areaId": "6207",
					"areaName": "张掖市",
					"latitude": 38.932897,
					"longitude": 100.455472,
					"children": [{
							"areaId": "620700",
							"areaName": "张掖市本级",
							"latitude": 38.932897,
							"longitude": 100.455472
						},
						{
							"areaId": "620702",
							"areaName": "甘州区",
							"latitude": 38.92947,
							"longitude": 100.4527
						},
						{
							"areaId": "620721",
							"areaName": "肃南裕固族自治县",
							"latitude": 38.83776,
							"longitude": 99.61407
						},
						{
							"areaId": "620722",
							"areaName": "民乐县",
							"latitude": 38.43479,
							"longitude": 100.81091
						},
						{
							"areaId": "620723",
							"areaName": "临泽县",
							"latitude": 39.15252,
							"longitude": 100.16445
						},
						{
							"areaId": "620724",
							"areaName": "高台县",
							"latitude": 39.37829,
							"longitude": 99.81918
						},
						{
							"areaId": "620725",
							"areaName": "山丹县",
							"latitude": 38.78468,
							"longitude": 101.09359
						}
					]
				},
				{
					"areaId": "6208",
					"areaName": "平凉市",
					"latitude": 35.54279,
					"longitude": 106.684691,
					"children": [{
							"areaId": "620800",
							"areaName": "平凉市本级",
							"latitude": 35.54279,
							"longitude": 106.684691
						},
						{
							"areaId": "620802",
							"areaName": "崆峒区",
							"latitude": 35.54262,
							"longitude": 106.67483
						},
						{
							"areaId": "620821",
							"areaName": "泾川县",
							"latitude": 35.33223,
							"longitude": 107.36581
						},
						{
							"areaId": "620822",
							"areaName": "灵台县",
							"latitude": 35.06768,
							"longitude": 107.6174
						},
						{
							"areaId": "620823",
							"areaName": "崇信县",
							"latitude": 35.30344,
							"longitude": 107.03738
						},
						{
							"areaId": "620824",
							"areaName": "华亭县",
							"latitude": 35.54279,
							"longitude": 106.684691
						},
						{
							"areaId": "620825",
							"areaName": "庄浪县",
							"latitude": 35.20235,
							"longitude": 106.03662
						},
						{
							"areaId": "620826",
							"areaName": "静宁县",
							"latitude": 35.51991,
							"longitude": 105.72723
						}
					]
				},
				{
					"areaId": "6209",
					"areaName": "酒泉市",
					"latitude": 39.744023,
					"longitude": 98.510795,
					"children": [{
							"areaId": "620900",
							"areaName": "酒泉市本级",
							"latitude": 39.744023,
							"longitude": 98.510795
						},
						{
							"areaId": "620902",
							"areaName": "肃州区",
							"latitude": 39.74506,
							"longitude": 98.50775
						},
						{
							"areaId": "620921",
							"areaName": "金塔县",
							"latitude": 39.97733,
							"longitude": 98.90002
						},
						{
							"areaId": "620922",
							"areaName": "瓜州县",
							"latitude": 40.51548,
							"longitude": 95.78271
						},
						{
							"areaId": "620923",
							"areaName": "肃北蒙古族自治县",
							"latitude": 39.51214,
							"longitude": 94.87649
						},
						{
							"areaId": "620924",
							"areaName": "阿克塞哈萨克族自治县",
							"latitude": 39.63435,
							"longitude": 94.34097
						},
						{
							"areaId": "620981",
							"areaName": "玉门市",
							"latitude": 40.29172,
							"longitude": 97.04538
						},
						{
							"areaId": "620982",
							"areaName": "敦煌市",
							"latitude": 40.14211,
							"longitude": 94.66159
						}
					]
				},
				{
					"areaId": "6210",
					"areaName": "庆阳市",
					"latitude": 35.734218,
					"longitude": 107.638372,
					"children": [{
							"areaId": "621000",
							"areaName": "庆阳市本级",
							"latitude": 35.734218,
							"longitude": 107.638372
						},
						{
							"areaId": "621002",
							"areaName": "西峰区",
							"latitude": 35.73065,
							"longitude": 107.65107
						},
						{
							"areaId": "621021",
							"areaName": "庆城县",
							"latitude": 36.01507,
							"longitude": 107.88272
						},
						{
							"areaId": "621022",
							"areaName": "环县",
							"latitude": 36.56846,
							"longitude": 107.30835
						},
						{
							"areaId": "621023",
							"areaName": "华池县",
							"latitude": 36.46108,
							"longitude": 107.9891
						},
						{
							"areaId": "621024",
							"areaName": "合水县",
							"latitude": 35.81911,
							"longitude": 108.02032
						},
						{
							"areaId": "621025",
							"areaName": "正宁县",
							"latitude": 35.49174,
							"longitude": 108.36007
						},
						{
							"areaId": "621026",
							"areaName": "宁县",
							"latitude": 35.50164,
							"longitude": 107.92517
						},
						{
							"areaId": "621027",
							"areaName": "镇原县",
							"latitude": 35.67712,
							"longitude": 107.199
						}
					]
				},
				{
					"areaId": "6211",
					"areaName": "定西市",
					"latitude": 35.579578,
					"longitude": 104.626294,
					"children": [{
							"areaId": "621100",
							"areaName": "定西市本级",
							"latitude": 35.579578,
							"longitude": 104.626294
						},
						{
							"areaId": "621102",
							"areaName": "安定区",
							"latitude": 23.121498,
							"longitude": 120.237083
						},
						{
							"areaId": "621121",
							"areaName": "通渭县",
							"latitude": 35.21101,
							"longitude": 105.24224
						},
						{
							"areaId": "621122",
							"areaName": "陇西县",
							"latitude": 35.00238,
							"longitude": 104.63446
						},
						{
							"areaId": "621123",
							"areaName": "渭源县",
							"latitude": 35.13649,
							"longitude": 104.21435
						},
						{
							"areaId": "621124",
							"areaName": "临洮县",
							"latitude": 35.3751,
							"longitude": 103.86196
						},
						{
							"areaId": "621125",
							"areaName": "漳县",
							"latitude": 34.84977,
							"longitude": 104.46704
						},
						{
							"areaId": "621126",
							"areaName": "岷县",
							"latitude": 34.43444,
							"longitude": 104.03772
						}
					]
				},
				{
					"areaId": "6212",
					"areaName": "陇南市",
					"latitude": 33.388598,
					"longitude": 104.929379,
					"children": [{
							"areaId": "621200",
							"areaName": "陇南市本级",
							"latitude": 33.388598,
							"longitude": 104.929379
						},
						{
							"areaId": "621202",
							"areaName": "武都区",
							"latitude": 33.39239,
							"longitude": 104.92652
						},
						{
							"areaId": "621221",
							"areaName": "成县",
							"latitude": 33.73925,
							"longitude": 105.72586
						},
						{
							"areaId": "621222",
							"areaName": "文县",
							"latitude": 32.94337,
							"longitude": 104.68362
						},
						{
							"areaId": "621223",
							"areaName": "宕昌县",
							"latitude": 34.04732,
							"longitude": 104.39349
						},
						{
							"areaId": "621224",
							"areaName": "康县",
							"latitude": 33.32912,
							"longitude": 105.60711
						},
						{
							"areaId": "621225",
							"areaName": "西和县",
							"latitude": 34.01432,
							"longitude": 105.30099
						},
						{
							"areaId": "621226",
							"areaName": "礼县",
							"latitude": 34.18935,
							"longitude": 105.17785
						},
						{
							"areaId": "621227",
							"areaName": "徽县",
							"latitude": 33.76898,
							"longitude": 106.08529
						},
						{
							"areaId": "621228",
							"areaName": "两当县",
							"latitude": 33.9096,
							"longitude": 106.30484
						}
					]
				},
				{
					"areaId": "6229",
					"areaName": "临夏回族自治州",
					"latitude": 35.599446,
					"longitude": 103.212006,
					"children": [{
							"areaId": "622900",
							"areaName": "临夏回族自治州本级",
							"latitude": 35.599446,
							"longitude": 103.212006
						},
						{
							"areaId": "622901",
							"areaName": "临夏市",
							"latitude": 35.59916,
							"longitude": 103.21
						},
						{
							"areaId": "622921",
							"areaName": "临夏县",
							"latitude": 35.49519,
							"longitude": 102.9938
						},
						{
							"areaId": "622922",
							"areaName": "康乐县",
							"latitude": 35.37219,
							"longitude": 103.71093
						},
						{
							"areaId": "622923",
							"areaName": "永靖县",
							"latitude": 23.924703,
							"longitude": 120.547775
						},
						{
							"areaId": "622924",
							"areaName": "广河县",
							"latitude": 35.48097,
							"longitude": 103.56933
						},
						{
							"areaId": "622925",
							"areaName": "和政县",
							"latitude": 35.42592,
							"longitude": 103.34936
						},
						{
							"areaId": "622926",
							"areaName": "东乡族自治县",
							"latitude": 35.66471,
							"longitude": 103.39477
						},
						{
							"areaId": "622927",
							"areaName": "积石山保安族东乡族撒拉族自治县",
							"latitude": 35.7182,
							"longitude": 102.87374
						}
					]
				},
				{
					"areaId": "6230",
					"areaName": "甘南藏族自治州",
					"latitude": 34.986354,
					"longitude": 102.911008,
					"children": [{
							"areaId": "623000",
							"areaName": "甘南藏族自治州本级",
							"latitude": 34.986354,
							"longitude": 102.911008
						},
						{
							"areaId": "623001",
							"areaName": "合作市",
							"latitude": 35.00016,
							"longitude": 102.91082
						},
						{
							"areaId": "623021",
							"areaName": "临潭县",
							"latitude": 34.69515,
							"longitude": 103.35287
						},
						{
							"areaId": "623022",
							"areaName": "卓尼县",
							"latitude": 34.58919,
							"longitude": 103.50811
						},
						{
							"areaId": "623023",
							"areaName": "舟曲县",
							"latitude": 33.78468,
							"longitude": 104.37155
						},
						{
							"areaId": "623024",
							"areaName": "迭部县",
							"latitude": 34.05623,
							"longitude": 103.22274
						},
						{
							"areaId": "623025",
							"areaName": "玛曲县",
							"latitude": 33.997,
							"longitude": 102.0754
						},
						{
							"areaId": "623026",
							"areaName": "碌曲县",
							"latitude": 34.58872,
							"longitude": 102.49176
						},
						{
							"areaId": "623027",
							"areaName": "夏河县",
							"latitude": 35.20487,
							"longitude": 102.52215
						}
					]
				}
			]
		},
		{
			"areaId": "63",
			"areaName": "青海省",
			"latitude": 36.623178,
			"longitude": 101.778916,
			"children": [{
					"areaId": "6301",
					"areaName": "西宁市",
					"latitude": 36.623178,
					"longitude": 101.778916,
					"children": [{
							"areaId": "630100",
							"areaName": "西宁市本级",
							"latitude": 36.623178,
							"longitude": 101.778916
						},
						{
							"areaId": "630102",
							"areaName": "城东区",
							"latitude": 36.59969,
							"longitude": 101.80373
						},
						{
							"areaId": "630103",
							"areaName": "城中区",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "630104",
							"areaName": "城西区",
							"latitude": 36.62828,
							"longitude": 101.76588
						},
						{
							"areaId": "630105",
							"areaName": "城北区",
							"latitude": 36.65014,
							"longitude": 101.7662
						},
						{
							"areaId": "630121",
							"areaName": "大通回族土族自治县",
							"latitude": 36.93489,
							"longitude": 101.70236
						},
						{
							"areaId": "630122",
							"areaName": "湟中县",
							"latitude": 36.623178,
							"longitude": 101.778916
						},
						{
							"areaId": "630123",
							"areaName": "湟源县",
							"latitude": 36.68243,
							"longitude": 101.25643
						}
					]
				},
				{
					"areaId": "6321",
					"areaName": "海东地区",
					"latitude": 36.623178,
					"longitude": 101.778916,
					"children": [{
							"areaId": "632100",
							"areaName": "海东地区本级",
							"latitude": 36.623178,
							"longitude": 101.778916
						},
						{
							"areaId": "632121",
							"areaName": "平安县",
							"latitude": 36.623178,
							"longitude": 101.778916
						},
						{
							"areaId": "632122",
							"areaName": "民和回族土族自治县",
							"latitude": 36.623178,
							"longitude": 101.778916
						},
						{
							"areaId": "632123",
							"areaName": "乐都县",
							"latitude": 36.623178,
							"longitude": 101.778916
						},
						{
							"areaId": "632126",
							"areaName": "互助土族自治县",
							"latitude": 36.623178,
							"longitude": 101.778916
						},
						{
							"areaId": "632127",
							"areaName": "化隆回族自治县",
							"latitude": 36.623178,
							"longitude": 101.778916
						},
						{
							"areaId": "632128",
							"areaName": "循化撒拉族自治县",
							"latitude": 36.623178,
							"longitude": 101.778916
						}
					]
				},
				{
					"areaId": "6322",
					"areaName": "海北藏族自治州",
					"latitude": 36.959435,
					"longitude": 100.901059,
					"children": [{
							"areaId": "632200",
							"areaName": "海北藏族自治州本级",
							"latitude": 36.959435,
							"longitude": 100.901059
						},
						{
							"areaId": "632221",
							"areaName": "门源回族自治县",
							"latitude": 37.37611,
							"longitude": 101.62228
						},
						{
							"areaId": "632222",
							"areaName": "祁连县",
							"latitude": 38.17901,
							"longitude": 100.24618
						},
						{
							"areaId": "632223",
							"areaName": "海晏县",
							"latitude": 36.89902,
							"longitude": 100.9927
						},
						{
							"areaId": "632224",
							"areaName": "刚察县",
							"latitude": 37.32161,
							"longitude": 100.14675
						}
					]
				},
				{
					"areaId": "6323",
					"areaName": "黄南藏族自治州",
					"latitude": 35.517744,
					"longitude": 102.019988,
					"children": [{
							"areaId": "632300",
							"areaName": "黄南藏族自治州本级",
							"latitude": 35.517744,
							"longitude": 102.019988
						},
						{
							"areaId": "632321",
							"areaName": "同仁县",
							"latitude": 35.51603,
							"longitude": 102.0184
						},
						{
							"areaId": "632322",
							"areaName": "尖扎县",
							"latitude": 35.93947,
							"longitude": 102.03411
						},
						{
							"areaId": "632323",
							"areaName": "泽库县",
							"latitude": 35.03519,
							"longitude": 101.46444
						},
						{
							"areaId": "632324",
							"areaName": "河南蒙古族自治县",
							"latitude": 34.73476,
							"longitude": 101.60864
						}
					]
				},
				{
					"areaId": "6325",
					"areaName": "海南藏族自治州",
					"latitude": 36.280353,
					"longitude": 100.619542,
					"children": [{
							"areaId": "632500",
							"areaName": "海南藏族自治州本级",
							"latitude": 36.280353,
							"longitude": 100.619542
						},
						{
							"areaId": "632521",
							"areaName": "共和县",
							"latitude": 36.2841,
							"longitude": 100.62003
						},
						{
							"areaId": "632522",
							"areaName": "同德县",
							"latitude": 35.25488,
							"longitude": 100.57159
						},
						{
							"areaId": "632523",
							"areaName": "贵德县",
							"latitude": 36.044,
							"longitude": 101.432
						},
						{
							"areaId": "632524",
							"areaName": "兴海县",
							"latitude": 35.59031,
							"longitude": 99.98846
						},
						{
							"areaId": "632525",
							"areaName": "贵南县",
							"latitude": 35.58667,
							"longitude": 100.74716
						}
					]
				},
				{
					"areaId": "6326",
					"areaName": "果洛藏族自治州",
					"latitude": 34.4736,
					"longitude": 100.242143,
					"children": [{
							"areaId": "632600",
							"areaName": "果洛藏族自治州本级",
							"latitude": 34.4736,
							"longitude": 100.242143
						},
						{
							"areaId": "632621",
							"areaName": "玛沁县",
							"latitude": 34.47746,
							"longitude": 100.23901
						},
						{
							"areaId": "632622",
							"areaName": "班玛县",
							"latitude": 32.93253,
							"longitude": 100.73745
						},
						{
							"areaId": "632623",
							"areaName": "甘德县",
							"latitude": 33.96838,
							"longitude": 99.90246
						},
						{
							"areaId": "632624",
							"areaName": "达日县",
							"latitude": 33.75193,
							"longitude": 99.65179
						},
						{
							"areaId": "632625",
							"areaName": "久治县",
							"latitude": 33.42989,
							"longitude": 101.48342
						},
						{
							"areaId": "632626",
							"areaName": "玛多县",
							"latitude": 34.91567,
							"longitude": 98.20996
						}
					]
				},
				{
					"areaId": "6327",
					"areaName": "玉树藏族自治州",
					"latitude": 33.004049,
					"longitude": 97.008522,
					"children": [{
							"areaId": "632700",
							"areaName": "玉树藏族自治州本级",
							"latitude": 33.004049,
							"longitude": 97.008522
						},
						{
							"areaId": "632721",
							"areaName": "玉树县",
							"latitude": 33.004049,
							"longitude": 97.008522
						},
						{
							"areaId": "632722",
							"areaName": "杂多县",
							"latitude": 32.89318,
							"longitude": 95.29864
						},
						{
							"areaId": "632723",
							"areaName": "称多县",
							"latitude": 33.36899,
							"longitude": 97.10788
						},
						{
							"areaId": "632724",
							"areaName": "治多县",
							"latitude": 33.8528,
							"longitude": 95.61572
						},
						{
							"areaId": "632725",
							"areaName": "囊谦县",
							"latitude": 32.20359,
							"longitude": 96.47753
						},
						{
							"areaId": "632726",
							"areaName": "曲麻莱县",
							"latitude": 34.12609,
							"longitude": 95.79757
						}
					]
				},
				{
					"areaId": "6328",
					"areaName": "海西蒙古族藏族自治州",
					"latitude": 37.374663,
					"longitude": 97.370785,
					"children": [{
							"areaId": "632800",
							"areaName": "海西蒙古族藏族自治州本级",
							"latitude": 37.374663,
							"longitude": 97.370785
						},
						{
							"areaId": "632801",
							"areaName": "格尔木市",
							"latitude": 36.40236,
							"longitude": 94.90329
						},
						{
							"areaId": "632802",
							"areaName": "德令哈市",
							"latitude": 37.36946,
							"longitude": 97.36084
						},
						{
							"areaId": "632821",
							"areaName": "乌兰县",
							"latitude": 36.93471,
							"longitude": 98.48196
						},
						{
							"areaId": "632822",
							"areaName": "都兰县",
							"latitude": 36.30135,
							"longitude": 98.09228
						},
						{
							"areaId": "632823",
							"areaName": "天峻县",
							"latitude": 37.30326,
							"longitude": 99.02453
						}
					]
				}
			]
		},
		{
			"areaId": "64",
			"areaName": "宁夏",
			"latitude": 38.46637,
			"longitude": 106.278179,
			"children": [{
					"areaId": "6401",
					"areaName": "银川市",
					"latitude": 38.46637,
					"longitude": 106.278179,
					"children": [{
							"areaId": "640100",
							"areaName": "银川市本级",
							"latitude": 38.46637,
							"longitude": 106.278179
						},
						{
							"areaId": "640104",
							"areaName": "兴庆区",
							"latitude": 38.47392,
							"longitude": 106.28872
						},
						{
							"areaId": "640105",
							"areaName": "西夏区",
							"latitude": 38.49137,
							"longitude": 106.15023
						},
						{
							"areaId": "640106",
							"areaName": "金凤区",
							"latitude": 38.47294,
							"longitude": 106.24261
						},
						{
							"areaId": "640121",
							"areaName": "永宁县",
							"latitude": 38.27559,
							"longitude": 106.2517
						},
						{
							"areaId": "640122",
							"areaName": "贺兰县",
							"latitude": 38.5544,
							"longitude": 106.34982
						},
						{
							"areaId": "640181",
							"areaName": "灵武市",
							"latitude": 38.10266,
							"longitude": 106.33999
						}
					]
				},
				{
					"areaId": "6402",
					"areaName": "石嘴山市",
					"latitude": 39.01333,
					"longitude": 106.376173,
					"children": [{
							"areaId": "640200",
							"areaName": "石嘴山市本级",
							"latitude": 39.01333,
							"longitude": 106.376173
						},
						{
							"areaId": "640202",
							"areaName": "大武口区",
							"latitude": 22.339919,
							"longitude": 120.889938
						},
						{
							"areaId": "640205",
							"areaName": "惠农区",
							"latitude": 39.13193,
							"longitude": 106.71145
						},
						{
							"areaId": "640221",
							"areaName": "平罗县",
							"latitude": 38.90429,
							"longitude": 106.54538
						}
					]
				},
				{
					"areaId": "6403",
					"areaName": "吴忠市",
					"latitude": 37.986165,
					"longitude": 106.199409,
					"children": [{
							"areaId": "640300",
							"areaName": "吴忠市本级",
							"latitude": 37.986165,
							"longitude": 106.199409
						},
						{
							"areaId": "640302",
							"areaName": "利通区",
							"latitude": 37.98512,
							"longitude": 106.20311
						},
						{
							"areaId": "640303",
							"areaName": "红寺堡区",
							"latitude": 37.99747,
							"longitude": 106.19822
						},
						{
							"areaId": "640323",
							"areaName": "盐池县",
							"latitude": 37.7833,
							"longitude": 107.40707
						},
						{
							"areaId": "640324",
							"areaName": "同心县",
							"latitude": 36.98116,
							"longitude": 105.91418
						},
						{
							"areaId": "640381",
							"areaName": "青铜峡市",
							"latitude": 38.02004,
							"longitude": 106.07489
						}
					]
				},
				{
					"areaId": "6404",
					"areaName": "固原市",
					"latitude": 36.004561,
					"longitude": 106.285241,
					"children": [{
							"areaId": "640400",
							"areaName": "固原市本级",
							"latitude": 36.004561,
							"longitude": 106.285241
						},
						{
							"areaId": "640402",
							"areaName": "原州区",
							"latitude": 36.00374,
							"longitude": 106.28778
						},
						{
							"areaId": "640422",
							"areaName": "西吉县",
							"latitude": 35.96616,
							"longitude": 105.73107
						},
						{
							"areaId": "640423",
							"areaName": "隆德县",
							"latitude": 35.61718,
							"longitude": 106.12426
						},
						{
							"areaId": "640424",
							"areaName": "泾源县",
							"latitude": 35.49072,
							"longitude": 106.33902
						},
						{
							"areaId": "640425",
							"areaName": "彭阳县",
							"latitude": 35.85076,
							"longitude": 106.64462
						}
					]
				},
				{
					"areaId": "6405",
					"areaName": "中卫市",
					"latitude": 37.514951,
					"longitude": 105.189568,
					"children": [{
							"areaId": "640500",
							"areaName": "中卫市本级",
							"latitude": 37.514951,
							"longitude": 105.189568
						},
						{
							"areaId": "640502",
							"areaName": "沙坡头区",
							"latitude": 37.51044,
							"longitude": 105.18962
						},
						{
							"areaId": "640521",
							"areaName": "中宁县",
							"latitude": 37.49149,
							"longitude": 105.68515
						},
						{
							"areaId": "640522",
							"areaName": "海原县",
							"latitude": 36.56498,
							"longitude": 105.64712
						}
					]
				}
			]
		},
		{
			"areaId": "65",
			"areaName": "新疆",
			"latitude": 43.792818,
			"longitude": 87.617733,
			"children": [{
					"areaId": "6501",
					"areaName": "乌鲁木齐市",
					"latitude": 43.792818,
					"longitude": 87.617733,
					"children": [{
							"areaId": "650100",
							"areaName": "乌鲁木齐市本级",
							"latitude": 43.792818,
							"longitude": 87.617733
						},
						{
							"areaId": "650102",
							"areaName": "天山区",
							"latitude": 43.79439,
							"longitude": 87.63167
						},
						{
							"areaId": "650103",
							"areaName": "沙依巴克区",
							"latitude": 43.80118,
							"longitude": 87.59788
						},
						{
							"areaId": "650104",
							"areaName": "新市区",
							"latitude": 23.07897,
							"longitude": 120.295138
						},
						{
							"areaId": "650105",
							"areaName": "水磨沟区",
							"latitude": 43.83247,
							"longitude": 87.64249
						},
						{
							"areaId": "650106",
							"areaName": "头屯河区",
							"latitude": 43.85487,
							"longitude": 87.29138
						},
						{
							"areaId": "650107",
							"areaName": "达坂城区",
							"latitude": 43.35797,
							"longitude": 88.30697
						},
						{
							"areaId": "650109",
							"areaName": "米东区",
							"latitude": 43.94739,
							"longitude": 87.68583
						},
						{
							"areaId": "650121",
							"areaName": "乌鲁木齐县",
							"latitude": 43.47125,
							"longitude": 87.40939
						}
					]
				},
				{
					"areaId": "6502",
					"areaName": "克拉玛依市",
					"latitude": 45.595886,
					"longitude": 84.873946,
					"children": [{
							"areaId": "650200",
							"areaName": "克拉玛依市本级",
							"latitude": 45.595886,
							"longitude": 84.873946
						},
						{
							"areaId": "650202",
							"areaName": "独山子区",
							"latitude": 44.32867,
							"longitude": 84.88671
						},
						{
							"areaId": "650203",
							"areaName": "克拉玛依区",
							"latitude": 45.59089,
							"longitude": 84.86225
						},
						{
							"areaId": "650204",
							"areaName": "白碱滩区",
							"latitude": 45.68768,
							"longitude": 85.13244
						},
						{
							"areaId": "650205",
							"areaName": "乌尔禾区",
							"latitude": 46.09006,
							"longitude": 85.69143
						}
					]
				},
				{
					"areaId": "6521",
					"areaName": "吐鲁番地区",
					"latitude": 43.792818,
					"longitude": 87.617733,
					"children": [{
							"areaId": "652100",
							"areaName": "吐鲁番地区本级",
							"latitude": 43.792818,
							"longitude": 87.617733
						},
						{
							"areaId": "652101",
							"areaName": "吐鲁番市",
							"latitude": 43.792818,
							"longitude": 87.617733
						},
						{
							"areaId": "652122",
							"areaName": "鄯善县",
							"latitude": 43.792818,
							"longitude": 87.617733
						},
						{
							"areaId": "652123",
							"areaName": "托克逊县",
							"latitude": 43.792818,
							"longitude": 87.617733
						}
					]
				},
				{
					"areaId": "6522",
					"areaName": "哈密地区",
					"latitude": 43.792818,
					"longitude": 87.617733,
					"children": [{
							"areaId": "652200",
							"areaName": "哈密地区本级",
							"latitude": 43.792818,
							"longitude": 87.617733
						},
						{
							"areaId": "652201",
							"areaName": "哈密市",
							"latitude": 43.792818,
							"longitude": 87.617733
						},
						{
							"areaId": "652222",
							"areaName": "巴里坤哈萨克自治县",
							"latitude": 43.792818,
							"longitude": 87.617733
						},
						{
							"areaId": "652223",
							"areaName": "伊吾县",
							"latitude": 43.792818,
							"longitude": 87.617733
						}
					]
				},
				{
					"areaId": "6523",
					"areaName": "昌吉回族自治州",
					"latitude": 44.014577,
					"longitude": 87.304012,
					"children": [{
							"areaId": "652300",
							"areaName": "昌吉回族自治州本级",
							"latitude": 44.014577,
							"longitude": 87.304012
						},
						{
							"areaId": "652301",
							"areaName": "昌吉市",
							"latitude": 44.01267,
							"longitude": 87.30249
						},
						{
							"areaId": "652302",
							"areaName": "阜康市",
							"latitude": 44.1584,
							"longitude": 87.98529
						},
						{
							"areaId": "652323",
							"areaName": "呼图壁县",
							"latitude": 44.18977,
							"longitude": 86.89892
						},
						{
							"areaId": "652324",
							"areaName": "玛纳斯县",
							"latitude": 44.30438,
							"longitude": 86.2145
						},
						{
							"areaId": "652325",
							"areaName": "奇台县",
							"latitude": 44.02221,
							"longitude": 89.5932
						},
						{
							"areaId": "652327",
							"areaName": "吉木萨尔县",
							"latitude": 44.00048,
							"longitude": 89.18078
						},
						{
							"areaId": "652328",
							"areaName": "木垒哈萨克自治县",
							"latitude": 43.83508,
							"longitude": 90.28897
						}
					]
				},
				{
					"areaId": "6527",
					"areaName": "博尔塔拉蒙古自治州",
					"latitude": 44.903258,
					"longitude": 82.074778,
					"children": [{
							"areaId": "652700",
							"areaName": "博尔塔拉蒙古自治州本级",
							"latitude": 44.903258,
							"longitude": 82.074778
						},
						{
							"areaId": "652701",
							"areaName": "博乐市",
							"latitude": 44.90052,
							"longitude": 82.0713
						},
						{
							"areaId": "652722",
							"areaName": "精河县",
							"latitude": 44.60774,
							"longitude": 82.89419
						},
						{
							"areaId": "652723",
							"areaName": "温泉县",
							"latitude": 44.97373,
							"longitude": 81.03134
						}
					]
				},
				{
					"areaId": "6528",
					"areaName": "巴音郭楞蒙古自治州",
					"latitude": 41.768552,
					"longitude": 86.150969,
					"children": [{
							"areaId": "652800",
							"areaName": "巴音郭楞蒙古自治州本级",
							"latitude": 41.768552,
							"longitude": 86.150969
						},
						{
							"areaId": "652801",
							"areaName": "库尔勒市",
							"latitude": 41.76602,
							"longitude": 86.15528
						},
						{
							"areaId": "652822",
							"areaName": "轮台县",
							"latitude": 41.77642,
							"longitude": 84.26101
						},
						{
							"areaId": "652823",
							"areaName": "尉犁县",
							"latitude": 41.33632,
							"longitude": 86.25903
						},
						{
							"areaId": "652824",
							"areaName": "若羌县",
							"latitude": 39.0179,
							"longitude": 88.16812
						},
						{
							"areaId": "652825",
							"areaName": "且末县",
							"latitude": 38.14534,
							"longitude": 85.52975
						},
						{
							"areaId": "652826",
							"areaName": "焉耆回族自治县",
							"latitude": 42.059,
							"longitude": 86.5744
						},
						{
							"areaId": "652827",
							"areaName": "和静县",
							"latitude": 42.31838,
							"longitude": 86.39611
						},
						{
							"areaId": "652828",
							"areaName": "和硕县",
							"latitude": 42.26814,
							"longitude": 86.86392
						},
						{
							"areaId": "652829",
							"areaName": "博湖县",
							"latitude": 41.98014,
							"longitude": 86.63333
						}
					]
				},
				{
					"areaId": "6529",
					"areaName": "阿克苏地区",
					"latitude": 41.170712,
					"longitude": 80.265068,
					"children": [{
							"areaId": "652900",
							"areaName": "阿克苏地区本级",
							"latitude": 41.170712,
							"longitude": 80.265068
						},
						{
							"areaId": "652901",
							"areaName": "阿克苏市",
							"latitude": 41.16754,
							"longitude": 80.26338
						},
						{
							"areaId": "652922",
							"areaName": "温宿县",
							"latitude": 41.27679,
							"longitude": 80.24173
						},
						{
							"areaId": "652923",
							"areaName": "库车县",
							"latitude": 41.170712,
							"longitude": 80.265068
						},
						{
							"areaId": "652924",
							"areaName": "沙雅县",
							"latitude": 41.22497,
							"longitude": 82.78131
						},
						{
							"areaId": "652925",
							"areaName": "新和县",
							"latitude": 41.54964,
							"longitude": 82.61053
						},
						{
							"areaId": "652926",
							"areaName": "拜城县",
							"latitude": 41.79801,
							"longitude": 81.87564
						},
						{
							"areaId": "652927",
							"areaName": "乌什县",
							"latitude": 41.21569,
							"longitude": 79.22937
						},
						{
							"areaId": "652928",
							"areaName": "阿瓦提县",
							"latitude": 40.63926,
							"longitude": 80.38336
						},
						{
							"areaId": "652929",
							"areaName": "柯坪县",
							"latitude": 40.50585,
							"longitude": 79.04751
						}
					]
				},
				{
					"areaId": "6530",
					"areaName": "克孜勒苏柯尔克孜自治州",
					"latitude": 39.713431,
					"longitude": 76.172825,
					"children": [{
							"areaId": "653000",
							"areaName": "克孜勒苏柯尔克孜自治州本级",
							"latitude": 39.713431,
							"longitude": 76.172825
						},
						{
							"areaId": "653001",
							"areaName": "阿图什市",
							"latitude": 39.71615,
							"longitude": 76.16827
						},
						{
							"areaId": "653022",
							"areaName": "阿克陶县",
							"latitude": 39.14892,
							"longitude": 75.94692
						},
						{
							"areaId": "653023",
							"areaName": "阿合奇县",
							"latitude": 40.93947,
							"longitude": 78.44848
						},
						{
							"areaId": "653024",
							"areaName": "乌恰县",
							"latitude": 39.71984,
							"longitude": 75.25839
						}
					]
				},
				{
					"areaId": "6531",
					"areaName": "喀什地区",
					"latitude": 39.467664,
					"longitude": 75.989138,
					"children": [{
							"areaId": "653100",
							"areaName": "喀什地区本级",
							"latitude": 39.467664,
							"longitude": 75.989138
						},
						{
							"areaId": "653101",
							"areaName": "喀什市",
							"latitude": 39.46768,
							"longitude": 75.99379
						},
						{
							"areaId": "653121",
							"areaName": "疏附县",
							"latitude": 39.37534,
							"longitude": 75.86029
						},
						{
							"areaId": "653122",
							"areaName": "疏勒县",
							"latitude": 39.40625,
							"longitude": 76.05398
						},
						{
							"areaId": "653123",
							"areaName": "英吉沙县",
							"latitude": 38.92968,
							"longitude": 76.17565
						},
						{
							"areaId": "653124",
							"areaName": "泽普县",
							"latitude": 38.18935,
							"longitude": 77.27145
						},
						{
							"areaId": "653125",
							"areaName": "莎车县",
							"latitude": 38.41601,
							"longitude": 77.24316
						},
						{
							"areaId": "653126",
							"areaName": "叶城县",
							"latitude": 37.88324,
							"longitude": 77.41659
						},
						{
							"areaId": "653127",
							"areaName": "麦盖提县",
							"latitude": 38.89662,
							"longitude": 77.64224
						},
						{
							"areaId": "653128",
							"areaName": "岳普湖县",
							"latitude": 39.23561,
							"longitude": 76.77233
						},
						{
							"areaId": "653129",
							"areaName": "伽师县",
							"latitude": 39.48801,
							"longitude": 76.72372
						},
						{
							"areaId": "653130",
							"areaName": "巴楚县",
							"latitude": 39.7855,
							"longitude": 78.54888
						},
						{
							"areaId": "653131",
							"areaName": "塔什库尔干塔吉克自治县",
							"latitude": 37.77893,
							"longitude": 75.23196
						}
					]
				},
				{
					"areaId": "6532",
					"areaName": "和田地区",
					"latitude": 37.110687,
					"longitude": 79.92533,
					"children": [{
							"areaId": "653200",
							"areaName": "和田地区本级",
							"latitude": 37.110687,
							"longitude": 79.92533
						},
						{
							"areaId": "653201",
							"areaName": "和田市",
							"latitude": 37.11214,
							"longitude": 79.91353
						},
						{
							"areaId": "653221",
							"areaName": "和田县",
							"latitude": 37.08922,
							"longitude": 79.82874
						},
						{
							"areaId": "653222",
							"areaName": "墨玉县",
							"latitude": 37.27248,
							"longitude": 79.74035
						},
						{
							"areaId": "653223",
							"areaName": "皮山县",
							"latitude": 37.62007,
							"longitude": 78.28125
						},
						{
							"areaId": "653224",
							"areaName": "洛浦县",
							"latitude": 37.07364,
							"longitude": 80.18536
						},
						{
							"areaId": "653225",
							"areaName": "策勒县",
							"latitude": 36.99843,
							"longitude": 80.80999
						},
						{
							"areaId": "653226",
							"areaName": "于田县",
							"latitude": 36.854,
							"longitude": 81.66717
						},
						{
							"areaId": "653227",
							"areaName": "民丰县",
							"latitude": 37.06577,
							"longitude": 82.68444
						}
					]
				},
				{
					"areaId": "6540",
					"areaName": "伊犁哈萨克自治州",
					"latitude": 43.92186,
					"longitude": 81.317946,
					"children": [{
							"areaId": "654000",
							"areaName": "伊犁哈萨克自治州本级",
							"latitude": 43.92186,
							"longitude": 81.317946
						},
						{
							"areaId": "654002",
							"areaName": "伊宁市",
							"latitude": 43.91294,
							"longitude": 81.32932
						},
						{
							"areaId": "654003",
							"areaName": "奎屯市",
							"latitude": 44.425,
							"longitude": 84.90228
						},
						{
							"areaId": "654021",
							"areaName": "伊宁县",
							"latitude": 43.97863,
							"longitude": 81.52764
						},
						{
							"areaId": "654022",
							"areaName": "察布查尔锡伯自治县",
							"latitude": 43.84023,
							"longitude": 81.14956
						},
						{
							"areaId": "654023",
							"areaName": "霍城县",
							"latitude": 44.0533,
							"longitude": 80.87826
						},
						{
							"areaId": "654024",
							"areaName": "巩留县",
							"latitude": 43.48429,
							"longitude": 82.22851
						},
						{
							"areaId": "654025",
							"areaName": "新源县",
							"latitude": 43.4284,
							"longitude": 83.26095
						},
						{
							"areaId": "654026",
							"areaName": "昭苏县",
							"latitude": 43.15828,
							"longitude": 81.1307
						},
						{
							"areaId": "654027",
							"areaName": "特克斯县",
							"latitude": 43.21938,
							"longitude": 81.84005
						},
						{
							"areaId": "654028",
							"areaName": "尼勒克县",
							"latitude": 43.79901,
							"longitude": 82.51184
						}
					]
				},
				{
					"areaId": "6542",
					"areaName": "塔城地区",
					"latitude": 46.746301,
					"longitude": 82.985732,
					"children": [{
							"areaId": "654200",
							"areaName": "塔城地区本级",
							"latitude": 46.746301,
							"longitude": 82.985732
						},
						{
							"areaId": "654201",
							"areaName": "塔城市",
							"latitude": 46.74852,
							"longitude": 82.97892
						},
						{
							"areaId": "654202",
							"areaName": "乌苏市",
							"latitude": 44.43729,
							"longitude": 84.68258
						},
						{
							"areaId": "654221",
							"areaName": "额敏县",
							"latitude": 46.5284,
							"longitude": 83.62872
						},
						{
							"areaId": "654223",
							"areaName": "沙湾县",
							"latitude": 44.33144,
							"longitude": 85.61932
						},
						{
							"areaId": "654224",
							"areaName": "托里县",
							"latitude": 45.93623,
							"longitude": 83.60592
						},
						{
							"areaId": "654225",
							"areaName": "裕民县",
							"latitude": 46.20377,
							"longitude": 82.99002
						},
						{
							"areaId": "654226",
							"areaName": "和布克赛尔蒙古自治县",
							"latitude": 46.79362,
							"longitude": 85.72662
						}
					]
				},
				{
					"areaId": "6543",
					"areaName": "阿勒泰地区",
					"latitude": 47.848393,
					"longitude": 88.13963,
					"children": [{
							"areaId": "654300",
							"areaName": "阿勒泰地区本级",
							"latitude": 47.848393,
							"longitude": 88.13963
						},
						{
							"areaId": "654301",
							"areaName": "阿勒泰市",
							"latitude": 47.8317,
							"longitude": 88.13913
						},
						{
							"areaId": "654321",
							"areaName": "布尔津县",
							"latitude": 47.70062,
							"longitude": 86.85751
						},
						{
							"areaId": "654322",
							"areaName": "富蕴县",
							"latitude": 46.99444,
							"longitude": 89.52679
						},
						{
							"areaId": "654323",
							"areaName": "福海县",
							"latitude": 47.11065,
							"longitude": 87.49508
						},
						{
							"areaId": "654324",
							"areaName": "哈巴河县",
							"latitude": 48.06046,
							"longitude": 86.42092
						},
						{
							"areaId": "654325",
							"areaName": "青河县",
							"latitude": 46.67382,
							"longitude": 90.38305
						},
						{
							"areaId": "654326",
							"areaName": "吉木乃县",
							"latitude": 47.43359,
							"longitude": 85.87814
						}
					]
				},
				{
					"areaId": "6590",
					"areaName": "自治区直辖县级行政单位",
					"latitude": 0,
					"longitude": 0,
					"children": [{
							"areaId": "659000",
							"areaName": "自治区直辖县级行政单位本级",
							"latitude": 0,
							"longitude": 0
						},
						{
							"areaId": "659001",
							"areaName": "石河子市",
							"latitude": 44.305886,
							"longitude": 86.041075
						},
						{
							"areaId": "659002",
							"areaName": "阿拉尔市",
							"latitude": 40.541914,
							"longitude": 81.285884
						},
						{
							"areaId": "659003",
							"areaName": "图木舒克市",
							"latitude": 39.867316,
							"longitude": 79.077978
						},
						{
							"areaId": "659004",
							"areaName": "五家渠市",
							"latitude": 44.167401,
							"longitude": 87.526884
						}
					]
				}
			]
		}
	];
	return data
}